"use strict";

var _toConsumableArray = require("/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _regeneratorRuntime = require("/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/regenerator/index.js");
var _slicedToArray = require("/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _taggedTemplateLiteral = require("/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _defineProperty = require("/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty.js");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _Hu, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _Or, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102, _templateObject103, _templateObject104, _templateObject105, _templateObject106, _templateObject107, _templateObject108, _templateObject109, _templateObject110, _templateObject111, _templateObject112, _templateObject113, _templateObject114, _templateObject115, _templateObject116, _templateObject117, _templateObject118, _templateObject119, _templateObject120, _templateObject121, _templateObject122, _templateObject123, _templateObject124, _templateObject125, _templateObject126, _templateObject127, _templateObject128, _templateObject129, _templateObject130, _templateObject131, _templateObject132, _templateObject133, _templateObject134, _templateObject135, _templateObject136, _templateObject137, _templateObject138, _templateObject139, _templateObject140, _templateObject141, _templateObject142, _templateObject143, _templateObject144, _templateObject145, _templateObject146, _templateObject147, _templateObject148, _templateObject149, _templateObject150, _templateObject151, _templateObject152, _templateObject153, _templateObject154, _templateObject155, _templateObject156, _templateObject157, _templateObject158, _templateObject159, _templateObject160, _templateObject161, _templateObject162, _templateObject163, _templateObject164, _templateObject165;
require("core-js/modules/esnext.global-this.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var Lo = Object.defineProperty,
  _o = Object.defineProperties;
var Io = Object.getOwnPropertyDescriptors;
var p1 = Object.getOwnPropertySymbols;
var I5 = Object.prototype.hasOwnProperty,
  N5 = Object.prototype.propertyIsEnumerable;
var _5 = function _5(e, t, n) {
    return t in e ? Lo(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }) : e[t] = n;
  },
  R = function R(e, t) {
    for (var n in t || (t = {})) {
      I5.call(t, n) && _5(e, n, t[n]);
    }
    if (p1) {
      var _iterator = _createForOfIteratorHelper(p1(t)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var n = _step.value;
          N5.call(t, n) && _5(e, n, t[n]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return e;
  },
  L = function L(e, t) {
    return _o(e, Io(t));
  };
var ee = function ee(e, t) {
  var n = {};
  for (var r in e) {
    I5.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  }
  if (e != null && p1) {
    var _iterator2 = _createForOfIteratorHelper(p1(e)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var r = _step2.value;
        t.indexOf(r) < 0 && N5.call(e, r) && (n[r] = e[r]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return n;
};
var at = function at(e, t, n) {
  return new Promise(function (r, o) {
    var c = function c(h) {
        try {
          u(n.next(h));
        } catch (s) {
          o(s);
        }
      },
      d = function d(h) {
        try {
          u(n.throw(h));
        } catch (s) {
          o(s);
        }
      },
      u = function u(h) {
        return h.done ? r(h.value) : Promise.resolve(h.value).then(c, d);
      };
    u((n = n.apply(e, t)).next());
  });
};
Object.defineProperty(exports, Symbol.toStringTag, {
  value: "Module"
});
var A = require("react"),
  i = require("@dls/web"),
  B = require("styled-components"),
  Nr = require("react-dom"),
  No = function No(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };
function Vo(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null, _defineProperty({}, Symbol.toStringTag, {
    value: "Module"
  }));
  if (e) {
    var _loop = function _loop(n) {
      if (n !== "default") {
        var r = Object.getOwnPropertyDescriptor(e, n);
        Object.defineProperty(t, n, r.get ? r : {
          enumerable: !0,
          get: function get() {
            return e[n];
          }
        });
      }
    };
    for (var n in e) {
      _loop(n);
    }
  }
  return t.default = e, Object.freeze(t);
}
var a = Vo(A),
  j = No(B);
var xt = {
    exports: {}
  },
  r1 = {}; /**
           * @license React
           * react-jsx-runtime.production.min.js
           *
           * Copyright (c) Facebook, Inc. and its affiliates.
           *
           * This source code is licensed under the MIT license found in the
           * LICENSE file in the root directory of this source tree.
           */
var V5;
function Fo() {
  if (V5) return r1;
  V5 = 1;
  var e = a.default,
    t = Symbol.for("react.element"),
    n = Symbol.for("react.fragment"),
    r = Object.prototype.hasOwnProperty,
    o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    c = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function d(u, h, s) {
    var v,
      g = {},
      x = null,
      w = null;
    s !== void 0 && (x = "" + s), h.key !== void 0 && (x = "" + h.key), h.ref !== void 0 && (w = h.ref);
    for (v in h) {
      r.call(h, v) && !c.hasOwnProperty(v) && (g[v] = h[v]);
    }
    if (u && u.defaultProps) for (v in h = u.defaultProps, h) {
      g[v] === void 0 && (g[v] = h[v]);
    }
    return {
      $$typeof: t,
      type: u,
      key: x,
      ref: w,
      props: g,
      _owner: o.current
    };
  }
  return r1.Fragment = n, r1.jsx = d, r1.jsxs = d, r1;
}
var l1 = {}; /**
             * @license React
             * react-jsx-runtime.development.js
             *
             * Copyright (c) Facebook, Inc. and its affiliates.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */
var F5;
function Do() {
  return F5 || (F5 = 1, process.env.NODE_ENV !== "production" && function () {
    var e = a.default,
      t = Symbol.for("react.element"),
      n = Symbol.for("react.portal"),
      r = Symbol.for("react.fragment"),
      o = Symbol.for("react.strict_mode"),
      c = Symbol.for("react.profiler"),
      d = Symbol.for("react.provider"),
      u = Symbol.for("react.context"),
      h = Symbol.for("react.forward_ref"),
      s = Symbol.for("react.suspense"),
      v = Symbol.for("react.suspense_list"),
      g = Symbol.for("react.memo"),
      x = Symbol.for("react.lazy"),
      w = Symbol.for("react.offscreen"),
      m = Symbol.iterator,
      b = "@@iterator";
    function O(f) {
      if (f === null || typeof f != "object") return null;
      var S = m && f[m] || f[b];
      return typeof S == "function" ? S : null;
    }
    var y = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function z(f) {
      {
        for (var S = arguments.length, T = new Array(S > 1 ? S - 1 : 0), H = 1; H < S; H++) {
          T[H - 1] = arguments[H];
        }
        E("error", f, T);
      }
    }
    function E(f, S, T) {
      {
        var H = y.ReactDebugCurrentFrame,
          F = H.getStackAddendum();
        F !== "" && (S += "%s", T = T.concat([F]));
        var U = T.map(function (V) {
          return String(V);
        });
        U.unshift("Warning: " + S), Function.prototype.apply.call(console[f], console, U);
      }
    }
    var p = !1,
      C = !1,
      M = !1,
      P = !1,
      _ = !1,
      Y;
    Y = Symbol.for("react.module.reference");
    function q(f) {
      return !!(typeof f == "string" || typeof f == "function" || f === r || f === c || _ || f === o || f === s || f === v || P || f === w || p || C || M || typeof f == "object" && f !== null && (f.$$typeof === x || f.$$typeof === g || f.$$typeof === d || f.$$typeof === u || f.$$typeof === h || f.$$typeof === Y || f.getModuleId !== void 0));
    }
    function le(f, S, T) {
      var H = f.displayName;
      if (H) return H;
      var F = S.displayName || S.name || "";
      return F !== "" ? T + "(" + F + ")" : T;
    }
    function re(f) {
      return f.displayName || "Context";
    }
    function J(f) {
      if (f == null) return null;
      if (typeof f.tag == "number" && z("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof f == "function") return f.displayName || f.name || null;
      if (typeof f == "string") return f;
      switch (f) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case c:
          return "Profiler";
        case o:
          return "StrictMode";
        case s:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof f == "object") switch (f.$$typeof) {
        case u:
          var S = f;
          return re(S) + ".Consumer";
        case d:
          var T = f;
          return re(T._context) + ".Provider";
        case h:
          return le(f, f.render, "ForwardRef");
        case g:
          var H = f.displayName || null;
          return H !== null ? H : J(f.type) || "Memo";
        case x:
          {
            var F = f,
              U = F._payload,
              V = F._init;
            try {
              return J(V(U));
            } catch (N) {
              return null;
            }
          }
      }
      return null;
    }
    var te = Object.assign,
      ae = 0,
      se,
      I,
      he,
      k,
      ve,
      be,
      de;
    function We() {}
    We.__reactDisabledLog = !0;
    function so() {
      {
        if (ae === 0) {
          se = console.log, I = console.info, he = console.warn, k = console.error, ve = console.group, be = console.groupCollapsed, de = console.groupEnd;
          var f = {
            configurable: !0,
            enumerable: !0,
            value: We,
            writable: !0
          };
          Object.defineProperties(console, {
            info: f,
            log: f,
            warn: f,
            error: f,
            group: f,
            groupCollapsed: f,
            groupEnd: f
          });
        }
        ae++;
      }
    }
    function uo() {
      {
        if (ae--, ae === 0) {
          var f = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: te({}, f, {
              value: se
            }),
            info: te({}, f, {
              value: I
            }),
            warn: te({}, f, {
              value: he
            }),
            error: te({}, f, {
              value: k
            }),
            group: te({}, f, {
              value: ve
            }),
            groupCollapsed: te({}, f, {
              value: be
            }),
            groupEnd: te({}, f, {
              value: de
            })
          });
        }
        ae < 0 && z("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var X1 = y.ReactCurrentDispatcher,
      K1;
    function w1(f, S, T) {
      {
        if (K1 === void 0) try {
          throw Error();
        } catch (F) {
          var H = F.stack.trim().match(/\n( *(at )?)/);
          K1 = H && H[1] || "";
        }
        return "\n" + K1 + f;
      }
    }
    var J1 = !1,
      y1;
    {
      var ho = typeof WeakMap == "function" ? WeakMap : Map;
      y1 = new ho();
    }
    function O5(f, S) {
      if (!f || J1) return "";
      {
        var T = y1.get(f);
        if (T !== void 0) return T;
      }
      var H;
      J1 = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var U;
      U = X1.current, X1.current = null, so();
      try {
        if (S) {
          var V = function V() {
            throw Error();
          };
          if (Object.defineProperty(V.prototype, "props", {
            set: function set() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(V, []);
            } catch (oe) {
              H = oe;
            }
            Reflect.construct(f, [], V);
          } else {
            try {
              V.call();
            } catch (oe) {
              H = oe;
            }
            f.call(V.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (oe) {
            H = oe;
          }
          f();
        }
      } catch (oe) {
        if (oe && H && typeof oe.stack == "string") {
          for (var N = oe.stack.split("\n"), ie = H.stack.split("\n"), X = N.length - 1, Z = ie.length - 1; X >= 1 && Z >= 0 && N[X] !== ie[Z];) {
            Z--;
          }
          for (; X >= 1 && Z >= 0; X--, Z--) {
            if (N[X] !== ie[Z]) {
              if (X !== 1 || Z !== 1) do {
                if (X--, Z--, Z < 0 || N[X] !== ie[Z]) {
                  var fe = "\n" + N[X].replace(" at new ", " at ");
                  return f.displayName && fe.includes("<anonymous>") && (fe = fe.replace("<anonymous>", f.displayName)), typeof f == "function" && y1.set(f, fe), fe;
                }
              } while (X >= 1 && Z >= 0);
              break;
            }
          }
        }
      } finally {
        J1 = !1, X1.current = U, uo(), Error.prepareStackTrace = F;
      }
      var _e = f ? f.displayName || f.name : "",
        Ce = _e ? w1(_e) : "";
      return typeof f == "function" && y1.set(f, Ce), Ce;
    }
    function fo(f, S, T) {
      return O5(f, !1);
    }
    function vo(f) {
      var S = f.prototype;
      return !!(S && S.isReactComponent);
    }
    function j1(f, S, T) {
      if (f == null) return "";
      if (typeof f == "function") return O5(f, vo(f));
      if (typeof f == "string") return w1(f);
      switch (f) {
        case s:
          return w1("Suspense");
        case v:
          return w1("SuspenseList");
      }
      if (typeof f == "object") switch (f.$$typeof) {
        case h:
          return fo(f.render);
        case g:
          return j1(f.type, S, T);
        case x:
          {
            var H = f,
              F = H._payload,
              U = H._init;
            try {
              return j1(U(F), S, T);
            } catch (V) {}
          }
      }
      return "";
    }
    var t1 = Object.prototype.hasOwnProperty,
      E5 = {},
      S5 = y.ReactDebugCurrentFrame;
    function z1(f) {
      if (f) {
        var S = f._owner,
          T = j1(f.type, f._source, S ? S.type : null);
        S5.setExtraStackFrame(T);
      } else S5.setExtraStackFrame(null);
    }
    function mo(f, S, T, H, F) {
      {
        var U = Function.call.bind(t1);
        for (var V in f) {
          if (U(f, V)) {
            var N = void 0;
            try {
              if (typeof f[V] != "function") {
                var ie = Error((H || "React class") + ": " + T + " type `" + V + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[V] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ie.name = "Invariant Violation", ie;
              }
              N = f[V](S, V, H, T, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (X) {
              N = X;
            }
            N && !(N instanceof Error) && (z1(F), z("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", H || "React class", T, V, typeof N), z1(null)), N instanceof Error && !(N.message in E5) && (E5[N.message] = !0, z1(F), z("Failed %s type: %s", T, N.message), z1(null));
          }
        }
      }
    }
    var go = Array.isArray;
    function Z1(f) {
      return go(f);
    }
    function xo(f) {
      {
        var S = typeof Symbol == "function" && Symbol.toStringTag,
          T = S && f[Symbol.toStringTag] || f.constructor.name || "Object";
        return T;
      }
    }
    function bo(f) {
      try {
        return C5(f), !1;
      } catch (S) {
        return !0;
      }
    }
    function C5(f) {
      return "" + f;
    }
    function R5(f) {
      if (bo(f)) return z("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", xo(f)), C5(f);
    }
    var n1 = y.ReactCurrentOwner,
      wo = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      },
      M5,
      T5,
      et;
    et = {};
    function yo(f) {
      if (t1.call(f, "ref")) {
        var S = Object.getOwnPropertyDescriptor(f, "ref").get;
        if (S && S.isReactWarning) return !1;
      }
      return f.ref !== void 0;
    }
    function jo(f) {
      if (t1.call(f, "key")) {
        var S = Object.getOwnPropertyDescriptor(f, "key").get;
        if (S && S.isReactWarning) return !1;
      }
      return f.key !== void 0;
    }
    function zo(f, S) {
      if (typeof f.ref == "string" && n1.current && S && n1.current.stateNode !== S) {
        var T = J(n1.current.type);
        et[T] || (z('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', J(n1.current.type), f.ref), et[T] = !0);
      }
    }
    function po(f, S) {
      {
        var T = function T() {
          M5 || (M5 = !0, z("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        T.isReactWarning = !0, Object.defineProperty(f, "key", {
          get: T,
          configurable: !0
        });
      }
    }
    function Oo(f, S) {
      {
        var T = function T() {
          T5 || (T5 = !0, z("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        T.isReactWarning = !0, Object.defineProperty(f, "ref", {
          get: T,
          configurable: !0
        });
      }
    }
    var Eo = function Eo(f, S, T, H, F, U, V) {
      var N = {
        $$typeof: t,
        type: f,
        key: S,
        ref: T,
        props: V,
        _owner: U
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: H
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function So(f, S, T, H, F) {
      {
        var U,
          V = {},
          N = null,
          ie = null;
        T !== void 0 && (R5(T), N = "" + T), jo(S) && (R5(S.key), N = "" + S.key), yo(S) && (ie = S.ref, zo(S, F));
        for (U in S) {
          t1.call(S, U) && !wo.hasOwnProperty(U) && (V[U] = S[U]);
        }
        if (f && f.defaultProps) {
          var X = f.defaultProps;
          for (U in X) {
            V[U] === void 0 && (V[U] = X[U]);
          }
        }
        if (N || ie) {
          var Z = typeof f == "function" ? f.displayName || f.name || "Unknown" : f;
          N && po(V, Z), ie && Oo(V, Z);
        }
        return Eo(f, N, ie, F, H, n1.current, V);
      }
    }
    var tt = y.ReactCurrentOwner,
      P5 = y.ReactDebugCurrentFrame;
    function Le(f) {
      if (f) {
        var S = f._owner,
          T = j1(f.type, f._source, S ? S.type : null);
        P5.setExtraStackFrame(T);
      } else P5.setExtraStackFrame(null);
    }
    var nt;
    nt = !1;
    function rt(f) {
      return typeof f == "object" && f !== null && f.$$typeof === t;
    }
    function k5() {
      {
        if (tt.current) {
          var f = J(tt.current.type);
          if (f) return "\n\nCheck the render method of `" + f + "`.";
        }
        return "";
      }
    }
    function Co(f) {
      {
        if (f !== void 0) {
          var S = f.fileName.replace(/^.*[\\\/]/, ""),
            T = f.lineNumber;
          return "\n\nCheck your code at " + S + ":" + T + ".";
        }
        return "";
      }
    }
    var A5 = {};
    function Ro(f) {
      {
        var S = k5();
        if (!S) {
          var T = typeof f == "string" ? f : f.displayName || f.name;
          T && (S = "\n\nCheck the top-level render call using <" + T + ">.");
        }
        return S;
      }
    }
    function B5(f, S) {
      {
        if (!f._store || f._store.validated || f.key != null) return;
        f._store.validated = !0;
        var T = Ro(S);
        if (A5[T]) return;
        A5[T] = !0;
        var H = "";
        f && f._owner && f._owner !== tt.current && (H = " It was passed a child from " + J(f._owner.type) + "."), Le(f), z('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', T, H), Le(null);
      }
    }
    function H5(f, S) {
      {
        if (typeof f != "object") return;
        if (Z1(f)) for (var T = 0; T < f.length; T++) {
          var H = f[T];
          rt(H) && B5(H, S);
        } else if (rt(f)) f._store && (f._store.validated = !0);else if (f) {
          var F = O(f);
          if (typeof F == "function" && F !== f.entries) for (var U = F.call(f), V; !(V = U.next()).done;) {
            rt(V.value) && B5(V.value, S);
          }
        }
      }
    }
    function Mo(f) {
      {
        var S = f.type;
        if (S == null || typeof S == "string") return;
        var T;
        if (typeof S == "function") T = S.propTypes;else if (typeof S == "object" && (S.$$typeof === h || S.$$typeof === g)) T = S.propTypes;else return;
        if (T) {
          var H = J(S);
          mo(T, f.props, "prop", H, f);
        } else if (S.PropTypes !== void 0 && !nt) {
          nt = !0;
          var F = J(S);
          z("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof S.getDefaultProps == "function" && !S.getDefaultProps.isReactClassApproved && z("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function To(f) {
      {
        for (var S = Object.keys(f.props), T = 0; T < S.length; T++) {
          var H = S[T];
          if (H !== "children" && H !== "key") {
            Le(f), z("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", H), Le(null);
            break;
          }
        }
        f.ref !== null && (Le(f), z("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var W5 = {};
    function L5(f, S, T, H, F, U) {
      {
        var V = q(f);
        if (!V) {
          var N = "";
          (f === void 0 || typeof f == "object" && f !== null && Object.keys(f).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ie = Co(F);
          ie ? N += ie : N += k5();
          var X;
          f === null ? X = "null" : Z1(f) ? X = "array" : f !== void 0 && f.$$typeof === t ? (X = "<" + (J(f.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : X = typeof f, z("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", X, N);
        }
        var Z = So(f, S, T, F, U);
        if (Z == null) return Z;
        if (V) {
          var fe = S.children;
          if (fe !== void 0) if (H) {
            if (Z1(fe)) {
              for (var _e = 0; _e < fe.length; _e++) {
                H5(fe[_e], f);
              }
              Object.freeze && Object.freeze(fe);
            } else z("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else H5(fe, f);
        }
        if (t1.call(S, "key")) {
          var Ce = J(f),
            oe = Object.keys(S).filter(function (Wo) {
              return Wo !== "key";
            }),
            lt = oe.length > 0 ? "{key: someKey, " + oe.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!W5[Ce + lt]) {
            var Ho = oe.length > 0 ? "{" + oe.join(": ..., ") + ": ...}" : "{}";
            z("A props object containing a \"key\" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />", lt, Ce, Ho, Ce), W5[Ce + lt] = !0;
          }
        }
        return f === r ? To(Z) : Mo(Z), Z;
      }
    }
    function Po(f, S, T) {
      return L5(f, S, T, !0);
    }
    function ko(f, S, T) {
      return L5(f, S, T, !1);
    }
    var Ao = ko,
      Bo = Po;
    l1.Fragment = r, l1.jsx = Ao, l1.jsxs = Bo;
  }()), l1;
}
process.env.NODE_ENV === "production" ? xt.exports = Fo() : xt.exports = Do();
var l = xt.exports;
var $o = i.utils.createMediaQueries,
  qo = i.theme.breakpointSizes,
  Ue = $o(qo),
  it = i.theme.space.reduce(function (e, t) {
    return L(R({}, e), _defineProperty({}, "".concat(t), "".concat(t, "px")));
  }, {}),
  $1 = j.default(i.Grid)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 20px 0px;\n\n  ", "\n\n  ", "\n\n  ", ";\n\n  &&& {\n    width: 100%;\n  }\n"])), function (_ref) {
    var e = _ref.vCompact;
    return !e && B.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n\n      ", ";\n\n      ", ";\n    "])), Ue.xs(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        padding-top: 20px;\n        padding-bottom: 0px;\n      "]))), Ue.sm(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        padding-top: 20px;\n        padding-bottom: 0px;\n      "]))), Ue.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        padding-top: 48px;\n        padding-bottom: 24px;\n      "]))));
  }, function (e) {
    return e && e.vCompact && "\n    padding-top: 0px ; \n    padding-bottom: 0px;\n  ";
  }, function (e) {
    return e && e.hCompact && "\n    padding-right: 0px; \n    padding-left: 0px;\n  ";
  });
j.default(i.Text).attrs({
  type: "sectionTitle"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  text-align: center;\n  padding-right: ", ";\n  padding-left: ", ";\n\n  ", "\n"])), it[16], it[16], Ue.sm(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n  "])), it[40]));
var Uo = j.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  height: 100%;\n\n  /* Targets the Card element */\n  > div {\n    display: flex;\n    flex-direction: column;\n\n    /* Targets the Card.Content element */\n    > div:nth-child(2) {\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n    }\n  }\n"]))),
  Go = j.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  flex: 1;\n"]))),
  Yo = function Yo(_ref2) {
    var e = _ref2.children,
      t = _ref2.selectedIndex,
      n = _ref2.onSelect,
      r = _ref2.tabs;
    var _A$useState = A.useState(t),
      _A$useState2 = _slicedToArray(_A$useState, 2),
      o = _A$useState2[0],
      c = _A$useState2[1],
      d = function d(u, h) {
        c(h), n && n(h);
      };
    return l.jsxs("div", {
      "data-testid": "Tab",
      children: [l.jsx($1, {
        vCompact: !0,
        children: l.jsx(i.Row, {
          children: l.jsx(i.Column, {
            children: l.jsx(i.Tabs, {
              tabs: r,
              onTabItemClick: d,
              selected: o
            })
          })
        })
      }), e]
    });
  },
  Qo = {
    title_only: {
      subTitle: void 0,
      icon: void 0
    },
    title_and_subtitle: {
      icon: void 0
    },
    title_with_icon: {
      subTitle: void 0
    }
  },
  Xo = function Xo(_ref3) {
    var _ref3$tabItems = _ref3.tabItems,
      e = _ref3$tabItems === void 0 ? [] : _ref3$tabItems,
      _ref3$selected = _ref3.selected,
      t = _ref3$selected === void 0 ? 0 : _ref3$selected,
      _ref3$hugToContent = _ref3.hugToContent,
      n = _ref3$hugToContent === void 0 ? !1 : _ref3$hugToContent,
      _ref3$displayType = _ref3.displayType,
      r = _ref3$displayType === void 0 ? "title_only" : _ref3$displayType,
      o = _ref3.seoTitleTag,
      c = _ref3.children;
    var _A$useState3 = A.useState(t),
      _A$useState4 = _slicedToArray(_A$useState3, 2),
      d = _A$useState4[0],
      u = _A$useState4[1],
      h = A.useRef([]);
    A.useEffect(function () {
      h.current.forEach(function (g, x) {
        g && (g.style.display = x === d ? "block" : "none");
      });
    }, [d]);
    var s = A.useCallback(function (g) {
        u(function (x) {
          return x === g ? x : g;
        });
      }, []),
      v = e.map(function (g) {
        var w;
        var x = o ? l.jsx(i.Text, {
          tag: o,
          "data-text": g.title,
          children: g.title
        }) : g.title;
        return R(L(R({}, g), {
          title: x
        }), (w = Qo[r]) != null ? w : {});
      });
    return l.jsxs("div", {
      children: [l.jsx(i.Tabs, {
        onTabItemClick: function onTabItemClick(g, x) {
          return s(x);
        },
        selected: d,
        tabs: v,
        hugToContent: n
      }), a.default.Children.map(c, function (g, x) {
        var w;
        return l.jsx("div", {
          ref: function ref(m) {
            h.current[x] = m;
          },
          id: "tabpanel-".concat(x),
          "aria-labelledby": "tab-".concat(x),
          children: (w = v[x]) != null && w.mountContent || x === d ? g : null
        }, x);
      })]
    });
  },
  Ko = {
    fullWidthBackground: "fullWidthBackground",
    halfWidthBackground: "halfWidthBackground"
  },
  Jo = function Jo(n) {
    var r = n,
      e = r.image,
      t = ee(r, ["image"]);
    var c, d, u, h, s, v;
    var o = R({
      desktopImage: ((c = e == null ? void 0 : e.srcSetObj) == null ? void 0 : c.lg) || ((d = e == null ? void 0 : e.src) == null ? void 0 : d.url),
      tabletImage: ((u = e == null ? void 0 : e.srcSetObj) == null ? void 0 : u.md) || ((h = e == null ? void 0 : e.src) == null ? void 0 : h.url),
      mobileImage: ((s = e == null ? void 0 : e.srcSetObj) == null ? void 0 : s.sm) || ((v = e == null ? void 0 : e.src) == null ? void 0 : v.url)
    }, t);
    return l.jsx("div", {
      "data-testid": "Banner",
      children: l.jsx(i.Banner, R({
        fullWidth: !0
      }, o))
    });
  },
  Zo = j.default(i.Grid)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding: 0px;\n"]))),
  ec = function ec(n) {
    var r = n,
      e = r.image,
      t = ee(r, ["image"]);
    var c, d, u, h, s, v;
    var o = R({
      desktopImage: ((c = e == null ? void 0 : e.srcSetObj) == null ? void 0 : c.lg) || ((d = e == null ? void 0 : e.src) == null ? void 0 : d.url),
      tabletImage: ((u = e == null ? void 0 : e.srcSetObj) == null ? void 0 : u.md) || ((h = e == null ? void 0 : e.src) == null ? void 0 : h.url),
      mobileImage: ((s = e == null ? void 0 : e.srcSetObj) == null ? void 0 : s.sm) || ((v = e == null ? void 0 : e.src) == null ? void 0 : v.url)
    }, t);
    return l.jsx(Zo, {
      children: l.jsx(i.Row, {
        children: l.jsx(i.Column, {
          xs: 12,
          noGutter: !0,
          children: l.jsx("div", {
            "data-testid": "Banner",
            children: l.jsx(i.Banner, R({
              "data-testid": "banner"
            }, o))
          })
        })
      })
    });
  },
  tc = function tc(n) {
    var r = n,
      e = r.variant,
      t = ee(r, ["variant"]);
    return l.jsx(l.Fragment, {
      children: e === Ko.halfWidthBackground ? l.jsx(ec, R({}, t)) : l.jsx(Jo, R({}, t))
    });
  },
  nc = j.default(i.Grid)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  .card, .card > div {\n    height: 100%;\n  }\n"]))),
  rc = j.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  gap: 16px; /* Space between the cards */\n  @media (max-width: 768px) {\n    grid-template-columns: repeat(2, 1fr); /* 2 columns on small screens */\n  }\n  @media (max-width: 480px) {\n    grid-template-columns: 1fr; /* 1 column on extra small screens */\n  }\n"])), function (e) {
    return e.columns;
  }),
  lc = function lc(_ref4) {
    var e = _ref4.columns,
      t = _ref4.children,
      n = _ref4.isDesktopSwimlane,
      r = _ref4.isMobileSwimlane;
    var _i$useDevice = i.useDevice(),
      o = _i$useDevice.isTV,
      c = _i$useDevice.isDesktop,
      d = _i$useDevice.isMobile,
      u = _i$useDevice.isTablet,
      h = function h() {
        return n && (c || o) ? l.jsx(i.Carousel, {
          type: "card",
          children: t
        }) : r && (d || u) ? l.jsx(i.Carousel, {
          type: "card",
          swimlaneChildrenConfig: {
            sm: 2
          },
          children: t
        }) : l.jsx(rc, {
          columns: e,
          children: t
        });
      };
    return l.jsx(nc, {
      children: l.jsx(i.Row, {
        children: l.jsx(i.Column, {
          xs: 12,
          noGutter: !0,
          children: h()
        })
      })
    });
  },
  ac = function ac(u) {
    var h = u,
      _h$type = h.type,
      e = _h$type === void 0 ? "image" : _h$type,
      _h$rowProps = h.rowProps,
      t = _h$rowProps === void 0 ? {} : _h$rowProps,
      _h$columnProps = h.columnProps,
      n = _h$columnProps === void 0 ? {
        noGutter: e === "image"
      } : _h$columnProps,
      r = h.carouselId,
      _h$autoplay = h.autoplay,
      o = _h$autoplay === void 0 ? 5 : _h$autoplay,
      c = h.children,
      d = ee(h, ["type", "rowProps", "columnProps", "carouselId", "autoplay", "children"]);
    return l.jsx("div", {
      "data-testid": "Carousel",
      id: r,
      children: l.jsx(i.Row, L(R({}, t), {
        children: l.jsx(i.Column, L(R({}, n), {
          children: l.jsx(i.Carousel, L(R({
            fullWidth: !0,
            type: e,
            autoplay: o
          }, d), {
            children: c
          }))
        }))
      }))
    });
  },
  O1 = 0,
  Vr = function Vr(_ref5) {
    var _ref5$top = _ref5.top,
      e = _ref5$top === void 0 ? O1 : _ref5$top,
      _ref5$bottom = _ref5.bottom,
      t = _ref5$bottom === void 0 ? O1 : _ref5$bottom,
      _ref5$left = _ref5.left,
      n = _ref5$left === void 0 ? O1 : _ref5$left,
      _ref5$right = _ref5.right,
      r = _ref5$right === void 0 ? O1 : _ref5$right,
      _ref5$hideInMobile = _ref5.hideInMobile,
      o = _ref5$hideInMobile === void 0 ? !1 : _ref5$hideInMobile,
      _ref5$isResponsive = _ref5.isResponsive,
      c = _ref5$isResponsive === void 0 ? !0 : _ref5$isResponsive,
      d = _ref5.children;
    var _i$useDevice2 = i.useDevice(),
      u = _i$useDevice2.isMobile,
      h = function h(s) {
        var g;
        if (o && u) return 0;
        var _i$useTheme = i.useTheme(),
          v = _i$useTheme.theme;
        return ((g = v == null ? void 0 : v.spacing) == null ? void 0 : g.gap[s]) / 8 || s / 8;
      };
    return l.jsx("div", {
      "data-testid": "PaddingController",
      children: l.jsx(i.Spacing, {
        top: h(e),
        bottom: h(t),
        right: h(r),
        left: h(n),
        responsive: c,
        children: d
      })
    });
  },
  q1 = function q1(e, t) {
    var n = function n(c) {
      var d = c,
        r = d.padding,
        o = ee(d, ["padding"]);
      var u = r || t;
      return l.jsx(l.Fragment, {
        children: l.jsx(Vr, L(R({}, u), {
          children: l.jsx(e, R({}, o))
        }))
      });
    };
    return n.displayName = "withPaddingController(".concat(e.displayName || e.name || "Component", ")"), n;
  };
i.theme.main.colours.tertiary.l6;
var ic = {
    lightGrey: i.theme.main.colours.tertiary.l5,
    white: i.theme.main.colours.white,
    none: "transparent"
  },
  oc = i.withTheme(j.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref6) {
    var e = _ref6.coreTheme,
      t = _ref6.backgroundColor,
      n = _ref6.image,
      r = _ref6.isMobile,
      o = _ref6.isTablet,
      c = _ref6.isDesktop;
    var d, u, h, s, v, g, x, w, m, b, O, y;
    return B.css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n  "])), ((d = e == null ? void 0 : e.color) == null ? void 0 : d.background[t]) || ic.none, ((u = n == null ? void 0 : n.src) == null ? void 0 : u.url) && B.css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n      background-image: url(", ");\n    "])), (h = n == null ? void 0 : n.src) == null ? void 0 : h.url), ((s = n == null ? void 0 : n.src) == null ? void 0 : s.url) && r && B.css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n      background-image: url(", ");\n    "])), ((v = n == null ? void 0 : n.srcSetObj) == null ? void 0 : v.sm) || ((g = n == null ? void 0 : n.src) == null ? void 0 : g.url)), ((x = n == null ? void 0 : n.src) == null ? void 0 : x.url) && o && B.css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      background-image: url(", ");\n    "])), ((w = n == null ? void 0 : n.srcSetObj) == null ? void 0 : w.md) || ((m = n == null ? void 0 : n.src) == null ? void 0 : m.url)), ((b = n == null ? void 0 : n.src) == null ? void 0 : b.url) && c && B.css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n      background-image: url(", ");\n    "])), ((O = n == null ? void 0 : n.srcSetObj) == null ? void 0 : O.lg) || ((y = n == null ? void 0 : n.src) == null ? void 0 : y.url)));
  })),
  cc = function cc(n) {
    var r = n,
      e = r.children,
      t = ee(r, ["children"]);
    var _i$useDevice3 = i.useDevice(),
      o = _i$useDevice3.isMobile,
      c = _i$useDevice3.isTablet,
      d = _i$useDevice3.isLandscapeTablet,
      u = _i$useDevice3.isDesktop,
      h = _i$useDevice3.isTV;
    return l.jsx("div", {
      "data-testid": "PageSection",
      children: l.jsx(oc, L(R({
        "data-testid": "StyledWrapper",
        isMobile: o,
        isTablet: c,
        isDesktop: d || u || h
      }, t), {
        children: e
      }))
    });
  },
  sc = q1(cc);
function D5(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function W(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? D5(Object(n), !0).forEach(function (r) {
      Ye(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : D5(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function u1(e) {
  return u1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (t) {
    return typeof t;
  } : function (t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, u1(e);
}
function $5(e, t, n, r, o, c, d) {
  try {
    var u = e[c](d),
      h = u.value;
  } catch (s) {
    return void n(s);
  }
  u.done ? t(h) : Promise.resolve(h).then(r, o);
}
function h1(e) {
  return function () {
    var t = this,
      n = arguments;
    return new Promise(function (r, o) {
      var c = e.apply(t, n);
      function d(h) {
        $5(c, r, o, d, u, "next", h);
      }
      function u(h) {
        $5(c, r, o, d, u, "throw", h);
      }
      d(void 0);
    });
  };
}
function q5(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ye(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function L1(e) {
  return L1 = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, L1(e);
}
function _1(e, t) {
  return _1 = Object.setPrototypeOf || function (n, r) {
    return n.__proto__ = r, n;
  }, _1(e, t);
}
function Fr() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function bt(e, t, n) {
  return bt = Fr() ? Reflect.construct : function (r, o, c) {
    var d = [null];
    d.push.apply(d, o);
    var u = new (Function.bind.apply(r, d))();
    return c && _1(u, c.prototype), u;
  }, bt.apply(null, arguments);
}
function Dr(e, t) {
  if (e == null) return {};
  var n,
    r,
    o = function (d, u) {
      if (d == null) return {};
      var h,
        s,
        v = {},
        g = Object.keys(d);
      for (s = 0; s < g.length; s++) {
        h = g[s], u.indexOf(h) >= 0 || (v[h] = d[h]);
      }
      return v;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    for (r = 0; r < c.length; r++) {
      n = c[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
  }
  return o;
}
function dc(e, t) {
  if (t && (typeof t == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return function (n) {
    if (n === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n;
  }(e);
}
function f1(e, t) {
  return uc(e) || function (n, r) {
    var o = n == null ? null : typeof Symbol != "undefined" && n[Symbol.iterator] || n["@@iterator"];
    if (o != null) {
      var c,
        d,
        u = [],
        h = !0,
        s = !1;
      try {
        for (o = o.call(n); !(h = (c = o.next()).done) && (u.push(c.value), !r || u.length !== r); h = !0) {
          ;
        }
      } catch (v) {
        s = !0, d = v;
      } finally {
        try {
          h || o.return == null || o.return();
        } finally {
          if (s) throw d;
        }
      }
      return u;
    }
  }(e, t) || $r(e, t) || fc();
}
function xe(e) {
  return function (t) {
    if (Array.isArray(t)) return wt(t);
  }(e) || hc(e) || $r(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function uc(e) {
  if (Array.isArray(e)) return e;
}
function hc(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function $r(e, t) {
  if (e) {
    if (typeof e == "string") return wt(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? wt(e, t) : void 0;
  }
}
function wt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }
  return r;
}
function fc() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function vc(e) {
  var t = function (n, r) {
    if (typeof n != "object" || n === null) return n;
    var o = n[Symbol.toPrimitive];
    if (o !== void 0) {
      var c = o.call(n, r || "default");
      if (typeof c != "object") return c;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var E1 = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {},
  yt = {
    exports: {}
  },
  I1 = {
    exports: {}
  },
  $ = {},
  ne = typeof Symbol == "function" && Symbol.for,
  jt = ne ? Symbol.for("react.element") : 60103,
  zt = ne ? Symbol.for("react.portal") : 60106,
  R1 = ne ? Symbol.for("react.fragment") : 60107,
  M1 = ne ? Symbol.for("react.strict_mode") : 60108,
  T1 = ne ? Symbol.for("react.profiler") : 60114,
  P1 = ne ? Symbol.for("react.provider") : 60109,
  k1 = ne ? Symbol.for("react.context") : 60110,
  pt = ne ? Symbol.for("react.async_mode") : 60111,
  N1 = ne ? Symbol.for("react.concurrent_mode") : 60111,
  A1 = ne ? Symbol.for("react.forward_ref") : 60112,
  B1 = ne ? Symbol.for("react.suspense") : 60113,
  mc = ne ? Symbol.for("react.suspense_list") : 60120,
  H1 = ne ? Symbol.for("react.memo") : 60115,
  W1 = ne ? Symbol.for("react.lazy") : 60116,
  gc = ne ? Symbol.for("react.block") : 60121,
  xc = ne ? Symbol.for("react.fundamental") : 60117,
  bc = ne ? Symbol.for("react.responder") : 60118,
  wc = ne ? Symbol.for("react.scope") : 60119;
function ue(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case jt:
        switch (e = e.type) {
          case pt:
          case N1:
          case R1:
          case T1:
          case M1:
          case B1:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case k1:
              case A1:
              case W1:
              case H1:
              case P1:
                return e;
              default:
                return t;
            }
        }
      case zt:
        return t;
    }
  }
}
function U5(e) {
  return ue(e) === N1;
}
$.AsyncMode = pt, $.ConcurrentMode = N1, $.ContextConsumer = k1, $.ContextProvider = P1, $.Element = jt, $.ForwardRef = A1, $.Fragment = R1, $.Lazy = W1, $.Memo = H1, $.Portal = zt, $.Profiler = T1, $.StrictMode = M1, $.Suspense = B1, $.isAsyncMode = function (e) {
  return U5(e) || ue(e) === pt;
}, $.isConcurrentMode = U5, $.isContextConsumer = function (e) {
  return ue(e) === k1;
}, $.isContextProvider = function (e) {
  return ue(e) === P1;
}, $.isElement = function (e) {
  return typeof e == "object" && e !== null && e.$$typeof === jt;
}, $.isForwardRef = function (e) {
  return ue(e) === A1;
}, $.isFragment = function (e) {
  return ue(e) === R1;
}, $.isLazy = function (e) {
  return ue(e) === W1;
}, $.isMemo = function (e) {
  return ue(e) === H1;
}, $.isPortal = function (e) {
  return ue(e) === zt;
}, $.isProfiler = function (e) {
  return ue(e) === T1;
}, $.isStrictMode = function (e) {
  return ue(e) === M1;
}, $.isSuspense = function (e) {
  return ue(e) === B1;
}, $.isValidElementType = function (e) {
  return typeof e == "string" || typeof e == "function" || e === R1 || e === N1 || e === T1 || e === M1 || e === B1 || e === mc || typeof e == "object" && e !== null && (e.$$typeof === W1 || e.$$typeof === H1 || e.$$typeof === P1 || e.$$typeof === k1 || e.$$typeof === A1 || e.$$typeof === xc || e.$$typeof === bc || e.$$typeof === wc || e.$$typeof === gc);
}, $.typeOf = ue;
var D = {}; /** @license React v16.13.1
            * react-is.development.js
            *
            * Copyright (c) Facebook, Inc. and its affiliates.
            *
            * This source code is licensed under the MIT license found in the
            * LICENSE file in the root directory of this source tree.
            */
process.env.NODE_ENV !== "production" && function () {
  var e = typeof Symbol == "function" && Symbol.for,
    t = e ? Symbol.for("react.element") : 60103,
    n = e ? Symbol.for("react.portal") : 60106,
    r = e ? Symbol.for("react.fragment") : 60107,
    o = e ? Symbol.for("react.strict_mode") : 60108,
    c = e ? Symbol.for("react.profiler") : 60114,
    d = e ? Symbol.for("react.provider") : 60109,
    u = e ? Symbol.for("react.context") : 60110,
    h = e ? Symbol.for("react.async_mode") : 60111,
    s = e ? Symbol.for("react.concurrent_mode") : 60111,
    v = e ? Symbol.for("react.forward_ref") : 60112,
    g = e ? Symbol.for("react.suspense") : 60113,
    x = e ? Symbol.for("react.suspense_list") : 60120,
    w = e ? Symbol.for("react.memo") : 60115,
    m = e ? Symbol.for("react.lazy") : 60116,
    b = e ? Symbol.for("react.block") : 60121,
    O = e ? Symbol.for("react.fundamental") : 60117,
    y = e ? Symbol.for("react.responder") : 60118,
    z = e ? Symbol.for("react.scope") : 60119;
  function E(k) {
    if (typeof k == "object" && k !== null) {
      var ve = k.$$typeof;
      switch (ve) {
        case t:
          var be = k.type;
          switch (be) {
            case h:
            case s:
            case r:
            case c:
            case o:
            case g:
              return be;
            default:
              var de = be && be.$$typeof;
              switch (de) {
                case u:
                case v:
                case m:
                case w:
                case d:
                  return de;
                default:
                  return ve;
              }
          }
        case n:
          return ve;
      }
    }
  }
  var p = h,
    C = s,
    M = u,
    P = d,
    _ = t,
    Y = v,
    q = r,
    le = m,
    re = w,
    J = n,
    te = c,
    ae = o,
    se = g,
    I = !1;
  function he(k) {
    return E(k) === s;
  }
  D.AsyncMode = p, D.ConcurrentMode = C, D.ContextConsumer = M, D.ContextProvider = P, D.Element = _, D.ForwardRef = Y, D.Fragment = q, D.Lazy = le, D.Memo = re, D.Portal = J, D.Profiler = te, D.StrictMode = ae, D.Suspense = se, D.isAsyncMode = function (k) {
    return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), he(k) || E(k) === h;
  }, D.isConcurrentMode = he, D.isContextConsumer = function (k) {
    return E(k) === u;
  }, D.isContextProvider = function (k) {
    return E(k) === d;
  }, D.isElement = function (k) {
    return typeof k == "object" && k !== null && k.$$typeof === t;
  }, D.isForwardRef = function (k) {
    return E(k) === v;
  }, D.isFragment = function (k) {
    return E(k) === r;
  }, D.isLazy = function (k) {
    return E(k) === m;
  }, D.isMemo = function (k) {
    return E(k) === w;
  }, D.isPortal = function (k) {
    return E(k) === n;
  }, D.isProfiler = function (k) {
    return E(k) === c;
  }, D.isStrictMode = function (k) {
    return E(k) === o;
  }, D.isSuspense = function (k) {
    return E(k) === g;
  }, D.isValidElementType = function (k) {
    return typeof k == "string" || typeof k == "function" || k === r || k === s || k === c || k === o || k === g || k === x || typeof k == "object" && k !== null && (k.$$typeof === m || k.$$typeof === w || k.$$typeof === d || k.$$typeof === u || k.$$typeof === v || k.$$typeof === O || k.$$typeof === y || k.$$typeof === z || k.$$typeof === b);
  }, D.typeOf = E;
}(), process.env.NODE_ENV === "production" ? I1.exports = $ : I1.exports = D;
var G5 = Object.getOwnPropertySymbols,
  yc = Object.prototype.hasOwnProperty,
  jc = Object.prototype.propertyIsEnumerable;
function zc(e) {
  if (e == null) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
var pc = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }
      var r = Object.getOwnPropertyNames(t).map(function (c) {
        return t[c];
      });
      if (r.join("") !== "0123456789") return !1;
      var o = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (c) {
        o[c] = c;
      }), Object.keys(Object.assign({}, o)).join("") === "abcdefghijklmnopqrst";
    } catch (c) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, r, o = zc(e), c = 1; c < arguments.length; c++) {
      for (var d in n = Object(arguments[c])) {
        yc.call(n, d) && (o[d] = n[d]);
      }
      if (G5) {
        r = G5(n);
        for (var u = 0; u < r.length; u++) {
          jc.call(n, r[u]) && (o[r[u]] = n[r[u]]);
        }
      }
    }
    return o;
  },
  qr = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  Ur = Function.call.bind(Object.prototype.hasOwnProperty),
  Ot = function Ot() {};
if (process.env.NODE_ENV !== "production") {
  var Oc = qr,
    Et = {},
    Ec = Ur;
  Ot = function Ot(e) {
    var t = "Warning: " + e;
    typeof console != "undefined" && console.error(t);
    try {
      throw new Error(t);
    } catch (n) {}
  };
}
function Gr(e, t, n, r, o) {
  if (process.env.NODE_ENV !== "production") {
    for (var c in e) {
      if (Ec(e, c)) {
        var d;
        try {
          if (typeof e[c] != "function") {
            var u = Error((r || "React class") + ": " + n + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
            throw u.name = "Invariant Violation", u;
          }
          d = e[c](t, c, r, n, null, Oc);
        } catch (s) {
          d = s;
        }
        if (!d || d instanceof Error || Ot((r || "React class") + ": type specification of " + n + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), d instanceof Error && !(d.message in Et)) {
          Et[d.message] = !0;
          var h = o ? o() : "";
          Ot("Failed " + n + " type: " + d.message + (h != null ? h : ""));
        }
      }
    }
  }
}
Gr.resetWarningCache = function () {
  process.env.NODE_ENV !== "production" && (Et = {});
};
var Sc = Gr,
  Cc = I1.exports,
  Rc = pc,
  Ie = qr,
  ot = Ur,
  Y5 = Sc,
  d1 = function d1() {};
function S1() {
  return null;
}
process.env.NODE_ENV !== "production" && (d1 = function d1(e) {
  var t = "Warning: " + e;
  typeof console != "undefined" && console.error(t);
  try {
    throw new Error(t);
  } catch (n) {}
});
function Yr() {}
function Qr() {}
Qr.resetWarningCache = Yr;
if (process.env.NODE_ENV !== "production") {
  var Mc = I1.exports;
  yt.exports = function (e, t) {
    var n = typeof Symbol == "function" && Symbol.iterator,
      r = "<<anonymous>>",
      o = {
        array: h("array"),
        bigint: h("bigint"),
        bool: h("boolean"),
        func: h("function"),
        number: h("number"),
        object: h("object"),
        string: h("string"),
        symbol: h("symbol"),
        any: u(S1),
        arrayOf: function arrayOf(m) {
          return u(function (b, O, y, z, E) {
            if (typeof m != "function") return new d("Property `" + E + "` of component `" + y + "` has invalid PropType notation inside arrayOf.");
            var p = b[O];
            if (!Array.isArray(p)) return new d("Invalid " + z + " `" + E + "` of type `" + g(p) + "` supplied to `" + y + "`, expected an array.");
            for (var C = 0; C < p.length; C++) {
              var M = m(p, C, y, z, E + "[" + C + "]", Ie);
              if (M instanceof Error) return M;
            }
            return null;
          });
        },
        element: u(function (m, b, O, y, z) {
          var E = m[b];
          return e(E) ? null : new d("Invalid " + y + " `" + z + "` of type `" + g(E) + "` supplied to `" + O + "`, expected a single ReactElement.");
        }),
        elementType: u(function (m, b, O, y, z) {
          var E = m[b];
          return Cc.isValidElementType(E) ? null : new d("Invalid " + y + " `" + z + "` of type `" + g(E) + "` supplied to `" + O + "`, expected a single ReactElement type.");
        }),
        instanceOf: function instanceOf(m) {
          return u(function (b, O, y, z, E) {
            if (!(b[O] instanceof m)) {
              var p = m.name || r;
              return new d("Invalid " + z + " `" + E + "` of type `" + ((C = b[O]).constructor && C.constructor.name ? C.constructor.name : r) + "` supplied to `" + y + "`, expected instance of `" + p + "`.");
            }
            var C;
            return null;
          });
        },
        node: u(function (m, b, O, y, z) {
          return v(m[b]) ? null : new d("Invalid " + y + " `" + z + "` supplied to `" + O + "`, expected a ReactNode.");
        }),
        objectOf: function objectOf(m) {
          return u(function (b, O, y, z, E) {
            if (typeof m != "function") return new d("Property `" + E + "` of component `" + y + "` has invalid PropType notation inside objectOf.");
            var p = b[O],
              C = g(p);
            if (C !== "object") return new d("Invalid " + z + " `" + E + "` of type `" + C + "` supplied to `" + y + "`, expected an object.");
            for (var M in p) {
              if (ot(p, M)) {
                var P = m(p, M, y, z, E + "." + M, Ie);
                if (P instanceof Error) return P;
              }
            }
            return null;
          });
        },
        oneOf: function oneOf(m) {
          if (!Array.isArray(m)) return process.env.NODE_ENV !== "production" && d1(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), S1;
          function b(O, y, z, E, p) {
            for (var C = O[y], M = 0; M < m.length; M++) {
              if (c(C, m[M])) return null;
            }
            var P = JSON.stringify(m, function (_, Y) {
              return x(Y) === "symbol" ? String(Y) : Y;
            });
            return new d("Invalid " + E + " `" + p + "` of value `" + String(C) + "` supplied to `" + z + "`, expected one of " + P + ".");
          }
          return u(b);
        },
        oneOfType: function oneOfType(m) {
          if (!Array.isArray(m)) return process.env.NODE_ENV !== "production" && d1("Invalid argument supplied to oneOfType, expected an instance of array."), S1;
          for (var b = 0; b < m.length; b++) {
            var O = m[b];
            if (typeof O != "function") return d1("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + w(O) + " at index " + b + "."), S1;
          }
          return u(function (y, z, E, p, C) {
            for (var M = [], P = 0; P < m.length; P++) {
              var _ = (0, m[P])(y, z, E, p, C, Ie);
              if (_ == null) return null;
              _.data && ot(_.data, "expectedType") && M.push(_.data.expectedType);
            }
            return new d("Invalid " + p + " `" + C + "` supplied to `" + E + "`" + (M.length > 0 ? ", expected one of type [" + M.join(", ") + "]" : "") + ".");
          });
        },
        shape: function shape(m) {
          return u(function (b, O, y, z, E) {
            var p = b[O],
              C = g(p);
            if (C !== "object") return new d("Invalid " + z + " `" + E + "` of type `" + C + "` supplied to `" + y + "`, expected `object`.");
            for (var M in m) {
              var P = m[M];
              if (typeof P != "function") return s(y, z, E, M, x(P));
              var _ = P(p, M, y, z, E + "." + M, Ie);
              if (_) return _;
            }
            return null;
          });
        },
        exact: function exact(m) {
          return u(function (b, O, y, z, E) {
            var p = b[O],
              C = g(p);
            if (C !== "object") return new d("Invalid " + z + " `" + E + "` of type `" + C + "` supplied to `" + y + "`, expected `object`.");
            var M = Rc({}, b[O], m);
            for (var P in M) {
              var _ = m[P];
              if (ot(m, P) && typeof _ != "function") return s(y, z, E, P, x(_));
              if (!_) return new d("Invalid " + z + " `" + E + "` key `" + P + "` supplied to `" + y + "`.\nBad object: " + JSON.stringify(b[O], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(m), null, "  "));
              var Y = _(p, P, y, z, E + "." + P, Ie);
              if (Y) return Y;
            }
            return null;
          });
        }
      };
    function c(m, b) {
      return m === b ? m !== 0 || 1 / m == 1 / b : m != m && b != b;
    }
    function d(m, b) {
      this.message = m, this.data = b && typeof b == "object" ? b : {}, this.stack = "";
    }
    function u(m) {
      if (process.env.NODE_ENV !== "production") var b = {},
        O = 0;
      function y(E, p, C, M, P, _, Y) {
        if (M = M || r, _ = _ || C, Y !== Ie) {
          if (t) {
            var q = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw q.name = "Invariant Violation", q;
          }
          if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var le = M + ":" + C;
            !b[le] && O < 3 && (d1("You are manually calling a React.PropTypes validation function for the `" + _ + "` prop on `" + M + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), b[le] = !0, O++);
          }
        }
        return p[C] == null ? E ? p[C] === null ? new d("The " + P + " `" + _ + "` is marked as required in `" + M + "`, but its value is `null`.") : new d("The " + P + " `" + _ + "` is marked as required in `" + M + "`, but its value is `undefined`.") : null : m(p, C, M, P, _);
      }
      var z = y.bind(null, !1);
      return z.isRequired = y.bind(null, !0), z;
    }
    function h(m) {
      return u(function (b, O, y, z, E, p) {
        var C = b[O];
        return g(C) !== m ? new d("Invalid " + z + " `" + E + "` of type `" + x(C) + "` supplied to `" + y + "`, expected `" + m + "`.", {
          expectedType: m
        }) : null;
      });
    }
    function s(m, b, O, y, z) {
      return new d((m || "React class") + ": " + b + " type `" + O + "." + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + z + "`.");
    }
    function v(m) {
      switch (typeof m) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !m;
        case "object":
          if (Array.isArray(m)) return m.every(v);
          if (m === null || e(m)) return !0;
          var b = function (E) {
            var p = E && (n && E[n] || E["@@iterator"]);
            if (typeof p == "function") return p;
          }(m);
          if (!b) return !1;
          var O,
            y = b.call(m);
          if (b !== m.entries) {
            for (; !(O = y.next()).done;) {
              if (!v(O.value)) return !1;
            }
          } else for (; !(O = y.next()).done;) {
            var z = O.value;
            if (z && !v(z[1])) return !1;
          }
          return !0;
        default:
          return !1;
      }
    }
    function g(m) {
      var b = typeof m;
      return Array.isArray(m) ? "array" : m instanceof RegExp ? "object" : function (O, y) {
        return O === "symbol" || !!y && (y["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && y instanceof Symbol);
      }(b, m) ? "symbol" : b;
    }
    function x(m) {
      if (m == null) return "" + m;
      var b = g(m);
      if (b === "object") {
        if (m instanceof Date) return "date";
        if (m instanceof RegExp) return "regexp";
      }
      return b;
    }
    function w(m) {
      var b = x(m);
      switch (b) {
        case "array":
        case "object":
          return "an " + b;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + b;
        default:
          return b;
      }
    }
    return d.prototype = Error.prototype, o.checkPropTypes = Y5, o.resetWarningCache = Y5.resetWarningCache, o.PropTypes = o, o;
  }(Mc.isElement, !0);
} else yt.exports = function () {
  function e(r, o, c, d, u, h) {
    if (h !== "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED") {
      var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw s.name = "Invariant Violation", s;
    }
  }
  function t() {
    return e;
  }
  e.isRequired = e;
  var n = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: Qr,
    resetWarningCache: Yr
  };
  return n.PropTypes = n, n;
}();
var ce = yt.exports,
  ke = Array.isArray,
  Xr = typeof E1 == "object" && E1 && E1.Object === Object && E1,
  Tc = Xr,
  Pc = typeof self == "object" && self && self.Object === Object && self,
  we = Tc || Pc || Function("return this")(),
  je = we.Symbol,
  Q5 = je,
  Kr = Object.prototype,
  kc = Kr.hasOwnProperty,
  Ac = Kr.toString,
  a1 = Q5 ? Q5.toStringTag : void 0,
  Bc = function Bc(e) {
    var t = kc.call(e, a1),
      n = e[a1];
    try {
      e[a1] = void 0;
      var r = !0;
    } catch (c) {}
    var o = Ac.call(e);
    return r && (t ? e[a1] = n : delete e[a1]), o;
  },
  Hc = Object.prototype.toString,
  Wc = Bc,
  Lc = function Lc(e) {
    return Hc.call(e);
  },
  X5 = je ? je.toStringTag : void 0,
  Qe = function Qe(e) {
    return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : X5 && X5 in Object(e) ? Wc(e) : Lc(e);
  },
  Ae = function Ae(e) {
    return e != null && typeof e == "object";
  },
  _c = Qe,
  Ic = Ae,
  l5 = function l5(e) {
    return typeof e == "symbol" || Ic(e) && _c(e) == "[object Symbol]";
  },
  Nc = ke,
  Vc = l5,
  Fc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  Dc = /^\w*$/,
  $c = function $c(e, t) {
    if (Nc(e)) return !1;
    var n = typeof e;
    return !(n != "number" && n != "symbol" && n != "boolean" && e != null && !Vc(e)) || Dc.test(e) || !Fc.test(e) || t != null && e in Object(t);
  },
  x1 = function x1(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  },
  qc = Qe,
  Uc = x1,
  K5,
  Jr = function Jr(e) {
    if (!Uc(e)) return !1;
    var t = qc(e);
    return t == "[object Function]" || t == "[object GeneratorFunction]" || t == "[object AsyncFunction]" || t == "[object Proxy]";
  },
  ct = we["__core-js_shared__"],
  J5 = (K5 = /[^.]+$/.exec(ct && ct.keys && ct.keys.IE_PROTO || "")) ? "Symbol(src)_1." + K5 : "",
  Gc = function Gc(e) {
    return !!J5 && J5 in e;
  },
  Yc = Function.prototype.toString,
  Zr = function Zr(e) {
    if (e != null) {
      try {
        return Yc.call(e);
      } catch (t) {}
      try {
        return e + "";
      } catch (t) {}
    }
    return "";
  },
  Qc = Jr,
  Xc = Gc,
  Kc = x1,
  Jc = Zr,
  Zc = /^\[object .+?Constructor\]$/,
  es = Function.prototype,
  ts = Object.prototype,
  ns = es.toString,
  rs = ts.hasOwnProperty,
  ls = RegExp("^" + ns.call(rs).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
  as = function as(e) {
    return !(!Kc(e) || Xc(e)) && (Qc(e) ? ls : Zc).test(Jc(e));
  },
  is = function is(e, t) {
    return e == null ? void 0 : e[t];
  },
  Be = function Be(e, t) {
    var n = is(e, t);
    return as(n) ? n : void 0;
  },
  U1 = Be(Object, "create"),
  Z5 = U1,
  os = function os() {
    this.__data__ = Z5 ? Z5(null) : {}, this.size = 0;
  },
  cs = function cs(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  },
  ss = U1,
  ds = Object.prototype.hasOwnProperty,
  us = function us(e) {
    var t = this.__data__;
    if (ss) {
      var n = t[e];
      return n === "__lodash_hash_undefined__" ? void 0 : n;
    }
    return ds.call(t, e) ? t[e] : void 0;
  },
  hs = U1,
  fs = Object.prototype.hasOwnProperty,
  vs = U1,
  ms = os,
  gs = cs,
  xs = us,
  bs = function bs(e) {
    var t = this.__data__;
    return hs ? t[e] !== void 0 : fs.call(t, e);
  },
  ws = function ws(e, t) {
    var n = this.__data__;
    return this.size += this.has(e) ? 0 : 1, n[e] = vs && t === void 0 ? "__lodash_hash_undefined__" : t, this;
  };
function Ve(e) {
  var t = -1,
    n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ve.prototype.clear = ms, Ve.prototype.delete = gs, Ve.prototype.get = xs, Ve.prototype.has = bs, Ve.prototype.set = ws;
var ys = Ve,
  js = function js() {
    this.__data__ = [], this.size = 0;
  },
  el = function el(e, t) {
    return e === t || e != e && t != t;
  },
  zs = el,
  G1 = function G1(e, t) {
    for (var n = e.length; n--;) {
      if (zs(e[n][0], t)) return n;
    }
    return -1;
  },
  ps = G1,
  Os = Array.prototype.splice,
  Es = G1,
  Ss = G1,
  Cs = G1,
  Rs = js,
  Ms = function Ms(e) {
    var t = this.__data__,
      n = ps(t, e);
    return !(n < 0) && (n == t.length - 1 ? t.pop() : Os.call(t, n, 1), --this.size, !0);
  },
  Ts = function Ts(e) {
    var t = this.__data__,
      n = Es(t, e);
    return n < 0 ? void 0 : t[n][1];
  },
  Ps = function Ps(e) {
    return Ss(this.__data__, e) > -1;
  },
  ks = function ks(e, t) {
    var n = this.__data__,
      r = Cs(n, e);
    return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
  };
function Fe(e) {
  var t = -1,
    n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Fe.prototype.clear = Rs, Fe.prototype.delete = Ms, Fe.prototype.get = Ts, Fe.prototype.has = Ps, Fe.prototype.set = ks;
var Y1 = Fe,
  a5 = Be(we, "Map"),
  er = ys,
  As = Y1,
  Bs = a5,
  Hs = function Hs(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  },
  Q1 = function Q1(e, t) {
    var n = e.__data__;
    return Hs(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
  },
  Ws = Q1,
  Ls = Q1,
  _s = Q1,
  Is = Q1,
  Ns = function Ns() {
    this.size = 0, this.__data__ = {
      hash: new er(),
      map: new (Bs || As)(),
      string: new er()
    };
  },
  Vs = function Vs(e) {
    var t = Ws(this, e).delete(e);
    return this.size -= t ? 1 : 0, t;
  },
  Fs = function Fs(e) {
    return Ls(this, e).get(e);
  },
  Ds = function Ds(e) {
    return _s(this, e).has(e);
  },
  $s = function $s(e, t) {
    var n = Is(this, e),
      r = n.size;
    return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
  };
function De(e) {
  var t = -1,
    n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
De.prototype.clear = Ns, De.prototype.delete = Vs, De.prototype.get = Fs, De.prototype.has = Ds, De.prototype.set = $s;
var tl = De,
  nl = tl;
function i5(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function") throw new TypeError("Expected a function");
  var n = function n() {
    var r = arguments,
      o = t ? t.apply(this, r) : r[0],
      c = n.cache;
    if (c.has(o)) return c.get(o);
    var d = e.apply(this, r);
    return n.cache = c.set(o, d) || c, d;
  };
  return n.cache = new (i5.Cache || nl)(), n;
}
i5.Cache = nl;
var qs = i5,
  Us = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
  Gs = /\\(\\)?/g,
  Ys = function (e) {
    var t = qs(e, function (r) {
        return n.size === 500 && n.clear(), r;
      }),
      n = t.cache;
    return t;
  }(function (e) {
    var t = [];
    return e.charCodeAt(0) === 46 && t.push(""), e.replace(Us, function (n, r, o, c) {
      t.push(o ? c.replace(Gs, "$1") : r || n);
    }), t;
  }),
  rl = function rl(e, t) {
    for (var n = -1, r = e == null ? 0 : e.length, o = Array(r); ++n < r;) {
      o[n] = t(e[n], n, e);
    }
    return o;
  },
  Qs = rl,
  Xs = ke,
  Ks = l5,
  tr = je ? je.prototype : void 0,
  nr = tr ? tr.toString : void 0,
  Js = function e(t) {
    if (typeof t == "string") return t;
    if (Xs(t)) return Qs(t, e) + "";
    if (Ks(t)) return nr ? nr.call(t) : "";
    var n = t + "";
    return n == "0" && 1 / t == -1 / 0 ? "-0" : n;
  },
  Zs = Js,
  e4 = ke,
  t4 = $c,
  n4 = Ys,
  r4 = function r4(e) {
    return e == null ? "" : Zs(e);
  },
  o5 = function o5(e, t) {
    return e4(e) ? e : t4(e, t) ? [e] : n4(r4(e));
  },
  l4 = l5,
  ll = function ll(e) {
    if (typeof e == "string" || l4(e)) return e;
    var t = e + "";
    return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
  },
  a4 = o5,
  i4 = ll,
  al = function al(e, t) {
    for (var n = 0, r = (t = a4(t, e)).length; e != null && n < r;) {
      e = e[i4(t[n++])];
    }
    return n && n == r ? e : void 0;
  },
  o4 = al,
  c5 = function c5(e, t, n) {
    var r = e == null ? void 0 : o4(e, t);
    return r === void 0 ? n : r;
  };
function c4(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var il;
il = function il(e, t, n, r) {
  t = t || "&", n = n || "=";
  var o = {};
  if (typeof e != "string" || e.length === 0) return o;
  var c = /\+/g;
  e = e.split(t);
  var d = 1e3;
  r && typeof r.maxKeys == "number" && (d = r.maxKeys);
  var u = e.length;
  d > 0 && u > d && (u = d);
  for (var h = 0; h < u; ++h) {
    var s,
      v,
      g,
      x,
      w = e[h].replace(c, "%20"),
      m = w.indexOf(n);
    m >= 0 ? (s = w.substr(0, m), v = w.substr(m + 1)) : (s = w, v = ""), g = decodeURIComponent(s), x = decodeURIComponent(v), c4(o, g) ? Array.isArray(o[g]) ? o[g].push(x) : o[g] = [o[g], x] : o[g] = x;
  }
  return o;
};
var V1 = function V1() {
    return typeof window != "undefined";
  },
  ol = function ol() {
    var e = V1 ? window.location.search.substring(1) : "";
    return il(e) || {};
  },
  cl = function cl(e) {
    var t = e.text,
      n = t === void 0 ? "" : t,
      r = e.fn,
      o = e.regex,
      c = new RegExp("{".concat(o === void 0 ? "\\w+" : o, "}"), "gi");
    return n.replace(c, r);
  },
  s4 = function s4(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "\\w+",
      r = new RegExp("{(".concat(n, ")}")),
      o = e.match(r),
      c = f1(o, 2),
      d = c[1],
      u = t[d.trim()];
    return u || e;
  },
  sl = function sl(e) {
    return s4(e, ol());
  },
  d4 = function d4(e) {
    return e && e.constructor.name === "Object";
  },
  u4 = function u4(e) {
    return d4(e) === !1;
  },
  Xe = function Xe(e) {
    return typeof e != "string" ? JSON.stringify(e) : e;
  },
  h4 = function h4(e) {
    return Object.keys(e).map(function (t) {
      return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
    }).join("&");
  },
  f4 = ["href"];
function s5(e) {
  return e && u1(e) === "object" && "default" in e ? e.default : e;
}
var dl = s5(require("posthtml-parser")),
  st = s5(require("react"));
s5(require("lodash/get"));
var rr = require("html-entities");
function ul(e) {
  return e.replace(/(-|:)(.)/g, function (t, n, r) {
    return r.toUpperCase();
  });
}
function v4(e) {
  var t = {};
  return e.split(";").filter(function (n) {
    return n.trim() !== "";
  }).forEach(function (n) {
    var r,
      o = n.split(":");
    if (o.length > 1) {
      var c = function (u) {
          return /^-ms-/.test(u) && (u = u.substr(1)), ul(u);
        }(o[0].trim()),
        d = (r = o.slice(1).join(":").trim(), /^\d+$/.test(r) ? Number(r) : r.replace(/'/g, '"'));
      t[c] = d;
    }
  }), t;
}
var m4 = {
    for: "htmlFor",
    class: "className",
    acceptcharset: "acceptCharset",
    accesskey: "accessKey",
    allowfullscreen: "allowFullScreen",
    allowtransparency: "allowTransparency",
    autocomplete: "autoComplete",
    autofocus: "autoFocus",
    autoplay: "autoPlay",
    cellpadding: "cellPadding",
    cellspacing: "cellSpacing",
    charset: "charSet",
    classid: "classID",
    classname: "className",
    colspan: "colSpan",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    crossorigin: "crossOrigin",
    datetime: "dateTime",
    enctype: "encType",
    formaction: "formAction",
    formenctype: "formEncType",
    formmethod: "formMethod",
    formnovalidate: "formNoValidate",
    formtarget: "formTarget",
    frameborder: "frameBorder",
    hreflang: "hrefLang",
    htmlfor: "htmlFor",
    httpequiv: "httpEquiv",
    inputmode: "inputMode",
    keyparams: "keyParams",
    keytype: "keyType",
    marginheight: "marginHeight",
    marginwidth: "marginWidth",
    maxlength: "maxLength",
    mediagroup: "mediaGroup",
    minlength: "minLength",
    novalidate: "noValidate",
    radiogroup: "radioGroup",
    readonly: "readOnly",
    rowspan: "rowSpan",
    spellcheck: "spellCheck",
    srcdoc: "srcDoc",
    srclang: "srcLang",
    srcset: "srcSet",
    tabindex: "tabIndex",
    usemap: "useMap"
  },
  g4 = new RegExp("Android|iPad|iPhone|iPod", "i"),
  x4 = (typeof navigator == "undefined" ? "undefined" : u1(navigator)) === "object" && g4.test(navigator.userAgent);
function b4(e) {
  var t = Xe(e);
  return typeof e == "function" ? e : new Function("isMobile", "return " + t.trim())(x4);
}
function w4(e) {
  var t = e.attrs,
    n = function (r) {
      var o = r.attrs,
        c = r.options,
        d = r.userInputData;
      if (o) {
        if (o.href) return hl(o.href, c, d);
        if (o.onClick) return f1(Xe(o.onClick).match(/window\.(location\.assign|open)\([\\'|\\"]([^,]*)[\\'|\\"]/), 3)[2];
      }
      return "#";
    }({
      attrs: t,
      options: e.options,
      userInputData: e.userInputData
    });
  return t.href, W(W({}, Dr(t, f4)), {}, {
    onClick: function onClick(r) {
      if (r.preventDefault(), console.log("isBrowser", V1), V1) return window.ReactNativeWebView.postMessage(JSON.stringify({
        action: "HANDLE_LINK_NATIVE",
        url: n
      }));
    }
  });
}
function y4(e) {
  var t = e.tag,
    n = e.attrs,
    r = e.options,
    o = e.userInputData;
  return function (c) {
    var d = c.tag,
      u = c.attrs;
    if (V1) {
      var h = c5(window, "ReactNativeWebView.postMessage");
      return u && (u.href || u.onClick) && d === "a" && h && typeof h == "function";
    }
  }({
    tag: t,
    attrs: n
  }) ? w4({
    attrs: n,
    options: r,
    userInputData: o
  }) : n;
}
function hl(e, t, n) {
  if (fl(e)) {
    var r = function (o, c) {
      return f1(o.match(c) || [], 2)[1];
    }(e, vl);
    if (n[r] !== void 0) return function (o, c, d) {
      if (typeof d[o] == "string") {
        var u = cl({
          text: d[o],
          fn: sl
        });
        return F1(u, c, d);
      }
      return d[o];
    }(r, t, n);
  }
  return j4.includes(e) || p4(e) ? JSON.parse(e) : e;
}
var j4 = ["true", "false"],
  z4 = /(^[-]?\d+\.\d*$)|(^[-]?\d+$)/,
  p4 = function p4(e) {
    return z4.test(e);
  };
function fl(e) {
  return vl.test(e);
}
var vl = new RegExp("{(.*\\w)}");
function O4(e) {
  switch (u1(e)) {
    case "string":
      return dl(e.trim());
    case "number":
      return [e.toString()];
    default:
      return Array.isArray(e) ? e : [];
  }
}
function E4(e, t) {
  var n = e.split("{"),
    r = [];
  return n.forEach(function (o, c) {
    var d = function (u, h, s) {
      var v = u.match(/^([\w\\.]+)}/);
      if (v) {
        var g = h[f1(v, 2)[1]];
        if (g !== void 0) {
          var x;
          x = xe(O4(g));
          var w = f1(u.match(/^[\w\\.]+}(.*)/), 2)[1];
          return w && (x = [].concat(xe(x), [w])), x;
        }
      }
      var m = u;
      return s >= 1 && (m = "{" + u), [m];
    }(o, t, c);
    r = [].concat(xe(r), xe(d));
  }), r;
}
function ml(e, t) {
  return e && e.reduce(function (n, r) {
    return typeof r != "string" || fl(r) === !1 ? [].concat(xe(n), [r]) : [].concat(xe(n), xe(E4(r, t)));
  }, []);
}
var S4 = ["table", "tbody", "thead", "tfoot", "tr"];
function gl(e, t, n, r) {
  var o = n.map._;
  if (typeof e == "string") {
    var c = cl({
        text: e,
        fn: sl
      }),
      d = c.trim();
    if (/^<!--[\s\S]+-->/.test(d)) return null;
    var u = rr.decode(c);
    return o ? o(u) : u;
  }
  var h = ml(e.content, r),
    s = e.tag,
    v = e.attrs,
    g = h,
    x = n.map[s];
  v && Object.keys(v).forEach(function (b) {
    v[b] = rr.decode(v[b]);
  });
  var w = Object.assign({}, function () {
    var b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      O = arguments[1],
      y = O.tag,
      z = O.options,
      E = O.userInputData,
      p = y4({
        tag: y,
        attrs: b,
        options: z,
        userInputData: E
      });
    return Object.keys(p).reduce(function (C, M) {
      if (/^on.*/.test(M)) {
        var P = p[M];
        return C[M] = b4(P), C;
      }
      var _ = M;
      /^(data|aria)-/.test(M) || (_ = ul(M));
      var Y = hl(p[M], z, E),
        q = m4[_] || _;
      return C[q] = q === "style" ? v4(p.style) : Y, C;
    }, {});
  }(v, {
    tag: s,
    options: n,
    userInputData: r
  }), {
    key: t
  });
  if (s === "style" && !x && !o) return w.dangerouslySetInnerHTML = {
    __html: g[0]
  }, st.createElement(s, w, null);
  var m = g === void 0 ? null : g.map(function (b, O) {
    return S4.indexOf(s) > -1 && typeof b == "string" && (b = b.trim()) === "" ? null : gl(b, t + "." + O, n, r);
  }).filter(function (b) {
    return b !== null;
  });
  return m && m.length === 0 && (m = null), x ? st.createElement(x, w, m) : o ? o(s, w, m) : st.createElement(s, w, m);
}
function C4(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
    n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
    r = {
      map: t.map || {}
    },
    o = dl(e.trim()),
    c = ml(o, n),
    d = c.map(function (u, h) {
      return gl(u, h.toString(), r, n);
    }).filter(function (u) {
      return u !== null;
    });
  return d.length > 1 ? d : d[0];
}
var R4 = function R4(e, t) {
    return t[e], {
      userInputData: Dr(t, [e].map(vc))
    };
  },
  F1 = function F1(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return C4(e, {
      map: W(W({}, t), {}, {
        _: function _(r, o, c) {
          return r === "script" || r === "style" ? null : o === void 0 ? r : a.default.createElement(r, o, c);
        }
      })
    }, n);
  },
  M4 = Ye({}, ["richText"][0], ce.string.isRequired),
  St = function (e) {
    (function (s, v) {
      if (typeof v != "function" && v !== null) throw new TypeError("Super expression must either be null or a function");
      s.prototype = Object.create(v && v.prototype, {
        constructor: {
          value: s,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(s, "prototype", {
        writable: !1
      }), v && _1(s, v);
    })(h, A.PureComponent);
    var t,
      n,
      r,
      o,
      c,
      d,
      u = (t = h, n = Fr(), function () {
        var s,
          v = L1(t);
        if (n) {
          var g = L1(this).constructor;
          s = Reflect.construct(v, arguments, g);
        } else s = v.apply(this, arguments);
        return dc(this, s);
      });
    function h(s) {
      var v;
      return function (g, x) {
        if (!(g instanceof x)) throw new TypeError("Cannot call a class as a function");
      }(this, h), (v = u.call(this, s)).state = {}, v;
    }
    return r = h, o = [{
      key: "componentDidMount",
      value: (d = h1(_regeneratorRuntime.mark(function s() {
        var v, g, x, w, m, b, O, y;
        return _regeneratorRuntime.wrap(function (z) {
          for (;;) {
            switch (z.prev = z.next) {
              case 0:
                if (v = this.state.template, !(x = (g = v === void 0 ? {} : v).richText)) {
                  z.next = 13;
                  break;
                }
                if (w = this.props.componentsToMap, z.t0 = w, !z.t0) {
                  z.next = 9;
                  break;
                }
                return z.next = 8, w;
              case 8:
                z.t0 = z.sent;
              case 9:
                m = z.t0, b = R4("richText", g), O = b.userInputData, y = F1(x, m, O), this.setState({
                  richTextWithComponents: y
                });
              case 13:
              case "end":
                return z.stop();
            }
          }
        }, s, this);
      })), function () {
        return d.apply(this, arguments);
      })
    }, {
      key: "render",
      value: function value() {
        var s = this.state.richTextWithComponents;
        return s ? l.jsx(l.Fragment, {
          children: s
        }) : null;
      }
    }], c = [{
      key: "getDerivedStateFromProps",
      value: function value(s) {
        var v = s.htmlString,
          g = s.componentsToMap,
          x = s.userInputData,
          w = s.templates,
          m = w === void 0 ? {} : w,
          b = s.templateKey,
          O = s.template;
        return v ? {
          richTextWithComponents: F1(v, g, x)
        } : {
          template: m[b] || m.default || O
        };
      }
    }], o && q5(r.prototype, o), c && q5(r, c), Object.defineProperty(r, "prototype", {
      writable: !1
    }), h;
  }();
St.propTypes = {
  template: ce.shape(W({}, M4)),
  templates: ce.object,
  templateKey: ce.string,
  componentsToMap: ce.object,
  htmlString: ce.string,
  userInputData: ce.object
}, St.defaultProps = {};
var T4 = Y1,
  P4 = Y1,
  k4 = a5,
  A4 = tl,
  B4 = Y1,
  H4 = function H4() {
    this.__data__ = new T4(), this.size = 0;
  },
  W4 = function W4(e) {
    var t = this.__data__,
      n = t.delete(e);
    return this.size = t.size, n;
  },
  L4 = function L4(e) {
    return this.__data__.get(e);
  },
  _4 = function _4(e) {
    return this.__data__.has(e);
  },
  I4 = function I4(e, t) {
    var n = this.__data__;
    if (n instanceof P4) {
      var r = n.__data__;
      if (!k4 || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
      n = this.__data__ = new A4(r);
    }
    return n.set(e, t), this.size = n.size, this;
  };
function $e(e) {
  var t = this.__data__ = new B4(e);
  this.size = t.size;
}
$e.prototype.clear = H4, $e.prototype.delete = W4, $e.prototype.get = L4, $e.prototype.has = _4, $e.prototype.set = I4;
var N4 = $e,
  V4 = function V4(e, t) {
    for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;) {
      ;
    }
    return e;
  },
  F4 = Be,
  xl = function () {
    try {
      var e = F4(Object, "defineProperty");
      return e({}, "", {}), e;
    } catch (t) {}
  }(),
  lr = xl,
  bl = function bl(e, t, n) {
    t == "__proto__" && lr ? lr(e, t, {
      configurable: !0,
      enumerable: !0,
      value: n,
      writable: !0
    }) : e[t] = n;
  },
  D4 = bl,
  $4 = el,
  q4 = Object.prototype.hasOwnProperty,
  wl = function wl(e, t, n) {
    var r = e[t];
    q4.call(e, t) && $4(r, n) && (n !== void 0 || t in e) || D4(e, t, n);
  },
  U4 = wl,
  G4 = bl,
  b1 = function b1(e, t, n, r) {
    var o = !n;
    n || (n = {});
    for (var c = -1, d = t.length; ++c < d;) {
      var u = t[c],
        h = r ? r(n[u], e[u], u, n, e) : void 0;
      h === void 0 && (h = e[u]), o ? G4(n, u, h) : U4(n, u, h);
    }
    return n;
  },
  Y4 = function Y4(e, t) {
    for (var n = -1, r = Array(e); ++n < e;) {
      r[n] = t(n);
    }
    return r;
  },
  Q4 = Qe,
  X4 = Ae,
  ar = function ar(e) {
    return X4(e) && Q4(e) == "[object Arguments]";
  },
  K4 = Ae,
  yl = Object.prototype,
  J4 = yl.hasOwnProperty,
  Z4 = yl.propertyIsEnumerable,
  jl = ar(function () {
    return arguments;
  }()) ? ar : function (e) {
    return K4(e) && J4.call(e, "callee") && !Z4.call(e, "callee");
  },
  D1 = {
    exports: {}
  },
  e3 = function e3() {
    return !1;
  };
(function (e, t) {
  var n = we,
    r = e3,
    o = t && !t.nodeType && t,
    c = o && e && !e.nodeType && e,
    d = c && c.exports === o ? n.Buffer : void 0,
    u = (d ? d.isBuffer : void 0) || r;
  e.exports = u;
})(D1, D1.exports);
var t3 = /^(?:0|[1-9]\d*)$/,
  n3 = function n3(e, t) {
    var n = typeof e;
    return !!(t = t == null ? 9007199254740991 : t) && (n == "number" || n != "symbol" && t3.test(e)) && e > -1 && e % 1 == 0 && e < t;
  },
  zl = function zl(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= 9007199254740991;
  },
  r3 = Qe,
  l3 = zl,
  a3 = Ae,
  Q = {};
Q["[object Float32Array]"] = Q["[object Float64Array]"] = Q["[object Int8Array]"] = Q["[object Int16Array]"] = Q["[object Int32Array]"] = Q["[object Uint8Array]"] = Q["[object Uint8ClampedArray]"] = Q["[object Uint16Array]"] = Q["[object Uint32Array]"] = !0, Q["[object Arguments]"] = Q["[object Array]"] = Q["[object ArrayBuffer]"] = Q["[object Boolean]"] = Q["[object DataView]"] = Q["[object Date]"] = Q["[object Error]"] = Q["[object Function]"] = Q["[object Map]"] = Q["[object Number]"] = Q["[object Object]"] = Q["[object RegExp]"] = Q["[object Set]"] = Q["[object String]"] = Q["[object WeakMap]"] = !1;
var i3 = function i3(e) {
    return a3(e) && l3(e.length) && !!Q[r3(e)];
  },
  d5 = function d5(e) {
    return function (t) {
      return e(t);
    };
  },
  v1 = {
    exports: {}
  };
(function (e, t) {
  var n = Xr,
    r = t && !t.nodeType && t,
    o = r && e && !e.nodeType && e,
    c = o && o.exports === r && n.process,
    d = function () {
      try {
        var u = o && o.require && o.require("util").types;
        return u || c && c.binding && c.binding("util");
      } catch (h) {}
    }();
  e.exports = d;
})(v1, v1.exports);
var o3 = i3,
  c3 = d5,
  ir = v1.exports,
  or = ir && ir.isTypedArray,
  s3 = or ? c3(or) : o3,
  d3 = Y4,
  u3 = jl,
  h3 = ke,
  f3 = D1.exports,
  v3 = n3,
  m3 = s3,
  g3 = Object.prototype.hasOwnProperty,
  pl = function pl(e, t) {
    var n = h3(e),
      r = !n && u3(e),
      o = !n && !r && f3(e),
      c = !n && !r && !o && m3(e),
      d = n || r || o || c,
      u = d ? d3(e.length, String) : [],
      h = u.length;
    for (var s in e) {
      !t && !g3.call(e, s) || d && (s == "length" || o && (s == "offset" || s == "parent") || c && (s == "buffer" || s == "byteLength" || s == "byteOffset") || v3(s, h)) || u.push(s);
    }
    return u;
  },
  x3 = Object.prototype,
  u5 = function u5(e) {
    var t = e && e.constructor;
    return e === (typeof t == "function" && t.prototype || x3);
  },
  Ol = function Ol(e, t) {
    return function (n) {
      return e(t(n));
    };
  },
  b3 = Ol(Object.keys, Object),
  w3 = u5,
  y3 = b3,
  j3 = Object.prototype.hasOwnProperty,
  z3 = Jr,
  p3 = zl,
  El = function El(e) {
    return e != null && p3(e.length) && !z3(e);
  },
  O3 = pl,
  E3 = function E3(e) {
    if (!w3(e)) return y3(e);
    var t = [];
    for (var n in Object(e)) {
      j3.call(e, n) && n != "constructor" && t.push(n);
    }
    return t;
  },
  S3 = El,
  h5 = function h5(e) {
    return S3(e) ? O3(e) : E3(e);
  },
  C3 = b1,
  R3 = h5,
  M3 = function M3(e, t) {
    return e && C3(t, R3(t), e);
  },
  T3 = x1,
  P3 = u5,
  k3 = function k3(e) {
    var t = [];
    if (e != null) for (var n in Object(e)) {
      t.push(n);
    }
    return t;
  },
  A3 = Object.prototype.hasOwnProperty,
  B3 = pl,
  H3 = function H3(e) {
    if (!T3(e)) return k3(e);
    var t = P3(e),
      n = [];
    for (var r in e) {
      (r != "constructor" || !t && A3.call(e, r)) && n.push(r);
    }
    return n;
  },
  W3 = El,
  f5 = function f5(e) {
    return W3(e) ? B3(e, !0) : H3(e);
  },
  L3 = b1,
  _3 = f5,
  I3 = function I3(e, t) {
    return e && L3(t, _3(t), e);
  },
  Ct = {
    exports: {}
  };
(function (e, t) {
  var n = we,
    r = t && !t.nodeType && t,
    o = r && e && !e.nodeType && e,
    c = o && o.exports === r ? n.Buffer : void 0,
    d = c ? c.allocUnsafe : void 0;
  e.exports = function (u, h) {
    if (h) return u.slice();
    var s = u.length,
      v = d ? d(s) : new u.constructor(s);
    return u.copy(v), v;
  };
})(Ct, Ct.exports);
var N3 = function N3(e, t) {
    var n = -1,
      r = e.length;
    for (t || (t = Array(r)); ++n < r;) {
      t[n] = e[n];
    }
    return t;
  },
  Sl = function Sl() {
    return [];
  },
  V3 = function V3(e, t) {
    for (var n = -1, r = e == null ? 0 : e.length, o = 0, c = []; ++n < r;) {
      var d = e[n];
      t(d, n, e) && (c[o++] = d);
    }
    return c;
  },
  F3 = Sl,
  D3 = Object.prototype.propertyIsEnumerable,
  cr = Object.getOwnPropertySymbols,
  v5 = cr ? function (e) {
    return e == null ? [] : (e = Object(e), V3(cr(e), function (t) {
      return D3.call(e, t);
    }));
  } : F3,
  $3 = b1,
  q3 = v5,
  U3 = function U3(e, t) {
    return $3(e, q3(e), t);
  },
  m5 = function m5(e, t) {
    for (var n = -1, r = t.length, o = e.length; ++n < r;) {
      e[o + n] = t[n];
    }
    return e;
  },
  g5 = Ol(Object.getPrototypeOf, Object),
  G3 = m5,
  Y3 = g5,
  Q3 = v5,
  X3 = Sl,
  Cl = Object.getOwnPropertySymbols ? function (e) {
    for (var t = []; e;) {
      G3(t, Q3(e)), e = Y3(e);
    }
    return t;
  } : X3,
  K3 = b1,
  J3 = Cl,
  Z3 = function Z3(e, t) {
    return K3(e, J3(e), t);
  },
  e6 = m5,
  t6 = ke,
  Rl = function Rl(e, t, n) {
    var r = t(e);
    return t6(e) ? r : e6(r, n(e));
  },
  n6 = Rl,
  r6 = v5,
  l6 = h5,
  a6 = function a6(e) {
    return n6(e, l6, r6);
  },
  i6 = Rl,
  o6 = Cl,
  c6 = f5,
  Ml = function Ml(e) {
    return i6(e, c6, o6);
  },
  Rt = Be(we, "DataView"),
  Mt = a5,
  Tt = Be(we, "Promise"),
  Pt = Be(we, "Set"),
  kt = Be(we, "WeakMap"),
  Tl = Qe,
  Ke = Zr,
  s6 = Ke(Rt),
  d6 = Ke(Mt),
  u6 = Ke(Tt),
  h6 = Ke(Pt),
  f6 = Ke(kt),
  Re = Tl;
(Rt && Re(new Rt(new ArrayBuffer(1))) != "[object DataView]" || Mt && Re(new Mt()) != "[object Map]" || Tt && Re(Tt.resolve()) != "[object Promise]" || Pt && Re(new Pt()) != "[object Set]" || kt && Re(new kt()) != "[object WeakMap]") && (Re = function Re(e) {
  var t = Tl(e),
    n = t == "[object Object]" ? e.constructor : void 0,
    r = n ? Ke(n) : "";
  if (r) switch (r) {
    case s6:
      return "[object DataView]";
    case d6:
      return "[object Map]";
    case u6:
      return "[object Promise]";
    case h6:
      return "[object Set]";
    case f6:
      return "[object WeakMap]";
  }
  return t;
});
var x5 = Re,
  v6 = Object.prototype.hasOwnProperty,
  m6 = function m6(e) {
    var t = e.length,
      n = new e.constructor(t);
    return t && typeof e[0] == "string" && v6.call(e, "index") && (n.index = e.index, n.input = e.input), n;
  },
  sr = we.Uint8Array,
  b5 = function b5(e) {
    var t = new e.constructor(e.byteLength);
    return new sr(t).set(new sr(e)), t;
  },
  g6 = b5,
  x6 = function x6(e, t) {
    var n = t ? g6(e.buffer) : e.buffer;
    return new e.constructor(n, e.byteOffset, e.byteLength);
  },
  b6 = /\w*$/,
  w6 = function w6(e) {
    var t = new e.constructor(e.source, b6.exec(e));
    return t.lastIndex = e.lastIndex, t;
  },
  dr = je ? je.prototype : void 0,
  ur = dr ? dr.valueOf : void 0,
  y6 = b5,
  j6 = b5,
  z6 = x6,
  p6 = w6,
  O6 = function O6(e) {
    return ur ? Object(ur.call(e)) : {};
  },
  E6 = function E6(e, t) {
    var n = t ? y6(e.buffer) : e.buffer;
    return new e.constructor(n, e.byteOffset, e.length);
  },
  S6 = function S6(e, t, n) {
    var r = e.constructor;
    switch (t) {
      case "[object ArrayBuffer]":
        return j6(e);
      case "[object Boolean]":
      case "[object Date]":
        return new r(+e);
      case "[object DataView]":
        return z6(e, n);
      case "[object Float32Array]":
      case "[object Float64Array]":
      case "[object Int8Array]":
      case "[object Int16Array]":
      case "[object Int32Array]":
      case "[object Uint8Array]":
      case "[object Uint8ClampedArray]":
      case "[object Uint16Array]":
      case "[object Uint32Array]":
        return E6(e, n);
      case "[object Map]":
      case "[object Set]":
        return new r();
      case "[object Number]":
      case "[object String]":
        return new r(e);
      case "[object RegExp]":
        return p6(e);
      case "[object Symbol]":
        return O6(e);
    }
  },
  C6 = x1,
  hr = Object.create,
  R6 = function () {
    function e() {}
    return function (t) {
      if (!C6(t)) return {};
      if (hr) return hr(t);
      e.prototype = t;
      var n = new e();
      return e.prototype = void 0, n;
    };
  }(),
  M6 = g5,
  T6 = u5,
  P6 = function P6(e) {
    return typeof e.constructor != "function" || T6(e) ? {} : R6(M6(e));
  },
  k6 = x5,
  A6 = Ae,
  B6 = function B6(e) {
    return A6(e) && k6(e) == "[object Map]";
  },
  H6 = d5,
  fr = v1.exports,
  vr = fr && fr.isMap,
  W6 = vr ? H6(vr) : B6,
  L6 = x5,
  _6 = Ae,
  I6 = function I6(e) {
    return _6(e) && L6(e) == "[object Set]";
  },
  N6 = d5,
  mr = v1.exports,
  gr = mr && mr.isSet,
  V6 = gr ? N6(gr) : I6,
  F6 = N4,
  D6 = V4,
  $6 = wl,
  q6 = M3,
  U6 = I3,
  G6 = Ct.exports,
  Y6 = N3,
  Q6 = U3,
  X6 = Z3,
  K6 = a6,
  J6 = Ml,
  Z6 = x5,
  ed = m6,
  td = S6,
  nd = P6,
  rd = ke,
  ld = D1.exports,
  ad = W6,
  id = x1,
  od = V6,
  cd = h5,
  sd = f5,
  G = {};
G["[object Arguments]"] = G["[object Array]"] = G["[object ArrayBuffer]"] = G["[object DataView]"] = G["[object Boolean]"] = G["[object Date]"] = G["[object Float32Array]"] = G["[object Float64Array]"] = G["[object Int8Array]"] = G["[object Int16Array]"] = G["[object Int32Array]"] = G["[object Map]"] = G["[object Number]"] = G["[object Object]"] = G["[object RegExp]"] = G["[object Set]"] = G["[object String]"] = G["[object Symbol]"] = G["[object Uint8Array]"] = G["[object Uint8ClampedArray]"] = G["[object Uint16Array]"] = G["[object Uint32Array]"] = !0, G["[object Error]"] = G["[object Function]"] = G["[object WeakMap]"] = !1;
var dd = function e(t, n, r, o, c, d) {
    var u,
      h = 1 & n,
      s = 2 & n,
      v = 4 & n;
    if (r && (u = c ? r(t, o, c, d) : r(t)), u !== void 0) return u;
    if (!id(t)) return t;
    var g = rd(t);
    if (g) {
      if (u = ed(t), !h) return Y6(t, u);
    } else {
      var x = Z6(t),
        w = x == "[object Function]" || x == "[object GeneratorFunction]";
      if (ld(t)) return G6(t, h);
      if (x == "[object Object]" || x == "[object Arguments]" || w && !c) {
        if (u = s || w ? {} : nd(t), !h) return s ? X6(t, U6(u, t)) : Q6(t, q6(u, t));
      } else {
        if (!G[x]) return c ? t : {};
        u = td(t, x, h);
      }
    }
    d || (d = new F6());
    var m = d.get(t);
    if (m) return m;
    d.set(t, u), od(t) ? t.forEach(function (O) {
      u.add(e(O, n, r, O, t, d));
    }) : ad(t) && t.forEach(function (O, y) {
      u.set(y, e(O, n, r, y, t, d));
    });
    var b = g ? void 0 : (v ? s ? J6 : K6 : s ? sd : cd)(t);
    return D6(b || t, function (O, y) {
      b && (O = t[y = O]), $6(u, y, e(O, n, r, y, t, d));
    }), u;
  },
  ud = al,
  hd = function hd(e, t, n) {
    var r = -1,
      o = e.length;
    t < 0 && (t = -t > o ? 0 : o + t), (n = n > o ? o : n) < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;
    for (var c = Array(o); ++r < o;) {
      c[r] = e[r + t];
    }
    return c;
  },
  fd = o5,
  vd = function vd(e) {
    var t = e == null ? 0 : e.length;
    return t ? e[t - 1] : void 0;
  },
  md = function md(e, t) {
    return t.length < 2 ? e : ud(e, hd(t, 0, -1));
  },
  gd = ll,
  xd = function xd(e, t) {
    return t = fd(t, e), (e = md(e, t)) == null || delete e[gd(vd(t))];
  },
  bd = Qe,
  wd = g5,
  yd = Ae,
  jd = Function.prototype,
  zd = Object.prototype,
  Pl = jd.toString,
  pd = zd.hasOwnProperty,
  Od = Pl.call(Object),
  Ed = function Ed(e) {
    if (!yd(e) || bd(e) != "[object Object]") return !1;
    var t = wd(e);
    if (t === null) return !0;
    var n = pd.call(t, "constructor") && t.constructor;
    return typeof n == "function" && n instanceof n && Pl.call(n) == Od;
  },
  Sd = function Sd(e) {
    return Ed(e) ? void 0 : e;
  },
  Cd = jl,
  Rd = ke,
  xr = je ? je.isConcatSpreadable : void 0,
  Md = m5,
  Td = function Td(e) {
    return Rd(e) || Cd(e) || !!(xr && e && e[xr]);
  },
  Pd = function e(t, n, r, o, c) {
    var d = -1,
      u = t.length;
    for (r || (r = Td), c || (c = []); ++d < u;) {
      var h = t[d];
      n > 0 && r(h) ? n > 1 ? e(h, n - 1, r, o, c) : Md(c, h) : o || (c[c.length] = h);
    }
    return c;
  },
  kd = Pd,
  Ad = function Ad(e) {
    return e != null && e.length ? kd(e, 1) : [];
  },
  Bd = function Bd(e, t, n) {
    switch (n.length) {
      case 0:
        return e.call(t);
      case 1:
        return e.call(t, n[0]);
      case 2:
        return e.call(t, n[0], n[1]);
      case 3:
        return e.call(t, n[0], n[1], n[2]);
    }
    return e.apply(t, n);
  },
  br = Math.max,
  Hd = function Hd(e, t, n) {
    return t = br(t === void 0 ? e.length - 1 : t, 0), function () {
      for (var r = arguments, o = -1, c = br(r.length - t, 0), d = Array(c); ++o < c;) {
        d[o] = r[t + o];
      }
      o = -1;
      for (var u = Array(t + 1); ++o < t;) {
        u[o] = r[o];
      }
      return u[t] = n(d), Bd(e, this, u);
    };
  },
  Wd = function Wd(e) {
    return function () {
      return e;
    };
  },
  wr = xl,
  Ld = wr ? function (e, t) {
    return wr(e, "toString", {
      configurable: !0,
      enumerable: !1,
      value: Wd(t),
      writable: !0
    });
  } : function (e) {
    return e;
  },
  _d = Date.now,
  Id = function (e) {
    var t = 0,
      n = 0;
    return function () {
      var r = _d(),
        o = 16 - (r - n);
      if (n = r, o > 0) {
        if (++t >= 800) return arguments[0];
      } else t = 0;
      return e.apply(void 0, arguments);
    };
  }(Ld),
  Nd = Ad,
  Vd = Hd,
  Fd = Id,
  Dd = rl,
  $d = dd,
  qd = xd,
  Ud = o5,
  Gd = b1,
  Yd = Sd,
  Qd = Ml,
  kl = function (e) {
    return Fd(Vd(e, void 0, Nd), e + "");
  }(function (e, t) {
    var n = {};
    if (e == null) return n;
    var r = !1;
    t = Dd(t, function (c) {
      return c = Ud(c, e), r || (r = c.length > 1), c;
    }), Gd(e, Qd(e), n), r && (n = $d(n, 7, Yd));
    for (var o = t.length; o--;) {
      qd(n, t[o]);
    }
    return n;
  }),
  Je = ["beforeFetch", "request", "shouldHideError", "shouldContinueNextApiOnError", "condition"],
  Xd = Je[0],
  Kd = Je[1],
  Jd = Je[2],
  Zd = Je[3],
  Al = Je[4],
  Ze = ["POST", "GET", "PUT", "PATCH", "DELETE"],
  eu = Ze[0],
  tu = Ze[1],
  nu = Ze[2],
  ru = Ze[3],
  lu = Ze[4],
  yr = {
    api: {},
    error: [],
    continueNextApi: !0
  };
(function () {
  var e = h1(_regeneratorRuntime.mark(function t(n) {
    var r, o, c, d, u, h, s, v, g, x;
    return _regeneratorRuntime.wrap(function (w) {
      for (;;) {
        switch (w.prev = w.next) {
          case 0:
            if (r = n.api, o = r === void 0 ? {} : r, c = n.all, d = c === void 0 ? {} : c, u = n.componentsToMap, h = u === void 0 ? {} : u, s = n.helpers, v = s === void 0 ? {} : s, o) {
              w.next = 3;
              break;
            }
            return w.abrupt("return", yr);
          case 3:
            return g = Bl(d), w.next = 6, Object.keys(o).reduce(function () {
              var m = h1(_regeneratorRuntime.mark(function b(O, y) {
                var z, E, p, C, M;
                return _regeneratorRuntime.wrap(function (P) {
                  for (;;) {
                    switch (P.prev = P.next) {
                      case 0:
                        return P.next = 2, O;
                      case 2:
                        if (z = P.sent, E = z.api, !z.continueNextApi) {
                          P.next = 11;
                          break;
                        }
                        return p = W(W({}, g), {}, {
                          api: W(W({}, o), E)
                        }), C = o[y], P.next = 9, iu({
                          apiConfig: C,
                          apiKey: y,
                          allInput: p,
                          componentsToMap: h,
                          allResults: z,
                          helpers: v
                        });
                      case 9:
                        return M = P.sent, P.abrupt("return", M);
                      case 11:
                        return P.abrupt("return", z);
                      case 12:
                      case "end":
                        return P.stop();
                    }
                  }
                }, b);
              }));
              return function (b, O) {
                return m.apply(this, arguments);
              };
            }(), yr);
          case 6:
            return x = w.sent, w.abrupt("return", kl(x, "continueNextApi"));
          case 8:
          case "end":
            return w.stop();
        }
      }
    }, t);
  }));
  return function (t) {
    return e.apply(this, arguments);
  };
})();
var Bl = function Bl(e) {
    return W({
      qs: ol()
    }, e);
  },
  au = function au(e) {
    return new URL(e).origin;
  },
  iu = function () {
    var e = h1(_regeneratorRuntime.mark(function t(n) {
      var r, o, c, d, u, h, s, v, g, x, w, m, b, O, y;
      return _regeneratorRuntime.wrap(function (z) {
        for (;;) {
          switch (z.prev = z.next) {
            case 0:
              if (r = n.apiConfig, o = r === void 0 ? {} : r, c = n.allInput, d = n.helpers, u = o.method, h = o[Kd], s = o.headers, v = o.url, g = o[Xd], x = cu(g, c), z.prev = 4, !ou(u)) {
                z.next = 7;
                break;
              }
              return z.abrupt("return", o);
            case 7:
              if (w = hu({
                headers: s,
                request: h,
                url: v
              }, x, d), m = fu(w, o), b = m.url, O = m.options, !window || !window.mockEnabled || typeof window.fetchMock != "function") {
                z.next = 15;
                break;
              }
              return z.next = 12, window.fetchMock(encodeURI(b), O, au(b), !0);
            case 12:
              z.t0 = z.sent, z.next = 18;
              break;
            case 15:
              return z.next = 17, fetch(encodeURI(b), O);
            case 17:
              z.t0 = z.sent;
            case 18:
              return y = z.t0, z.abrupt("return", jr(W(W({}, n), {}, {
                response: y,
                allInput: x
              })));
            case 22:
              return z.prev = 22, z.t1 = z.catch(4), z.abrupt("return", jr(W(W({}, n), {}, {
                response: z.t1,
                allInput: x
              })));
            case 25:
            case "end":
              return z.stop();
          }
        }
      }, t, null, [[4, 22]]);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
  ou = function ou(e) {
    return Ze.includes(e) === !1;
  },
  cu = function cu(e, t) {
    var n = w5(e, t);
    return u4(n) ? t : W(W({}, t), {}, {
      beforeFetch: n
    });
  },
  w5 = function w5(e, t, n) {
    if (!e) return e;
    var r = Hl(e, t);
    return uu(r, n);
  },
  Hl = function Hl(e, t) {
    if (!e) return "";
    var n = Xe(e).split("{"),
      r = "";
    return n.forEach(function (o, c) {
      var d = su(o, c, t);
      r = "".concat(r).concat(d);
    }), r.replace(du, function (o) {
      return o.replace(/[\\"|\\']/, "");
    });
  },
  su = function su(e, t, n) {
    var r = e.indexOf("}"),
      o = e.substring(0, r),
      c = e.substring(r + 1),
      d = c5(n, o);
    if (d !== void 0) {
      var u = Xe(d);
      return c ? "".concat(u).concat(c) : u;
    }
    var h = e;
    return t >= 1 && (h = "{" + e), h;
  },
  du = /[\\"|\\'](\[)|(\])[\\"|\\']|[\\"|\\']({)|(})[\\"|\\']/g,
  uu = function uu(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    try {
      var n = Xe(e),
        r = bt(Function, xe(Object.keys(t)).concat(["return " + n])),
        o = r.apply(void 0, xe(Object.values(t)));
      return o;
    } catch (c) {
      return e;
    }
  },
  hu = function hu(e, t, n) {
    var r = Bl(t);
    return Object.keys(e).reduce(function (o, c) {
      return W(W({}, o), {}, Ye({}, c, w5(e[c], r, n)));
    }, {});
  },
  fu = function fu(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.request,
      r = e.url,
      o = e.headers,
      c = o === void 0 ? null : o,
      d = JSON.parse(Xe(c)) || {},
      u = t.method,
      h = W(W({}, kl(t, Je, "url")), {}, {
        headers: d
      }),
      s = {
        url: r,
        options: h
      };
    if (!n) return s;
    switch (u) {
      case eu:
      case nu:
      case ru:
        return {
          url: r,
          options: W(W({}, h), {}, {
            body: typeof n == "string" ? n : JSON.stringify(n)
          })
        };
      case lu:
      case tu:
        var v = typeof n == "string" ? n : h4(n);
        return {
          options: h,
          url: "".concat(r, "?").concat(v)
        };
      default:
        return s;
    }
  },
  jr = function () {
    var e = h1(_regeneratorRuntime.mark(function t(n) {
      var r, o, c, d, u, h, s, v, g, x, w, m, b, O;
      return _regeneratorRuntime.wrap(function (y) {
        for (;;) {
          switch (y.prev = y.next) {
            case 0:
              if (r = n.response, o = n.apiConfig, c = n.allInput, d = n.apiKey, u = n.allResults, h = u.api, s = r.ok, v = r.status, g = o[Al], y.prev = 4, typeof s != "boolean" || !v) {
                y.next = 16;
                break;
              }
              return y.next = 8, r.json();
            case 8:
              if (x = y.sent, w = W(W({}, c), {}, {
                api: W(W({}, h), {}, Ye({}, d, W({}, x)))
              }, x), m = vu(g), b = Hl(m, w), !mu({
                ok: s,
                condition: g,
                errKey: m,
                errVal: b,
                status: v
              })) {
                y.next = 15;
                break;
              }
              return O = ut(W(W({}, n), {}, {
                errVal: b,
                status: v,
                allInput: w
              })), y.abrupt("return", O);
            case 15:
              return y.abrupt("return", W(W({}, u), {}, {
                continueNextApi: !0,
                api: W(W({}, h), {}, Ye({}, d, W({}, x)))
              }));
            case 16:
              return y.abrupt("return", ut(W(W({}, n), {}, {
                status: v
              })));
            case 19:
              return y.prev = 19, y.t0 = y.catch(4), y.abrupt("return", ut(W(W({}, n), {}, {
                status: v
              })));
            case 22:
            case "end":
              return y.stop();
          }
        }
      }, t, null, [[4, 19]]);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
  vu = function vu() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      t = e.key;
    return t;
  },
  mu = function mu(e) {
    var t = e.condition,
      n = e.errKey,
      r = e.errVal,
      o = e.status;
    return zr(n) && n === r ? dt(t, o) : zr(n) && dt(t, r) || gu(n) && dt(t, o);
  },
  zr = function zr(e) {
    return e !== void 0;
  },
  gu = function gu(e) {
    return e === void 0;
  },
  dt = function dt(e, t) {
    return (e && t && c5(e, "".concat(t, ".continue"))) !== !0;
  },
  ut = function ut(e) {
    var t = e.status,
      n = e.allResults,
      r = e.apiConfig,
      o = e.errVal,
      c = n.error,
      d = r[Jd],
      u = r[Zd],
      h = r[Al],
      s = u || !1;
    if (d) return W(W({}, n), {}, {
      continueNextApi: s
    });
    var v = h[o] || h[t] || h.default,
      g = xu(W(W({}, e), {}, {
        currentAction: v
      }));
    return W(W({}, n), {}, {
      error: [].concat(xe(c), xe(g)),
      continueNextApi: s
    });
  },
  xu = function xu(e) {
    var t = e.currentAction,
      n = t === void 0 ? {} : t,
      r = e.componentsToMap,
      o = e.allInput,
      c = [];
    if (n) {
      var d = n.redirect,
        u = n.render,
        h = n.message;
      if (d || h) {
        var s = d ? "redirect" : "message";
        c = [Ye({}, s, w5(n[s], o))];
      }
      u && (c = [{
        render: F1(u, r, o)
      }]);
    }
    return c;
  };
ce.object.isRequired, ce.func.isRequired, ce.func.isRequired, ce.func, ce.object, ce.object.isRequired, ce.object;
process.env.NODE_ENV, ".".concat("ss360SearchBox");
var bu = function bu(e) {
    return l.jsx(i.Text, L(R({}, e), {
      type: "bannerTitle"
    }));
  },
  wu = function wu(e) {
    return l.jsx(i.Text, L(R({}, e), {
      type: "pageTitle"
    }));
  },
  yu = function yu(e) {
    return l.jsx(i.Text, L(R({}, e), {
      type: "sectionTitle"
    }));
  },
  ju = function ju(e) {
    return l.jsx(i.Text, L(R({}, e), {
      type: "header"
    }));
  },
  zu = function zu(e) {
    return l.jsx(i.Text, L(R({}, e), {
      type: "boldBody"
    }));
  },
  pu = function pu(e) {
    return l.jsx(i.Text, L(R({}, e), {
      type: "boldBody",
      tag: "span"
    }));
  },
  Ou = function Ou(e) {
    return l.jsx(i.Text, L(R({}, e), {
      type: "body",
      tag: "div"
    }));
  },
  Eu = function Eu(e) {
    return l.jsx(i.Text, L(R({}, e), {
      type: "body"
    }));
  },
  Su = function Su(e) {
    return l.jsx(i.Text, L(R({}, e), {
      type: "link"
    }));
  },
  Cu = function Cu(_ref7) {
    var e = _ref7.children;
    return l.jsx("div", {
      children: A.Children.map(e, function (t, n) {
        return A.isValidElement(t) ? A.createElement(i.BulletList, L(R({}, t.props), {
          key: n
        }), t.props.children) : null;
      })
    });
  },
  Ru = function Ru(e) {
    var t = JSON.parse(e.columns || "{}"),
      n = JSON.parse(e.data || "{}");
    return l.jsx(i.Table, R(R({}, t), n));
  },
  Mu = function Mu(n) {
    var r = n,
      e = r.children,
      t = ee(r, ["children"]);
    return l.jsx(i.NumberedList, L(R({}, t), {
      children: A.Children.map(e, function (o, c) {
        return A.isValidElement(o) ? A.createElement(i.NumberedList.Item, L(R({}, o.props), {
          key: c
        }), o) : null;
      })
    }));
  },
  Tu = {
    h1: bu,
    h2: wu,
    h3: yu,
    h4: ju,
    h5: zu,
    p: Eu,
    div: Ou,
    a: Su,
    ul: Cu,
    ol: Mu,
    b: pu,
    table: Ru
  },
  Pu = function Pu(e) {
    var t = "";
    var n = e.split("\r\n")[0],
      o = new DOMParser().parseFromString(e, "text/html"),
      c = Array.from(o.querySelectorAll("tr")),
      d = o.querySelector("tr");
    var u = Array.from(o.querySelectorAll("th")).map(function (O) {
      return O.textContent;
    });
    var h = d ? Array.from(d.children).map(function (O) {
      return O.textContent;
    }) : [];
    u = u.length > 0 ? u : h;
    var s = c.slice(1).map(function (O) {
        return Array.from(O.querySelectorAll("td")).map(function (y) {
          return y.textContent;
        });
      }),
      g = (d ? Array.from(d.children) : []).map(function (O) {
        var y = O.getAttribute("style");
        if (y && y.includes("text-align")) {
          var z = y.match(/text-align:\s*(left|right|center);?/);
          return z ? z[1] : null;
        }
        return null;
      }),
      x = u.map(function (O, y) {
        var z = g[y];
        return {
          title: O,
          key: "header" + y,
          style: z ? {
            textAlign: z
          } : {}
        };
      }),
      w = s.map(function (O) {
        return Object.assign.apply(Object, [{}].concat(_toConsumableArray(O.map(function (y, z) {
          return _defineProperty({}, "header" + z, y);
        }))));
      }),
      m = "columns='".concat(JSON.stringify({
        columns: x
      }), "'"),
      b = "data='".concat(JSON.stringify({
        data: w
      }), "'");
    return t = n.replace("<table", "<table ".concat(m, " ").concat(b)), t + "</table>";
  },
  ku = function ku(e, t) {
    var n = document.createElement("div");
    n.innerHTML = e, n.querySelectorAll("table").forEach(function (d) {
      d.outerHTML = Pu(d.outerHTML);
    });
    var o = n.querySelector("li");
    return o && o.setAttributeNS(null, "counterIncrement", "".concat(t)), n.innerHTML;
  },
  Au = function Au(_ref9) {
    var e = _ref9.text,
      t = _ref9.incrementCounter,
      _ref9$inverse = _ref9.inverse,
      n = _ref9$inverse === void 0 ? !1 : _ref9$inverse;
    var r = ku(e, t),
      m = {
        h1: function h1(b) {
          return l.jsx(i.Text, L(R({}, b), {
            type: "bannerTitle",
            inverse: !0
          }));
        },
        h2: function h2(b) {
          return l.jsx(i.Text, L(R({}, b), {
            type: "pageTitle",
            inverse: !0
          }));
        },
        h3: function h3(b) {
          return l.jsx(i.Text, L(R({}, b), {
            type: "sectionTitle",
            inverse: !0
          }));
        },
        h4: function h4(b) {
          return l.jsx(i.Text, L(R({}, b), {
            type: "header",
            inverse: !0
          }));
        },
        h5: function h5(b) {
          return l.jsx(i.Text, L(R({}, b), {
            type: "boldBody",
            inverse: !0
          }));
        },
        p: function p(b) {
          return l.jsx(i.Text, L(R({}, b), {
            type: "body",
            inverse: !0
          }));
        },
        div: function div(b) {
          return l.jsx(i.Text, L(R({}, b), {
            type: "body",
            tag: "div",
            inverse: !0
          }));
        },
        a: function a(b) {
          return l.jsx(i.Text, L(R({}, b), {
            type: "link",
            inverse: !0
          }));
        },
        ul: function ul(_ref10) {
          var b = _ref10.children;
          return l.jsx("div", {
            children: A.Children.map(b, function (O, y) {
              return A.isValidElement(O) ? A.createElement(i.BulletList, L(R({}, O.props), {
                key: y,
                inverse: !0
              }), O.props.children) : null;
            })
          });
        },
        b: function b(_b) {
          return l.jsx(i.Text, L(R({}, _b), {
            type: "boldBody",
            tag: "span",
            inverse: !0
          }));
        }
      };
    return l.jsx("div", {
      "data-testid": "RichText",
      children: l.jsx($1, {
        vCompact: !0,
        children: l.jsx(St, {
          htmlString: r,
          componentsToMap: n ? m : Tu
        })
      })
    });
  },
  y5 = q1(Au, {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }),
  ge = {
    right: "right",
    left: "left",
    center: "center"
  };
"".concat(i.theme.main.colours.tertiary.l5).concat(i.theme.main.colours.white);
var Bu = "-",
  C1 = 12,
  Hu = (_Hu = {}, _defineProperty(_Hu, ge.left, "start"), _defineProperty(_Hu, ge.center, "center"), _defineProperty(_Hu, ge.right, "end"), _Hu),
  Wu = function Wu(_ref11) {
    var _l$jsx;
    var _ref11$small = _ref11.small,
      e = _ref11$small === void 0 ? C1 : _ref11$small,
      _ref11$medium = _ref11.medium,
      t = _ref11$medium === void 0 ? C1 : _ref11$medium,
      _ref11$large = _ref11.large,
      n = _ref11$large === void 0 ? C1 : _ref11$large,
      _ref11$alignment = _ref11.alignment,
      r = _ref11$alignment === void 0 ? ge.left : _ref11$alignment,
      _ref11$isFluid = _ref11.isFluid,
      o = _ref11$isFluid === void 0 ? !1 : _ref11$isFluid,
      c = _ref11.children;
    var _i$useDevice4 = i.useDevice(),
      d = _i$useDevice4.isMobile,
      u = _i$useDevice4.isTablet,
      h = A.Children.toArray(c),
      g = function (x) {
        var b = new RegExp(/^([1-9]|1[012])((-([1-9]|1[012]))+)?$/).test(x) ? x.split(Bu) : [C1];
        return h.map(function (y, z) {
          var E = z % b.length;
          return {
            data: y,
            size: Number(b[E])
          };
        });
      }("".concat(d ? e : u ? t : n));
    return l.jsx("div", {
      "data-testid": "ColumnController",
      children: l.jsx(i.Grid, {
        fluid: o,
        children: l.jsx(i.Row, (_l$jsx = {
          "data-testid": "ColumnControllerRow"
        }, _defineProperty(_l$jsx, Hu[r], "xs"), _defineProperty(_l$jsx, "children", g.map(function (x, w) {
          return l.jsx(i.Column, {
            xs: x.size,
            children: x.data
          }, w);
        })), _l$jsx))
      })
    });
  },
  Lu = B.createGlobalStyle(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  body {\n    height: 100vh;\n    overflow-y: hidden;\n  }\n"]))),
  _u = j.default.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  position: fixed;\n  display: block;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 99999;\n"]))),
  Iu = j.default(i.Grid)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  height: 100vh;\n"]))),
  Nu = j.default(i.Row)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"]))),
  Wl = function Wl(_ref12) {
    var e = _ref12.onClose,
      t = _ref12.children;
    var n = A.useRef(null);
    A.useEffect(function () {
      var o = function o(c) {
        c.key === "Escape" && e();
      };
      return document.addEventListener("keydown", o), function () {
        document.removeEventListener("keydown", o);
      };
    }, []);
    var r = function r(o) {
      var c;
      n != null && n.current && !((c = n == null ? void 0 : n.current) != null && c.contains(o.target)) && e();
    };
    return l.jsxs(_u, {
      onClick: r,
      children: [l.jsx(Lu, {}), l.jsx(Iu, {
        children: l.jsx(Nu, {
          center: "xs",
          children: l.jsx(i.Column, {
            xs: 12,
            noGutter: !0,
            children: a.default.cloneElement(t, {
              ref: n
            })
          })
        })
      })]
    });
  },
  Vu = j.default.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"]))),
  Fu = function Fu(_ref13) {
    var e = _ref13.type,
      t = _ref13.label,
      n = _ref13.url,
      r = _ref13.target,
      _ref13$inverse = _ref13.inverse,
      o = _ref13$inverse === void 0 ? !1 : _ref13$inverse;
    var _A$useState5 = A.useState(!1),
      _A$useState6 = _slicedToArray(_A$useState5, 2),
      c = _A$useState6[0],
      d = _A$useState6[1],
      u = l.jsx("iframe", {
        "data-testid": "SingtelIframe",
        src: n,
        style: {
          border: 0,
          width: "100%",
          height: "90vh"
        },
        frameBorder: 0,
        allowFullScreen: !0
      }),
      h = function h() {
        r === "iframe" ? d(!0) : window.open(n, r);
      };
    return l.jsxs($1, {
      vCompact: !0,
      children: [l.jsx(Vu, {
        children: l.jsx(i.Button, {
          "data-testid": "SingtelButton",
          secondary: e === "secondary",
          text: t,
          onClick: h,
          inverse: o
        })
      }), c && Nr.createPortal(l.jsx(Wl, {
        onClose: function onClose() {
          return d(!1);
        },
        children: u
      }), document.body)]
    });
  };
function At() {
  return At = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, At.apply(this, arguments);
}
var Ll = function Ll(e) {
  return a.createElement("svg", At({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M12.75 11.25H16c.41 0 .75.34.75.75s-.34.75-.75.75h-3.25V16c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3.25H8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.25V8c0-.41.34-.75.75-.75s.75.34.75.75z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1 12C1 5.93 5.93 1 12 1s11 4.93 11 11-4.93 11-11 11S1 18.07 1 12m1.5 0c0 5.24 4.26 9.5 9.5 9.5s9.5-4.26 9.5-9.5-4.26-9.5-9.5-9.5S2.5 6.76 2.5 12",
    clipRule: "evenodd"
  }));
};
Ll.displayName = "AddGeneric";
function Bt() {
  return Bt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Bt.apply(this, arguments);
}
var _l = function _l(e) {
  return a.createElement("svg", Bt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M3.5 7.32A3.825 3.825 0 0 1 7.32 3.5h9.03a.75.75 0 0 0 0-1.5H7.32A5.325 5.325 0 0 0 2 7.32v9.03a.75.75 0 0 0 1.5 0zM8.33 6.1c-1.234 0-2.23.996-2.23 2.23V19.2c0 1.234.996 2.23 2.23 2.23H19.2c1.234 0 2.23-.996 2.23-2.23V8.33c0-1.234-.996-2.23-2.23-2.23zM7.6 8.33c0-.406.324-.73.73-.73H19.2c.406 0 .73.324.73.73V19.2c0 .406-.324.73-.73.73H8.33a.727.727 0 0 1-.73-.73zm6.22 1.53a.75.75 0 0 1 .75.75v2.46h2.46a.75.75 0 0 1 0 1.5h-2.46v2.46a.75.75 0 0 1-1.5 0v-2.46h-2.46a.75.75 0 1 1 0-1.5h2.46v-2.46a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  }));
};
_l.displayName = "AddonProduct";
function Ht() {
  return Ht = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Ht.apply(this, arguments);
}
var Il = function Il(e) {
  return a.createElement("svg", Ht({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    fill: e.color || "#222222",
    clipPath: "url(#a)"
  }, a.createElement("path", {
    d: "M18.64 3.74c-.09 0-.19-.02-.28-.06l-.01.01a.746.746 0 0 1-.41-.98l.36-.87c.16-.39.6-.57.98-.41.39.16.57.6.41.98l-.36.87c-.12.29-.4.46-.69.46"
  }), a.createElement("path", {
    fillRule: "evenodd",
    d: "M14.85 1.85c.5.04.94.33 1.17.78l.02-.01 4.81 9.41c.24.46.21.99-.06 1.43-.28.44-.75.71-1.27.68-1.46-.04-4.05.07-6.48.99l3.05 3.63c.86 1.04.79 2.53-.16 3.48-.49.49-1.14.76-1.83.76s-1.34-.27-1.83-.76l-4.49-4.49-1.37.7c-.31.15-.63.23-.96.23-.22 0-.44-.03-.65-.1a2.08 2.08 0 0 1-1.23-1.04l-2.24-4.38c-.26-.5-.3-1.06-.13-1.6s.54-.97 1.04-1.23l5.51-2.82.02-.011c.286-.158 3.526-1.941 5.8-5.059.3-.41.78-.63 1.28-.59M5.26 17.16c.15.05.32.03.46-.04l4.84-2.48-2.79-5.46-4.84 2.48a.6.6 0 0 0-.3.35c-.05.15-.03.32.04.46l2.24 4.39c.07.14.2.25.35.3m8.06 4.02c.41.41 1.12.41 1.53 0 .4-.4.43-1.03.07-1.46l-3.31-3.94-2.44 1.25zM9.08 8.47l2.83 5.52c2.84-1.24 5.95-1.38 7.63-1.34l-4.83-9.28c-1.93 2.66-4.46 4.39-5.63 5.1",
    clipRule: "evenodd"
  }), a.createElement("path", {
    d: "m22.3 8.05-.92-.07a.756.756 0 0 0-.8.69c-.03.41.28.77.69.8l.92.07h.06c.39 0 .72-.3.75-.69a.75.75 0 0 0-.69-.8zM20.09 6.55c-.27 0-.54-.15-.67-.41a.76.76 0 0 1 .33-1.01l1.78-.91c.37-.18.82-.04 1.01.33.18.37.04.82-.33 1.01l-1.78.91c-.11.05-.22.08-.34.08"
  })), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
Il.displayName = "Announcement";
function Wt() {
  return Wt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Wt.apply(this, arguments);
}
var Nl = function Nl(e) {
  return a.createElement("svg", Wt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M9.28 22.79a6.86 6.86 0 0 1-4.88-2.03 6.86 6.86 0 0 1-2.01-4.88c0-1.84.73-3.57 2.03-4.86l8.35-8.3c.98-.97 2.28-1.51 3.66-1.51h.01c1.38 0 2.69.55 3.66 1.53 2.02 2.03 2.01 5.32-.02 7.33l-7.66 7.62c-.66.65-1.53 1.01-2.45 1.01a3.486 3.486 0 0 1-2.45-5.95l5.22-5.19c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-5.22 5.19c-.77.77-.78 2.03 0 2.8.37.38.87.58 1.4.58s1.02-.21 1.4-.58l7.66-7.62a3.68 3.68 0 0 0 .01-5.21 3.68 3.68 0 0 0-2.6-1.09c-.98 0-1.9.38-2.6 1.07l-8.37 8.32a5.4 5.4 0 0 0-1.59 3.81c0 1.44.55 2.79 1.57 3.81a5.387 5.387 0 0 0 7.62.02l5.93-5.9c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-5.93 5.9c-1.34 1.33-3.1 2-4.86 2z"
  }));
};
Nl.displayName = "Attachment";
function Lt() {
  return Lt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Lt.apply(this, arguments);
}
var Vl = function Vl(e) {
  return a.createElement("svg", Lt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M12 14c-.41 0-.75-.34-.75-.75v-6c0-.41.34-.75.75-.75s.75.34.75.75v6c0 .41-.34.75-.75.75M12 18.04a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5",
    clipRule: "evenodd"
  }));
};
Vl.displayName = "Attention";
function _t() {
  return _t = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, _t.apply(this, arguments);
}
var Fl = function Fl(e) {
  return a.createElement("svg", _t({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M5.75 4a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 .75.75v16.106l-1.17-.772a.75.75 0 0 0-.827 0l-1.92 1.267-1.92-1.267a.75.75 0 0 0-.826 0L9.667 20.6l-1.92-1.267a.75.75 0 0 0-.827 0l-1.17.772zm.75-2.25A2.25 2.25 0 0 0 4.25 4v17.5a.75.75 0 0 0 1.163.626l1.92-1.268 1.92 1.268a.75.75 0 0 0 .827 0L12 20.858l1.92 1.268a.75.75 0 0 0 .827 0l1.92-1.268 1.92 1.268a.75.75 0 0 0 1.163-.626V4a2.25 2.25 0 0 0-2.25-2.25zm4.863 7.055c-.235.046-.378.118-.463.198a.52.52 0 0 0-.09.602c.16.261.528.432 1.17.612l.616.17.018.006c.558.17 1.397.468 1.857 1.225.49.81.307 1.84-.333 2.458l-.003.003c-.37.353-.822.512-1.214.589l-.171.029V15a.75.75 0 0 1-1.5 0v-.31a2.76 2.76 0 0 1-1.106-.484 2.16 2.16 0 0 1-.89-1.726.75.75 0 0 1 1.5-.021.66.66 0 0 0 .289.546c.2.15.492.245.8.245.286 0 .553-.008.79-.055.236-.046.379-.118.464-.198a.505.505 0 0 0 .091-.6c-.136-.225-.444-.396-1.002-.566l-.607-.169h-.003c-.576-.162-1.542-.446-2.05-1.28l-.001-.003c-.479-.795-.31-1.832.334-2.455l.003-.004c.37-.352.822-.511 1.214-.588l.174-.03V7a.75.75 0 0 1 1.5 0v.31c.393.08.776.239 1.103.484.508.38.879.97.89 1.725a.75.75 0 0 1-1.5.022.66.66 0 0 0-.289-.546c-.2-.15-.492-.245-.8-.245-.286 0-.553.008-.79.055",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M5.75 4a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 .75.75v16.106l-1.17-.772a.75.75 0 0 0-.827 0l-1.92 1.267-1.92-1.267a.75.75 0 0 0-.826 0L9.667 20.6l-1.92-1.267a.75.75 0 0 0-.827 0l-1.17.772zm.75-2.25A2.25 2.25 0 0 0 4.25 4v17.5a.75.75 0 0 0 1.163.626l1.92-1.268 1.92 1.268a.75.75 0 0 0 .827 0L12 20.858l1.92 1.268a.75.75 0 0 0 .827 0l1.92-1.268 1.92 1.268a.75.75 0 0 0 1.163-.626V4a2.25 2.25 0 0 0-2.25-2.25zm4.863 7.055c-.235.046-.378.118-.463.198a.52.52 0 0 0-.09.602c.16.261.528.432 1.17.612l.616.17.018.006c.558.17 1.397.468 1.857 1.225.49.81.307 1.84-.333 2.458l-.003.003c-.37.353-.822.512-1.214.589l-.171.029V15a.75.75 0 0 1-1.5 0v-.31a2.76 2.76 0 0 1-1.106-.484 2.16 2.16 0 0 1-.89-1.726.75.75 0 0 1 1.5-.021.66.66 0 0 0 .289.546c.2.15.492.245.8.245.286 0 .553-.008.79-.055.236-.046.379-.118.464-.198a.505.505 0 0 0 .091-.6c-.136-.225-.444-.396-1.002-.566l-.607-.169h-.003c-.576-.162-1.542-.446-2.05-1.28l-.001-.003c-.479-.795-.31-1.832.334-2.455l.003-.004c.37-.352.822-.511 1.214-.588l.174-.03V7a.75.75 0 0 1 1.5 0v.31c.393.08.776.239 1.103.484.508.38.879.97.89 1.725a.75.75 0 0 1-1.5.022.66.66 0 0 0-.289-.546c-.2-.15-.492-.245-.8-.245-.286 0-.553.008-.79.055",
    clipRule: "evenodd"
  }));
};
Fl.displayName = "Bills";
function It() {
  return It = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, It.apply(this, arguments);
}
var Dl = function Dl(e) {
  return a.createElement("svg", It({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    clipPath: "url(#a)"
  }, a.createElement("path", {
    fill: e.color || "#222222",
    d: "M5.41 22.71c-.21 0-.41-.05-.6-.17-.36-.21-.58-.59-.58-1.01V4.22c0-1.62 1.32-2.93 2.93-2.93h9.66c1.62 0 2.93 1.32 2.93 2.93V21.5c0 .42-.22.8-.58 1.01s-.8.22-1.17.02l-5.61-3.08a.83.83 0 0 0-.81 0l-5.61 3.11c-.18.1-.38.15-.57.15zM7.17 2.79c-.79 0-1.43.64-1.43 1.43v16.76l5.14-2.84c.71-.39 1.55-.39 2.26 0l5.13 2.82V4.22c0-.79-.64-1.43-1.43-1.43z"
  })), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
Dl.displayName = "Bookmark";
function Nt() {
  return Nt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Nt.apply(this, arguments);
}
var $l = function $l(e) {
  return a.createElement("svg", Nt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M13.685 5.64h.005-.01zM14.25 5.38a.76.76 0 0 1-.565.26.76.76 0 0 1-.485-.18c-1.51-1.29-3.43-2-5.41-2s-3.86.7-5.35 1.96c-.32.27-.79.23-1.06-.09a.75.75 0 0 1 .09-1.06 9.82 9.82 0 0 1 6.32-2.31c2.31 0 4.61.84 6.38 2.36.31.27.35.74.08 1.06"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M11.46 7.84c.14.13.33.2.51.2h.01c.2 0 .4-.08.55-.24.28-.3.26-.78-.04-1.06A6.92 6.92 0 0 0 7.8 4.89c-1.72 0-3.37.64-4.64 1.8-.31.28-.33.75-.05 1.06s.76.33 1.06.05c.99-.91 2.25-1.41 3.62-1.41s2.67.52 3.67 1.45"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M10.22 10.44c-.21 0-.42-.09-.57-.26-.92-1.08-2.74-1.09-3.68-.04-.28.31-.75.34-1.06.06a.747.747 0 0 1-.06-1.06A3.95 3.95 0 0 1 7.8 7.82c1.13 0 2.25.5 3 1.38.27.32.23.79-.08 1.06-.14.12-.31.18-.49.18zM16.37 14.1h-1.31c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.31v-1.31c0-.41.34-.75.75-.75s.75.34.75.75v1.31h1.32c.41 0 .75.34.75.75s-.34.75-.75.75h-1.32v1.32c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M8.54 11.7v1.19h2.93a5.673 5.673 0 0 1 5.65-5.2 5.67 5.67 0 0 1 5.666 5.876l.004.074v7.66c0 .41-.34.75-.75.75H1.97c-.41 0-.75-.34-.75-.75v-7.66c0-.41.34-.75.75-.75h5.07V11.7c0-.41.34-.75.75-.75s.75.34.75.75m12.75 5.5a5.66 5.66 0 0 1-4.17 1.83 5.674 5.674 0 0 1-5.577-4.64H2.72v6.16h18.57zm-8.34-3.84c0-2.3 1.87-4.17 4.17-4.17s4.17 1.87 4.17 4.17-1.87 4.17-4.17 4.17-4.17-1.87-4.17-4.17",
    clipRule: "evenodd"
  }));
};
$l.displayName = "BroadbandAddon";
function Vt() {
  return Vt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Vt.apply(this, arguments);
}
var ql = function ql(e) {
  return a.createElement("svg", Vt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M13.69 5.64h-.005a.76.76 0 0 0 .565-.26c.27-.32.23-.79-.08-1.06a9.87 9.87 0 0 0-6.38-2.36c-2.31 0-4.55.82-6.32 2.31-.32.27-.36.74-.09 1.06s.75.36 1.06.09a8.26 8.26 0 0 1 5.35-1.96c1.98 0 3.9.71 5.41 2a.76.76 0 0 0 .485.18h-.005z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M11.97 8.04c-.18 0-.37-.07-.51-.2-1-.93-2.3-1.45-3.67-1.45s-2.63.5-3.62 1.41c-.3.28-.78.26-1.06-.05a.746.746 0 0 1 .05-1.06 6.87 6.87 0 0 1 4.64-1.8c1.72 0 3.41.66 4.69 1.85.3.28.32.76.04 1.06-.15.16-.35.24-.55.24z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M9.65 10.18c.15.17.36.26.57.26h.01c.18 0 .35-.06.49-.18.31-.27.35-.74.08-1.06a3.97 3.97 0 0 0-3-1.38c-1.13 0-2.2.48-2.95 1.32-.28.31-.25.78.06 1.06s.78.25 1.06-.06c.94-1.05 2.76-1.04 3.68.04M14.52 18.49a1 1 0 1 0 0-2 1 1 0 0 0 0 2M19.11 17.49a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M8.54 12.89V11.7c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.19H2.97c-.96 0-1.75.79-1.75 1.75v5.66c0 .96.79 1.75 1.75 1.75h18.07c.96 0 1.75-.79 1.75-1.75v-5.66c0-.96-.79-1.75-1.75-1.75zm-5.82 1.74c0-.14.11-.25.25-.25h18.07c.14 0 .25.11.25.25v5.66c0 .14-.11.25-.25.25H2.97c-.14 0-.25-.11-.25-.25z",
    clipRule: "evenodd"
  }));
};
ql.displayName = "Broadband";
function Ft() {
  return Ft = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Ft.apply(this, arguments);
}
var Ul = function Ul(e) {
  return a.createElement("svg", Ft({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    d: "M14.004 21.187a.75.75 0 0 1 0 1.5H9.996a.75.75 0 0 1 0-1.5zM12 1.313a7.64 7.64 0 0 1 4.87 13.528c-.434.358-.675.806-.675 1.234v2.506c0 .896-.726 1.623-1.623 1.623H9.43a1.623 1.623 0 0 1-1.623-1.623v-2.506c0-.428-.243-.876-.675-1.234A7.64 7.64 0 0 1 12 1.314M9.306 18.581c0 .068.055.123.123.123h5.143a.123.123 0 0 0 .123-.123v-1.025h-5.39zM12 2.813a6.14 6.14 0 0 0-3.912 10.872c.663.55 1.21 1.38 1.217 2.37h5.391c.007-.99.554-1.82 1.217-2.37A6.14 6.14 0 0 0 12 2.813m.23 1.43A4.667 4.667 0 0 1 16.665 8.9a.75.75 0 0 1-1.5 0 3.165 3.165 0 0 0-3.01-3.16L12 5.735l-.077-.004A.75.75 0 0 1 12 4.236z"
  }));
};
Ul.displayName = "Bulb";
function Dt() {
  return Dt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Dt.apply(this, arguments);
}
var Gl = function Gl(e) {
  return a.createElement("svg", Dt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M6.65 14.39a1 1 0 1 0 0-2 1 1 0 0 0 0 2M13 13.39a1 1 0 1 1-2 0 1 1 0 0 1 2 0M17.35 14.39a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7.65 18.18a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12 19.18a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18.35 18.18a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M15.25 3.01H8.7v-.89c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.89H4.02c-1.52 0-2.75 1.23-2.75 2.75v14.12c0 1.52 1.23 2.75 2.75 2.75h15.92c1.52 0 2.75-1.23 2.75-2.75V5.76c0-1.52-1.23-2.75-2.75-2.75h-3.19v-.89c0-.41-.34-.75-.75-.75s-.75.34-.75.75zm-7.3 3.34c-.41 0-.75-.34-.75-.75V4.51H4.02c-.69 0-1.25.56-1.25 1.25v2.73h18.42V5.76c0-.69-.56-1.25-1.25-1.25h-3.19V5.6c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.51H8.7V5.6c0 .41-.34.75-.75.75M2.77 9.99h18.42v9.89c0 .69-.56 1.25-1.25 1.25H4.02c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  }));
};
Gl.displayName = "Calendar";
function $t() {
  return $t = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, $t.apply(this, arguments);
}
var Yl = function Yl(e) {
  return a.createElement("svg", $t({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    clipPath: "url(#a)"
  }, a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M16.47 14.79c-4 0-7.25-3.25-7.25-7.25S12.47.29 16.47.29s7.25 3.25 7.25 7.25-3.25 7.25-7.25 7.25m0-13c-3.17 0-5.75 2.58-5.75 5.75s2.58 5.75 5.75 5.75 5.75-2.58 5.75-5.75-2.58-5.75-5.75-5.75m-.46 21.92c-.06 0-.13 0-.19-.01-1.84-.21-3.57-.64-5.14-1.28h-.01l-.88-.37.02-.02c-4.13-1.96-6.46-5.16-7.75-7.82l-.02.02-.37-.88v-.01A18.6 18.6 0 0 1 .31 8.16c-.05-.47.1-.94.42-1.29.33-.36.8-.57 1.29-.57h1.19c.8 0 1.5.54 1.7 1.32l.65 2.61c.17.68-.08 1.39-.63 1.81L3.3 13.28c1.17 2.54 3.38 5.68 7.44 7.52l1.25-1.67c.42-.57 1.14-.82 1.83-.65l2.6.65c.78.2 1.33.89 1.33 1.7v1.15c0 .5-.21.97-.58 1.3-.31.28-.72.43-1.13.43zm-3.85-2.34c1.19.4 2.47.68 3.82.83.06 0 .11 0 .15-.05.03-.03.08-.08.08-.18v-1.15c0-.11-.08-.21-.19-.24l-2.6-.65c-.1-.02-.2.01-.26.09zM2 7.79c-.07 0-.13.03-.17.07-.044.044-.042.096-.04.121v.01c.1.92.34 2.279.9 3.849l1.3-1c.08-.06.11-.16.09-.26l-.65-2.61a.255.255 0 0 0-.24-.19H2zm13.97 1h3c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.25V5.04c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3c0 .41.34.75.75.75",
    clipRule: "evenodd"
  })), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
Yl.displayName = "CallBack";
function qt() {
  return qt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, qt.apply(this, arguments);
}
var Ql = function Ql(e) {
  return a.createElement("svg", qt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M6.91 12.95c0 2.81 2.28 5.09 5.09 5.09s5.09-2.28 5.09-5.09S14.81 7.86 12 7.86s-5.09 2.28-5.09 5.09m1.5 0c0-1.98 1.61-3.59 3.59-3.59s3.59 1.61 3.59 3.59-1.61 3.59-3.59 3.59-3.59-1.61-3.59-3.59",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M4.05 21.41h15.9l.01.01c1.5 0 2.72-1.22 2.72-2.72V8.58c0-1.44-1.17-2.61-2.61-2.61h-2.3l-1.62-2.44c-.38-.58-1.03-.93-1.72-.93H9.37c-.69 0-1.33.34-1.71.92L6.04 5.96h-2.1c-1.44 0-2.61 1.17-2.61 2.61v10.12c0 1.5 1.22 2.72 2.72 2.72M2.83 8.57c0-.61.5-1.11 1.11-1.11l-.01.01h2.21c.44 0 .84-.22 1.08-.58L8.9 4.35c.1-.16.27-.25.46-.25h5.06c.18 0 .36.09.46.25l1.68 2.52c.24.37.65.59 1.09.59h2.41c.61 0 1.11.5 1.11 1.11v10.12c0 .67-.55 1.22-1.22 1.22H4.05c-.67 0-1.22-.55-1.22-1.22z",
    clipRule: "evenodd"
  }));
};
Ql.displayName = "Camera";
function Ut() {
  return Ut = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Ut.apply(this, arguments);
}
var Xl = function Xl(e) {
  return a.createElement("svg", Ut({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1.25 4A.75.75 0 0 1 2 3.25h2.594a1.75 1.75 0 0 1 1.685 1.28l.405 1.447H20c.966 0 1.75.784 1.75 1.75v3.065a1.75 1.75 0 0 1-1.457 1.725l-11.248 1.91.179.64a.25.25 0 0 0 .24.183H21a.75.75 0 0 1 0 1.5H9.465a1.75 1.75 0 0 1-1.686-1.28L4.835 4.934a.25.25 0 0 0-.24-.183H1.999A.75.75 0 0 1 1.25 4m7.39 8.974 11.402-1.936a.25.25 0 0 0 .208-.246V7.727a.25.25 0 0 0-.25-.25H7.103zM11 19.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m8.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M1.25 4A.75.75 0 0 1 2 3.25h2.594a1.75 1.75 0 0 1 1.685 1.28l.405 1.447H20c.966 0 1.75.784 1.75 1.75v3.065a1.75 1.75 0 0 1-1.457 1.725l-11.248 1.91.179.64a.25.25 0 0 0 .24.183H21a.75.75 0 0 1 0 1.5H9.465a1.75 1.75 0 0 1-1.686-1.28L4.835 4.934a.25.25 0 0 0-.24-.183H1.999A.75.75 0 0 1 1.25 4m7.39 8.974 11.402-1.936a.25.25 0 0 0 .208-.246V7.727a.25.25 0 0 0-.25-.25H7.103zM11 19.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m8.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  }));
};
Xl.displayName = "Cart";
function Gt() {
  return Gt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Gt.apply(this, arguments);
}
var Kl = function Kl(e) {
  return a.createElement("svg", Gt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M15.248 5.977H6.684L6.28 4.53A1.75 1.75 0 0 0 4.595 3.25H2a.75.75 0 0 0 0 1.5h2.594a.25.25 0 0 1 .24.183L7.78 15.47c.212.756.9 1.279 1.686 1.279H21a.75.75 0 0 0 0-1.5H9.465a.25.25 0 0 1-.241-.183l-.18-.64 11.249-1.91a1.75 1.75 0 0 0 1.457-1.725V8.398a4.5 4.5 0 0 1-1.5.54v1.854a.25.25 0 0 1-.208.246L8.639 12.974 7.103 7.477h9.023a4.5 4.5 0 0 1-.878-1.5M11 19.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m10 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M15.248 5.977H6.684L6.28 4.53A1.75 1.75 0 0 0 4.595 3.25H2a.75.75 0 0 0 0 1.5h2.594a.25.25 0 0 1 .24.183L7.78 15.47c.212.756.9 1.279 1.686 1.279H21a.75.75 0 0 0 0-1.5H9.465a.25.25 0 0 1-.241-.183l-.18-.64 11.249-1.91a1.75 1.75 0 0 0 1.457-1.725V8.398a4.5 4.5 0 0 1-1.5.54v1.854a.25.25 0 0 1-.208.246L8.639 12.974 7.103 7.477h9.023a4.5 4.5 0 0 1-.878-1.5M11 19.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m10 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.activeDotColor || "#E71336",
    d: "M19.5 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  }));
};
Kl.displayName = "CartActive";
function Yt() {
  return Yt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Yt.apply(this, arguments);
}
var Jl = function Jl(e) {
  return a.createElement("svg", Yt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M11.65 3.647V2.09c0-.41.34-.75.75-.75s.75.34.75.75v1.596c2.354.282 4.624 1.865 4.66 4.574 0 .41-.33.75-.74.76-.41 0-.74-.33-.75-.74-.03-2.04-2.04-3.14-3.92-3.14-1.54 0-3.08.12-3.97.97-.79.76-.98 2.03-.42 2.95.69 1.15 2.18 1.65 3.64 2.07l1.57.43c1.52.46 3.18 1.12 4.08 2.61.9 1.51.61 3.58-.67 4.81-.966.926-2.318 1.235-3.48 1.338v1.592c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.54h-.05c-2.6 0-5.38-1.62-5.42-4.62 0-.41.33-.75.74-.76.44-.02.75.33.76.74.03 2.04 2.04 3.14 3.92 3.14 1.54 0 3.08-.12 3.97-.97.79-.76.98-2.03.42-2.95-.63-1.05-1.91-1.55-3.2-1.94l-1.56-.43c-1.68-.48-3.55-1.12-4.52-2.74-.9-1.51-.61-3.58.67-4.81 1.196-1.147 2.984-1.347 4.27-1.383",
    clipRule: "evenodd"
  }));
};
Jl.displayName = "Cash";
function Qt() {
  return Qt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Qt.apply(this, arguments);
}
var Zl = function Zl(e) {
  return a.createElement("svg", Qt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M4.5 2.25A2.25 2.25 0 0 0 2.25 4.5v4a2.25 2.25 0 0 0 2.25 2.25h4a2.25 2.25 0 0 0 2.25-2.25v-4A2.25 2.25 0 0 0 8.5 2.25zM3.75 4.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75zm.75 8.75a2.25 2.25 0 0 0-2.25 2.25v4a2.25 2.25 0 0 0 2.25 2.25h4a2.25 2.25 0 0 0 2.25-2.25v-4a2.25 2.25 0 0 0-2.25-2.25zm-.75 2.25a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75zm9.5 0a2.25 2.25 0 0 1 2.25-2.25h4a2.25 2.25 0 0 1 2.25 2.25v4a2.25 2.25 0 0 1-2.25 2.25h-4a2.25 2.25 0 0 1-2.25-2.25zm2.25-.75a.75.75 0 0 0-.75.75v4c0 .414.336.75.75.75h4a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-.75-.75zm0-12.5a2.25 2.25 0 0 0-2.25 2.25v4a2.25 2.25 0 0 0 2.25 2.25h4a2.25 2.25 0 0 0 2.25-2.25v-4a2.25 2.25 0 0 0-2.25-2.25zm-.75 2.25a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M4.5 2.25A2.25 2.25 0 0 0 2.25 4.5v4a2.25 2.25 0 0 0 2.25 2.25h4a2.25 2.25 0 0 0 2.25-2.25v-4A2.25 2.25 0 0 0 8.5 2.25zM3.75 4.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75zm.75 8.75a2.25 2.25 0 0 0-2.25 2.25v4a2.25 2.25 0 0 0 2.25 2.25h4a2.25 2.25 0 0 0 2.25-2.25v-4a2.25 2.25 0 0 0-2.25-2.25zm-.75 2.25a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75zm9.5 0a2.25 2.25 0 0 1 2.25-2.25h4a2.25 2.25 0 0 1 2.25 2.25v4a2.25 2.25 0 0 1-2.25 2.25h-4a2.25 2.25 0 0 1-2.25-2.25zm2.25-.75a.75.75 0 0 0-.75.75v4c0 .414.336.75.75.75h4a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-.75-.75zm0-12.5a2.25 2.25 0 0 0-2.25 2.25v4a2.25 2.25 0 0 0 2.25 2.25h4a2.25 2.25 0 0 0 2.25-2.25v-4a2.25 2.25 0 0 0-2.25-2.25zm-.75 2.25a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75z",
    clipRule: "evenodd"
  }));
};
Zl.displayName = "Category";
function Xt() {
  return Xt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Xt.apply(this, arguments);
}
var ea = function ea(e) {
  return a.createElement("svg", Xt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M3.923 2.8a.25.25 0 0 0-.346.31L5.69 8.848a.25.25 0 0 0 .403.099l3.322-3.02a.25.25 0 0 0-.057-.409zM2.17 3.63C1.621 2.14 3.176.749 4.594 1.459l5.436 2.718a1.75 1.75 0 0 1 .395 2.86l-3.322 3.02a1.75 1.75 0 0 1-2.82-.69z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M3.923 2.8a.25.25 0 0 0-.346.31L5.69 8.848a.25.25 0 0 0 .403.099l3.322-3.02a.25.25 0 0 0-.057-.409zM2.17 3.63C1.621 2.14 3.176.749 4.594 1.459l5.436 2.718a1.75 1.75 0 0 1 .395 2.86l-3.322 3.02a1.75 1.75 0 0 1-2.82-.69z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M22.174 1.671a.75.75 0 1 0-1.348.658l.5 1.025a.75.75 0 1 0 1.348-.657z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    d: "M22.174 1.671a.75.75 0 1 0-1.348.658l.5 1.025a.75.75 0 1 0 1.348-.657z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M10.537 2.524a.75.75 0 0 0-1.074-1.048l-1 1.026A.75.75 0 1 0 9.537 3.55z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    d: "M10.537 2.524a.75.75 0 0 0-1.074-1.048l-1 1.026A.75.75 0 1 0 9.537 3.55z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M18.592 4.513a.75.75 0 0 0-1.183-.923l-.404.518A9.7 9.7 0 0 0 13 3.25c-1.584 0-3.08.378-4.403 1.049l1.098.548a1 1 0 0 1 .432.417A8.2 8.2 0 0 1 13 4.75c1.077 0 2.107.207 3.05.582l-.641.822a.75.75 0 0 0 1.182.923l.82-1.05a8.25 8.25 0 1 1-11.95 3.62 1 1 0 0 1-.474-.54l-.39-1.056A9.7 9.7 0 0 0 3.25 13c0 5.385 4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75a9.74 9.74 0 0 0-4.413-8.161z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    d: "M18.592 4.513a.75.75 0 0 0-1.183-.923l-.404.518A9.7 9.7 0 0 0 13 3.25c-1.584 0-3.08.378-4.403 1.049l1.098.548a1 1 0 0 1 .432.417A8.2 8.2 0 0 1 13 4.75c1.077 0 2.107.207 3.05.582l-.641.822a.75.75 0 0 0 1.182.923l.82-1.05a8.25 8.25 0 1 1-11.95 3.62 1 1 0 0 1-.474-.54l-.39-1.056A9.7 9.7 0 0 0 3.25 13c0 5.385 4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75a9.74 9.74 0 0 0-4.413-8.161z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M2.629 18.002a.75.75 0 1 0-1.258.817l1 1.539a.75.75 0 0 0 1.258-.818z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    d: "M2.629 18.002a.75.75 0 1 0-1.258.817l1 1.539a.75.75 0 0 0 1.258-.818z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M22.537 21.498a.75.75 0 0 0-1.074-1.047l-1 1.026a.75.75 0 1 0 1.074 1.047z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    d: "M22.537 21.498a.75.75 0 0 0-1.074-1.047l-1 1.026a.75.75 0 1 0 1.074 1.047z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M10.548 12.436c-.82-.62-1.732-.275-2.096 0a.75.75 0 1 1-.904-1.197c.636-.48 2.324-1.192 3.904 0a.75.75 0 1 1-.904 1.197"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    d: "M10.548 12.436c-.82-.62-1.732-.275-2.096 0a.75.75 0 1 1-.904-1.197c.636-.48 2.324-1.192 3.904 0a.75.75 0 1 1-.904 1.197"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M15.452 12.436c.364-.275 1.276-.62 2.096 0a.75.75 0 1 0 .904-1.197c-1.58-1.192-3.268-.48-3.904 0a.75.75 0 1 0 .904 1.197"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    d: "M15.452 12.436c.364-.275 1.276-.62 2.096 0a.75.75 0 1 0 .904-1.197c-1.58-1.192-3.268-.48-3.904 0a.75.75 0 1 0 .904 1.197"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M14.945 16.945A2.75 2.75 0 0 1 10.25 15a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75c0 .73-.29 1.429-.805 1.945M13 16.25a1.25 1.25 0 0 0 1-.5h-2q.053.07.116.134c.235.234.553.366.884.366",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M14.945 16.945A2.75 2.75 0 0 1 10.25 15a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75c0 .73-.29 1.429-.805 1.945M13 16.25a1.25 1.25 0 0 0 1-.5h-2q.053.07.116.134c.235.234.553.366.884.366",
    clipRule: "evenodd"
  }));
};
ea.displayName = "Celebrate";
function Kt() {
  return Kt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Kt.apply(this, arguments);
}
var ta = function ta(e) {
  return a.createElement("svg", Kt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M2.05 22.02h19.89c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H2.8V2.72c0-.41-.34-.75-.75-.75s-.75.34-.75.75v18.55c0 .41.34.75.75.75M21.2 10.57c0 .41.34.75.75.75s.75-.34.75-.75V6.82a.755.755 0 0 0-.871-.74H18.2c-.41 0-.75.34-.75.75s.34.75.75.75h1.893l-5.383 5.27-3.12-3.17a.75.75 0 0 0-.53-.22.7.7 0 0 0-.53.22l-6.01 5.95c-.29.29-.29.77 0 1.06.14.15.34.22.53.22l-.02.01c.19 0 .38-.08.53-.22l5.48-5.42 3.12 3.17c.29.28.77.29 1.06 0l5.98-5.856z",
    clipRule: "evenodd"
  }));
};
ta.displayName = "Chart";
function Jt() {
  return Jt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Jt.apply(this, arguments);
}
var na = function na(e) {
  return a.createElement("svg", Jt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1.24 4.91a3.08 3.08 0 0 0 3.08 3.07c1.7 0 3.08-1.37 3.08-3.07S6.02 1.83 4.32 1.83 1.24 3.22 1.24 4.91m1.5 0c0-.87.71-1.58 1.58-1.58s1.58.72 1.58 1.58a1.581 1.581 0 0 1-3.16 0",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M3.15 21.95c.14.14.35.19.53.22v-.01c.2 0 .39-.08.53-.22l2.71-2.69c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-2.18 2.16-.92-.93a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M4.32 15.56c-1.7 0-3.08-1.38-3.08-3.08s1.38-3.07 3.08-3.07 3.08 1.38 3.08 3.07-1.38 3.08-3.08 3.08m0-4.64c-.87 0-1.58.71-1.58 1.57s.71 1.58 1.58 1.58 1.58-.71 1.58-1.58-.71-1.57-1.58-1.57",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M10.91 5.66h11.1c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-11.1c-.41 0-.75.34-.75.75s.34.75.75.75M22.01 13.24h-11.1c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h11.1c.41 0 .75.34.75.75s-.34.75-.75.75M10.91 20.82h11.1c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-11.1c-.41 0-.75.34-.75.75s.34.75.75.75"
  }));
};
na.displayName = "Checklist";
function Zt() {
  return Zt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Zt.apply(this, arguments);
}
var ra = function ra(e) {
  return a.createElement("svg", Zt({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M8.05 6.58a3.93 3.93 0 1 0 7.861-.001 3.93 3.93 0 0 0-7.86.001m1.5-.01c0-1.34 1.09-2.43 2.43-2.43s2.43 1.09 2.43 2.43S13.32 9 11.98 9 9.55 7.91 9.55 6.57",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M16.91 20.61h1.5v-3.5c0-2.07-1.68-3.75-3.75-3.75H9.32c-2.07 0-3.75 1.68-3.75 3.75v3.5h1.5v-3.5c0-1.24 1.01-2.25 2.25-2.25h5.34c1.24 0 2.25 1.01 2.25 2.25z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M4.24 11.15c-1.54 0-2.8-1.26-2.8-2.8s1.26-2.8 2.8-2.8 2.8 1.26 2.8 2.8-1.26 2.8-2.8 2.8m0-4.09c-.72 0-1.3.58-1.3 1.3s.58 1.3 1.3 1.3 1.3-.58 1.3-1.3-.58-1.3-1.3-1.3M16.93 8.35c0 1.54 1.26 2.8 2.8 2.8 1.55 0 2.8-1.26 2.8-2.8s-1.26-2.8-2.8-2.8-2.8 1.26-2.8 2.8m1.5.01c0-.72.58-1.3 1.3-1.3s1.3.58 1.3 1.3-.58 1.3-1.3 1.3-1.3-.58-1.3-1.3",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M2.03 19.43c-.41 0-.75-.34-.75-.75v-3.13c0-1.52 1.23-2.75 2.75-2.75h1.05c.41 0 .75.34.75.75s-.34.75-.75.75H4.03c-.69 0-1.25.56-1.25 1.25v3.13c0 .41-.34.75-.75.75M21.22 18.68c0 .41.34.75.75.75s.75-.34.75-.75v-3.13c0-1.52-1.23-2.75-2.75-2.75h-1.05c-.41 0-.75.34-.75.75s.34.75.75.75h1.05c.69 0 1.25.56 1.25 1.25z"
  }));
};
ra.displayName = "Community";
function e2() {
  return e2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, e2.apply(this, arguments);
}
var la = function la(e) {
  return a.createElement("svg", e2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M15.74 4.5a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M17.99.75a3.75 3.75 0 0 0-2.535 6.514l-.719 1.198a3.7 3.7 0 0 0-1.246-.212c-.96 0-1.835.36-2.498.953L9.547 7.812a3 3 0 1 0-.878 1.237l1.42 1.367A3.7 3.7 0 0 0 9.74 12c0 .466.085.912.24 1.324l-2.718 1.71a3 3 0 1 0 .82 1.256l2.699-1.697a3.74 3.74 0 0 0 2.709 1.157c.403 0 .791-.064 1.155-.181l1.162 2.045a3 3 0 1 0 1.519-.363L15.95 14.83c.79-.688 1.289-1.7 1.289-2.83a3.74 3.74 0 0 0-1.218-2.766l.718-1.197A3.75 3.75 0 1 0 17.99.75M8.016 7.539l-.032.05A1.499 1.499 0 0 1 5.24 6.75a1.5 1.5 0 1 1 2.776.789M13.49 9.75c.398 0 .772.103 1.096.284a1 1 0 0 0 .12.072 2.25 2.25 0 1 1-1.215-.356m3.75 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-13.5-1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
    clipRule: "evenodd"
  }));
};
la.displayName = "Connected";
function t2() {
  return t2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, t2.apply(this, arguments);
}
var aa = function aa(e) {
  return a.createElement("svg", t2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M10.49 8.26c0 1.64 1.34 2.98 2.98 2.98s2.98-1.34 2.98-2.98-1.34-2.98-2.98-2.98-2.98 1.34-2.98 2.98m1.5 0c0-.82.66-1.48 1.48-1.48s1.48.66 1.48 1.48-.66 1.48-1.48 1.48-1.48-.66-1.48-1.48M17.46 18.58H9.48c-.86 0-1.56-.72-1.56-1.62 0-1.76.78-3.07 2.31-3.87.9-.47 1.93-.71 3.06-.71h.26c1.13 0 2.17.24 3.09.73 1.6.84 2.38 2.1 2.38 3.86 0 .89-.7 1.62-1.56 1.62zm-4.17-4.7q-1.335 0-2.37.54c-1.04.55-1.51 1.33-1.51 2.54 0 .08.05.12.06.12h7.98s.06-.04.06-.12c0-1.2-.47-1.95-1.57-2.53-.71-.37-1.51-.56-2.4-.56h-.26z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M6.46 22.66h12.72c1.52 0 2.75-1.23 2.75-2.75V4.09c0-1.52-1.23-2.75-2.75-2.75H6.46c-1.52 0-2.75 1.23-2.75 2.75v1.63h-.9c-.41 0-.75.34-.75.75s.34.75.75.75h.9v4.14h-.9c-.41 0-.75.34-.75.75s.34.75.75.75h.9V17h-.9c-.41 0-.75.34-.75.75s.34.75.75.75h.9v1.41c0 1.52 1.23 2.75 2.75 2.75M5.21 18.5v1.41c0 .69.56 1.25 1.25 1.25h12.72c.69 0 1.25-.56 1.25-1.25V4.09c0-.69-.56-1.25-1.25-1.25H6.46c-.69 0-1.25.56-1.25 1.25v1.63h.41c.41 0 .75.34.75.75s-.34.75-.75.75h-.41v4.14h.41c.41 0 .75.34.75.75s-.34.75-.75.75h-.41V17h.41c.41 0 .75.34.75.75s-.34.75-.75.75z",
    clipRule: "evenodd"
  }));
};
aa.displayName = "Contacts";
function n2() {
  return n2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, n2.apply(this, arguments);
}
var ia = function ia(e) {
  return a.createElement("svg", n2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M4.16 3.83c0-.593.481-1.07 1.07-1.07h13.55c.593 0 1.07.482 1.07 1.07v.325a1.52 1.52 0 0 0-1.302.892L13.46 15.953l-.01.022a1.55 1.55 0 0 0-.11.883l.309 1.897c.162 1.084 1.377 1.638 2.307 1.078l.002-.001 1.656-.988a1 1 0 0 0 .097-.069c.229-.161.385-.37.49-.58l.009-.018 1.64-3.516V20.1c0 .67-.498 1.13-1.07 1.13H5.23a1.07 1.07 0 0 1-1.07-1.07zm17.19 7.616V20.1c0 1.47-1.143 2.63-2.57 2.63H5.23a2.57 2.57 0 0 1-2.57-2.57V3.83a2.57 2.57 0 0 1 2.57-2.57h13.55a2.57 2.57 0 0 1 2.57 2.57v.824l1.204.565a1.53 1.53 0 0 1 .745 2.05zm-1.17-5.684a.8.8 0 0 0 .21.098l1.531.72.011.004.01.006.004.008.002.012q0 .005-.006.018l-5.086 10.903-.013.02a1 1 0 0 0-.08.054l-1.577.94-.004.003a.04.04 0 0 1-.017.006.04.04 0 0 1-.018-.004l-.012-.008-.001-.002v-.002l-.002-.006-.312-1.922-.002-.01q.001-.007.008-.027L19.91 5.677l.004-.01.006-.009.008-.004.011-.002q.006 0 .02.006zM7.22 7.15a.75.75 0 0 0 0 1.5h6.75a.75.75 0 0 0 0-1.5zm-.75 4.95a.75.75 0 0 1 .75-.75h5.26a.75.75 0 0 1 0 1.5H7.22a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  }));
};
ia.displayName = "Contract";
function r2() {
  return r2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, r2.apply(this, arguments);
}
var oa = function oa(e) {
  return a.createElement("svg", r2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M3.25 4A2.75 2.75 0 0 1 6 1.25h8A2.75 2.75 0 0 1 16.75 4v11A2.75 2.75 0 0 1 14 17.75H6A2.75 2.75 0 0 1 3.25 15zM6 2.75c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25zm14 2.5a.75.75 0 0 1 .75.75v11A4.75 4.75 0 0 1 16 21.75h-6a.75.75 0 0 1 0-1.5h6A3.25 3.25 0 0 0 19.25 17V6a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  }));
};
oa.displayName = "Copy";
function l2() {
  return l2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, l2.apply(this, arguments);
}
var ca = function ca(e) {
  return a.createElement("svg", l2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M11.03 22.56c.07.04.47.25 1.02.25l-.02-.01c.26 0 .55-.05.86-.18 1.5-.66 3.06-1.61 4.91-2.99 1.45-1.09 2.99-2.47 3.36-4.5.4-2.17.67-4.45.81-6.8.03-.37.03-.71 0-1.03-.14-1.77-.96-2.58-2.33-3.38-1.32-.78-2.8-1.44-4.4-1.98l-.33-.11-.147-.05c-.704-.235-1.427-.477-2.203-.57-1.09-.13-2.05.15-2.9.4-1.92.57-3.72 1.34-5.32 2.28-1.37.8-2.19 1.61-2.33 3.38-.02.32-.02.66 0 1.03.14 2.34.42 4.63.81 6.8.37 2.03 1.91 3.42 3.36 4.5 1.42 1.06 3.09 2.25 4.85 2.96m-.913-19.505c.643-.188 1.248-.365 1.882-.365.127 0 .254 0 .381.02.651.077 1.284.29 1.96.52l.09.03.34.11c1.5.51 2.89 1.13 4.12 1.85 1.09.65 1.5 1.08 1.59 2.21.02.27.02.55 0 .82-.13 2.28-.4 4.51-.78 6.62-.28 1.52-1.56 2.65-2.78 3.56-1.76 1.31-3.22 2.21-4.62 2.82-.28.13-.54 0-.62-.04-1.68-.68-3.26-1.81-4.6-2.81-1.22-.91-2.5-2.04-2.78-3.56-.38-2.11-.64-4.34-.78-6.62a6 6 0 0 1 0-.82c.09-1.14.49-1.57 1.59-2.21 1.5-.88 3.18-1.59 4.99-2.13zm.373 11.415c.14.14.33.22.53.22l-.01-.01c.2 0 .39-.08.53-.22l4.32-4.28c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-3.78 3.75-1.77-1.8a.754.754 0 0 0-1.06 0c-.29.29-.29.76 0 1.06z",
    clipRule: "evenodd"
  }));
};
ca.displayName = "Coverage";
function a2() {
  return a2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, a2.apply(this, arguments);
}
var sa = function sa(e) {
  return a.createElement("svg", a2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M4.57 3.56h14.85c1.79 0 3.25 1.46 3.25 3.25v10.38c0 1.79-1.46 3.25-3.25 3.25H4.57c-1.79 0-3.25-1.46-3.25-3.25V6.81c0-1.79 1.46-3.25 3.25-3.25m14.85 1.5H4.57c-.96 0-1.75.79-1.75 1.75v1.25h18.35V6.81c0-.96-.79-1.75-1.75-1.75M4.57 18.94h14.85c.96 0 1.75-.79 1.75-1.75V9.56H2.82v7.63c0 .96.79 1.75 1.75 1.75m.94-3.51h3.7c.41 0 .75.34.75.75s-.34.75-.75.75h-3.7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75m3.7-3h-3.7c-.41 0-.75.34-.75.75s.34.75.75.75h3.7c.41 0 .75-.34.75-.75s-.34-.75-.75-.75m5.22-.49h3.5c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.69 0-1.25-.56-1.25-1.25v-2.5c0-.69.56-1.25 1.25-1.25m.25 3.5h3v-2h-3z",
    clipRule: "evenodd"
  }));
};
sa.displayName = "Creditcard";
function i2() {
  return i2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, i2.apply(this, arguments);
}
var da = function da(e) {
  return a.createElement("svg", i2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M18.15 22.75H5.85c-1.65 0-2.99-1.23-2.99-2.75V4c0-1.52 1.34-2.75 2.99-2.75h7.97c.75 0 1.46.28 1.99.79l4.47 4.23c.54.51.85 1.23.85 1.96v11.76c0 1.52-1.34 2.75-2.99 2.75zm-12.3-20c-.82 0-1.49.56-1.49 1.25v16c0 .69.67 1.25 1.49 1.25h12.31c.82 0 1.49-.56 1.49-1.25V8.24c0-.33-.14-.64-.39-.88l-4.47-4.24c-.25-.24-.6-.38-.96-.38H5.86zm3.92 12.31c.19 0 .35-.02.5-.05.14-.03.28-.07.41-.13V14h-.58c-.08 0-.15-.02-.2-.07a.22.22 0 0 1-.07-.17v-.74h2.07v2.46c-.15.11-.3.2-.47.28-.16.08-.33.14-.52.19s-.38.09-.58.11a7 7 0 0 1-.67.04c-.43 0-.82-.08-1.18-.23s-.68-.36-.94-.62a2.9 2.9 0 0 1-.62-.94c-.15-.36-.23-.76-.23-1.19s.07-.83.22-1.2c.14-.36.35-.68.62-.94s.59-.47.97-.62.8-.22 1.27-.22a3.7 3.7 0 0 1 1.27.22c.18.07.34.15.49.25s.28.2.4.31l-.39.6c-.04.06-.08.1-.13.13s-.11.05-.17.05c-.08 0-.16-.03-.25-.08q-.095-.053-.18-.102l-.12-.068c-.09-.05-.19-.08-.29-.11s-.2-.05-.31-.06a4 4 0 0 0-.37-.02c-.25 0-.48.04-.68.13s-.38.21-.52.38c-.14.16-.25.36-.33.59s-.12.48-.12.76c0 .31.04.58.13.82s.2.44.35.61.33.29.54.38.43.13.68.13m2.95-4.86v5.83h2.32c.35 0 .66-.04.93-.13.28-.09.5-.21.69-.37.18-.16.32-.35.42-.56.09-.21.14-.44.14-.69 0-.33-.1-.6-.28-.81s-.47-.36-.85-.45c.17-.07.32-.14.45-.23s.23-.19.31-.29.14-.22.18-.34.06-.25.06-.38c0-.24-.04-.45-.12-.65s-.21-.36-.39-.5a1.8 1.8 0 0 0-.69-.32 4.3 4.3 0 0 0-1.03-.11zm2.05 2.46h-.69v-1.44h.79c.15 0 .28.02.39.04q.165.03.27.12c.07.05.13.13.16.22.03.1.05.21.05.35s-.03.26-.07.35a.5.5 0 0 1-.19.22c-.09.05-.19.09-.31.11s-.25.03-.4.03m-.7 2.35v-1.45l.02-.02h.94c.17 0 .31.02.42.05.11.04.2.08.27.14.06.06.11.14.14.22.03.09.04.18.04.29 0 .1-.02.19-.04.28s-.07.17-.13.24c-.07.08-.16.13-.27.18-.12.05-.26.07-.44.07z",
    clipRule: "evenodd"
  }));
};
da.displayName = "Data";
function o2() {
  return o2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, o2.apply(this, arguments);
}
var ua = function ua(e) {
  return a.createElement("svg", o2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M22.69 10.87a.72.72 0 0 0-.17-.58L19.4 6.58a.74.74 0 0 0-.57-.27h-1.92l.16-1.39a.756.756 0 0 0-.75-.84H4.33c-.41 0-.75.34-.75.75s.34.75.75.75h11.16l-.9 7.78v.08a.3.3 0 0 0 .018.08l.012.04c0 .04.01.09.03.13.015.043.04.082.064.119l.026.041.02.035q.014.026.03.045s.01 0 .02.01c.05.05.11.09.18.13a.2.2 0 0 1 .035.024l.035.026q.135.06.3.06h5.39l-.43 3.19h-1.15a2.77 2.77 0 0 0-2.67-2.03c-1.28 0-2.34.86-2.67 2.03h-4.1a2.77 2.77 0 0 0-2.67-2.03c-1.28 0-2.34.86-2.67 2.03H2.81c-.41 0-.75.34-.75.75s.34.75.75.75h1.58a2.77 2.77 0 0 0 2.67 2.03c1.28 0 2.34-.86 2.67-2.03h4.1a2.77 2.77 0 0 0 2.67 2.03c1.28 0 2.34-.86 2.67-2.03h1.81c.38 0 .69-.28.74-.65l.64-4.69.36-2.68zM7.03 19.42c-.71 0-1.28-.58-1.28-1.28s.58-1.28 1.28-1.28 1.28.58 1.28 1.28-.58 1.28-1.28 1.28m9.44 0c-.71 0-1.28-.58-1.28-1.28s.58-1.28 1.28-1.28 1.28.58 1.28 1.28-.58 1.28-1.28 1.28m.27-11.62-.569 4.88h4.76l.23-1.7-2.68-3.18zM9.01 8.81c0-.41-.34-.75-.75-.75h-6.5c-.41 0-.75.34-.75.75s.34.75.75.75h6.5c.41 0 .75-.34.75-.75m-2.75 4.38h-3.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.5c.41 0 .75.34.75.75s-.34.75-.75.75",
    clipRule: "evenodd"
  }));
};
ua.displayName = "Delivery";
function c2() {
  return c2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, c2.apply(this, arguments);
}
var ha = function ha(e) {
  return a.createElement("svg", c2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    clipPath: "url(#a)"
  }, a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M22.65 10.62c.88-1.35.29-3.18-1.22-3.76a2.54 2.54 0 0 1-1.63-2.24 2.54 2.54 0 0 0-2.53-2.41q-.33 0-.66.09t-.66.09c-.76 0-1.49-.34-1.97-.94-.51-.63-1.24-.94-1.97-.94s-1.47.31-1.97.94a2.52 2.52 0 0 1-2.63.85c-.22-.06-.45-.09-.66-.09-1.31 0-2.46 1.03-2.53 2.41-.05 1-.69 1.88-1.63 2.24-1.51.58-2.1 2.4-1.22 3.76.55.84.55 1.93 0 2.77a2.545 2.545 0 0 0 1.22 3.76 2.54 2.54 0 0 1 1.63 2.24 2.54 2.54 0 0 0 2.53 2.41q.33 0 .66-.09t.66-.09c.76 0 1.49.34 1.97.94.51.63 1.24.94 1.97.94s1.47-.31 1.97-.94a2.52 2.52 0 0 1 2.63-.85c.22.06.45.09.66.09 1.31 0 2.46-1.03 2.53-2.41.05-1 .69-1.88 1.63-2.24 1.51-.58 2.1-2.4 1.22-3.76-.55-.84-.55-1.93 0-2.77m-1.26 3.58c.24.36.17.71.12.89s-.21.49-.62.65a4.04 4.04 0 0 0-2.59 3.56c-.03.62-.55.99-1.03.99-.09 0-.18-.01-.27-.04a4.022 4.022 0 0 0-4.19 1.36c-.27.34-.62.39-.81.39s-.54-.05-.81-.39A4.04 4.04 0 0 0 7 20.25c-.09.02-.18.04-.27.04-.48 0-1-.37-1.03-.99a4.04 4.04 0 0 0-2.59-3.56c-.4-.15-.56-.47-.62-.65s-.12-.53.12-.89c.87-1.34.87-3.07 0-4.41-.24-.36-.17-.71-.12-.89s.21-.49.62-.65A4.04 4.04 0 0 0 5.7 4.69c.03-.62.55-.99 1.03-.99.09 0 .18.01.27.04a4.022 4.022 0 0 0 4.19-1.36c.27-.34.62-.39.81-.39s.54.05.81.39A4.04 4.04 0 0 0 17 3.74c.09-.02.18-.04.27-.04.48 0 1 .37 1.03.99.08 1.59 1.1 2.99 2.59 3.56.4.15.56.47.62.65s.12.53-.12.89a4.05 4.05 0 0 0 0 4.41M9.91 8.46c.29.77-.1 1.65-.87 1.94-.77.3-1.65-.1-1.94-.87s.1-1.65.87-1.94 1.65.1 1.94.87m4.18 7.08c-.29-.77.1-1.65.87-1.94s1.65.1 1.94.87-.1 1.65-.87 1.94c-.77.3-1.65-.1-1.94-.87m.59-8.04c.26-.32.73-.37 1.05-.11.32.27.37.74.11 1.06l-6.51 8.04c-.15.18-.36.28-.58.28-.16 0-.33-.06-.47-.17a.76.76 0 0 1-.11-1.06z",
    clipRule: "evenodd"
  })), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
ha.displayName = "Discount";
function s2() {
  return s2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, s2.apply(this, arguments);
}
var fa = function fa(e) {
  return a.createElement("svg", s2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M17.87 22.75c1.59 0 2.88-1.23 2.88-2.75V8.24a2.76 2.76 0 0 0-.81-1.95l-4.27-4.24c-.4-.4-.9-.658-1.443-.756a.7.7 0 0 0-.155-.023 3 3 0 0 0-.342-.021h-7.6C4.54 1.25 3.25 2.48 3.25 4v16c0 1.52 1.29 2.75 2.88 2.75zm-4.58-20H6.13c-.76 0-1.38.56-1.38 1.25v16c0 .69.62 1.25 1.38 1.25h11.73c.76 0 1.38-.56 1.38-1.25V8.39h-3.2c-1.52 0-2.75-1.23-2.75-2.75zm1.5.549V5.64c0 .69.56 1.25 1.25 1.25h2.367zM12 18.5c-.41 0-.75-.34-.75-.75v-4.5c0-.41.34-.75.75-.75s.75.34.75.75v4.5c0 .41-.34.75-.75.75m1-8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
    clipRule: "evenodd"
  }));
};
fa.displayName = "DocumentInfo";
function d2() {
  return d2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, d2.apply(this, arguments);
}
var va = function va(e) {
  return a.createElement("svg", d2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M10.99 16.9a.75.75 0 0 1-.53-.22l-2.3-2.34a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.77 1.8 3.78-3.75c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-4.32 4.28a.75.75 0 0 1-.53.22z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M17.87 22.75H6.13c-1.59 0-2.88-1.23-2.88-2.75V4c0-1.52 1.29-2.75 2.88-2.75h7.6q.173 0 .341.02.081.004.156.024a2.7 2.7 0 0 1 1.443.756l4.27 4.24a2.7 2.7 0 0 1 .703 1.192q.106.372.107.758V20c0 1.52-1.29 2.75-2.88 2.75m1.37-14.36V20c0 .69-.62 1.25-1.38 1.25H6.13c-.76 0-1.38-.56-1.38-1.25V4c0-.69.62-1.25 1.38-1.25h7.16v2.89c0 1.52 1.23 2.75 2.75 2.75zm-.833-1.5L14.79 3.299V5.64c0 .69.56 1.25 1.25 1.25z",
    clipRule: "evenodd"
  }));
};
va.displayName = "DocumentWTick";
function u2() {
  return u2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, u2.apply(this, arguments);
}
var ma = function ma(e) {
  return a.createElement("svg", u2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M6.13 22.75h11.74c1.59 0 2.88-1.23 2.88-2.75V8.24a2.76 2.76 0 0 0-.81-1.95l-4.27-4.24c-.4-.4-.9-.658-1.443-.756a.7.7 0 0 0-.155-.023 3 3 0 0 0-.342-.021h-7.6C4.54 1.25 3.25 2.48 3.25 4v16c0 1.52 1.29 2.75 2.88 2.75m7.16-20H6.13c-.76 0-1.38.56-1.38 1.25v16c0 .69.62 1.25 1.38 1.25h11.73c.76 0 1.38-.56 1.38-1.25V8.39h-3.2c-1.52 0-2.75-1.23-2.75-2.75zm1.5.549V5.64c0 .69.56 1.25 1.25 1.25h2.367z",
    clipRule: "evenodd"
  }));
};
ma.displayName = "Document";
function h2() {
  return h2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, h2.apply(this, arguments);
}
var ga = function ga(e) {
  return a.createElement("svg", h2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M11.22 15.857V2c0-.41.34-.75.75-.75s.75.34.75.75v13.847l3.61-3.787c.29-.3.76-.31 1.06-.03.3.29.31.76.03 1.06l-4.81 5.045a.7.7 0 0 1-.12.145.75.75 0 0 1-.52.21v-.01c-.2 0-.4-.08-.54-.23L6.52 13.1c-.29-.3-.27-.78.03-1.06.3-.29.77-.27 1.06.03zM5.23 22.75h13.54c2.04 0 3.7-1.66 3.7-3.7v-2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2c0 1.21-.99 2.2-2.2 2.2H5.23c-1.21 0-2.2-.99-2.2-2.2v-2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2c0 2.04 1.66 3.7 3.7 3.7",
    clipRule: "evenodd"
  }));
};
ga.displayName = "Download";
function f2() {
  return f2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, f2.apply(this, arguments);
}
var xa = function xa(e) {
  return a.createElement("svg", f2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#151518",
    fillRule: "evenodd",
    d: "m8.66 2.14-.435.61-.436-.61a.75.75 0 0 1 .871 0m4.98 6.17c-.747-1.768-1.886-3.228-2.87-4.27a18 18 0 0 0-1.468-1.392 14 14 0 0 0-.59-.47l-.036-.027-.01-.008-.004-.002s-.002-.001-.437.609l-.436-.61-.003.002-.005.003-.015.01a6 6 0 0 0-.24.184c-.16.125-.384.308-.653.545-.535.472-1.25 1.16-1.965 2.029C3.488 6.636 2 9.149 2 12.135s1.478 5.482 2.89 7.192c.71.86 1.42 1.542 1.952 2.008a15 15 0 0 0 .888.719l.015.01.004.004h.002s.001.002.434-.61l-.433.612a.75.75 0 0 0 .31.127l.123-.74-.123.74h.003l.006.002.018.003a6 6 0 0 0 .3.04 17.908 17.908 0 0 0 3.67.031c2.223-.215 5.052-.939 7.164-3.05 2.112-2.112 2.835-4.941 3.05-7.164.109-1.12.09-2.111.046-2.824a15 15 0 0 0-.117-1.146l-.003-.018v-.006l-.001-.002-.74.122.74-.123a.75.75 0 0 0-.617-.617l-.123.74.123-.74h-.006l-.013-.003-.045-.007-.163-.022c-.14-.018-.341-.041-.592-.062a18 18 0 0 0-2.04-.054c-1.443.045-3.294.276-5.081 1.013m.49 1.421a9.4 9.4 0 0 1 .32 2.404c0 .801-.109 1.567-.294 2.291l5.63-5.63a17 17 0 0 0-1.017 0c-1.367.043-3.056.266-4.64.935m-2.064 8.907a17 17 0 0 1-1.988 2.213c.535.01 1.162-.005 1.837-.07 2.064-.2 4.488-.86 6.247-2.619 1.76-1.76 2.419-4.184 2.618-6.247.075-.77.084-1.477.066-2.058zm-3.127 1.224a15.7 15.7 0 0 0 1.955-2.162c1.118-1.508 2.055-3.417 2.055-5.565 0-.902-.163-1.762-.436-2.572-.618-1.835-1.79-3.387-2.834-4.494a17 17 0 0 0-.708-.707zm-1.5-.01c-.419-.392-.906-.89-1.393-1.48C4.74 16.789 3.5 14.624 3.5 12.135s1.248-4.668 2.566-6.269c.491-.596.983-1.1 1.405-1.498z",
    clipRule: "evenodd"
  }));
};
xa.displayName = "Eco";
function v2() {
  return v2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, v2.apply(this, arguments);
}
var ba = function ba(e) {
  return a.createElement("svg", v2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1.5 22.5c.14.14.33.22.53.22v-.02h.09l5.79-.71a.73.73 0 0 0 .44-.21l10.83-10.83a.8.8 0 0 0 .148-.148L21.91 8.22a2.76 2.76 0 0 0 0-3.89L20.8 3.22l-.02-.02-1.11-1.11a2.76 2.76 0 0 0-3.89 0L2.21 15.65a.8.8 0 0 0-.21.44l-.71 5.79c-.03.23.05.46.21.62M18.73 9.29l2.12-2.12c.49-.49.49-1.28 0-1.77l-1.11-1.11-.02-.02-1.11-1.11a1.25 1.25 0 0 0-1.77 0l-2.116 2.115zm-5.067-2.956L3.46 16.53l-.57 4.58 4.58-.56 10.2-10.2z",
    clipRule: "evenodd"
  }));
};
ba.displayName = "Edit";
function m2() {
  return m2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, m2.apply(this, arguments);
}
var wa = function wa(e) {
  return a.createElement("svg", m2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M4.22 11.75C3 11.75 2 10.75 2 9.53c0-.85.48-1.6 1.19-1.97A2.712 2.712 0 0 1 5.73 3.9c.19 0 .37.02.55.06a3.684 3.684 0 0 1 3.56-2.72c1.2 0 2.29.58 2.97 1.52.53-.36 1.16-.57 1.81-.57a3.205 3.205 0 0 1 3.156 2.671l.074-.001c.99 0 1.82.7 2.02 1.64.99.33 1.69 1.27 1.69 2.36a2.5 2.5 0 0 1-2.27 2.49l-1.76 10.77c-.06.36-.37.63-.74.63h-3.378a1 1 0 0 1-.122.01v-.01H7.12c-.37 0-.68-.27-.74-.63L4.672 11.673q-.21.046-.462.047zm14.674-1.902.006.002h.15c.55 0 1-.45 1-1s-.42-.97-.95-.99c-.21 0-.41-.11-.54-.27a.76.76 0 0 1-.16-.58c.01-.4-.24-.65-.55-.65a.56.56 0 0 0-.56.56c0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-.537.207-1.025.543-1.392a1 1 0 0 1-.013-.138c0-.93-.76-1.7-1.7-1.7-.56 0-1.08.28-1.4.74-.16.23-.44.36-.72.32a.76.76 0 0 1-.61-.51c-.3-.9-1.13-1.5-2.06-1.5-1.21 0-2.19.98-2.19 2.18l.004.034q.005.03.006.066c.02.29-.14.57-.4.7-.26.14-.57.11-.81-.07-.15-.12-.4-.26-.73-.26-.67 0-1.21.54-1.21 1.21 0 .35.15.67.42.9.25.22.33.58.19.88s-.46.47-.8.42a.724.724 0 0 0-.83.7c0 .4.32.72.72.72.21 0 .3-.06.56-.26a.76.76 0 0 1 .656-.15h4.143a.7.7 0 0 1 .17 0h8.93q.122 0 .235.038M8.939 11.31l.852 9.94H7.75l-1.62-9.94zm5.171 9.94h2.04l1.62-9.94h-2.808zm-.65-9.94-.85 9.94h-1.318l-.852-9.94z",
    clipRule: "evenodd"
  }));
};
wa.displayName = "Entertainment";
function g2() {
  return g2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, g2.apply(this, arguments);
}
var ya = function ya(e) {
  return a.createElement("svg", g2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M20.75 9.03c0 .41.34.75.75.75s.75-.34.75-.75V2.5a.7.7 0 0 0-.071-.316.74.74 0 0 0-.367-.365.7.7 0 0 0-.312-.069h-6.53c-.41 0-.75.34-.75.75s.34.75.75.75h4.72l-6.72 6.72c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l6.72-6.72zM1.75 21.5v-6.53c0-.41.34-.75.75-.75s.75.34.75.75v4.72l6.72-6.72c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-6.72 6.72h4.72c.41 0 .75.34.75.75s-.34.75-.75.75H2.5a.75.75 0 0 1-.72-.544.7.7 0 0 1-.03-.206"
  }));
};
ya.displayName = "Expand";
function x2() {
  return x2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, x2.apply(this, arguments);
}
var ja = function ja(e) {
  return a.createElement("svg", x2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M16.5 3H13c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.5c.41 0 .75.34.75.75s-.34.75-.75.75M3.86 14.13H1.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.11c.41 0 .75.34.75.75s-.34.75-.75.75M14 13.38q0 .039.004.076a.756.756 0 0 0 .746.674h2.93c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H15.5V8.67c0-.41-.34-.75-.75-.75s-.75.34-.75.75z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M6.5 13.38c0 4.55 3.7 8.25 8.25 8.25S23 17.93 23 13.38s-3.7-8.25-8.25-8.25-8.25 3.7-8.25 8.25m1.5 0c0-3.72 3.03-6.75 6.75-6.75s6.75 3.03 6.75 6.75-3.03 6.75-6.75 6.75S8 17.1 8 13.38",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M5.22 9.88H3.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.97c.41 0 .75.34.75.75s-.34.75-.75.75M3.25 18.38h1.97c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H3.25c-.41 0-.75.34-.75.75s.34.75.75.75"
  }));
};
ja.displayName = "Express";
function b2() {
  return b2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, b2.apply(this, arguments);
}
var za = function za(e) {
  return a.createElement("svg", b2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M12.11 12.66h-.005a.74.74 0 0 0 .525-.22l8.61-8.549V9.27c0 .41.34.75.75.75v.01c.41 0 .75-.34.75-.75V2.1a.7.7 0 0 0-.015-.15.74.74 0 0 0-.841-.6H14.82c-.41 0-.75.34-.75.75s.34.75.75.75h5.342l-8.582 8.53c-.29.29-.29.77 0 1.06a.73.73 0 0 0 .525.22H12.1z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M1.26 21.1c0 .86.7 1.55 1.55 1.55h16.4c.86 0 1.55-.7 1.55-1.55v-8.2c0-.41-.34-.75-.75-.75s-.75.34-.75.75l-.05 8.25-16.45-.05.05-16.45h8.2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-8.2c-.86 0-1.55.7-1.55 1.55z"
  }));
};
za.displayName = "ExternalLink";
function w2() {
  return w2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, w2.apply(this, arguments);
}
var pa = function pa(e) {
  return a.createElement("svg", w2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    d: "M15.37 15.403a.75.75 0 1 1 1.06 1.06c-.705.706-1.98 1.6-4.214 1.6-2.22 0-3.782-1.014-4.349-1.615l1.091-1.029c.3.319 1.475 1.143 3.258 1.144 1.767 0 2.676-.683 3.153-1.16m-7.472-.015a.75.75 0 0 1 1.06.031l-1.09 1.03a.75.75 0 0 1 .03-1.061m3.88-3.585V9.59a.75.75 0 0 1 1.5 0v2.213a1.83 1.83 0 0 1-1.829 1.829h-.565a.75.75 0 0 1 0-1.5h.565a.33.33 0 0 0 .33-.33M6.875 9.02v-.77a.75.75 0 1 1 1.5 0v.77a.75.75 0 0 1-1.5 0m9.063 0v-.77a.75.75 0 0 1 1.5 0v.77a.75.75 0 0 1-1.5 0M1.25 6.375V5.272A4.023 4.023 0 0 1 5.272 1.25h1.103l.077.004a.75.75 0 0 1 0 1.492l-.077.004H5.272A2.523 2.523 0 0 0 2.75 5.272v1.103a.75.75 0 0 1-1.5 0M22.75 6.375V5.272a4.023 4.023 0 0 0-4.023-4.022h-1.103l-.077.004a.75.75 0 0 0 0 1.492l.077.004h1.103a2.523 2.523 0 0 1 2.522 2.522v1.103a.75.75 0 0 0 1.5 0M22.75 17.625v1.102a4.023 4.023 0 0 1-4.023 4.023h-1.103l-.077-.004a.75.75 0 0 1 0-1.492l.077-.004h1.103a2.523 2.523 0 0 0 2.522-2.523v-1.102a.75.75 0 0 1 1.5 0M1.25 17.625v1.102a4.023 4.023 0 0 0 4.022 4.023h1.103l.077-.004a.75.75 0 0 0 0-1.492l-.077-.004H5.272a2.523 2.523 0 0 1-2.522-2.523v-1.102a.75.75 0 0 0-1.5 0"
  }));
};
pa.displayName = "FaceID";
function y2() {
  return y2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, y2.apply(this, arguments);
}
var Oa = function Oa(e) {
  return a.createElement("svg", y2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    d: "M11.89 15.75a1.01 1.01 0 1 0 0-2.02 1.01 1.01 0 0 0 0 2.02M11.89 12.43c-.41 0-.75-.34-.75-.75 0-.7.08-1.43.68-2.05.18-.18.4-.38.62-.57.29-.25.59-.51.76-.73.32-.42.41-.94.24-1.4-.16-.44-.54-.75-1.06-.86-.82-.19-1.73.29-1.94 1.02-.11.4-.53.63-.93.51A.74.74 0 0 1 9 6.67c.43-1.48 2.12-2.42 3.71-2.07 1.02.23 1.8.89 2.14 1.81.34.93.18 1.99-.45 2.82-.26.35-.63.67-.98.97-.19.16-.38.32-.52.48-.2.2-.26.46-.26 1.01 0 .41-.34.75-.75.75z"
  }), a.createElement("path", {
    fill: e.color || "#242328",
    d: "M21.25 5c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h12.299c.624 0 1.23.212 1.718.602l2.827 2.262.064.038a.25.25 0 0 0 .342-.233zm1.5 14.919c0 1.421-1.593 2.232-2.734 1.448l-.109-.08-2.828-2.263a1.25 1.25 0 0 0-.78-.274H4A2.75 2.75 0 0 1 1.25 16V5A2.75 2.75 0 0 1 4 2.25h16A2.75 2.75 0 0 1 22.75 5z"
  }));
};
Oa.displayName = "FAQ";
function j2() {
  return j2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, j2.apply(this, arguments);
}
var Ea = function Ea(e) {
  return a.createElement("svg", j2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M4.678 5A2.904 2.904 0 0 0 7.48 7.15c1.34 0 2.47-.913 2.802-2.15H22c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H10.282A2.904 2.904 0 0 0 7.48 1.35c-1.34 0-2.47.913-2.802 2.15H2c-.41 0-.75.34-.75.75S1.59 5 2 5zm4.202-.764a1.404 1.404 0 0 0-1.4-1.386c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4c.765 0 1.393-.623 1.4-1.386v-.028M22 20.5H10.282a2.904 2.904 0 0 1-2.802 2.15c-1.34 0-2.47-.913-2.802-2.15H2c-.41 0-.75-.34-.75-.75S1.59 19 2 19h2.678a2.904 2.904 0 0 1 2.802-2.15c1.34 0 2.47.913 2.802 2.15H22c.41 0 .75.34.75.75s-.34.75-.75.75m-13.12-.75v-.014a1.404 1.404 0 0 0-1.4-1.386c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4c.765 0 1.393-.622 1.4-1.386zM13.718 11.25A2.904 2.904 0 0 1 16.52 9.1c1.34 0 2.47.913 2.802 2.15H22c.41 0 .75.34.75.75s-.34.75-.75.75h-2.678a2.904 2.904 0 0 1-2.802 2.15c-1.34 0-2.47-.913-2.802-2.15H2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75zm4.202.764a1.404 1.404 0 0 1-1.4 1.386c-.77 0-1.4-.63-1.4-1.4s.63-1.4 1.4-1.4c.765 0 1.393.623 1.4 1.386v.028",
    clipRule: "evenodd"
  }));
};
Ea.displayName = "Filter";
function z2() {
  return z2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, z2.apply(this, arguments);
}
var Sa = function Sa(e) {
  return a.createElement("svg", z2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M15.16 23h-2.82c-.27 0-.52-.15-.65-.38l-4.33-7.71H4.28c-2.22 0-2.96-1.75-3.03-2.68v-.41c.08-.99.81-2.74 3.03-2.74h3.08l4.33-7.7c.13-.24.38-.38.65-.38h2.82c.24 0 .47.12.61.31s.18.45.1.68L13.5 9.1h4.48l1.55-1.55a.75.75 0 0 1 .53-.22h1.95c.23 0 .45.11.59.29s.19.42.13.65L21.78 12l.95 3.74c.06.22 0 .46-.13.65-.14.18-.36.29-.59.29h-1.95a.75.75 0 0 1-.53-.22l-1.55-1.55H13.5l2.37 7.11c.08.23.04.48-.1.68a.74.74 0 0 1-.61.31zm-2.38-1.5h1.34l-2.37-7.11a.75.75 0 0 1 .1-.68c.14-.2.37-.31.61-.31h5.84c.2 0 .39.08.53.22l1.55 1.55h.67l-.72-2.81c-.02-.09-.08-.39 0-.72l.72-2.81h-.67l-1.55 1.55a.75.75 0 0 1-.53.22h-5.84c-.24 0-.47-.12-.61-.31a.75.75 0 0 1-.1-.68l2.37-7.11h-1.34l-4.33 7.71c-.13.24-.38.38-.65.38H4.28c-1.34 0-1.52 1.09-1.54 1.31v.28c.02.15.2 1.24 1.54 1.24H7.8c.27 0 .52.15.65.38l4.33 7.71z"
  }));
};
Sa.displayName = "FlightLeft";
function p2() {
  return p2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, p2.apply(this, arguments);
}
var Ca = function Ca(e) {
  return a.createElement("svg", p2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M11.66 23H8.84c-.24 0-.47-.12-.61-.31a.75.75 0 0 1-.1-.68l2.37-7.11H6.02l-1.55 1.55a.75.75 0 0 1-.53.22H1.99c-.23 0-.45-.11-.59-.29a.75.75 0 0 1-.13-.65L2.22 12l-.95-3.74c-.06-.22 0-.46.13-.65.14-.18.36-.29.59-.29h1.95c.2 0 .39.08.53.22l1.55 1.55h4.48L8.13 1.98a.75.75 0 0 1 .1-.68c.14-.2.37-.31.61-.31h2.82c.27 0 .52.15.65.38l4.33 7.71h3.08c2.22 0 2.96 1.75 3.03 2.68v.41c-.08.99-.81 2.74-3.03 2.74h-3.08l-4.33 7.71c-.13.24-.38.38-.65.38m-1.78-1.5h1.34l4.33-7.71c.13-.24.38-.38.65-.38h3.52c1.34 0 1.52-1.09 1.54-1.31v-.28c-.02-.15-.2-1.24-1.54-1.24H16.2c-.27 0-.52-.15-.65-.38l-4.33-7.71H9.88l2.37 7.11c.08.23.04.48-.1.68a.74.74 0 0 1-.61.31H5.7a.75.75 0 0 1-.53-.22L3.62 8.82h-.67l.72 2.81c.02.08.08.38 0 .72l-.72 2.81h.67l1.55-1.55a.75.75 0 0 1 .53-.22h5.84c.24 0 .47.12.61.31s.18.45.1.68l-2.37 7.11z"
  }));
};
Ca.displayName = "FlightRight";
function O2() {
  return O2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, O2.apply(this, arguments);
}
var Ra = function Ra(e) {
  return a.createElement("svg", O2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M19.964 2.251c.504.018.878.219 1.166.445q.06.048.11.106c.22.262.451.62.5 1.123.048.485-.085 1-.367 1.567-.528 1.06-1.701 2.544-3.911 4.79l2.758 7.5a1.75 1.75 0 0 1-.401 1.838l-.492.495a1.75 1.75 0 0 1-2.754-.354l-3.264-5.617-3.102 2.88.175 2.26a.75.75 0 0 1-.218.59L8.502 21.53a.75.75 0 0 1-1.224-.249l-1.335-3.29-3.238-1.387a.75.75 0 0 1-.237-1.218l1.395-1.404a.75.75 0 0 1 .532-.22h2.451l2.851-3.222-5.913-3.567a1.75 1.75 0 0 1-.248-2.815l.547-.48a1.75 1.75 0 0 1 1.792-.311l7.765 3.049c2.247-2.072 3.73-3.21 4.782-3.746.56-.286 1.066-.437 1.542-.42m-.86 1.756c-.9.459-2.345 1.552-4.789 3.829a.75.75 0 0 1-.785.15L5.327 4.763a.25.25 0 0 0-.256.044l-.547.48a.25.25 0 0 0 .035.401l6.684 4.033a.75.75 0 0 1 .174 1.14l-3.671 4.147a.75.75 0 0 1-.562.253H4.707l-.397.399 2.507 1.074a.75.75 0 0 1 .4.408l1.026 2.528.617-.615-.177-2.277a.75.75 0 0 1 .238-.607l4.055-3.766a.75.75 0 0 1 1.158.173l3.736 6.428a.25.25 0 0 0 .393.05l.492-.494a.25.25 0 0 0 .057-.263l-2.923-7.947a.75.75 0 0 1 .173-.788c2.427-2.438 3.533-3.867 3.968-4.741.212-.426.228-.65.218-.753a.45.45 0 0 0-.106-.24.4.4 0 0 0-.23-.08c-.123-.005-.366.03-.809.256",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M19.964 2.251c.504.018.878.219 1.166.445q.06.048.11.106c.22.262.451.62.5 1.123.048.485-.085 1-.367 1.567-.528 1.06-1.701 2.544-3.911 4.79l2.758 7.5a1.75 1.75 0 0 1-.401 1.838l-.492.495a1.75 1.75 0 0 1-2.754-.354l-3.264-5.617-3.102 2.88.175 2.26a.75.75 0 0 1-.218.59L8.502 21.53a.75.75 0 0 1-1.224-.249l-1.335-3.29-3.238-1.387a.75.75 0 0 1-.237-1.218l1.395-1.404a.75.75 0 0 1 .532-.22h2.451l2.851-3.222-5.913-3.567a1.75 1.75 0 0 1-.248-2.815l.547-.48a1.75 1.75 0 0 1 1.792-.311l7.765 3.049c2.247-2.072 3.73-3.21 4.782-3.746.56-.286 1.066-.437 1.542-.42m-.86 1.756c-.9.459-2.345 1.552-4.789 3.829a.75.75 0 0 1-.785.15L5.327 4.763a.25.25 0 0 0-.256.044l-.547.48a.25.25 0 0 0 .035.401l6.684 4.033a.75.75 0 0 1 .174 1.14l-3.671 4.147a.75.75 0 0 1-.562.253H4.707l-.397.399 2.507 1.074a.75.75 0 0 1 .4.408l1.026 2.528.617-.615-.177-2.277a.75.75 0 0 1 .238-.607l4.055-3.766a.75.75 0 0 1 1.158.173l3.736 6.428a.25.25 0 0 0 .393.05l.492-.494a.25.25 0 0 0 .057-.263l-2.923-7.947a.75.75 0 0 1 .173-.788c2.427-2.438 3.533-3.867 3.968-4.741.212-.426.228-.65.218-.753a.45.45 0 0 0-.106-.24.4.4 0 0 0-.23-.08c-.123-.005-.366.03-.809.256",
    clipRule: "evenodd"
  }));
};
Ra.displayName = "Flight";
function E2() {
  return E2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, E2.apply(this, arguments);
}
var Ma = function Ma(e) {
  return a.createElement("svg", E2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M7.53 1.5c-.62 0-1.26.26-1.81.78-1.2 1.14-1.95 3.37-1.95 5.76-.12 1.44.3 2.63 1.16 3.26.25.18.66.54.65.87l-.31 8.43c-.01.5.18.98.54 1.34.38.38.89.6 1.42.6h.51c.56 0 1.1-.21 1.48-.58.36-.35.56-.83.56-1.37l-.34-8.43c0-.34.4-.69.65-.88.85-.63 1.28-1.82 1.16-3.2 0-2.47-.74-4.71-1.92-5.83-.54-.51-1.16-.76-1.79-.76zm1.65 8.59c-.86.63-1.28 1.35-1.26 2.13l.34 8.41c0 .11-.04.19-.11.27-.1.1-.26.17-.48.15h-.46a.55.55 0 0 1-.35-.15.37.37 0 0 1-.11-.25l.31-8.44c.02-.78-.4-1.49-1.26-2.12-.41-.3-.62-1.04-.55-1.99 0-2.29.75-4.03 1.48-4.73.24-.23.48-.35.71-.37h.15c.22.01.45.13.68.35.72.69 1.46 2.42 1.46 4.81.07.89-.14 1.63-.56 1.93zm7.32-1.26c.41 0 .75-.34.75-.75V2.25c0-.41-.34-.75-.75-.75s-.75.34-.75.75v5.83c0 .41.34.75.75.75m3.13-6.65.6 5.83c.12 1.34-.24 2.49-.99 3.14-.33.29-.77.68-.77.96l.31 8.49a1.9 1.9 0 0 1-.55 1.39c-.36.37-.87.58-1.39.58h-.66c-.53 0-1.03-.21-1.4-.59-.36-.37-.55-.86-.54-1.38l.28-8.5c.01-.265-.423-.645-.751-.934l-.019-.016c-.75-.66-1.11-1.8-.99-3.14l.6-5.84a.75.75 0 0 1 .82-.67c.41.04.71.41.67.82l-.6 5.83c-.08.83.1 1.53.48 1.86l.005.005c.55.48 1.305 1.138 1.275 2.125l-.28 8.5c0 .14.08.24.12.29.09.09.2.14.33.14h.65c.15.01.24-.04.33-.13.05-.04.12-.14.12-.29l-.31-8.49c-.03-.997.725-1.656 1.275-2.135l.005-.005c.38-.33.56-1.03.48-1.87l-.59-5.82a.75.75 0 0 1 .67-.82c.42-.04.78.26.82.67",
    clipRule: "evenodd"
  }));
};
Ma.displayName = "Food";
function S2() {
  return S2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, S2.apply(this, arguments);
}
var Ta = function Ta(e) {
  return a.createElement("svg", S2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    fill: e.color || "#222222",
    clipPath: "url(#a)"
  }, a.createElement("path", {
    d: "M16 16.37c-2.23 0-2.83-4.88-2.83-7.76S13.77.85 16 .85s2.83 4.88 2.83 7.76-.6 7.76-2.83 7.76m-.03-14.02c-.33.15-1.3 2.24-1.3 6.26s.92 6.01 1.33 6.25c.41-.24 1.33-2.33 1.33-6.25s-.97-6.11-1.36-6.26"
  }), a.createElement("path", {
    fillRule: "evenodd",
    d: "M16 16.37c-4.28 0-7.76-3.48-7.76-7.76S11.72.85 16 .85s7.76 3.48 7.76 7.76-3.48 7.76-7.76 7.76m0-14.02a6.27 6.27 0 0 0-5.617 3.5h11.234A6.27 6.27 0 0 0 16 2.35M9.74 8.61q.001-.648.128-1.26h12.264a6.3 6.3 0 0 1 .005 2.5H9.864a6.3 6.3 0 0 1-.124-1.24M16 14.87a6.27 6.27 0 0 1-5.627-3.52h11.254A6.27 6.27 0 0 1 16 14.87M1.27 22.99c.24.11.48.16.73.16v.01c.42 0 .82-.15 1.15-.44l2.06-1.8c.04-.04.1-.06.16-.06h10.62c.96 0 1.75-.79 1.75-1.75v-.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.5c0 .14-.11.25-.25.25H5.37c-.42 0-.83.15-1.15.43l-2.06 1.8c-.11.09-.22.06-.27.04-.06-.03-.15-.09-.15-.23V8.6c0-.14.11-.25.25-.25h4c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4c-.96 0-1.75.79-1.75 1.75v12.8c0 .69.4 1.3 1.03 1.59",
    clipRule: "evenodd"
  })), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
Ta.displayName = "GlobalSMS";
function C2() {
  return C2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, C2.apply(this, arguments);
}
var Pa = function Pa(e) {
  return a.createElement("svg", C2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M9.868 5.207C9.188 6.908 8.75 9.31 8.75 12s.438 5.092 1.118 6.793c.34.852.728 1.492 1.12 1.906.39.412.732.551 1.012.551s.622-.139 1.012-.551c.392-.414.78-1.054 1.12-1.907.68-1.7 1.118-4.102 1.118-6.792s-.438-5.092-1.118-6.793c-.34-.852-.728-1.492-1.12-1.906-.39-.412-.732-.551-1.012-.551s-.622.139-1.012.551c-.392.414-.78 1.054-1.12 1.906m.03-2.936c.567-.6 1.277-1.021 2.102-1.021s1.535.421 2.102 1.02c.565.598 1.04 1.423 1.423 2.38.767 1.919 1.225 4.518 1.225 7.35s-.458 5.431-1.225 7.35c-.383.957-.858 1.782-1.423 2.38-.567.599-1.277 1.02-2.102 1.02s-1.535-.421-2.102-1.02c-.565-.598-1.04-1.423-1.423-2.38C7.708 17.43 7.25 14.832 7.25 12s.458-5.431 1.225-7.35c.383-.957.858-1.782 1.423-2.38",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M9.868 5.207C9.188 6.908 8.75 9.31 8.75 12s.438 5.092 1.118 6.793c.34.852.728 1.492 1.12 1.906.39.412.732.551 1.012.551s.622-.139 1.012-.551c.392-.414.78-1.054 1.12-1.907.68-1.7 1.118-4.102 1.118-6.792s-.438-5.092-1.118-6.793c-.34-.852-.728-1.492-1.12-1.906-.39-.412-.732-.551-1.012-.551s-.622.139-1.012.551c-.392.414-.78 1.054-1.12 1.906m.03-2.936c.567-.6 1.277-1.021 2.102-1.021s1.535.421 2.102 1.02c.565.598 1.04 1.423 1.423 2.38.767 1.919 1.225 4.518 1.225 7.35s-.458 5.431-1.225 7.35c-.383.957-.858 1.782-1.423 2.38-.567.599-1.277 1.02-2.102 1.02s-1.535-.421-2.102-1.02c-.565-.598-1.04-1.423-1.423-2.38C7.708 17.43 7.25 14.832 7.25 12s.458-5.431 1.225-7.35c.383-.957.858-1.782 1.423-2.38",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M21 8.75H3v-1.5h18z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M21 8.75H3v-1.5h18z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M21 16.75H3v-1.5h18z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M21 16.75H3v-1.5h18z",
    clipRule: "evenodd"
  }));
};
Pa.displayName = "Globe";
function R2() {
  return R2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, R2.apply(this, arguments);
}
var ka = function ka(e) {
  return a.createElement("svg", R2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M12 21.25c-.18 0-.36-.06-.5-.19l-7.79-7.03c-2.5-2.6-2.34-5.15-2.33-5.25 0-1.89.55-3.42 1.64-4.49 1.56-1.54 3.65-1.54 3.73-1.52 2.71 0 4.41 1.33 5.26 2.24.85-.91 2.55-2.24 5.27-2.24.08 0 2.16-.01 3.72 1.52 1.09 1.07 1.64 2.6 1.64 4.54 0 .05.16 2.6-2.29 5.16l-7.83 7.07c-.14.13-.32.19-.5.19zm-5.27-17s-1.58.01-2.68 1.1c-.78.78-1.18 1.95-1.18 3.46 0 .13-.09 2.07 1.88 4.12L12 19.47l7.29-6.58c1.93-2.02 1.85-3.96 1.84-4.04 0-1.57-.4-2.73-1.18-3.51-1.12-1.11-2.68-1.1-2.67-1.1-3.17 0-4.57 2.24-4.63 2.33-.14.22-.41.38-.64.36-.26 0-.51-.14-.64-.36-.06-.09-1.47-2.33-4.62-2.33z"
  }));
};
ka.displayName = "Heart";
function M2() {
  return M2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, M2.apply(this, arguments);
}
var Aa = function Aa(e) {
  return a.createElement("svg", M2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M12.02 14.68c-.41 0-.75-.34-.75-.75 0-.76.09-1.56.74-2.23.2-.2.44-.42.69-.64.33-.28.67-.58.86-.83.37-.5.48-1.11.28-1.65-.19-.52-.64-.89-1.25-1.02-.97-.21-2.03.35-2.28 1.21-.12.4-.53.62-.93.51a.746.746 0 0 1-.51-.93c.46-1.61 2.32-2.64 4.05-2.25 1.11.25 1.96.97 2.33 1.97.37 1.02.19 2.16-.49 3.07-.274.368-.645.691-1.014 1.012l-.066.058-.026.022a8 8 0 0 0-.564.518c-.24.25-.32.55-.32 1.19 0 .41-.34.75-.75.75zM12.02 17.93a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5",
    clipRule: "evenodd"
  }));
};
Aa.displayName = "Help";
function T2() {
  return T2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, T2.apply(this, arguments);
}
var Ba = function Ba(e) {
  return a.createElement("svg", T2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M18.15 22.75H5.85c-1.65 0-2.99-1.23-2.99-2.75V4c0-1.52 1.34-2.75 2.99-2.75h7.97c.75 0 1.46.28 1.99.79l4.47 4.24c.54.51.85 1.23.85 1.96V20c0 1.52-1.34 2.75-2.99 2.75zm-12.3-20c-.82 0-1.49.56-1.49 1.25v16c0 .69.67 1.25 1.49 1.25h12.31c.82 0 1.49-.56 1.49-1.25V8.24c0-.33-.14-.64-.39-.88l-4.47-4.24c-.25-.24-.6-.38-.96-.38H5.86z"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M6.26 16.03V8.54h1.55v2.76c.19-.16.39-.29.61-.39q.33-.15.78-.15.42 0 .75.15c.22.1.4.24.55.41.15.18.26.38.34.62s.11.5.11.79v3.3H9.4v-3.3c0-.25-.06-.45-.17-.59-.12-.14-.29-.21-.52-.21-.17 0-.33.04-.48.11s-.29.17-.43.3v3.7H6.25zM14.14 9.43c0 .12-.02.24-.07.35s-.12.2-.21.29c-.09.08-.19.15-.3.19-.11.05-.24.07-.37.07s-.24-.02-.35-.07a1 1 0 0 1-.29-.19 1 1 0 0 1-.2-.29.8.8 0 0 1-.07-.35c0-.13.02-.25.07-.36s.11-.21.2-.29c.08-.08.18-.15.29-.19s.23-.07.35-.07a.97.97 0 0 1 .67.26c.09.08.15.18.21.29.05.11.07.23.07.36m-.18 2.17v4.43h-1.55V11.6zM15.61 15.25c0-.12.02-.23.07-.33.04-.1.11-.19.18-.27a.75.75 0 0 1 .28-.18c.11-.04.22-.07.35-.07s.24.02.35.07.2.11.28.18c.08.08.14.17.19.27s.07.21.07.33-.02.23-.07.34-.11.2-.19.27-.17.14-.28.18-.22.07-.35.07-.24-.02-.35-.07a.8.8 0 0 1-.46-.45.8.8 0 0 1-.07-.34m1.62-6.5v2.11c0 .31-.02.61-.06.91s-.08.61-.15.92h-1.05c-.06-.31-.11-.62-.15-.92s-.05-.61-.05-.91V8.75h1.46"
  }));
};
Ba.displayName = "HiAppPrepaid";
function P2() {
  return P2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, P2.apply(this, arguments);
}
var Ha = function Ha(e) {
  return a.createElement("svg", P2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M10.02 15.07 20.46 4.63c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-1.576 1.576c-1.79-1.162-3.78-1.787-5.844-1.796-3.57.02-7.06 1.99-9.33 5.26-.4.57-.78 1.2-1.12 1.87-.35.67-.75 1.44-.15 2.54l.09.17c.35.66.72 1.34 1.17 1.99a13 13 0 0 0 2.469 2.681L3.6 19.37c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l5.325-5.325zm-6.14-.75c.658.944 1.43 1.775 2.302 2.468l2.263-2.263A4.45 4.45 0 0 1 7.58 11.9a4.421 4.421 0 0 1 7.046-3.556L16.74 6.23c-1.475-.897-3.088-1.371-4.7-1.38-3.13.02-6.16 1.74-8.15 4.62-.36.52-.71 1.09-1.02 1.7-.34.66-.36.78-.16 1.14l.09.17c.35.65.68 1.26 1.08 1.84m9.67-4.899A2.9 2.9 0 0 0 12 8.97a2.923 2.923 0 0 0-2.475 4.475z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M9.28 20.07c.89.25 1.81.38 2.72.38v.01c3.58-.01 7.08-1.97 9.36-5.26.45-.65.82-1.33 1.17-1.99l.09-.17c.59-1.1.2-1.87-.15-2.54-.34-.67-.72-1.3-1.12-1.87-.1-.14-.2-.28-.3-.41A.76.76 0 0 0 20 8.08c-.33.25-.39.72-.14 1.05a14.7 14.7 0 0 1 1.28 2.06c.34.66.36.77.16 1.14l-.09.17c-.35.65-.68 1.26-1.08 1.84-2.01 2.89-5.05 4.62-8.13 4.62-.78 0-1.55-.12-2.32-.33-.4-.12-.81.12-.92.52-.11.39.12.81.52.92"
  }));
};
Ha.displayName = "Hide";
function k2() {
  return k2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, k2.apply(this, arguments);
}
var Wa = function Wa(e) {
  return a.createElement("svg", k2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M12.858 4.342a1.25 1.25 0 0 0-1.716 0l-7 6.611a1.25 1.25 0 0 0-.392.91V19.5c0 .414.336.75.75.75h4a.25.25 0 0 0 .25-.25v-3.5a3.25 3.25 0 0 1 6.5 0V20c0 .138.112.25.25.25h4a.75.75 0 0 0 .75-.75v-7.638a1.25 1.25 0 0 0-.392-.909zm-2.746-1.09a2.75 2.75 0 0 1 3.776 0l7 6.61c.55.52.862 1.243.862 2V19.5a2.25 2.25 0 0 1-2.25 2.25h-4A1.75 1.75 0 0 1 13.75 20v-3.5a1.75 1.75 0 1 0-3.5 0V20a1.75 1.75 0 0 1-1.75 1.75h-4a2.25 2.25 0 0 1-2.25-2.25v-7.638c0-.757.312-1.48.862-2z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M12.858 4.342a1.25 1.25 0 0 0-1.716 0l-7 6.611a1.25 1.25 0 0 0-.392.91V19.5c0 .414.336.75.75.75h4a.25.25 0 0 0 .25-.25v-3.5a3.25 3.25 0 0 1 6.5 0V20c0 .138.112.25.25.25h4a.75.75 0 0 0 .75-.75v-7.638a1.25 1.25 0 0 0-.392-.909zm-2.746-1.09a2.75 2.75 0 0 1 3.776 0l7 6.61c.55.52.862 1.243.862 2V19.5a2.25 2.25 0 0 1-2.25 2.25h-4A1.75 1.75 0 0 1 13.75 20v-3.5a1.75 1.75 0 1 0-3.5 0V20a1.75 1.75 0 0 1-1.75 1.75h-4a2.25 2.25 0 0 1-2.25-2.25v-7.638c0-.757.312-1.48.862-2z",
    clipRule: "evenodd"
  }));
};
Wa.displayName = "Home";
function A2() {
  return A2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, A2.apply(this, arguments);
}
var La = function La(e) {
  return a.createElement("svg", A2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    d: "M12 1.75a6.25 6.25 0 0 1 6.125 5h3.295a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-.75.75H2.58a.75.75 0 0 1-.75-.75v-14a.75.75 0 0 1 .75-.75h3.295a6.25 6.25 0 0 1 6.125-5m-8.67 19h2.42V8.25H3.33zM12 3.25A4.747 4.747 0 0 0 7.25 8v12.75h2V13A2.756 2.756 0 0 1 12 10.25 2.756 2.756 0 0 1 14.75 13v7.75h2V8A4.747 4.747 0 0 0 12 3.25m6.25 17.5h2.42V8.25h-2.42zm-7.5-.18h2.5v-1.82h-2.5zM12 11.75c-.686 0-1.25.564-1.25 1.25v4.25h2.5V13c0-.686-.564-1.25-1.25-1.25m1-5a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5z"
  }));
};
La.displayName = "Hotel";
function B2() {
  return B2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, B2.apply(this, arguments);
}
var _a = function _a(e) {
  return a.createElement("svg", B2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    fill: e.color || "#222222",
    clipPath: "url(#a)"
  }, a.createElement("path", {
    d: "M15.96 15.81c-2.23 0-2.83-4.88-2.83-7.76s.6-7.76 2.83-7.76 2.83 4.88 2.83 7.76-.6 7.76-2.83 7.76m-.03-14.02c-.33.15-1.3 2.24-1.3 6.26s.92 6 1.33 6.25c.41-.24 1.33-2.32 1.33-6.25s-.97-6.11-1.36-6.26"
  }), a.createElement("path", {
    fillRule: "evenodd",
    d: "M8.21 8.05c0 4.28 3.48 7.76 7.76 7.76s7.76-3.48 7.76-7.76S20.25.29 15.97.29 8.21 3.77 8.21 8.05m2.142-2.76a6.27 6.27 0 0 1 5.618-3.5 6.27 6.27 0 0 1 5.617 3.5zm-.514 1.5h12.264a6.3 6.3 0 0 1 .005 2.5H9.833a6.3 6.3 0 0 1 .005-2.5m6.132 7.52a6.27 6.27 0 0 0 5.627-3.52H10.343a6.27 6.27 0 0 0 5.627 3.52m.03 9.4h.02c.41 0 .82-.15 1.13-.43.37-.33.58-.8.58-1.3v-1.15c0-.81-.55-1.5-1.33-1.7l-2.6-.65c-.69-.17-1.41.08-1.83.65l-1.25 1.67c-4.07-1.84-6.27-4.98-7.44-7.52l1.63-1.24c.55-.42.8-1.13.63-1.81l-.65-2.61c-.2-.78-.9-1.32-1.7-1.32H2c-.5 0-.96.21-1.29.57-.32.35-.47.82-.42 1.29.13 1.2.47 3.07 1.36 5.18l.37.89.02-.02c1.29 2.66 3.62 5.85 7.75 7.82l-.02.02.9.37c1.57.64 3.3 1.07 5.14 1.28.07.01.13.01.19.01m-.03-1.51a18.4 18.4 0 0 1-3.82-.83l1-1.35c.06-.08.16-.11.26-.09l2.6.65c.11.03.19.12.19.24v1.15c0 .1-.05.15-.08.18-.04.05-.09.05-.15.05M1.82 7.86c.04-.04.1-.07.17-.07v-.02h1.19c.11 0 .21.08.24.19l.65 2.61c.02.1-.01.2-.09.26l-1.3 1a17 17 0 0 1-.9-3.854c-.001-.018-.005-.071.04-.116",
    clipRule: "evenodd"
  })), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
_a.displayName = "IDD";
function H2() {
  return H2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, H2.apply(this, arguments);
}
var Ia = function Ia(e) {
  return a.createElement("svg", H2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M22.01 19.51a.72.72 0 0 0-.2-.5s-.01-.02-.02-.03l-2.48-2.48a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.21 1.21H9.55c-.06 0-.11.02-.16.03a2.75 2.75 0 0 0-2.65-2.04c-.94 0-1.78.48-2.27 1.2a2.98 2.98 0 0 1-.97-2.2c0-1.66 1.35-3 3-3h2.87c.33 1.15 1.38 2 2.63 2s2.3-.85 2.63-2h2.87c2.48 0 4.5-2.02 4.5-4.5 0-1.54-.79-2.95-2.07-3.77 0-.08.02-.15.02-.23 0-1.52-1.23-2.75-2.75-2.75-1.26 0-2.31.85-2.64 2.01H7.37c-.33-1.15-1.38-2-2.63-2-1.52 0-2.75 1.23-2.75 2.75s1.23 2.75 2.75 2.75c1.26 0 2.31-.85 2.63-2h7.19a2.75 2.75 0 0 0 2.64 2.01c.89 0 1.67-.43 2.17-1.08.7.56 1.12 1.41 1.12 2.33 0 1.66-1.35 3-3 3h-2.86c-.33-1.15-1.38-2-2.63-2s-2.3.85-2.63 2H6.5c-2.48 0-4.5 2.02-4.5 4.5 0 1.51.76 2.9 1.99 3.73v.02c0 1.52 1.23 2.75 2.75 2.75 1.26 0 2.32-.86 2.64-2.02.05.01.11.03.17.03h9.91l-1.21 1.21c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l2.48-2.48s.01-.02.02-.03a.717.717 0 0 0 .2-.5zM17.21 5.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M12 10.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m-5.26 10a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
  }));
};
Ia.displayName = "Itinerary";
function W2() {
  return W2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, W2.apply(this, arguments);
}
var Na = function Na(e) {
  return a.createElement("svg", W2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    d: "M14.01 1.2a2.5 2.5 0 0 1 2.5 2.5v4.59h3.74a2.5 2.5 0 0 1 2.5 2.5v10.55c0 .56-.31 1.07-.81 1.33-.22.11-.45.17-.69.17-.3 0-.6-.09-.86-.27l-1.47-1.03c-.25-.16-.53-.25-.83-.25H10a2.5 2.5 0 0 1-2.5-2.5v-5.04H5.91c-.26 0-.51.07-.73.19l-1.37 1.37c-.29.29-.67.44-1.06.44-.19 0-.38-.03-.57-.11-.56-.24-.93-.78-.93-1.39V3.7a2.5 2.5 0 0 1 2.5-2.5zm-4 8.59c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h8.09c.59 0 1.17.17 1.66.5l1.49 1.05V10.79c0-.516-.396-.944-.898-.995l-.092-.005zm5.49.97c.41 0 .75.34.75.75v.67h2.61c.41 0 .75.34.75.75s-.34.75-.75.75h-.55c-.25.99-.77 2.2-1.64 3.2.52.25 1.09.38 1.71.38.41 0 .75.34.75.75s-.34.75-.75.75a5.34 5.34 0 0 1-2.9-.83c-.77.5-1.71.83-2.85.83-.41 0-.75-.34-.75-.75s.34-.75.75-.75c.64 0 1.18-.14 1.65-.37-.42-.47-.79-1-1.11-1.63a.76.76 0 0 1 .33-1.01c.37-.18.82-.04 1.01.33.28.56.61 1.02.97 1.4.66-.74 1.05-1.64 1.26-2.3h-4.6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.61v-.67c0-.41.34-.75.75-.75M3.76 2.7c-.55 0-1 .45-1 1v10.55l1.49-1.5c.49-.32 1.07-.5 1.66-.5H7.5v-1.46c0-.303.057-.592.155-.86H6.37l-.68 1.35c-.19.38-.63.53-1.01.34a.75.75 0 0 1-.33-1.01l3.49-6.99a.76.76 0 0 1 .67-.41c.28 0 .54.17.67.42l2.32 4.66h3.51V3.7c0-.55-.45-1-1-1zm3.35 5.74h2.042q.325-.117.682-.142L8.51 5.65z"
  }));
};
Na.displayName = "Languages";
function L2() {
  return L2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, L2.apply(this, arguments);
}
var Va = function Va(e) {
  return a.createElement("svg", L2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M10.48 18.54h3.04c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3.04c-.41 0-.75.34-.75.75s.34.75.75.75"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M19.99 12.44c0 .22-.042.432-.118.627q.062.106.088.233l1.22 5.88c.11.55-.02 1.13-.37 1.55-.3.37-.74.58-1.2.58H4.37c-.46 0-.89-.21-1.2-.58-.34-.42-.48-1-.37-1.55l1.22-5.88a.7.7 0 0 1 .1-.251 1.7 1.7 0 0 1-.11-.61v-8c0-.96.79-1.75 1.75-1.75h12.48c.96 0 1.75.79 1.75 1.75zm-1.75 1.75H5.76q-.095 0-.186-.01H5.37v.01l-1.1 5.29c-.04.18.06.32.1.33h15.26s.13-.15.1-.34l-1.1-5.29h-.204a2 2 0 0 1-.186.01m-12.48-10c-.14 0-.25.11-.25.25v8c0 .14.11.25.25.25h12.48c.14 0 .25-.11.25-.25v-8c0-.14-.11-.25-.25-.25z",
    clipRule: "evenodd"
  }));
};
Va.displayName = "Laptop";
function _2() {
  return _2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, _2.apply(this, arguments);
}
var Fa = function Fa(e) {
  return a.createElement("svg", _2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "m13.83 2 .11.382c4.459-.443 6.737 1.321 7.72 2.448.86.99 1.35 2.2 1.15 2.88a.755.755 0 0 1-1.04.48c-2.52-1.18-3.82.55-3.96.75-.2.29-.59.4-.92.26-.669-.289-1.27-.416-1.802-.437L17.63 21.85c.08.41-.19.8-.59.88q-.04.001-.078.005-.033.005-.062.005v.01c-.35 0-.67-.25-.74-.61L13.607 8.995a3.6 3.6 0 0 0-1.517 1.065c-.23.31-.67.39-1 .19-2.26-1.4-3.95.44-4.13.65-.15.17-.36.26-.57.26l.01-.01c-.09 0-.18-.01-.26-.05a.76.76 0 0 1-.49-.7c0-.672.194-6.352 6.789-7.785l-.059-.205a.76.76 0 0 1 .52-.93c.39-.12.81.12.93.52M5.783 20.3c-1.314-.465-2.236-1.408-2.873-2.9-.79-1.843-1.434-3.633-1.586-4.056l-.034-.094c-.14-.39.07-.82.46-.96s.82.07.96.46c0 .02.7 2 1.58 4.05.73 1.71 1.77 2.35 3.81 2.35 1.89 0 3.39-1.3 3.4-1.31.31-.27.78-.24 1.06.07.27.31.24.78-.07 1.06a7.5 7.5 0 0 1-1.737 1.082L12.55 21.4a.75.75 0 0 1-.9 1.2l-2.48-1.86-5.83 1.97c-.08.03-.16.04-.24.04-.31 0-.6-.2-.71-.51-.13-.39.08-.82.47-.95zM10.85 4.71c-2.188 1.026-3.083 2.704-3.45 4 .865-.428 1.96-.667 3.158-.34-.114-1.144-.084-2.519.292-3.66m2.45-.737.21-.033-.01.01.226-.03c1.387.056 2.205 2.389 2.508 3.48-1.761-.397-3.197.064-4.177.698-.113-1.445-.017-3.744 1.244-4.125m4.39 3.041c-.274-1.04-.751-2.246-1.458-3.16 1.89.166 3.094.843 3.828 1.486.39.34.68.7.88 1.01a4.4 4.4 0 0 0-3.25.664",
    clipRule: "evenodd"
  }));
};
Fa.displayName = "Leisure";
function I2() {
  return I2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, I2.apply(this, arguments);
}
var Da = function Da(e) {
  return a.createElement("svg", I2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M9.62 22.75c-.24 0-.49-.05-.73-.17-.73-.34-1.1-1.1-.92-1.88l1.47-6.63a.15.15 0 0 0-.04-.15c-.02-.03-.06-.04-.14-.07l-2.33.04H6.9c-.63 0-1.21-.35-1.49-.92a1.67 1.67 0 0 1 .16-1.77l6.99-9.28c.48-.63 1.29-.85 2.01-.53.73.32 1.12 1.06.98 1.84L14.38 9.6c-.01.07.01.12.04.15.02.03.04.08.14.06h2.54a1.673 1.673 0 0 1 1.32 2.71l-7.5 9.58c-.33.42-.81.65-1.31.65zm-.36-10.39c.51 0 .98.22 1.3.62.33.4.45.92.34 1.42l-1.47 6.63s-.03.14.1.2c.12.06.19-.02.22-.05l7.5-9.58c.06-.07.04-.14.02-.19a.18.18 0 0 0-.16-.1h-2.54c-.5 0-.97-.22-1.29-.6s-.45-.89-.36-1.38l1.17-6.37s.03-.14-.1-.2-.19.03-.21.06l-7 9.29c-.06.07-.04.14-.02.19.02.04.08.07.16.1l2.33-.04h.03z"
  }));
};
Da.displayName = "Lightning";
function N2() {
  return N2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, N2.apply(this, arguments);
}
var $a = function $a(e) {
  return a.createElement("svg", N2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M19.15 22.68c-.91 0-1.65-.22-2.21-.65-.76-.58-.74-1.33-.73-1.87v-3.55c0-1.52 1.24-2.75 2.75-2.75h2.19c0-.59-.01-1.18-.01-1.77 0-.63-.07-1.28-.21-1.93-.38-1.81-1.2-3.43-2.35-4.68-1.14-1.23-2.64-2.09-4.33-2.48 0 0-.97-.17-2.26-.18-1.3 0-2.28.18-2.29.19a8.4 8.4 0 0 0-4.29 2.47c-1.15 1.25-1.97 2.87-2.35 4.68-.14.65-.21 1.3-.21 1.93 0 .59 0 1.18-.01 1.77h2.19c1.52 0 2.75 1.23 2.75 2.75v3.55c.01.54.03 1.29-.73 1.87-.56.43-1.3.65-2.21.65-.99 0-1.8-.32-2.41-.95-1.13-1.17-1.08-2.97-1.08-3.05-.05-1.43-.03-2.94-.02-4.39 0-.73.02-1.46.02-2.2s.08-1.49.24-2.24c.44-2.08 1.38-3.94 2.72-5.39C5.65 3 7.42 1.99 9.4 1.54c.08-.02 1.14-.21 2.59-.22 1.46 0 2.53.2 2.57.21 2.02.46 3.78 1.47 5.12 2.93 1.34 1.45 2.28 3.31 2.72 5.39.16.75.24 1.5.24 2.24s0 1.46.02 2.2c.02 1.45.03 2.96-.02 4.44 0 .03.05 1.84-1.08 3-.61.63-1.42.95-2.41.95m-.19-7.32c-.69 0-1.25.56-1.25 1.25v3.58c-.01.5 0 .55.15.66.36.28.9.34 1.29.34.57 0 1.01-.16 1.33-.49.69-.7.66-1.95.66-1.97.03-1.13.03-2.26.02-3.37h-2.21zm-16.13 0c0 1.1 0 2.22.02 3.32 0 .06-.02 1.31.66 2.01.32.33.76.49 1.33.49.39 0 .93-.06 1.29-.34.14-.11.16-.15.15-.65v-3.58c0-.69-.56-1.25-1.25-1.25H2.82z"
  }));
};
$a.displayName = "Listen";
function V2() {
  return V2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, V2.apply(this, arguments);
}
var qa = function qa(e) {
  return a.createElement("svg", V2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M21.56 15.55c.07.03.14.03.21.03.33 0 .63-.21.72-.54.29-.99.43-2.01.43-3.04 0-6.02-4.9-10.92-10.92-10.92-.41 0-.75.34-.75.75s.34.75.75.75c5.19 0 9.42 4.22 9.42 9.42 0 .89-.12 1.77-.37 2.62-.12.4.11.81.51.93M7.01 2.98c.09.33.39.54.72.54v.01a.76.76 0 0 0 .39-.11c.36-.21.48-.67.27-1.03a.746.746 0 0 0-.97-.3c-.33.15-.51.53-.41.89M2.8 7.6c.12.07.24.1.37.1.26 0 .51-.14.65-.38.37-.64.81-1.23 1.31-1.77.28-.3.26-.78-.04-1.06a.755.755 0 0 0-1.06.04c-.58.62-1.09 1.31-1.51 2.05-.2.36-.08.81.28 1.02M2.13 15.23c-.34 0-.64-.23-.73-.57-.22-.86-.33-1.76-.33-2.66 0-.47.03-.94.09-1.4.05-.41.43-.7.84-.65s.7.43.65.84c-.05.4-.08.8-.08 1.21 0 .78.09 1.55.28 2.29.1.4-.14.81-.55.91-.06.02-.12.02-.18.02zM7.945 22.08h.005-.01zM8.63 21.63a.75.75 0 0 1-.98.39c-1.65-.71-3.11-1.84-4.22-3.26-.26-.33-.2-.8.12-1.05.33-.26.8-.2 1.05.12a9.54 9.54 0 0 0 3.64 2.81c.38.17.55.61.39.99M11.997 22.92a.756.756 0 0 1-.747-.75c0-.41.34-.75.75-.75 2.56 0 4.96-1.01 6.75-2.85.29-.29.76-.3 1.06-.01s.3.76.01 1.06a10.83 10.83 0 0 1-7.823 3.3M11.997 22.92H12h-.01z"
  }));
};
qa.displayName = "Loading";
function F2() {
  return F2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, F2.apply(this, arguments);
}
var Ua = function Ua(e) {
  return a.createElement("svg", F2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M14.62 3.16c0-1.47 1.53-2.44 2.86-1.81l3.5 1.66c.7.33 1.14 1.03 1.14 1.81v14.35a2 2 0 0 1-1.14 1.81l-3.5 1.66c-1.33.63-2.86-.34-2.86-1.81v-.33H5.91a2.406 2.406 0 0 1-2.41-2.41V16A.75.75 0 0 1 5 16v2.09c0 .506.404.91.91.91h8.71V5H5.91a.906.906 0 0 0-.91.91V8a.75.75 0 0 1-1.5 0V5.91A2.406 2.406 0 0 1 5.91 3.5h8.71zM9.5 7.67a.75.75 0 0 0-1.06 1.06l2.52 2.52H2.75a.75.75 0 0 0 0 1.5h8.21l-2.52 2.52a.75.75 0 0 0 1.06 1.06l3.732-3.732a.75.75 0 0 0 0-1.196z",
    clipRule: "evenodd"
  }));
};
Ua.displayName = "LogIn";
function D2() {
  return D2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, D2.apply(this, arguments);
}
var Ga = function Ga(e) {
  return a.createElement("svg", D2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.activeDotColor || "#E71336",
    d: "M20 6.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M19.919 10.5a6.5 6.5 0 0 1-2.065-.365L13.46 13.31c-.85.67-2.04.67-2.91-.03L2.79 7.658V7.55c0-.69.56-1.25 1.25-1.25h9.881a6.4 6.4 0 0 1-.372-1.5H4.04c-1.52 0-2.75 1.23-2.75 2.75v10.63c0 1.52 1.23 2.75 2.75 2.75h15.84c1.52 0 2.75-1.23 2.75-2.75V9.94a6.4 6.4 0 0 1-1.5.461v7.779c0 .69-.56 1.25-1.25 1.25H4.04c-.69 0-1.25-.56-1.25-1.25V9.503l6.86 4.957c.7.57 1.55.85 2.39.85v.01c.83 0 1.65-.27 2.33-.81z",
    clipRule: "evenodd"
  }));
};
Ga.displayName = "MailUnread";
function $2() {
  return $2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, $2.apply(this, arguments);
}
var Ya = function Ya(e) {
  return a.createElement("svg", $2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M4.04 20.93h15.84c1.52 0 2.75-1.23 2.75-2.75V7.55c0-1.52-1.23-2.75-2.75-2.75H4.04c-1.52 0-2.75 1.23-2.75 2.75v10.63c0 1.52 1.23 2.75 2.75 2.75M2.79 7.55c0-.69.56-1.25 1.25-1.25h15.84c.69 0 1.25.56 1.25 1.25v.218l-7.67 5.542c-.85.68-2.03.67-2.91-.03L2.79 7.658zm0 1.953 6.86 4.957c.7.57 1.55.85 2.39.85l-.01.01c.83 0 1.65-.27 2.33-.81l6.77-4.887v8.557c0 .69-.56 1.25-1.25 1.25H4.04c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  }));
};
Ya.displayName = "Mail";
function q2() {
  return q2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, q2.apply(this, arguments);
}
var Qa = function Qa(e) {
  return a.createElement("svg", q2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M7.56 14.88c-1.504-1.903-2.8-4.214-2.8-6.28 0-3.99 3.25-7.24 7.24-7.24s7.24 3.25 7.24 7.24c0 2.066-1.295 4.377-2.8 6.28h2.17c.78 0 1.5.45 1.83 1.15l1.06 3.02c.35.72.3 1.64-.17 2.39s-1.28 1.2-2.17 1.2H4.83c-.88 0-1.69-.45-2.17-1.2-.46-.73-.52-1.62-.17-2.41l.86-3c.33-.7 1.05-1.15 1.83-1.15zm1.302 1.5H5.18c-.19 0-.36.1-.45.26l-.86 2.98c-.16.33-.14.71.06 1.02s.52.5.9.5h14.33c.37 0 .7-.18.9-.5.2-.31.22-.69.06-1.02l-1.06-3.02c-.06-.1-.24-.22-.45-.22h-3.472c-1.4 1.476-2.719 2.46-3.138 2.46s-1.739-.984-3.138-2.46M12 2.86c-3.16 0-5.74 2.57-5.74 5.74 0 3.37 4.44 7.6 5.73 8.6 1.31-1.02 5.75-5.25 5.75-8.6 0-3.16-2.57-5.74-5.74-5.74m0 9.1a3.26 3.26 0 1 1 .001-6.521 3.26 3.26 0 0 1-.001 6.52m0-5.02c-.97 0-1.76.79-1.76 1.76s.79 1.76 1.76 1.76 1.76-.79 1.76-1.76-.79-1.76-1.76-1.76",
    clipRule: "evenodd"
  }));
};
Qa.displayName = "Map";
function U2() {
  return U2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, U2.apply(this, arguments);
}
var Xa = function Xa(e) {
  return a.createElement("svg", U2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M4.5 5.25h15c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-15c-.41 0-.75.34-.75.75s.34.75.75.75m15 7.5h-15c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h15c.41 0 .75.34.75.75s-.34.75-.75.75m0 7.5h-15c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h15c.41 0 .75.34.75.75s-.34.75-.75.75",
    clipRule: "evenodd"
  }));
};
Xa.displayName = "Menu";
function G2() {
  return G2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, G2.apply(this, arguments);
}
var Ka = function Ka(e) {
  return a.createElement("svg", G2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    d: "M16.39 9.19H7.61c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.78c.41 0 .75.34.75.75s-.34.75-.75.75M16.39 13.46H7.61c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.78c.41 0 .75.34.75.75s-.34.75-.75.75"
  }), a.createElement("path", {
    fill: e.color || "#242328",
    d: "M21.25 5c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h12.299c.624 0 1.23.212 1.718.602l2.827 2.262.064.038a.25.25 0 0 0 .342-.233zm1.5 14.919c0 1.421-1.593 2.232-2.734 1.448l-.109-.08-2.828-2.263a1.25 1.25 0 0 0-.78-.274H4A2.75 2.75 0 0 1 1.25 16V5A2.75 2.75 0 0 1 4 2.25h16A2.75 2.75 0 0 1 22.75 5z"
  }));
};
Ka.displayName = "Message";
function Y2() {
  return Y2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Y2.apply(this, arguments);
}
var Ja = function Ja(e) {
  return a.createElement("svg", Y2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M8 12.04c0 2.21 1.79 4 4 4s4-1.79 4-4V5.31c0-2.21-1.79-4-4-4s-4 1.79-4 4zm1.5-6.73a2.5 2.5 0 0 1 5 0v6.73a2.5 2.5 0 0 1-5 0z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M4.5 12.04a7.504 7.504 0 0 0 6.75 7.463v1.687H7.12c-.41 0-.75.34-.75.75s.34.75.75.75h9.76c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4.13v-1.687a7.504 7.504 0 0 0 6.75-7.463v-2.02c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.02c0 3.31-2.69 6-6 6s-6-2.69-6-6v-2.02c0-.41-.34-.75-.75-.75s-.75.34-.75.75z"
  }));
};
Ja.displayName = "Mic";
function Q2() {
  return Q2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Q2.apply(this, arguments);
}
var Za = function Za(e) {
  return a.createElement("svg", Q2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M14.56 11.45c.15.15.34.22.53.22h6.48c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H16.9l6.65-6.65c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-6.65 6.65V4.45c0-.41-.34-.75-.75-.75s-.75.34-.75.75v6.47q.001.165.067.306a.7.7 0 0 0 .153.224M2.45 23.53c.15.15.34.22.53.22s.38-.07.53-.22l6.65-6.65v4.67c0 .41.34.75.75.75s.75-.34.75-.75v-6.47a.7.7 0 0 0-.015-.15.74.74 0 0 0-.842-.6H4.43c-.41 0-.75.34-.75.75s.34.75.75.75h4.66l-6.64 6.64c-.29.29-.29.77 0 1.06",
    clipRule: "evenodd"
  }));
};
Za.displayName = "Minimise";
function X2() {
  return X2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, X2.apply(this, arguments);
}
var ei = function ei(e) {
  return a.createElement("svg", X2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1.75 21.5c0 .96.79 1.75 1.75 1.75h12c.96 0 1.75-.79 1.75-1.75V20c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5c0 .14-.11.25-.25.25h-12c-.14 0-.25-.11-.25-.25v-19c0-.14.11-.25.25-.25h12c.14 0 .25.11.25.25V4c0 .41.34.75.75.75s.75-.34.75-.75V2.5c0-.96-.79-1.75-1.75-1.75h-12c-.96 0-1.75.79-1.75 1.75zm9-16.25h-2.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.5c.41 0 .75.34.75.75s-.34.75-.75.75m0 6.75c0 3.17 2.58 5.75 5.75 5.75s5.75-2.58 5.75-5.75-2.58-5.75-5.75-5.75-5.75 2.58-5.75 5.75m1.5 0a4.26 4.26 0 0 1 4.25-4.25A4.26 4.26 0 0 1 20.75 12a4.26 4.26 0 0 1-4.25 4.25A4.26 4.26 0 0 1 12.25 12m2.31.74h1.19v1.19c0 .41.34.75.75.75s.75-.34.75-.75v-1.19h1.2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-1.2v-1.2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.2h-1.19c-.41 0-.75.34-.75.75s.34.75.75.75M8.5 19.5c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1",
    clipRule: "evenodd"
  }));
};
ei.displayName = "MobileAddon";
function K2() {
  return K2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, K2.apply(this, arguments);
}
var ti = function ti(e) {
  return a.createElement("svg", K2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M13.76 5.13V3.06c0-.16-.11-.29-.25-.29H10.5c-.14 0-.25.13-.25.29v2.07zm-5.01.05V3.06c0-.99.79-1.79 1.75-1.79h3.01c.96 0 1.75.8 1.75 1.79v2.122c.76.19 1.33.883 1.33 1.698v11.38c0 2.46-2.06 4.46-4.59 4.46s-4.59-2-4.59-4.46V6.88a1.76 1.76 0 0 1 1.34-1.7M12 21.22c-1.7 0-3.09-1.33-3.09-2.96V6.88c0-.14.11-.25.25-.25h5.68c.14 0 .25.11.25.25v11.38c0 1.63-1.39 2.96-3.09 2.96m-9.06-4.55c-.22 0-.45-.1-.59-.29A7.08 7.08 0 0 1 .85 12c0-1.6.59-3.3 1.66-4.58.27-.32.74-.36 1.06-.1.32.27.36.74.1 1.06A5.63 5.63 0 0 0 2.36 12c0 1.32.41 2.46 1.18 3.46.25.33.19.8-.13 1.05-.14.11-.3.16-.46.16zm1.97-1.89c.15.17.35.25.56.25.18 0 .36-.06.5-.19.31-.28.34-.75.06-1.06-.44-.49-.68-1.12-.68-1.78s.24-1.29.68-1.78c.27-.31.25-.78-.06-1.06a.756.756 0 0 0-1.06.06A4.2 4.2 0 0 0 3.85 12c0 1.03.37 2.02 1.06 2.78m16.15 1.89c-.16 0-.32-.05-.46-.16a.74.74 0 0 1-.13-1.05c.77-1 1.18-2.2 1.18-3.46s-.47-2.6-1.31-3.62a.75.75 0 0 1 .1-1.06.75.75 0 0 1 1.06.1A7.16 7.16 0 0 1 23.16 12c0 1.67-.52 3.11-1.5 4.38-.15.19-.37.29-.59.29zm-3.03-1.83c.14.13.32.19.5.19.21 0 .41-.08.56-.25A4.2 4.2 0 0 0 20.15 12c0-1.03-.37-2.02-1.06-2.78a.747.747 0 0 0-1.06-.06c-.31.28-.34.75-.06 1.06.44.49.68 1.12.68 1.78s-.24 1.29-.68 1.78c-.27.31-.25.78.06 1.06",
    clipRule: "evenodd"
  }));
};
ti.displayName = "MobileBroadband";
function J2() {
  return J2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, J2.apply(this, arguments);
}
var ni = function ni(e) {
  return a.createElement("svg", J2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M5.28 9.119 1.43 3.46a.74.74 0 0 1-.04-.77c.13-.25.39-.4.66-.4h7.96c.28 0 .53.15.66.4s.11.54-.04.77L6.78 9.12v11.85c0 .41-.34.75-.75.75s-.75-.34-.75-.75zm.74-1.569L3.46 3.78h5.12zm15.93 14.17c-.41 0-.75-.34-.75-.75v-16c0-.41.34-.75.75-.75s.75.34.75.75v16c0 .41-.34.75-.75.75m-12.69-.75c0 .41.34.75.75.75s.75-.34.75-.75v-4c0-.41-.34-.75-.75-.75s-.75.34-.75.75zm4.73.75c-.41 0-.75-.34-.75-.75v-7.5c0-.41.34-.75.75-.75s.75.34.75.75v7.5c0 .41-.34.75-.75.75m3.23-.75c0 .41.34.75.75.75s.75-.34.75-.75v-11c0-.41-.34-.75-.75-.75s-.75.34-.75.75z",
    clipRule: "evenodd"
  }));
};
ni.displayName = "MobileSignal";
function Z2() {
  return Z2 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Z2.apply(this, arguments);
}
var ri = function ri(e) {
  return a.createElement("svg", Z2({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M4.27 2.26a.253.253 0 0 0-.25.25v19c0 .136.114.25.25.25h12c.136 0 .25-.114.25-.25v-2.54a.75.75 0 0 1 1.5 0v2.54c0 .964-.786 1.75-1.75 1.75h-12c-.964 0-1.75-.786-1.75-1.75v-19c0-.964.786-1.75 1.75-1.75h12c.964 0 1.75.786 1.75 1.75v2.42a.75.75 0 0 1-1.5 0V2.51a.253.253 0 0 0-.25-.25zm4 2.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m3 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-.36-5.76a.75.75 0 0 1 .75-.75h10.09a.75.75 0 0 1 .53 1.28l-2.96 2.96a.75.75 0 1 1-1.06-1.06l1.68-1.68h-8.28a.75.75 0 0 1-.75-.75m4.231-5.93a.75.75 0 1 0-1.062-1.06l-2.95 2.96a.75.75 0 0 0 .53 1.28h10.09a.75.75 0 1 0 0-1.5h-8.283z",
    clipRule: "evenodd"
  }));
};
ri.displayName = "MobileShare";
function en() {
  return en = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, en.apply(this, arguments);
}
var li = function li(e) {
  return a.createElement("svg", en({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    fill: e.color || "#222222",
    clipPath: "url(#a)"
  }, a.createElement("path", {
    d: "M12 18.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1M11.85 15.33c-1.19 0-2.05-.74-2.45-1.44a.75.75 0 0 1 .27-1.03c.36-.21.82-.08 1.02.27.07.12.44.69 1.15.69.31 0 .96 0 1.22-.25.15-.14.19-.4.09-.57-.16-.27-.58-.43-.98-.55l-.59-.16c-.74-.21-1.56-.5-2.02-1.27a1.99 1.99 0 0 1 .34-2.43c.69-.67 1.71-.67 2.25-.67 1.07 0 1.95.52 2.46 1.45.2.36.07.82-.3 1.02-.36.2-.82.07-1.02-.3-.25-.46-.62-.67-1.14-.67-.31 0-.96 0-1.22.25-.15.14-.19.4-.09.57.18.3.66.46 1.14.59l.6.16c.68.21 1.42.51 1.85 1.22.46.78.32 1.79-.34 2.43-.69.67-1.71.67-2.25.67z"
  }), a.createElement("path", {
    d: "M12.15 16.38c-.41 0-.75-.34-.75-.75v-1.06c0-.41.34-.75.75-.75s.75.34.75.75v1.06c0 .41-.34.75-.75.75M12.15 9.45c-.41 0-.75-.34-.75-.75V7.64c0-.41.34-.75.75-.75s.75.34.75.75V8.7c0 .41-.34.75-.75.75M13.25 5.25h-2.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.5c.41 0 .75.34.75.75s-.34.75-.75.75"
  }), a.createElement("path", {
    d: "M18 23.25H6c-.96 0-1.75-.79-1.75-1.75v-19c0-.96.79-1.75 1.75-1.75h12c.96 0 1.75.79 1.75 1.75v19c0 .96-.79 1.75-1.75 1.75m-12-21c-.14 0-.25.11-.25.25v19c0 .14.11.25.25.25h12c.14 0 .25-.11.25-.25v-19c0-.14-.11-.25-.25-.25z"
  })), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
li.displayName = "MobilephoneBill";
function tn() {
  return tn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, tn.apply(this, arguments);
}
var ai = function ai(e) {
  return a.createElement("svg", tn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M4.25 21.5c0 .96.79 1.75 1.75 1.75h12c.96 0 1.75-.79 1.75-1.75v-19c0-.96-.79-1.75-1.75-1.75H6c-.96 0-1.75.79-1.75 1.75zm1.5-19c0-.14.11-.25.25-.25h12c.14 0 .25.11.25.25v19c0 .14-.11.25-.25.25H6c-.14 0-.25-.11-.25-.25zm7.25 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0m.25-14.25h-2.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.5c.41 0 .75.34.75.75s-.34.75-.75.75",
    clipRule: "evenodd"
  }));
};
ai.displayName = "Mobilephone";
function nn() {
  return nn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, nn.apply(this, arguments);
}
var ii = function ii(e) {
  return a.createElement("svg", nn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M13.598 18.1h-3.206l-.308 3.04h3.822zm1.505 0h4.967c1.52 0 2.75-1.23 2.75-2.75V4.11c0-1.52-1.23-2.75-2.75-2.75H3.92c-1.52 0-2.75 1.23-2.75 2.75v11.24c0 1.52 1.23 2.75 2.75 2.75h4.967l-.308 3.04h-2.17c-.41 0-.75.34-.75.75s.34.75.75.75H17.59c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H15.41zm6.217-4.17v1.42c0 .69-.56 1.25-1.25 1.25H3.92c-.69 0-1.25-.56-1.25-1.25v-1.42zm0-1.5H2.67V4.11c0-.69.56-1.25 1.25-1.25h16.15c.69 0 1.25.56 1.25 1.25z",
    clipRule: "evenodd"
  }));
};
ii.displayName = "Monitor";
function rn() {
  return rn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, rn.apply(this, arguments);
}
var oi = function oi(e) {
  return a.createElement("svg", rn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M3 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
    clipRule: "evenodd"
  }));
};
oi.displayName = "More";
function ln() {
  return ln = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, ln.apply(this, arguments);
}
var ci = function ci(e) {
  return a.createElement("svg", ln({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M8.54 9.168q.213.277.471.512h-.868q.223-.236.396-.512M8.084 5.1a3.28 3.28 0 0 0-2.335-.97c-1.82 0-3.29 1.47-3.29 3.29 0 .876.343 1.671.9 2.26h-.34c-.96 0-1.75.79-1.75 1.75v8c0 .96.79 1.75 1.75 1.75h14c.96 0 1.75-.79 1.75-1.75v-.748l2.98.948c.08.03.15.04.23.04v.01c.15 0 .31-.05.44-.14.2-.15.31-.37.31-.61v-6.98c0-.24-.12-.47-.31-.61a.76.76 0 0 0-.67-.11l-2.98.948v-.748c0-.96-.79-1.75-1.75-1.75h-2.691a3.94 3.94 0 0 0 1.291-2.92c0-2.18-1.77-3.95-3.95-3.95A3.95 3.95 0 0 0 8.085 5.1m3.585-.78c-1.35 0-2.45 1.1-2.45 2.45s1.1 2.45 2.45 2.45 2.45-1.1 2.45-2.45-1.1-2.45-2.45-2.45m7.1 9.43v3.36l2.46.78v-4.92zm-1.5-.55v-1.77c0-.14-.11-.25-.25-.25h-14c-.14 0-.25.11-.25.25v8c0 .14.11.25.25.25h14c.14 0 .25-.11.25-.25V13.2M3.96 7.43c0-.99.8-1.79 1.79-1.79s1.79.8 1.79 1.79-.8 1.79-1.79 1.79-1.79-.8-1.79-1.79",
    clipRule: "evenodd"
  }));
};
ci.displayName = "Movie";
function an() {
  return an = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, an.apply(this, arguments);
}
var si = function si(e) {
  return a.createElement("svg", an({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M8.29 16.013V7.08c0-1.08.68-2.05 1.69-2.42l8.34-3.08c.67-.24 1.41-.15 1.99.25.58.41.93 1.07.93 1.78v13.27c0 1.97-1.6 3.57-3.57 3.57s-3.57-1.6-3.57-3.57a3.572 3.572 0 0 1 5.64-2.908V7.97l-9.95 3.475v6.704a3.572 3.572 0 0 1-3.47 4.411c-1.97 0-3.57-1.6-3.57-3.57a3.572 3.572 0 0 1 5.54-2.977m1.5-6.163 9.95-3.475V3.61c0-.22-.1-.42-.29-.55a.64.64 0 0 0-.61-.08L10.5 6.06c-.42.16-.71.57-.71 1.02zm7.88 4.96c-1.14 0-2.07.93-2.07 2.07s.93 2.07 2.07 2.07 2.07-.93 2.07-2.07-.93-2.07-2.07-2.07M6.32 16.93c-1.14 0-2.07.93-2.07 2.07s.93 2.07 2.07 2.07 2.07-.93 2.07-2.07-.93-2.07-2.07-2.07",
    clipRule: "evenodd"
  }));
};
si.displayName = "Music";
function on() {
  return on = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, on.apply(this, arguments);
}
var di = function di(e) {
  return a.createElement("svg", on({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M19.76 22.75H4.24c-.41 0-.75-.34-.75-.75V2c0-.41.34-.75.75-.75h15.53c.41 0 .75.34.75.75v20c0 .41-.34.75-.75.75zm-14.77-1.5h14.03V2.75H4.99zm7.22-14.1a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m-4.24 3.81h8.05c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H7.97c-.41 0-.75.34-.75.75s.34.75.75.75m8.05 4.08H7.97c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.05c.41 0 .75.34.75.75s-.34.75-.75.75m-8.04 4.08h3.63c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H7.98c-.41 0-.75.34-.75.75s.34.75.75.75",
    clipRule: "evenodd"
  }));
};
di.displayName = "Notice";
function cn() {
  return cn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, cn.apply(this, arguments);
}
var ui = function ui(e) {
  return a.createElement("svg", cn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.activeDotColor || "#E71336",
    d: "M20 6.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M14.02 1.46a7 7 0 0 0-.89-.15c-.74-.08-1.52-.08-2.26 0-.67.07-1.34.24-1.98.49-2.13.84-3.64 2.78-4.14 5.3-.18.88-.16 1.76-.14 2.61.01.25.01.5.01.74v2.89c0 .99-.19 1.44-.73 1.79-.96.62-1.77 1.83-1.4 3.11.16.68.61 1.41 1.38 1.41h16.27c.76 0 1.21-.73 1.37-1.38.38-1.3-.43-2.52-1.39-3.14-.55-.35-.73-.8-.73-1.79v-2.868a6.4 6.4 0 0 1-1.51-.328v3.196c0 1.05.17 2.25 1.41 3.05.48.31.93.9.76 1.49-.02.09-.06.2-.1.27H4.05a2 2 0 0 1-.11-.29c-.16-.56.29-1.16.77-1.47 1.24-.8 1.41-1.99 1.41-3.05v-2.89q-.001-.186-.005-.377-.005-.196-.005-.393c-.02-.8-.03-1.57.11-2.28.4-2.04 1.55-3.53 3.22-4.19.52-.21 1.05-.34 1.59-.4.63-.07 1.31-.07 1.94 0q.313.034.622.102.13-.762.428-1.452m-.15 21.29h-3.73c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.73c.41 0 .75.34.75.75s-.34.75-.75.75",
    clipRule: "evenodd"
  }));
};
ui.displayName = "NotificationActive";
function sn() {
  return sn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, sn.apply(this, arguments);
}
var hi = function hi(e) {
  return a.createElement("svg", sn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M3.44 19.557c-.521-.2-.842-.776-.98-1.327-.37-1.28.44-2.49 1.4-3.11.54-.35.72-.8.72-1.79v-2.88c0-.24 0-.49-.01-.74-.02-.85-.04-1.73.14-2.6.5-2.52 2-4.44 4.13-5.28.64-.25 1.31-.42 1.98-.49.74-.08 1.51-.08 2.25 0 .67.07 1.34.24 1.98.49 1.354.536 2.453 1.497 3.208 2.795L21.27 1.59c.29-.29.77-.3 1.06 0 .29.29.3.77 0 1.06L2.73 22.4c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.745.745 0 0 1 0-1.06zM17.152 5.74c-.583-1.19-1.507-2.06-2.652-2.52-.52-.2-1.05-.34-1.59-.39-.63-.07-1.3-.07-1.94 0-.54.06-1.07.19-1.58.39-1.67.66-2.81 2.14-3.21 4.18-.131.666-.122 1.375-.112 2.128l.002.152q.001.195.005.385.005.191.005.385v2.88c0 1.06-.17 2.24-1.41 3.05-.48.31-.92.9-.76 1.46.03.1.07.21.11.29h.64q.09 0 .175.021zM10.08 19.63h9.96c.76 0 1.21-.73 1.37-1.38.37-1.3-.43-2.51-1.39-3.13-.54-.35-.72-.8-.72-1.79v-2.88c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.88c0 1.06.17 2.25 1.41 3.05.48.31.92.9.75 1.49-.02.07-.06.18-.1.26h-9.78c-.41 0-.75.34-.75.75s.34.75.75.75m3.72 3.09h-3.72c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.72c.41 0 .75.34.75.75s-.34.75-.75.75",
    clipRule: "evenodd"
  }));
};
hi.displayName = "NotificationDisabled";
function dn() {
  return dn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, dn.apply(this, arguments);
}
var fi = function fi(e) {
  return a.createElement("svg", dn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M3.9 19.63h16.21c.76 0 1.21-.73 1.37-1.38.37-1.3-.43-2.51-1.39-3.13-.54-.35-.72-.8-.72-1.79v-2.88q0-.187.005-.37a18 18 0 0 0 .006-.493c.01-.812.02-1.649-.141-2.477-.5-2.51-2-4.44-4.13-5.28-.64-.25-1.31-.42-1.98-.49-.73-.08-1.51-.08-2.25 0-.67.07-1.34.24-1.98.49-2.13.84-3.63 2.76-4.13 5.28-.18.87-.16 1.75-.14 2.6.01.25.01.5.01.74v2.88c0 .99-.18 1.44-.72 1.79-.96.62-1.77 1.83-1.4 3.11.17.68.62 1.4 1.38 1.4m16.03-1.5H4.08a2 2 0 0 1-.11-.29c-.16-.56.28-1.15.76-1.46 1.24-.81 1.41-1.99 1.41-3.05v-2.88q-.001-.194-.005-.385L6.13 9.68l-.002-.152c-.01-.753-.02-1.462.112-2.128.4-2.04 1.54-3.52 3.21-4.18.51-.2 1.04-.33 1.58-.39.64-.07 1.31-.07 1.94 0 .53.05 1.06.19 1.58.39 1.67.66 2.81 2.14 3.21 4.18.14.71.13 1.47.11 2.28-.01.26-.01.52-.01.77v2.88c0 1.06.17 2.25 1.41 3.05.48.31.93.9.76 1.49-.02.08-.06.19-.1.26m-9.79 4.59h3.72c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3.72c-.41 0-.75.34-.75.75s.34.75.75.75",
    clipRule: "evenodd"
  }));
};
fi.displayName = "Notification";
function un() {
  return un = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, un.apply(this, arguments);
}
var vi = function vi(e) {
  return a.createElement("svg", un({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M10 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0m2 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4",
    clipRule: "evenodd"
  }));
};
vi.displayName = "Options";
function hn() {
  return hn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, hn.apply(this, arguments);
}
var mi = function mi(e) {
  return a.createElement("svg", hn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M4.13 4.08a2.25 2.25 0 0 1 2.25-2.25h10.98a2.25 2.25 0 0 1 2.25 2.25v17.5a.75.75 0 0 1-1.164.626l-1.916-1.267-1.917 1.267a.75.75 0 0 1-.827 0l-1.916-1.267-1.917 1.267a.75.75 0 0 1-.827 0L7.21 20.939l-1.917 1.267a.75.75 0 0 1-1.163-.626zm2.25-.75a.75.75 0 0 0-.75.75v16.105l1.166-.77a.75.75 0 0 1 .827 0L9.54 20.68l1.916-1.267a.75.75 0 0 1 .827 0l1.917 1.267 1.916-1.267a.75.75 0 0 1 .827 0l1.167.771V4.08a.75.75 0 0 0-.75-.75zm1.76 3.659a.75.75 0 0 1 .751-.749l5.99.01a.75.75 0 1 1-.002 1.5l-5.99-.01a.75.75 0 0 1-.75-.751m.74 3.341a.75.75 0 1 0 0 1.5h6a.75.75 0 0 0 0-1.5zm-.75 4.829a.75.75 0 0 1 .751-.749l5.99.01a.75.75 0 1 1-.002 1.5l-5.99-.01a.75.75 0 0 1-.75-.751",
    clipRule: "evenodd"
  }));
};
mi.displayName = "Order";
function fn() {
  return fn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, fn.apply(this, arguments);
}
var gi = function gi(e) {
  return a.createElement("svg", fn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M18 10.83h-4c-1.52 0-2.75-1.23-2.75-2.75v-4c0-1.52 1.23-2.75 2.75-2.75h4c1.52 0 2.75 1.23 2.75 2.75v4c0 1.52-1.23 2.75-2.75 2.75m-4-8c-.69 0-1.25.56-1.25 1.25v4c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-4c0-.69-.56-1.25-1.25-1.25zm5.44 11.33c.79-.16 1.47-.29 2.33.33h.01c.75.54 1.07 1.44.9 2.53-.21 1.44-3.7 4-3.73 4.02-1.52.99-4.14 1.62-5.43 1.62-.14 0-.26-.01-.36-.02-1.19-.16-2.48-.51-3.51-.79l-.082-.022c-.555-.15-1.03-.28-1.288-.318-.177-.024-.64-.022-1.058-.02H6.93c-.25.68-.88 1.16-1.64 1.16H3.03c-.96 0-1.75-.79-1.75-1.75v-6.58c0-.96.79-1.75 1.75-1.75h2.26c.86 0 1.58.63 1.72 1.45.81-.45 1.88-1.01 2.37-1.16 1.34-.41 5.89.36 6.96 1.19.55.43.79.97.86 1.51 1.16-.87 1.78-1.3 2.24-1.4m-14.15 7c.14 0 .25-.11.25-.25v-6.58c0-.14-.11-.25-.25-.25H3.03c-.14 0-.25.11-.25.25v6.58c0 .14.11.25.25.25zm12.83-1.37c.77-.5 2.91-2.45 3.07-3.01h-.02c.05-.34.04-.82-.3-1.07-.3-.22-.39-.23-1.15-.07-.25.09-1.19.79-1.75 1.21l-.244.18c-.533.393-.985.726-1.316.9-.49.26-1.24.57-1.98.57l-2.18-.21a.75.75 0 0 1-.67-.82c.04-.41.41-.72.82-.67l2.11.21c.23 0 .6-.12 1.01-.31.15-.33.41-1.06-.11-1.47-.63-.48-4.64-1.23-5.59-.93-.42.13-1.83.89-2.78 1.43V20c.63 0 1.17 0 1.46.04.35.06.88.2 1.54.38.99.27 2.23.6 3.32.75.64.08 3.3-.43 4.76-1.38",
    clipRule: "evenodd"
  }));
};
gi.displayName = "PartnerApps";
function vn() {
  return vn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, vn.apply(this, arguments);
}
var xi = function xi(e) {
  return a.createElement("svg", vn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M6.46 20.71h.58c1.39 0 2.52-1.13 2.52-2.52V5.64c0-1.3-1.05-2.35-2.35-2.35h-.75c-1.39 0-2.52 1.13-2.52 2.52v12.38c0 1.39 1.13 2.52 2.52 2.52M5.44 5.81c0-.56.46-1.02 1.02-1.02h.76c.47 0 .85.38.85.85v12.55c0 .56-.46 1.02-1.02 1.02h-.59c-.56 0-1.02-.46-1.02-1.02zm11.51 14.9h.58c1.39 0 2.52-1.13 2.52-2.52V5.81c0-1.39-1.13-2.52-2.52-2.52h-.75c-1.3 0-2.35 1.05-2.35 2.35v12.55c0 1.39 1.13 2.52 2.52 2.52M15.93 5.64c0-.47.38-.85.85-.85h.76c.56 0 1.02.46 1.02 1.02v12.38c0 .56-.46 1.02-1.02 1.02h-.59c-.56 0-1.02-.46-1.02-1.02z",
    clipRule: "evenodd"
  }));
};
xi.displayName = "Pause";
function mn() {
  return mn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, mn.apply(this, arguments);
}
var bi = function bi(e) {
  return a.createElement("svg", mn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5m3.32-2.13c.45.34 1.297.749 2.325.75H8.14h.01-.005c.709 0 1.487-.191 2.275-.72.34-.23.43-.7.2-1.04a.753.753 0 0 0-1.04-.2c-1.47 1-2.7.13-2.84.03a.748.748 0 0 0-.92 1.18m7.39 0c.44.34 1.297.749 2.325.75h-.005.01-.005c.709 0 1.487-.191 2.275-.72.34-.23.43-.7.2-1.04a.753.753 0 0 0-1.04-.2c-1.47 1-2.7.13-2.84.03a.756.756 0 0 0-1.05.13c-.25.32-.2.8.13 1.05M12 17.53c-2.34 0-4.408-1.187-4.624-1.311l-.016-.009a.76.76 0 0 1-.26-1.03c.21-.36.67-.47 1.03-.26l.008.005c.138.078 1.94 1.105 3.862 1.105s3.724-1.027 3.862-1.105l.008-.005a.74.74 0 0 1 1.03.26c.21.36.1.82-.26 1.03l-.015.008c-.212.122-2.292 1.312-4.625 1.312",
    clipRule: "evenodd"
  }));
};
bi.displayName = "PeaceOfMind";
function gn() {
  return gn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, gn.apply(this, arguments);
}
var wi = function wi(e) {
  return a.createElement("svg", gn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M8.25 8a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M12 2.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5m-5 11.5a3.75 3.75 0 1 0 0 7.5h10a3.75 3.75 0 1 0 0-7.5zM4.75 18A2.25 2.25 0 0 1 7 15.75h10a2.25 2.25 0 0 1 0 4.5H7A2.25 2.25 0 0 1 4.75 18",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M8.25 8a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M12 2.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5m-5 11.5a3.75 3.75 0 1 0 0 7.5h10a3.75 3.75 0 1 0 0-7.5zM4.75 18A2.25 2.25 0 0 1 7 15.75h10a2.25 2.25 0 0 1 0 4.5H7A2.25 2.25 0 0 1 4.75 18",
    clipRule: "evenodd"
  }));
};
wi.displayName = "Personal";
function xn() {
  return xn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, xn.apply(this, arguments);
}
var yi = function yi(e) {
  return a.createElement("svg", xn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M20 21.71h-.18c-2.12-.23-4.1-.71-5.89-1.44h-.02l-.88-.36v-.02c-4.73-2.22-7.37-5.88-8.81-8.9H4.2l-.38-.88C2.8 7.68 2.42 5.54 2.28 4.17c-.05-.47.11-.94.42-1.29.33-.36.79-.57 1.29-.57h1.56c.8 0 1.5.54 1.7 1.33l.78 3.11c.17.68-.08 1.39-.63 1.81l-1.95 1.49c1.32 2.9 3.84 6.52 8.52 8.61l1.5-2.01c.42-.57 1.14-.82 1.83-.65l3.1.77c.78.2 1.33.89 1.33 1.7V20c0 .49-.21.97-.57 1.29-.31.28-.72.44-1.14.44zm-4.59-2.5c1.42.49 2.95.82 4.57 1 .08.01.12-.02.15-.05s.08-.08.08-.18v-1.53c0-.12-.08-.21-.19-.24l-3.1-.77c-.1-.02-.2.01-.26.09l-1.26 1.68zM4 3.79c-.07 0-.13.03-.17.07-.05.06-.04.11-.04.13.11 1.09.39 2.72 1.07 4.6l1.63-1.25c.08-.06.12-.16.09-.26L5.8 3.97a.255.255 0 0 0-.24-.19H4z"
  }));
};
yi.displayName = "PhoneContact";
function bn() {
  return bn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, bn.apply(this, arguments);
}
var ji = function ji(e) {
  return a.createElement("svg", bn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M3.27 10.15c0 5.21 7.42 12.42 8.73 12.42v.01c1.03 0 8.73-6.96 8.73-12.42 0-4.81-3.92-8.73-8.73-8.73s-8.73 3.91-8.73 8.72m1.5.01c0-3.988 3.247-7.227 7.225-7.23 3.988.003 7.225 3.252 7.225 7.23 0 4.27-5.73 9.67-7.23 10.79-1.48-1.09-7.22-6.49-7.22-10.79m3.39.11a3.841 3.841 0 0 0 7.68 0 3.841 3.841 0 0 0-7.68 0m1.5.01c0-1.29 1.05-2.34 2.34-2.34s2.34 1.05 2.34 2.34-1.05 2.34-2.34 2.34-2.34-1.05-2.34-2.34",
    clipRule: "evenodd"
  }));
};
ji.displayName = "Pin";
function wn() {
  return wn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, wn.apply(this, arguments);
}
var zi = function zi(e) {
  return a.createElement("svg", wn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M6.28 20.61c-.34 0-.69-.09-1-.27-.63-.36-1-1.01-1-1.73V5.39c0-.72.37-1.37 1-1.73s1.37-.36 2 0l11.44 6.61c.63.36 1 1.01 1 1.73s-.37 1.37-1 1.73L7.28 20.34c-.31.18-.66.27-1 .27m0-15.72c-.12 0-.21.04-.25.07-.08.04-.25.17-.25.43V18.6c0 .26.17.39.25.43s.28.13.5 0l11.44-6.61c.23-.13.25-.35.25-.43 0-.09-.02-.3-.25-.43L6.53 4.96a.5.5 0 0 0-.25-.07"
  }));
};
zi.displayName = "Play";
function yn() {
  return yn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, yn.apply(this, arguments);
}
var pi = function pi(e) {
  return a.createElement("svg", yn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M11.49 22.74c-.48 0-1-.03-1.52-.22-.86-.31-1.69-.91-2.45-1.79l-4.35-5.55-.06-.09c-.46-.81-.92-2.62.68-3.71.98-.67 2.09-.74 3.04-.19.05.03.09.06.13.1l.68.61V4.21c0-.4.09-.82.27-1.22.37-.84 1.12-1.44 2.05-1.63.56-.12 1.39-.22 2.12.25.62.4.97 1.07.97 1.85v4.43l5.18 1.75c1.97.67 3.1 1.95 3.1 3.51v4.7q0 .945-.54 2.07c-.42.87-.98 1.6-1.61 2.12-.85.69-1.62.69-2.45.69h-5.25zM4.38 14.3l4.29 5.47c.57.65 1.18 1.11 1.8 1.33.41.15.87.14 1.39.13h4.77c.85 0 1.18-.02 1.6-.36.47-.38.88-.93 1.21-1.6.26-.54.39-1.03.39-1.42v-4.7c0-1.21-1.3-1.83-2.08-2.09l-5.69-1.92c-.3-.1-.51-.39-.51-.71V3.46c0-.15-.04-.43-.28-.58-.21-.13-.52-.15-1.01-.05-.46.09-.81.37-.98.76-.09.21-.14.43-.14.62v9.38c0 .3-.17.57-.45.69-.27.12-.59.07-.81-.13l-1.86-1.68c-.55-.27-1.06-.07-1.39.17-.77.52-.38 1.42-.25 1.68z"
  }));
};
pi.displayName = "Pointer";
function jn() {
  return jn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, jn.apply(this, arguments);
}
var Oi = function Oi(e) {
  return a.createElement("svg", jn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#151518",
    fillRule: "evenodd",
    d: "M12.75 2.568a.75.75 0 0 0-1.5 0v10a.75.75 0 1 0 1.5 0zm4 1.773A.75.75 0 1 0 16 5.64a8 8 0 1 1-8.038.021.75.75 0 0 0-.757-1.294 9.5 9.5 0 1 0 9.546-.026",
    clipRule: "evenodd"
  }));
};
Oi.displayName = "PowerSwitch";
function zn() {
  return zn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, zn.apply(this, arguments);
}
var Ei = function Ei(e) {
  return a.createElement("svg", zn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M15.15 22.75h-11c-1.52 0-2.75-1.23-2.75-2.75V4c0-1.52 1.23-2.75 2.75-2.75h11c1.52 0 2.75 1.23 2.75 2.75v4.357c2.694.662 4.7 3.1 4.7 5.993 0 2.902-2.017 5.344-4.722 5.998a2.75 2.75 0 0 1-2.728 2.402M16.4 4v4.18a6.18 6.18 0 0 0-6.14 6.17 6.18 6.18 0 0 0 6.028 6.168 1.25 1.25 0 0 1-1.138.732h-11c-.69 0-1.25-.56-1.25-1.25V4c0-.69.56-1.25 1.25-1.25h11c.69 0 1.25.56 1.25 1.25m-2.61 2.38H5.63c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.16c.41 0 .75.34.75.75s-.34.75-.75.75M5.63 10.1h3.08c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H5.63c-.41 0-.75.34-.75.75s.34.75.75.75m10.8-.42a4.669 4.669 0 1 0 0 9.34 4.669 4.669 0 1 0 0-9.34m1.41 6.97c.14.12.3.17.47.17l.01-.01c.22 0 .43-.1.58-.28.26-.32.21-.79-.11-1.05l-1.67-1.35v-2.71c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.07c0 .22.1.44.28.58z",
    clipRule: "evenodd"
  }));
};
Ei.displayName = "Processing";
function pn() {
  return pn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, pn.apply(this, arguments);
}
var Si = function Si(e) {
  return a.createElement("svg", pn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M11.95 21c-4.04 0-7.29-.99-7.43-1.03a.75.75 0 0 1-.52-.6L2.04 6.81a.755.755 0 0 1 1.22-.7L8 9.95l3.32-6.55a.76.76 0 0 1 .67-.41c.28 0 .54.16.67.41l3.32 6.55 4.79-3.84c.24-.19.58-.22.85-.06s.41.46.36.77l-2.01 12.56c-.05.28-.25.51-.52.6-.14.04-3.44 1.03-7.48 1.03zm-6.54-2.34c1 .26 3.57.84 6.54.84s5.59-.59 6.6-.85l1.63-10.16-3.99 3.2a.751.751 0 0 1-1.14-.24L11.98 5.4l-3.07 6.06c-.1.2-.29.35-.51.39-.22.05-.45 0-.63-.15L3.83 8.5l1.59 10.15z"
  }));
};
Si.displayName = "Recommended";
function On() {
  return On = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, On.apply(this, arguments);
}
var Ci = function Ci(e) {
  return a.createElement("svg", On({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M11.79 1.76C6.14 1.76 1.55 6.35 1.55 12s4.59 10.24 10.24 10.24S22.03 17.65 22.03 12 17.43 1.76 11.79 1.76m5.74 16.81c-.37.32-.76.61-1.17.86l-3.35-5.46a2.84 2.84 0 0 0 2.6-2.82c0-1.56-1.27-2.83-2.83-2.83h-2.35V6.99h2.58c2.37 0 4.09 1.72 4.09 4.09 0 1.59-.46 2.63-1.44 3.27l-.63.41 2.51 3.81zm-4.76-8.74c.73 0 1.33.6 1.33 1.33s-.6 1.33-1.33 1.33h-2.35V9.84h2.35zM8.92 20.25a8 8 0 0 1-1.56-.73V9.83h1.56zm1.5.37v-7.98l4.59 7.48c-1 .4-2.09.63-3.23.63-.47 0-.92-.05-1.36-.12zm8.18-3.16-1.53-2.32c1.02-.93 1.52-2.27 1.52-4.07 0-3.19-2.4-5.59-5.59-5.59H8.92v2.83H5.86v10.07c-1.72-1.6-2.81-3.87-2.81-6.4 0-4.8 3.92-8.72 8.74-8.72s8.74 3.92 8.74 8.74c0 2.07-.73 3.97-1.93 5.46"
  }));
};
Ci.displayName = "RedMembership";
function En() {
  return En = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, En.apply(this, arguments);
}
var Ri = function Ri(e) {
  return a.createElement("svg", En({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M16.27 23.25c.96 0 1.75-.79 1.75-1.75v-2.04c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.04c0 .14-.11.25-.25.25h-12c-.14 0-.25-.11-.25-.25v-19c0-.14.11-.25.25-.25h12c.14 0 .25.11.25.25v1.42c0 .41.34.75.75.75s.75-.34.75-.75V2.5c0-.96-.79-1.75-1.75-1.75h-12c-.96 0-1.75.79-1.75 1.75v19c0 .96.79 1.75 1.75 1.75zm-7.25-18h2.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.5c-.41 0-.75.34-.75.75s.34.75.75.75m1.25 15.26a1 1 0 1 0 0-2 1 1 0 0 0 0 2m8.84-10.04h2.78a.743.743 0 0 0 .3-.06.75.75 0 0 0 .45-.804V6.85c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.542a5.761 5.761 0 0 0-9.62 4.278c0 3.18 2.58 5.76 5.76 5.76v.01a5.73 5.73 0 0 0 5.5-4.05c.13-.4-.09-.82-.49-.94-.4-.13-.82.1-.94.49a4.24 4.24 0 0 1-4.07 2.99c-2.35 0-4.26-1.91-4.26-4.26a4.263 4.263 0 0 1 7.562-2.7H19.11c-.41 0-.75.34-.75.75s.34.75.75.75",
    clipRule: "evenodd"
  }));
};
Ri.displayName = "RefreshPhone";
function Sn() {
  return Sn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Sn.apply(this, arguments);
}
var Mi = function Mi(e) {
  return a.createElement("svg", Sn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1.47 12c0 5.928 4.817 10.747 10.745 10.75h-.005.01-.005A10.7 10.7 0 0 0 22.48 15.2c.13-.4-.09-.82-.49-.94-.4-.13-.82.1-.94.49a9.205 9.205 0 0 1-8.83 6.5c-5.1 0-9.25-4.15-9.25-9.25s4.15-9.25 9.25-9.25a9.24 9.24 0 0 1 8.002 4.61H15.89c-.41 0-.75.34-.75.75s.34.75.75.75h5.55a.755.755 0 0 0 .745-.835 1 1 0 0 0 .005-.085V2.38c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3a10.73 10.73 0 0 0-8.47-4.13C6.3 1.25 1.47 6.07 1.47 12",
    clipRule: "evenodd"
  }));
};
Mi.displayName = "Refresh";
function Cn() {
  return Cn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Cn.apply(this, arguments);
}
var Ti = function Ti(e) {
  return a.createElement("svg", Cn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M14.71 2.12c.04.39.37.68.75.68h.06l.091-.003c.079-.004.185-.009.316-.004q.06.014.123.017c.75.03 2.2.3 3.52 1.62s1.6 2.75 1.65 3.48c.03.4.36.7.75.7h.04a.75.75 0 0 0 .7-.8c-.06-.95-.4-2.77-2.08-4.44-1.614-1.604-3.394-1.981-4.383-2.053a1 1 0 0 0-.127-.017c-.35-.03-.61-.01-.73 0-.41.04-.72.41-.68.82m-6.33 20.6c-.74 0-1.43-.29-1.94-.81l-4.35-4.35c-.52-.52-.81-1.21-.81-1.94s.29-1.42.81-1.94l7.73-7.73c1.04-1.04 2.85-1.04 3.89 0l1.343 1.343a1.17 1.17 0 0 1 1.654 1.654L18.06 10.3a2.73 2.73 0 0 1 0 3.88l-7.73 7.73c-.52.52-1.21.81-1.94.81zm3.37-16.08c-.32 0-.64.12-.88.37l-7.73 7.73a1.234 1.234 0 0 0 0 1.76l4.35 4.35c.47.47 1.29.47 1.77 0l7.73-7.73a1.234 1.234 0 0 0 0-1.76l-4.35-4.35c-.24-.24-.56-.37-.88-.37zm-.09 4.78c-.19 0-.38-.07-.53-.22l-.94-.94a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.94.94c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22m2.07 2.39c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-.94-.94a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06zm-3.3 4.05c-.19 0-.38-.07-.53-.22l-1.245-1.245L7.41 17.64c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l1.245-1.245L6.35 14.09a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.245 1.245L9.9 13.03c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-1.245 1.245 1.245 1.245c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22m8.54-8.85h-.07a.756.756 0 0 1-.68-.81v-.005c0-.087.01-.875-.75-1.635-.82-.82-1.64-.79-1.67-.78a.743.743 0 0 1-.8-.69c-.03-.41.26-.77.67-.8h.018c.183-.009 1.561-.07 2.812 1.19 1.34 1.34 1.22 2.79 1.21 2.86a.75.75 0 0 1-.75.68z",
    clipRule: "evenodd"
  }));
};
Ti.displayName = "Remote";
function Rn() {
  return Rn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Rn.apply(this, arguments);
}
var Pi = function Pi(e) {
  return a.createElement("svg", Rn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1.41 5.02q0 .036.003.07c.004.175.07.349.197.49l2.61 2.87c.14.17.35.25.55.25h.01c.18 0 .36-.07.5-.2.31-.28.33-.75.05-1.06L3.811 5.77H19.84c.69 0 1.25.56 1.25 1.25v3.99c0 .41.34.75.75.75s.75-.34.75-.75V7.02c0-1.52-1.23-2.75-2.75-2.75H3.857L5.33 2.65c.28-.31.26-.78-.05-1.06a.746.746 0 0 0-1.06.05L1.61 4.51a.77.77 0 0 0-.2.51M18.73 22.4c.14.14.32.2.5.2h.01c.2 0 .4-.09.55-.25l2.61-2.87a.75.75 0 0 0 .196-.535.75.75 0 0 0-.196-.535l-2.61-2.87a.746.746 0 0 0-1.06-.05c-.31.28-.33.75-.05 1.06l1.528 1.68H4.16c-.69 0-1.25-.56-1.25-1.25v-3.99c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.99c0 1.52 1.23 2.75 2.75 2.75h15.984l-1.464 1.61c-.28.31-.26.78.05 1.06",
    clipRule: "evenodd"
  }));
};
Pi.displayName = "Return";
function Mn() {
  return Mn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Mn.apply(this, arguments);
}
var ki = function ki(e) {
  return a.createElement("svg", Mn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M8.171 3.741c-.235.22-.275.393-.273.517.002.155.075.338.218.527.038.05.179.175.5.36.298.173.678.357 1.106.546.327.145.668.287 1.006.424a12 12 0 0 0-1.103-1.89 1 1 0 0 1-.047-.076c-.522-.657-1.144-.577-1.407-.408m2.77-.187a1 1 0 0 0-.056-.093c-.99-1.375-2.666-1.521-3.671-.786l-.054.043c-.529.47-.77 1.01-.762 1.559.007.521.239.97.486 1.297.223.296.592.544.935.743.213.123.45.245.698.365H5c-1.519 0-2.75 1.135-2.75 2.534v9.217c0 1.4 1.231 2.534 2.75 2.534h14c1.519 0 2.75-1.134 2.75-2.534V9.216c0-1.4-1.231-2.534-2.75-2.534h-3.517c.249-.12.486-.242.698-.365.343-.198.712-.447.934-.742.248-.328.48-.776.488-1.298.008-.55-.234-1.09-.763-1.559l-.054-.043c-1.005-.735-2.68-.59-3.67.786a1 1 0 0 0-.057.093c-.43.61-.782 1.23-1.059 1.793a13 13 0 0 0-1.059-1.793m1.809 16.03H19c.69 0 1.25-.515 1.25-1.151v-3.917h-7.5zm-1.5-5.068v5.069H5c-.69 0-1.25-.516-1.25-1.152v-3.917zm1.5-1.383h7.5V9.217c0-.636-.56-1.152-1.25-1.152h-6.25zm-1.5-5.069v5.07h-7.5V9.215c0-.636.56-1.152 1.25-1.152zm3.125-3.838a1 1 0 0 0 .048-.077c.521-.657 1.144-.577 1.406-.408.235.22.275.393.274.517-.003.155-.076.338-.218.527h-.001c-.037.05-.179.175-.5.36-.297.173-.678.357-1.106.546-.327.145-.668.287-1.006.424.27-.575.636-1.241 1.103-1.89",
    clipRule: "evenodd"
  }));
};
ki.displayName = "Rewards";
function Tn() {
  return Tn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Tn.apply(this, arguments);
}
var Ai = function Ai(e) {
  return a.createElement("svg", Tn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    clipPath: "url(#a)"
  }, a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M2.55 23.25c-.96 0-1.75-.79-1.75-1.75v-19c0-.96.79-1.75 1.75-1.75h12c.96 0 1.75.79 1.75 1.75v1.42c0 .41-.34.75-.75.75s-.75-.34-.75-.75V2.5c0-.14-.11-.25-.25-.25h-12c-.14 0-.25.11-.25.25v19c0 .14.11.25.25.25h12c.14 0 .25-.11.25-.25v-2.54c0-.41.34-.75.75-.75s.75.34.75.75v2.54c0 .96-.79 1.75-1.75 1.75zm19.16-10.8a.746.746 0 0 0 .98-.4c.36-.88.86-2.68.11-4.9-.75-2.25-2.26-3.38-3.1-3.85a.74.74 0 0 0-1.02.28.74.74 0 0 0 .28 1.02c.65.36 1.83 1.25 2.42 3.02s.2 3.17-.08 3.85c-.15.38.03.82.41.98M9.55 19.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m9.28-7.98a.747.747 0 0 1-.64-1.13c.03-.05.41-.75.06-1.81-.37-1.1-1.12-1.43-1.15-1.44a.755.755 0 0 1-.41-.97c.15-.38.58-.57.96-.42.06.02 1.42.57 2.01 2.33.575 1.714-.098 2.933-.182 3.086l-.008.014c-.14.23-.39.35-.64.35zm-7.44 5.1v-3.66h.75c.17 0 .3.02.39.07.08.05.17.13.24.24l1.98 3.01c.07.11.16.2.27.26q.165.09.39.09h1.57l-2.35-3.47q-.24-.345-.57-.54c.33-.11.62-.25.88-.42s.47-.37.65-.6c.17-.23.31-.49.4-.77s.14-.58.14-.9c0-.39-.07-.76-.21-1.09-.13-.33-.35-.61-.64-.85s-.66-.43-1.12-.56-1.01-.2-1.65-.2H9.64v9.39zm1.09-4.92h-1.1V8.58h1.12c.65 0 1.13.12 1.44.38s.47.62.47 1.1c0 .24-.05.46-.12.66s-.19.37-.35.52c-.15.14-.36.26-.6.34s-.53.12-.86.12M7.3 5.25h2.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H7.3c-.41 0-.75.34-.75.75s.34.75.75.75",
    clipRule: "evenodd"
  })), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
Ai.displayName = "Roaming";
function Pn() {
  return Pn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Pn.apply(this, arguments);
}
var j5 = function j5(e) {
  return a.createElement("svg", Pn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5M2.25 10.5a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5M2.25 10.5a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M15.47 15.47a.75.75 0 0 1 1.06 0l5 5a.75.75 0 1 1-1.06 1.06l-5-5a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M15.47 15.47a.75.75 0 0 1 1.06 0l5 5a.75.75 0 1 1-1.06 1.06l-5-5a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  }));
};
j5.displayName = "Search";
function kn() {
  return kn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, kn.apply(this, arguments);
}
var Bi = function Bi(e) {
  return a.createElement("svg", kn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M15.61 7.95V6.06c0-1.79-1.46-3.25-3.25-3.25h-.53c-1.79 0-3.25 1.46-3.25 3.25v1.89zm-8.53 0V6.06c0-2.62 2.13-4.75 4.75-4.75h.53c2.62 0 4.75 2.13 4.75 4.75v1.89h.74c1.52 0 2.75 1.23 2.75 2.75v9.23c0 1.52-1.23 2.75-2.75 2.75H6.14c-1.52 0-2.75-1.23-2.75-2.75V10.7c0-1.52 1.23-2.75 2.75-2.75zM4.89 10.7c0-.69.56-1.25 1.25-1.25h11.71c.69 0 1.25.56 1.25 1.25v9.23c0 .69-.56 1.25-1.25 1.25H6.14c-.69 0-1.25-.56-1.25-1.25zM12 18.55c-.41 0-.75-.34-.75-.75v-2.165a2 2 0 1 1 1.5 0V17.8c0 .41-.34.75-.75.75",
    clipRule: "evenodd"
  }));
};
Bi.displayName = "Secure";
function An() {
  return An = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, An.apply(this, arguments);
}
var Hi = function Hi(e) {
  return a.createElement("svg", An({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M13.7 22.37a.748.748 0 0 0 1.4.01l7.71-20.22c.11-.28.04-.59-.17-.8a.74.74 0 0 0-.8-.17L1.62 8.89c-.29.12-.48.4-.48.71s.2.59.49.7l8.82 3.25zm-2.846-10.284L4.03 9.58l16.78-6.39-6.39 16.78-2.506-6.824L15.25 9.81c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0z",
    clipRule: "evenodd"
  }));
};
Hi.displayName = "Send";
function Bn() {
  return Bn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Bn.apply(this, arguments);
}
var Wi = function Wi(e) {
  return a.createElement("svg", Bn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M15.54 10.46c-.41 0-.75-.34-.75-.75V6.68h-3.03c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.03V2.16c0-.41.34-.75.75-.75s.75.34.75.75v3.02h3.02c.41 0 .75.34.75.75s-.34.75-.75.75h-3.02v3.03c0 .41-.34.75-.75.75M3.03 22.57h2.26a1.76 1.76 0 0 0 1.643-1.151c.996-.032 1.284.002 1.357.011.27.04.78.18 1.36.34 1.04.29 2.33.64 3.53.8.1.02.21.02.34.02v-.01c1.28 0 3.92-.64 5.43-1.63.03-.02 3.51-2.59 3.73-4.02.17-1.09-.15-1.99-.9-2.53-.864-.616-1.502-.492-2.314-.333l-.016.003c-.47.096-1.078.514-2.229 1.377-.067-.517-.316-1.04-.871-1.477-1.06-.83-5.62-1.61-6.97-1.19-.488.148-1.553.708-2.367 1.156A1.76 1.76 0 0 0 5.29 12.49H3.03c-.96 0-1.75.79-1.75 1.75v6.58c0 .96.79 1.75 1.75 1.75m4.01-6.927v4.276c1.094-.02 1.373.014 1.47.041.35.05.87.19 1.53.37l.146.04c.972.262 2.137.577 3.184.72.63.08 3.31-.43 4.76-1.38.77-.5 2.91-2.45 3.07-3.01.05-.34.04-.83-.3-1.08-.31-.23-.39-.23-1.16-.08-.26.08-1.21.79-1.77 1.22-.63.48-1.18.89-1.55 1.08q-1.095.57-1.98.57l-2.19-.21a.75.75 0 0 1-.67-.82c.04-.41.4-.72.82-.67l2.11.21c.213 0 .577-.108.989-.3l-.029-.02c.1-.15.58-.96-.04-1.45-.63-.49-4.64-1.23-5.6-.94-.42.137-1.838.898-2.79 1.433M2.78 14.24c0-.14.11-.25.25-.25h2.26c.14 0 .25.11.25.25v6.58c0 .14-.11.25-.25.25H3.03c-.14 0-.25-.11-.25-.25z",
    clipRule: "evenodd"
  }));
};
Wi.displayName = "Services";
function Hn() {
  return Hn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Hn.apply(this, arguments);
}
var Li = function Li(e) {
  return a.createElement("svg", Hn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M10.54 23h2.92l.01.02c1.02 0 1.85-.8 1.85-1.79v-1.49c.74-.28 1.43-.66 2.06-1.13l1.41.77c.87.48 2 .19 2.5-.64l1.48-2.41c.25-.42.31-.9.19-1.36a1.78 1.78 0 0 0-.88-1.11l-1.37-.75c.05-.37.08-.72.08-1.09s-.03-.74-.08-1.1l1.36-.75c.43-.23.75-.63.88-1.1.13-.46.06-.96-.19-1.37l-1.47-2.4c-.5-.83-1.62-1.13-2.5-.66l-1.42.77c-.63-.47-1.32-.85-2.05-1.13V2.79c0-.99-.83-1.79-1.85-1.79h-2.92C9.53 1 8.7 1.8 8.7 2.79v1.49c-.73.28-1.42.66-2.05 1.13l-1.43-.78c-.88-.47-2-.18-2.49.65l-1.48 2.4c-.25.41-.31.9-.19 1.36.13.47.44.87.88 1.11l1.37.75c-.05.36-.08.74-.08 1.1s.03.73.08 1.09l-1.37.75c-.44.25-.75.64-.88 1.11-.13.46-.06.95.19 1.37l1.47 2.4c.51.83 1.63 1.12 2.5.64l1.41-.77c.63.46 1.32.84 2.06 1.13v1.49c0 .99.83 1.79 1.85 1.79m-3.35-5.88a.74.74 0 0 0-.48-.18v.01c-.12 0-.25.03-.36.09L4.5 18.05c-.17.09-.4.04-.49-.11l-1.47-2.4a.25.25 0 0 1-.03-.2c.02-.07.07-.14.15-.18l1.83-1.01c.29-.16.44-.49.37-.81-.09-.45-.14-.89-.14-1.34s.05-.9.15-1.33a.76.76 0 0 0-.37-.82L2.66 8.84a.3.3 0 0 1-.15-.18.22.22 0 0 1 .02-.19l1.48-2.4c.09-.15.32-.2.49-.11l1.86 1.01c.27.14.6.11.84-.09a7 7 0 0 1 2.46-1.34c.32-.1.53-.39.53-.72V2.8c0-.16.16-.29.35-.29h2.92c.19 0 .35.13.35.29v2.02c0 .33.22.62.53.72.9.27 1.73.73 2.46 1.34.24.21.57.24.84.09l1.85-1.01c.17-.1.4-.05.5.11l1.47 2.4c.05.07.04.14.03.19s-.04.12-.15.18l-1.85 1.01c-.29.16-.44.49-.37.82.1.43.15.89.15 1.33s-.05.89-.14 1.34c-.07.32.08.65.37.81l1.83 1.01c.07.05.13.11.15.19.02.05.02.12-.02.19l-1.47 2.41c-.09.14-.32.19-.49.1l-1.85-1.01a.74.74 0 0 0-.84.08 7.2 7.2 0 0 1-2.48 1.36c-.31.09-.52.38-.52.71v2.02c0 .16-.16.29-.35.29h-2.92c-.19 0-.35-.13-.35-.29v-2.02a.75.75 0 0 0-.52-.71c-.92-.29-1.76-.75-2.48-1.36m.9-5.12a3.91 3.91 0 1 0 7.82 0 3.91 3.91 0 1 0-7.82 0m1.5 0c0-1.33 1.08-2.41 2.41-2.41s2.41 1.08 2.41 2.41-1.08 2.41-2.41 2.41S9.59 13.33 9.59 12",
    clipRule: "evenodd"
  }));
};
Li.displayName = "Settings";
function Wn() {
  return Wn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Wn.apply(this, arguments);
}
var _i = function _i(e) {
  return a.createElement("svg", Wn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    clipPath: "url(#a)"
  }, a.createElement("g", {
    fill: e.color || "#222222",
    clipPath: "url(#b)"
  }, a.createElement("path", {
    d: "M5.29 16.03c-2.22 0-4.03-1.81-4.03-4.03s1.81-4.03 4.03-4.03S9.32 9.78 9.32 12s-1.81 4.03-4.03 4.03m0-6.56C3.9 9.47 2.76 10.6 2.76 12s1.13 2.53 2.53 2.53S7.82 13.4 7.82 12 6.69 9.47 5.29 9.47M18.63 9.38c-2.22 0-4.03-1.81-4.03-4.03s1.81-4.03 4.03-4.03 4.03 1.81 4.03 4.03-1.81 4.03-4.03 4.03m0-6.56c-1.39 0-2.53 1.13-2.53 2.53s1.13 2.53 2.53 2.53 2.53-1.13 2.53-2.53-1.13-2.53-2.53-2.53M18.71 22.68c-2.22 0-4.03-1.81-4.03-4.03s1.81-4.03 4.03-4.03 4.03 1.81 4.03 4.03-1.81 4.03-4.03 4.03m0-6.56c-1.39 0-2.53 1.13-2.53 2.53s1.13 2.53 2.53 2.53 2.53-1.13 2.53-2.53-1.13-2.53-2.53-2.53"
  }), a.createElement("path", {
    d: "M15.2 6.07 7.826 9.986l.703 1.325 7.375-3.917zM8.528 12.681l-.704 1.325 7.376 3.915.703-1.325z"
  }))), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  })), a.createElement("clipPath", {
    id: "b"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
_i.displayName = "Share";
function Ln() {
  return Ln = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Ln.apply(this, arguments);
}
var Ii = function Ii(e) {
  return a.createElement("svg", Ln({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    d: "M20 3.25a.75.75 0 0 1 .75.75v1.25h.75a.75.75 0 0 1 0 1.5h-5.648l-1.25 1.5H21.5a.75.75 0 0 1 0 1.5H10.841l-2.673 3.054L10.7 14.25h10.8a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.372-.099L6.801 13.75H4.264l2.394 4.39.013.027a2.7 2.7 0 0 1 1.587.815 1.22 1.22 0 0 0 1.77 0 2.723 2.723 0 0 1 3.944 0 1.22 1.22 0 0 0 1.77 0 2.723 2.723 0 0 1 3.944 0c.482.506 1.29.506 1.771 0a.75.75 0 0 1 1.086 1.036 2.723 2.723 0 0 1-3.943 0 1.22 1.22 0 0 0-1.77 0 2.723 2.723 0 0 1-3.944 0 1.223 1.223 0 0 0-1.771 0 2.723 2.723 0 0 1-3.944 0 1.22 1.22 0 0 0-1.77 0 2.723 2.723 0 0 1-3.841.101l-.103-.101-.05-.059a.75.75 0 0 1 1.136-.977c.482.506 1.29.506 1.772 0 .232-.243.498-.432.783-.57L2.342 13.36A.75.75 0 0 1 3 12.25h3.66l3.276-3.744a.75.75 0 0 1 .564-.256h2.149l2.275-2.73a.75.75 0 0 1 .576-.27h1.25V4a.75.75 0 0 1 1.5 0v1.25h1V4a.75.75 0 0 1 .75-.75m-7.5 8a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1 0-1.5zm4 0a.75.75 0 0 1 0 1.5H16a.75.75 0 0 1 0-1.5zm4 0a.75.75 0 0 1 0 1.5H20a.75.75 0 0 1 0-1.5z"
  }));
};
Ii.displayName = "Ship";
function _n() {
  return _n = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, _n.apply(this, arguments);
}
var Ni = function Ni(e) {
  return a.createElement("svg", _n({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M4.245 8.776A2.75 2.75 0 0 1 6.986 6.25h10.028a2.75 2.75 0 0 1 2.74 2.526l.817 10a2.75 2.75 0 0 1-2.741 2.974H6.17a2.75 2.75 0 0 1-2.741-2.974zM6.986 7.75c-.65 0-1.193.5-1.246 1.148l-.816 10A1.25 1.25 0 0 0 6.17 20.25h11.66a1.25 1.25 0 0 0 1.246-1.352l-.816-10a1.25 1.25 0 0 0-1.246-1.148z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M4.245 8.776A2.75 2.75 0 0 1 6.986 6.25h10.028a2.75 2.75 0 0 1 2.74 2.526l.817 10a2.75 2.75 0 0 1-2.741 2.974H6.17a2.75 2.75 0 0 1-2.741-2.974zM6.986 7.75c-.65 0-1.193.5-1.246 1.148l-.816 10A1.25 1.25 0 0 0 6.17 20.25h11.66a1.25 1.25 0 0 0 1.246-1.352l-.816-10a1.25 1.25 0 0 0-1.246-1.148z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M8.75 6.512c.04-1.256.438-2.194 1.005-2.81.565-.612 1.34-.952 2.245-.952.933 0 1.727.314 2.289.896.561.582.96 1.505.96 2.854v2a.75.75 0 0 0 1.5 0v-2c0-1.65-.495-2.978-1.381-3.896S13.277 1.25 12 1.25c-1.305 0-2.486.502-3.347 1.436-.857.929-1.355 2.237-1.403 3.791V8.5a.75.75 0 0 0 1.5 0z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M8.75 6.512c.04-1.256.438-2.194 1.005-2.81.565-.612 1.34-.952 2.245-.952.933 0 1.727.314 2.289.896.561.582.96 1.505.96 2.854v2a.75.75 0 0 0 1.5 0v-2c0-1.65-.495-2.978-1.381-3.896S13.277 1.25 12 1.25c-1.305 0-2.486.502-3.347 1.436-.857.929-1.355 2.237-1.403 3.791V8.5a.75.75 0 0 0 1.5 0z",
    clipRule: "evenodd"
  }));
};
Ni.displayName = "Shop";
function In() {
  return In = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, In.apply(this, arguments);
}
var Vi = function Vi(e) {
  return a.createElement("svg", In({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1.43 13.23C2.55 15.42 5.83 20.5 12 20.5s9.45-5.09 10.57-7.27c.4-.78.4-1.7 0-2.48-1.12-2.19-4.4-7.27-10.57-7.27S2.55 8.56 1.43 10.75c-.4.78-.4 1.7 0 2.48m1.33-1.79c1-1.94 3.89-6.45 9.24-6.45s8.24 4.51 9.24 6.45c.18.35.18.76 0 1.11-1 1.94-3.89 6.45-9.24 6.45s-8.24-4.51-9.24-6.45c-.18-.35-.18-.76 0-1.11m4.79.56c0 2.45 2 4.45 4.45 4.45s4.45-2 4.45-4.45-2-4.45-4.45-4.45-4.45 2-4.45 4.45m1.5 0A2.949 2.949 0 1 1 12 14.95c-1.63 0-2.95-1.32-2.95-2.95",
    clipRule: "evenodd"
  }));
};
Vi.displayName = "Show";
function Nn() {
  return Nn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Nn.apply(this, arguments);
}
var Fi = function Fi(e) {
  return a.createElement("svg", Nn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M18.15 22.75H5.85c-1.65 0-2.99-1.23-2.99-2.75V4c0-1.52 1.34-2.75 2.99-2.75h7.97c.75 0 1.46.28 1.99.79l4.47 4.23c.54.51.85 1.23.85 1.96v11.76c0 1.52-1.34 2.75-2.99 2.75zm-12.3-20c-.82 0-1.49.56-1.49 1.25v16c0 .69.67 1.25 1.49 1.25h12.31c.82 0 1.49-.56 1.49-1.25V8.24c0-.33-.14-.64-.39-.88l-4.47-4.24c-.25-.24-.6-.38-.96-.38H5.86zm7.76 16.94H8.05c-.96 0-1.75-.79-1.75-1.75v-5.95c0-.96.79-1.75 1.75-1.75h7.89c.96 0 1.75.79 1.75 1.75v5.95c0 .96-.79 1.75-1.75 1.75h-2.21a1 1 0 0 1-.12.01zm-.75-1.5h-4.8c-.14 0-.25-.11-.25-.25v-1.62h5.05zm1.5 0v-2.62c0-.41-.34-.75-.75-.75h-5.8v-2.83c0-.14.11-.25.25-.25h1.55v.8c0 .41.34.75.75.75s.75-.34.75-.75v-.8h1.78v.8c0 .41.34.75.75.75s.75-.34.75-.75v-.8h1.56c.14 0 .25.11.25.25v5.95c0 .14-.11.25-.25.25z",
    clipRule: "evenodd"
  }));
};
Fi.displayName = "Simcard";
function Vn() {
  return Vn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Vn.apply(this, arguments);
}
var Di = function Di(e) {
  return a.createElement("svg", Vn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5a9.46 9.46 0 0 1-2.067 5.912 10.84 10.84 0 0 0-6.247-2.907l2.164-4.335c.18-.37.03-.82-.34-1a.763.763 0 0 0-1.01.34l-2.466 4.94a10.78 10.78 0 0 0-6.96 2.97A9.46 9.46 0 0 1 2.5 12m9.49 4.44a9.13 9.13 0 0 0-6.39 2.575A9.46 9.46 0 0 0 12 21.5a9.46 9.46 0 0 0 6.405-2.488 9.16 9.16 0 0 0-6.385-2.572h-.03m-6.96-4.28h-.06a.743.743 0 0 1-.68-.81c.33-3.98 3.73-7.1 7.72-7.1s7.39 3.12 7.72 7.09a.75.75 0 0 1-.68.81.75.75 0 0 1-.81-.68c-.27-3.21-3.01-5.72-6.23-5.72s-5.96 2.51-6.23 5.72c-.03.39-.36.69-.75.69m8.22 6.74a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
    clipRule: "evenodd"
  }));
};
Di.displayName = "SpeedMeter";
function Fn() {
  return Fn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Fn.apply(this, arguments);
}
var $i = function $i(e) {
  return a.createElement("svg", Fn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M17.49 22.75c-.3 0-.6-.08-.88-.23l-4.45-2.44a.31.31 0 0 0-.32 0l-4.45 2.44c-.62.34-1.36.3-1.94-.11-.61-.43-.91-1.16-.78-1.9l.85-5.17a.46.46 0 0 0-.12-.39l-3.6-3.67c-.51-.52-.69-1.28-.45-1.99.23-.68.8-1.17 1.49-1.28l4.97-.75c.12-.02.22-.1.28-.22l2.22-4.71c.31-.67.96-1.08 1.68-1.08s1.37.41 1.68 1.08l2.22 4.71c.06.12.16.2.28.22l4.97.75c.69.11 1.27.59 1.49 1.28.23.7.06 1.46-.45 1.99l-3.6 3.67c-.1.1-.14.25-.12.39l.85 5.17c.12.74-.18 1.47-.78 1.9-.32.23-.69.34-1.06.34zM12 18.53c.3 0 .61.08.88.23l4.44 2.44c.15.08.27.03.35-.02.05-.04.21-.17.17-.43l-.85-5.17c-.1-.62.1-1.25.53-1.68l3.6-3.66c.18-.18.12-.4.1-.46a.38.38 0 0 0-.3-.27l-4.97-.75c-.61-.09-1.14-.49-1.41-1.06l-2.22-4.71a.35.35 0 0 0-.33-.22c-.09 0-.23.03-.33.22L9.44 7.7c-.27.57-.8.97-1.41 1.06l-4.97.75c-.2.03-.27.2-.3.27-.02.06-.08.28.1.46l3.6 3.67c.43.44.63 1.07.53 1.68l-.85 5.17c-.04.26.12.4.17.43.08.06.2.1.35.02l4.44-2.44c.28-.15.58-.23.88-.23z"
  }));
};
$i.displayName = "Star";
function Dn() {
  return Dn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Dn.apply(this, arguments);
}
var qi = function qi(e) {
  return a.createElement("svg", Dn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M9.31 10.49H10v-.01c.45 0 .875-.108 1.25-.3v10.95H4.61V10.489l.09.001v-.01c.44 0 .88-.08 1.3-.23a4.5 4.5 0 0 0 1.236-.704 2.74 2.74 0 0 0 2.074.944M2 21.13h1.11V10.15c-.714-.31-1.26-.804-1.53-1.41-.45-1.01-.04-1.93.24-2.55.26-.58.56-1.13.86-1.66l.16-.29c.183-.338.372-.67.563-1.005l.207-.365.06-.11c.5-.86 1.42-1.4 2.42-1.4h11.35v.01h.47c1 0 1.93.54 2.42 1.4l.06.11c.26.45.52.91.77 1.37l.16.29.105.19c.258.472.526.96.755 1.47l.007.017c.27.61.679 1.532.233 2.533-.264.591-.79 1.076-1.48 1.387V21.13H22c.41 0 .75.34.75.75s-.34.75-.75.75H2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75m17.44 0V10.497l-.14.003v-.01c-.44 0-.88-.08-1.3-.23a4.5 4.5 0 0 1-1.246-.712 2.74 2.74 0 0 1-2.064.932v.01H14a2.74 2.74 0 0 1-1.25-.3v10.94zM11.25 7.742A1.25 1.25 0 0 1 10 8.98h-.69c-.69 0-1.25-.56-1.25-1.25V2.86h3.19v4.882m7.27 1.108c-.378-.137-.749-.383-1.108-.723q.027-.195.028-.397V2.87h.47c.46 0 .89.25 1.12.65l.06.11c.26.44.51.89.76 1.34l.16.29.083.151c.26.475.509.929.717 1.399.29.64.39.99.24 1.33-.21.46-.86.73-1.36.82-.39.07-.79.03-1.17-.11m-5.77-1.11V2.86h3.19v4.87c0 .69-.56 1.25-1.25 1.25H14a1.25 1.25 0 0 1-1.25-1.24M6.09 2.86h.47v4.88q0 .195.026.382-.54.514-1.106.718c-.38.14-.78.18-1.17.11-.5-.09-1.15-.36-1.36-.82-.15-.34-.05-.69.24-1.33.208-.47.457-.924.717-1.399l.083-.151.16-.29c.25-.45.5-.89.76-1.34l.06-.11c.23-.4.66-.65 1.12-.65M9.1 16.21c-.41 0-.75-.34-.75-.75v-1.5c0-.41.34-.75.75-.75s.75.34.75.75v1.5c0 .41-.34.75-.75.75m5.08-.75c0 .41.34.75.75.75s.75-.34.75-.75v-1.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75z",
    clipRule: "evenodd"
  }));
};
qi.displayName = "Store";
function $n() {
  return $n = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, $n.apply(this, arguments);
}
var Ui = function Ui(e) {
  return a.createElement("svg", $n({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M2.75 5c0-.69.56-1.25 1.25-1.25h16c.69 0 1.25.56 1.25 1.25v14.92a.25.25 0 0 1-.406.195l-2.828-2.262a2.75 2.75 0 0 0-1.718-.603H4c-.69 0-1.25-.56-1.25-1.25zM4 2.25A2.75 2.75 0 0 0 1.25 5v11A2.75 2.75 0 0 0 4 18.75h12.298c.284 0 .56.097.781.274l2.828 2.262c1.146.917 2.843.1 2.843-1.367V5A2.75 2.75 0 0 0 20 2.25zm4.604 9.306a.75.75 0 1 0-1.208.889c.895 1.215 2.654 1.89 4.353 1.966 1.723.078 3.638-.445 4.837-1.942a.75.75 0 0 0-1.172-.937c-.801 1.002-2.174 1.445-3.597 1.38-1.444-.064-2.685-.64-3.213-1.357M8.25 9.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M17 8.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
    clipRule: "evenodd"
  }));
};
Ui.displayName = "Support";
function qn() {
  return qn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, qn.apply(this, arguments);
}
var Gi = function Gi(e) {
  return a.createElement("svg", qn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M19.28 23.25H4.71c-1.08 0-1.96-.79-1.96-1.75v-19c0-.96.88-1.75 1.96-1.75h14.57c1.08 0 1.96.79 1.96 1.75v19c0 .96-.88 1.75-1.96 1.75m-14.57-21c-.29 0-.46.16-.46.25v19c0 .09.18.25.46.25h14.57c.29 0 .46-.16.46-.25v-19c0-.09-.18-.25-.46-.25zM12 20.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M10.5 5.25h3c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3c-.41 0-.75.34-.75.75s.34.75.75.75",
    clipRule: "evenodd"
  }));
};
Gi.displayName = "Tablet";
function Un() {
  return Un = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Un.apply(this, arguments);
}
var Yi = function Yi(e) {
  return a.createElement("svg", Un({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, a.createElement("path", {
    d: "M16.571 3.506a.75.75 0 0 1 .895.125l3.484 3.484a.75.75 0 0 1 .093.946l-2.703 4.056c-.37.555-.564 1.202-.794 1.97l-.116.387c-.316 1.032-.88 1.993-1.439 2.732-.28.371-.568.697-.834.957-.254.247-.53.475-.79.605a.75.75 0 0 1-.865-.14l-8.13-8.13a.75.75 0 0 1-.054-.999c1.535-1.92 3.187-2.774 4.528-3.087.272-.063.546-.118.808-.171l.03-.006c.275-.055.537-.108.793-.169.514-.122.966-.267 1.361-.486zm.234 1.586L13.567 6.89c-.57.316-1.173.5-1.743.634-.286.068-.572.126-.845.18l-.02.005c-.27.054-.524.105-.772.163-.894.208-2.074.759-3.263 2.055l7.173 7.173.013-.012c.206-.201.444-.469.684-.788.486-.642.95-1.447 1.201-2.266l.104-.347c.223-.753.486-1.644.993-2.403l2.362-3.544z"
  }), a.createElement("path", {
    fillOpacity: .2,
    d: "M16.571 3.506a.75.75 0 0 1 .895.125l3.484 3.484a.75.75 0 0 1 .093.946l-2.703 4.056c-.37.555-.564 1.202-.794 1.97l-.116.387c-.316 1.032-.88 1.993-1.439 2.732-.28.371-.568.697-.834.957-.254.247-.53.475-.79.605a.75.75 0 0 1-.865-.14l-8.13-8.13a.75.75 0 0 1-.054-.999c1.535-1.92 3.187-2.774 4.528-3.087.272-.063.546-.118.808-.171l.03-.006c.275-.055.537-.108.793-.169.514-.122.966-.267 1.361-.486zm.234 1.586L13.567 6.89c-.57.316-1.173.5-1.743.634-.286.068-.572.126-.845.18l-.02.005c-.27.054-.524.105-.772.163-.894.208-2.074.759-3.263 2.055l7.173 7.173.013-.012c.206-.201.444-.469.684-.788.486-.642.95-1.447 1.201-2.266l.104-.347c.223-.753.486-1.644.993-2.403l2.362-3.544z"
  }), a.createElement("path", {
    d: "M15.244 2.47a.75.75 0 0 1 1.06 0l5.807 5.806a.75.75 0 0 1-1.06 1.06L15.243 3.53a.75.75 0 0 1 0-1.06"
  }), a.createElement("path", {
    fillOpacity: .2,
    d: "M15.244 2.47a.75.75 0 0 1 1.06 0l5.807 5.806a.75.75 0 0 1-1.06 1.06L15.243 3.53a.75.75 0 0 1 0-1.06"
  }), a.createElement("path", {
    d: "M10.498 13.502a.75.75 0 0 1 0 1.06L3.53 21.53a.75.75 0 0 1-1.06-1.06l6.967-6.968a.75.75 0 0 1 1.061 0"
  }), a.createElement("path", {
    fillOpacity: .2,
    d: "M10.498 13.502a.75.75 0 0 1 0 1.06L3.53 21.53a.75.75 0 0 1-1.06-1.06l6.967-6.968a.75.75 0 0 1 1.061 0"
  })), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
Yi.displayName = "Tack";
function Gn() {
  return Gn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Gn.apply(this, arguments);
}
var Qi = function Qi(e) {
  return a.createElement("svg", Gn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    d: "M22 9.27a.75.75 0 0 1 0 1.5q-.13 0-.25.007V22a.75.75 0 0 1-1.5 0V11.307a3 3 0 0 0-.436.422c-.552.644-.922 1.496-1.46 2.54-.302.587-.651 1.209-1.104 1.795V22a.75.75 0 0 1-1.5 0v-4.52c-.795.526-1.771.891-3 1.033V22a.75.75 0 0 1-1.5 0v-3.42h-3V22a.75.75 0 0 1-1.5 0v-3.42h-3V22a.75.75 0 0 1-1.5 0v-3.42H2a.75.75 0 0 1 0-1.5h9.56c1.768 0 2.877-.448 3.653-1.058.795-.627 1.314-1.48 1.807-2.44.468-.908.952-2.01 1.654-2.83.76-.886 1.79-1.481 3.326-1.481M9 1.58a7.75 7.75 0 0 1 0 15.5l-.398-.01A7.75 7.75 0 0 1 9 1.58M5.144 14.246a6.2 6.2 0 0 0 3.106 1.287v-4.392zm4.606 1.287a6.2 6.2 0 0 0 3.105-1.287L9.75 11.141zM2.797 10.08a6.2 6.2 0 0 0 1.286 3.105l3.106-3.105zm11.119 3.105a6.2 6.2 0 0 0 1.287-3.105h-4.392zM4.083 5.474A6.2 6.2 0 0 0 2.797 8.58h4.392zM10.81 8.58h4.393a6.2 6.2 0 0 0-1.287-3.106zM8.25 3.126a6.2 6.2 0 0 0-3.106 1.287L8.25 7.52zm1.5 4.394 3.105-3.107A6.2 6.2 0 0 0 9.75 3.126z"
  }));
};
Qi.displayName = "Themepark";
function Yn() {
  return Yn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Yn.apply(this, arguments);
}
var Xi = function Xi(e) {
  return a.createElement("svg", Yn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M10.45 21.54h7.84l.01.01c1.52 0 2.37-1.39 2.64-2.25l1.75-6.81c.02-.03.02-.07.02-.1.12-1-.26-1.92-1.03-2.55-.78-.64-1.53-.69-2.28-.69h-3.29V4.82c0-.77-.36-1.43-1-1.87-.74-.5-1.77-.61-2.61-.28-.54.21-1.03.55-1.41 1L6.65 8.88a1.74 1.74 0 0 0-1.12-.41h-2.5c-.96 0-1.75.79-1.75 1.75v9.5c0 .96.79 1.75 1.75 1.75h2.5a1.76 1.76 0 0 0 1.747-1.652c.836.87 1.854 1.722 3.173 1.722m-3.17-3.904a1 1 0 0 1 .06.054c.17.17.34.35.51.55.77.84 1.65 1.8 2.6 1.8h7.84c.81 0 1.2-1.16 1.2-1.17l1.72-6.71c.04-.46-.13-.87-.49-1.16-.37-.3-.7-.35-1.33-.35h-4.04c-.41 0-.75-.34-.75-.75V4.82c0-.27-.11-.48-.34-.63-.33-.22-.83-.27-1.21-.12-.31.12-.6.33-.81.58l-4.96 5.808zm-4.5-7.416c0-.14.11-.25.25-.25h2.5c.14 0 .25.11.25.25v9.5c0 .14-.11.25-.25.25h-2.5c-.14 0-.25-.11-.25-.25z",
    clipRule: "evenodd"
  }));
};
Xi.displayName = "Thumbsup";
function Qn() {
  return Qn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Qn.apply(this, arguments);
}
var Ki = function Ki(e) {
  return a.createElement("svg", Qn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5m9.5.75c-.41 0-.75-.34-.75-.75V5.56c0-.41.34-.75.75-.75s.75.34.75.75v5.69H16c.41 0 .75.34.75.75s-.34.75-.75.75h-4",
    clipRule: "evenodd"
  }));
};
Ki.displayName = "Time";
function Xn() {
  return Xn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Xn.apply(this, arguments);
}
var Ji = function Ji(e) {
  return a.createElement("svg", Xn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M4.96 7.326a3.06 3.06 0 0 1-2.3-2.956c0-1.68 1.37-3.05 3.05-3.05s3.05 1.37 3.05 3.05c0 1.421-.98 2.62-2.3 2.956v1.728a3.06 3.06 0 0 1 2.3 2.956c0 1.421-.98 2.62-2.3 2.956v1.708a3.06 3.06 0 0 1 2.3 2.956c0 1.68-1.37 3.05-3.05 3.05s-3.05-1.37-3.05-3.05c0-1.421.98-2.62 2.3-2.956v-1.708a3.06 3.06 0 0 1-2.3-2.956c0-1.421.98-2.62 2.3-2.957zm-.8-2.956c0-.85.7-1.55 1.55-1.55s1.55.7 1.55 1.55-.7 1.55-1.55 1.55-1.55-.7-1.55-1.55m0 7.64c0-.85.7-1.55 1.55-1.55s1.55.7 1.55 1.55-.7 1.55-1.55 1.55-1.55-.7-1.55-1.55m1.55 6.07c-.85 0-1.55.7-1.55 1.55s.7 1.55 1.55 1.55 1.55-.7 1.55-1.55-.7-1.55-1.55-1.55m5.78-12.96h9.1c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-9.1c-.41 0-.75.34-.75.75s.34.75.75.75m7.59 7.64h-7.59c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.59c.41 0 .75.34.75.75s-.34.75-.75.75m-7.59 7.64h9.1c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-9.1c-.41 0-.75.34-.75.75s.34.75.75.75",
    clipRule: "evenodd"
  }));
};
Ji.displayName = "Timeline";
function Kn() {
  return Kn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Kn.apply(this, arguments);
}
var Zi = function Zi(e) {
  return a.createElement("svg", Kn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "m17.83 6.52.417 2.77H5.743l.417-2.77c.2-1.32 1.31-2.28 2.65-2.28h6.37c1.33 0 2.45.96 2.65 2.28M3.169 9.785l-1.51-.735a.74.74 0 0 1-.34-1 .74.74 0 0 1 1-.34l1.978.963L4.66 6.3A4.15 4.15 0 0 1 8.8 2.75h6.37c2.08 0 3.82 1.5 4.14 3.56l.364 2.377 2.006-.977c.37-.18.82-.03 1 .34s.03.82-.34 1l-1.503.732a3.79 3.79 0 0 1 1.923 3.298v6.38c0 .96-.78 1.75-1.75 1.75l-3.37.03h-.02v.01a1.588 1.588 0 0 1-1.59-1.59v-1.12l-8.15-.04v1.12c0 .88-.71 1.59-1.59 1.59H3c-.96 0-1.75-.79-1.75-1.75v-6.38c0-1.41.774-2.642 1.919-3.295M2.74 13.09c0-1.188.916-2.171 2.076-2.28h14.358a2.297 2.297 0 0 1 2.076 2.28v6.38c0 .14-.11.25-.25.25l-3.38.03-.09-.09v-1.61c0-.55-.45-1-1-1l-9.15-.04h-.01c-.55 0-1 .45-1 1v1.62c0 .05-.04.09-.09.09H2.99c-.14 0-.25-.11-.25-.25zm3.22 1.57h2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2c-.41 0-.75.34-.75.75s.34.75.75.75m10.08 0h2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2c-.41 0-.75.34-.75.75s.34.75.75.75",
    clipRule: "evenodd"
  }));
};
Zi.displayName = "Transport";
function Jn() {
  return Jn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Jn.apply(this, arguments);
}
var e7 = function e7(e) {
  return a.createElement("svg", Jn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M20.02 19.65V6.5h.43c.41 0 .75-.34.75-.75S20.86 5 20.45 5h-2.735l-.755-2.25c-.3-.88-1.08-1.47-1.96-1.47H9c-.89 0-1.68.59-1.97 1.48L6.29 5H3.56c-.41 0-.75.34-.75.75s.34.75.75.75h.35v13.15a3.06 3.06 0 0 0 3.06 3.06h9.99a3.06 3.06 0 0 0 3.06-3.06M5.41 6.5v13.15c0 .86.7 1.56 1.56 1.56h9.99c.86 0 1.56-.7 1.56-1.56V6.5zM7.866 5h8.258l-.594-1.77c-.09-.27-.31-.45-.54-.45h-6c-.23 0-.45.18-.54.45zm4.054 13.76c-.41 0-.75-.34-.75-.75v-9c0-.41.34-.75.75-.75s.75.34.75.75v9c0 .41-.34.75-.75.75m-4.25-1.9c0 .41.34.75.75.75s.75-.34.75-.75v-6.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75zm6.97 0c0 .41.34.75.75.75s.75-.34.75-.75v-6.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75z",
    clipRule: "evenodd"
  }));
};
e7.displayName = "Trash";
function Zn() {
  return Zn = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Zn.apply(this, arguments);
}
var t7 = function t7(e) {
  return a.createElement("svg", Zn({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M4.49 3.78a.727.727 0 0 0-.73.73v4.02a.75.75 0 0 1-1.5 0V4.51c0-1.234.996-2.23 2.23-2.23h4.02a.75.75 0 0 1 0 1.5zm16.47 10.96a.75.75 0 0 1 .75.75v4.02c0 1.234-.996 2.23-2.23 2.23h-4.02a.75.75 0 1 1 0-1.5h4.02c.406 0 .73-.324.73-.73v-4.02a.75.75 0 0 1 .75-.75M17.9 3.14a.75.75 0 0 0-.958-.086l-3.81 2.65a.75.75 0 0 0-.312.737l.518 3.16-2.943 2.943L9.33 11.48a1.426 1.426 0 0 0-2.01 0l-3.33 3.33A3.671 3.671 0 0 0 9.18 20l3.33-3.33a1.426 1.426 0 0 0 0-2.01l-1.054-1.055 2.942-2.943 3.16.518a.75.75 0 0 0 .738-.312l2.65-3.81a.75.75 0 0 0-.086-.958zm-3.107 6.067-.416-2.541 2.906-2.022 2.073 2.073-2.022 2.906zm-6.468 3.389L5.05 15.87a2.171 2.171 0 0 0 3.07 3.07l3.274-3.275z",
    clipRule: "evenodd"
  }));
};
t7.displayName = "Troubleshoot";
function e0() {
  return e0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, e0.apply(this, arguments);
}
var n7 = function n7(e) {
  return a.createElement("svg", e0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M2.92 17.22h8.29v1.84H9.29c-.41 0-.75.34-.75.75s.34.75.75.75h5.34a.75.75 0 0 0 .58-.278 5.757 5.757 0 0 0 7.432-6.472h.028V5.09c0-.91-.74-1.65-1.65-1.65H2.92c-.91 0-1.65.74-1.65 1.65v10.48c0 .91.74 1.65 1.65 1.65m18.25-6.343V5.09c0-.08-.07-.15-.15-.15H2.92c-.08 0-.15.07-.15.15v10.48c0 .08.07.15.15.15h8.382a5.757 5.757 0 0 1 5.678-6.66c1.65 0 3.14.7 4.19 1.817m-8.46 7.78v.403h.401a6 6 0 0 1-.401-.403m.02-3.847a4.26 4.26 0 0 1 4.25-4.25 4.26 4.26 0 0 1 4.25 4.25 4.26 4.26 0 0 1-4.25 4.25 4.26 4.26 0 0 1-4.25-4.25m2.25.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.25v-1.25c0-.41.34-.75.75-.75s.75.34.75.75v1.25h1.25c.41 0 .75.34.75.75s-.34.75-.75.75h-1.25v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.25z",
    clipRule: "evenodd"
  }));
};
n7.displayName = "TVAddon";
function t0() {
  return t0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, t0.apply(this, arguments);
}
var r7 = function r7(e) {
  return a.createElement("svg", t0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M11.25 17.22h-8.3c-.91 0-1.65-.74-1.65-1.65V5.09c0-.91.74-1.65 1.65-1.65h18.1c.91 0 1.65.74 1.65 1.65v10.48c0 .91-.74 1.65-1.65 1.65h-8.3v1.84h1.92c.41 0 .75.34.75.75s-.34.75-.75.75H9.33c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.92zM2.95 4.94c-.08 0-.15.07-.15.15v10.48c0 .08.07.15.15.15h18.1c.08 0 .15-.07.15-.15V5.09c0-.08-.07-.15-.15-.15z",
    clipRule: "evenodd"
  }));
};
r7.displayName = "TV";
function n0() {
  return n0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, n0.apply(this, arguments);
}
var l7 = function l7(e) {
  return a.createElement("svg", n0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M7.48 8.31a.755.755 0 0 1-.55-1.27l4.49-4.72a.755.755 0 0 1 1.1.01l4.49 4.72c.29.3.27.78-.03 1.06a.75.75 0 0 1-.52.21v-.01c-.2 0-.4-.08-.54-.23l-3.2-3.364V17.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.706L8.02 8.07c-.15.15-.35.23-.54.23zM5.8 21.9h12.39c1.9 0 3.45-1.55 3.45-3.45v-1.83c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.83c0 1.07-.87 1.95-1.95 1.95H5.8c-1.08 0-1.95-.87-1.95-1.95v-1.83c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.83c0 1.9 1.55 3.45 3.45 3.45",
    clipRule: "evenodd"
  }));
};
l7.displayName = "Upload";
function r0() {
  return r0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, r0.apply(this, arguments);
}
var a7 = function a7(e) {
  return a.createElement("svg", r0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M18.23 4.49c0-.406.324-.73.73-.73h1.03c.406 0 .73.324.73.73v15.75h-2.49zm.73-2.23c-1.234 0-2.23.996-2.23 2.23v16.5c0 .414.336.75.75.75h3.99a.75.75 0 0 0 .75-.75V4.49c0-1.234-.996-2.23-2.23-2.23zm-7.48 6.5a.727.727 0 0 0-.73.73v10.75h2.49V9.49a.727.727 0 0 0-.73-.73zm-2.23.73c0-1.234.996-2.23 2.23-2.23h1.03c1.234 0 2.23.996 2.23 2.23v11.5a.75.75 0 0 1-.75.75H10a.75.75 0 0 1-.75-.75zM4 13.76a.727.727 0 0 0-.73.73v5.75h2.49v-5.75a.727.727 0 0 0-.73-.73zm-2.23.73c0-1.234.996-2.23 2.23-2.23h1.03c1.234 0 2.23.996 2.23 2.23v6.5a.75.75 0 0 1-.75.75H2.52a.75.75 0 0 1-.75-.75z",
    clipRule: "evenodd"
  }));
};
a7.displayName = "Usage";
function l0() {
  return l0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, l0.apply(this, arguments);
}
var i7 = function i7(e) {
  return a.createElement("svg", l0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M18.27 22.71H5.73c-1.52 0-2.75-1.23-2.75-2.75V4.04c0-1.52 1.23-2.75 2.75-2.75h12.54c1.52 0 2.75 1.23 2.75 2.75v15.93c0 1.52-1.23 2.75-2.75 2.75zM5.73 2.79c-.69 0-1.25.56-1.25 1.25v15.93c0 .69.56 1.25 1.25 1.25h12.54c.69 0 1.25-.56 1.25-1.25V4.04c0-.69-.56-1.25-1.25-1.25zm1.86 4.26h-.15a1 1 0 1 0 0 2h.15a1 1 0 1 0 0-2m-.15 3.92h.15a1 1 0 1 1 0 2h-.15a1 1 0 1 1 0-2m.15 4h-.15a1 1 0 1 0 0 2h.15a1 1 0 1 0 0-2m3.08-6.17h6c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-6c-.41 0-.75.34-.75.75s.34.75.75.75m6 3.95h-6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75m-6 3.95h6c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-6c-.41 0-.75.34-.75.75s.34.75.75.75",
    clipRule: "evenodd"
  }));
};
i7.displayName = "Viewlist";
function a0() {
  return a0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, a0.apply(this, arguments);
}
var o7 = function o7(e) {
  return a.createElement("svg", a0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    clipPath: "url(#a)"
  }, a.createElement("g", {
    fill: e.color || "#222222",
    clipPath: "url(#b)"
  }, a.createElement("path", {
    d: "M21.75 5c.28 0 .5.22.5.5v3.7a2.804 2.804 0 0 0-2.31 2.76c0 1.38 1 2.52 2.31 2.76v3.79c0 .28-.22.5-.5.5H2.25c-.28 0-.5-.22-.5-.5v-3.79a2.81 2.81 0 0 0 2.3-2.75c0-1.37-.99-2.52-2.3-2.75v-3.7c0-.28.22-.5.5-.5h19.5m0-1.52H2.25c-1.1 0-2 .9-2 2v5.16h1c.72 0 1.3.58 1.3 1.3s-.58 1.3-1.3 1.3h-1v5.24c0 1.1.9 2 2 2h19.5c1.1 0 2-.9 2-2v-5.24h-1.01c-.72 0-1.3-.58-1.3-1.3s.58-1.3 1.3-1.3h1.01V5.5c0-1.1-.9-2-2-2"
  }), a.createElement("path", {
    d: "M8.68 8.44c-.41 0-.75-.34-.75-.75v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75M8.68 13.72c-.41 0-.75-.34-.75-.75v-2.01c0-.41.34-.75.75-.75s.75.34.75.75v2.01c0 .41-.34.75-.75.75M8.68 18.99c-.41 0-.75-.34-.75-.75v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75"
  }))), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  })), a.createElement("clipPath", {
    id: "b"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
o7.displayName = "Voucher";
function i0() {
  return i0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, i0.apply(this, arguments);
}
var c7 = function c7(e) {
  return a.createElement("svg", i0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M19.17 21.25H4.83a2.58 2.58 0 0 1-2.58-2.58V5.56c0-1.55 1.26-2.81 2.81-2.81h11.11a2.58 2.58 0 0 1 2.58 2.58v1.53h.42a2.58 2.58 0 0 1 2.58 2.58v9.21a2.58 2.58 0 0 1-2.58 2.58zM17.869 8.37q.06.01.121.01h1.17c.59 0 1.08.48 1.08 1.08v1.79h-3.92c-.41 0-.75.34-.75.75v3.74c0 .41.34.75.75.75h3.92v2.18c0 .59-.48 1.08-1.08 1.08H4.83c-.59 0-1.08-.48-1.08-1.08V8.046c.391.207.837.324 1.31.324zM5.06 4.26v-.01c-.72 0-1.31.59-1.31 1.31s.59 1.31 1.31 1.31h12.18V5.35c0-.6-.49-1.08-1.08-1.08H5.06zm12.01 8.49h3.17v2.24h-3.17z",
    clipRule: "evenodd"
  }));
};
c7.displayName = "Wallet";
function o0() {
  return o0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, o0.apply(this, arguments);
}
var s7 = function s7(e) {
  return a.createElement("svg", o0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1.71 10.08c.14.12.3.17.47.17v.01c.22 0 .43-.1.58-.28 2.29-2.81 5.7-4.42 9.27-4.42s6.93 1.58 9.21 4.35c.27.32.74.36 1.06.1.32-.27.36-.74.1-1.06-2.57-3.11-6.31-4.9-10.37-4.9S4.17 5.86 1.6 9.02c-.26.33-.21.8.11 1.06m2.88 2.87c.13.1.29.15.44.15v-.01c.23 0 .45-.1.6-.3a7.99 7.99 0 0 1 6.4-3.24c2.51 0 4.9 1.21 6.4 3.24a.752.752 0 0 0 1.21-.89 9.46 9.46 0 0 0-7.6-3.85c-2.99 0-5.83 1.44-7.61 3.85-.24.34-.17.8.16 1.05m3.31 3.06q-.18 0-.36-.09c-.36-.2-.5-.65-.3-1.02a5.452 5.452 0 0 1 9.56-.04c.2.36.07.82-.29 1.02s-.82.07-1.02-.29a3.946 3.946 0 0 0-6.93.03c-.14.25-.39.39-.66.39m5.38 1.49a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
    clipRule: "evenodd"
  }));
};
s7.displayName = "Wifi";
function c0() {
  return c0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, c0.apply(this, arguments);
}
var d7 = function d7(e) {
  return a.createElement("svg", c0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M8.25 6.75H4c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25H8.25m7.5-1.5H20c1.52 0 2.75 1.23 2.75 2.75v11c0 1.52-1.23 2.75-2.75 2.75H4c-1.52 0-2.75-1.23-2.75-2.75V8c0-1.52 1.23-2.75 2.75-2.75h4.25V4c0-.96.79-1.75 1.75-1.75h4c.96 0 1.75.79 1.75 1.75zm-1.5 0V4c0-.14-.11-.25-.25-.25h-4c-.14 0-.25.11-.25.25v1.25zm-11.5 8.7V19c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25v-5.05c-.375.192-.8.3-1.25.3h-5.5v1.26c0 .96-.79 1.75-1.75 1.75h-1.5c-.96 0-1.75-.79-1.75-1.75v-1.26H4c-.45 0-.875-.108-1.25-.3m8.25.31v1.25c0 .14.11.25.25.25h1.5c.14 0 .25-.11.25-.25v-1.25z",
    clipRule: "evenodd"
  }));
};
d7.displayName = "Work";
function s0() {
  return s0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, s0.apply(this, arguments);
}
var u7 = function u7(e) {
  return a.createElement("svg", s0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M3.5 7.32A3.825 3.825 0 0 1 7.32 3.5h9.03a.75.75 0 0 0 0-1.5H7.32A5.325 5.325 0 0 0 2 7.32v9.03a.75.75 0 0 0 1.5 0zm2.6 1.01c0-1.234.996-2.23 2.23-2.23H19.2c1.234 0 2.23.996 2.23 2.23V19.2c0 1.234-.996 2.23-2.23 2.23H8.33A2.227 2.227 0 0 1 6.1 19.2zm8.47 1.78a.75.75 0 1 0-1.5 0v2.96h-2.96a.75.75 0 0 0 0 1.5h2.96v2.96a.75.75 0 0 0 1.5 0v-2.96h2.96a.75.75 0 0 0 0-1.5h-2.96z",
    clipRule: "evenodd"
  }));
};
u7.displayName = "AddonProductFilled";
function d0() {
  return d0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, d0.apply(this, arguments);
}
var h7 = function h7(e) {
  return a.createElement("svg", d0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M6.5 1.75A2.25 2.25 0 0 0 4.25 4v17.5a.75.75 0 0 0 1.163.626l1.92-1.268 1.92 1.268a.75.75 0 0 0 .827 0L12 20.858l1.92 1.268a.75.75 0 0 0 .827 0l1.92-1.268 1.92 1.268a.75.75 0 0 0 1.163-.626V4a2.25 2.25 0 0 0-2.25-2.25zM12.75 7a.75.75 0 0 0-1.5 0v.303a4 4 0 0 0-.174.03c-.392.076-.845.235-1.214.587l-.003.004c-.645.623-.813 1.66-.334 2.455l.002.004c.507.833 1.473 1.117 2.05 1.279h.002l.607.168c.558.171.867.342 1.002.566a.505.505 0 0 1-.091.6c-.085.081-.228.153-.463.2a4.2 4.2 0 0 1-.792.054c-.307 0-.6-.095-.8-.245a.66.66 0 0 1-.288-.546.75.75 0 0 0-1.5.021c.011.756.382 1.346.89 1.726.328.246.712.406 1.106.485V15a.75.75 0 0 0 1.5 0v-.303q.085-.013.171-.03c.392-.076.845-.235 1.214-.588l.003-.003c.64-.619.824-1.649.333-2.458-.46-.757-1.299-1.055-1.857-1.225l-.018-.006-.615-.17h-.002c-.641-.18-1.01-.35-1.17-.612a.52.52 0 0 1 .091-.602c.085-.08.228-.152.463-.198.238-.047.505-.055.792-.055.307 0 .6.095.8.245a.66.66 0 0 1 .288.546.75.75 0 0 0 1.5-.022 2.16 2.16 0 0 0-.89-1.725 2.75 2.75 0 0 0-1.103-.484z",
    clipRule: "evenodd"
  }));
};
h7.displayName = "BillsFilled";
function u0() {
  return u0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, u0.apply(this, arguments);
}
var f7 = function f7(e) {
  return a.createElement("svg", u0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    d: "M22.52 10.28 19.4 6.57a.74.74 0 0 0-.57-.27h-1.92l.16-1.39a.756.756 0 0 0-.75-.84H4.38a.81.81 0 0 0-.8.72c-.05.47.32.89.8.89h4.06c.41 0 .75.34.75.75s-.34.75-.75.75H2.98c-.38 0-.7.29-.74.66-.05.45.3.84.74.84h3.96c.41 0 .75.34.75.75s-.34.75-.75.75H2.13c-.38 0-.7.29-.74.66-.05.45.3.84.74.84h2.81c.41 0 .75.34.75.75s-.34.75-.75.75H3.51c-.51 0-.93.38-.99.88l-.48 3.99a.756.756 0 0 0 .75.84h1.49c0 .08-.03.16-.03.25a2.78 2.78 0 0 0 2.78 2.78c1.53 0 2.78-1.25 2.78-2.78 0-.09-.02-.17-.03-.25h3.92c0 .08-.03.16-.03.25a2.78 2.78 0 0 0 2.78 2.78c1.53 0 2.78-1.25 2.78-2.78 0-.09-.02-.17-.03-.25h1.72c.38 0 .69-.28.74-.65l.02-.13.98-7.25a.72.72 0 0 0-.17-.58zM7.03 20.42c-.71 0-1.28-.58-1.28-1.28s.58-1.28 1.28-1.28 1.28.58 1.28 1.28-.58 1.28-1.28 1.28m9.44 0c-.71 0-1.28-.58-1.28-1.28s.58-1.28 1.28-1.28 1.28.58 1.28 1.28-.58 1.28-1.28 1.28m4.46-7.73h-4.76l.57-4.89h1.74l2.68 3.18-.23 1.7z"
  }));
};
f7.displayName = "DeliveryFilled";
function h0() {
  return h0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, h0.apply(this, arguments);
}
var v7 = function v7(e) {
  return a.createElement("svg", h0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    clipPath: "url(#a)"
  }, a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M13.974 1.443a2.54 2.54 0 0 0-3.949 0 2.54 2.54 0 0 1-2.633.855A2.54 2.54 0 0 0 4.197 4.62a2.54 2.54 0 0 1-1.628 2.24 2.54 2.54 0 0 0-1.22 3.756 2.54 2.54 0 0 1 0 2.77 2.54 2.54 0 0 0 1.22 3.755 2.54 2.54 0 0 1 1.628 2.24 2.54 2.54 0 0 0 3.195 2.322c.97-.261 2.002.074 2.633.855a2.54 2.54 0 0 0 3.95 0 2.54 2.54 0 0 1 2.633-.855 2.54 2.54 0 0 0 3.195-2.321 2.54 2.54 0 0 1 1.627-2.24 2.54 2.54 0 0 0 1.22-3.756 2.54 2.54 0 0 1 0-2.77 2.54 2.54 0 0 0-1.22-3.755 2.54 2.54 0 0 1-1.627-2.24 2.54 2.54 0 0 0-3.195-2.322 2.54 2.54 0 0 1-2.634-.855m-5.686 15.14a.75.75 0 0 1-.11-1.055l6.481-8.005a.75.75 0 1 1 1.166.944l-6.482 8.005a.75.75 0 0 1-1.055.11m-1.192-7.05a1.502 1.502 0 0 0 2.808-1.07c-.29-.77-1.169-1.156-1.94-.867-.772.289-1.157 1.167-.868 1.937m7 6a1.502 1.502 0 0 0 2.808-1.07c-.29-.77-1.169-1.156-1.94-.867-.772.289-1.157 1.167-.868 1.937",
    clipRule: "evenodd"
  })), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
v7.displayName = "DiscountFilled";
function f0() {
  return f0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, f0.apply(this, arguments);
}
var m7 = function m7(e) {
  return a.createElement("svg", f0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#242328",
    fillRule: "evenodd",
    d: "M20.975 2.893a1.7 1.7 0 0 0-1.02-.392c-.417-.015-.879.117-1.42.393-1.037.528-2.53 1.675-4.84 3.813L5.5 3.489a1 1 0 0 0-1.025.178l-1.29 1.13a1 1 0 0 0 .142 1.61l6.756 4.075-3.125 3.53H4.395a.5.5 0 0 0-.355.148l-1.395 1.403a.5.5 0 0 0 .158.812l3.333 1.428 1.373 3.385a.5.5 0 0 0 .817.166l1.661-1.657a.5.5 0 0 0 .146-.393l-.185-2.38 3.42-3.176 3.749 6.45a1 1 0 0 0 1.573.203l1.176-1.183a1 1 0 0 0 .23-1.05l-2.924-7.948c2.281-2.31 3.46-3.8 3.977-4.84.27-.543.384-1.01.343-1.431-.043-.433-.241-.745-.444-.986a.5.5 0 0 0-.073-.07",
    clipRule: "evenodd"
  }));
};
m7.displayName = "FlightFilled";
function v0() {
  return v0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, v0.apply(this, arguments);
}
var g7 = function g7(e) {
  return a.createElement("svg", v0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    stroke: "none",
    d: "M12 21.25c-.18 0-.36-.06-.5-.19l-7.79-7.03c-2.5-2.6-2.34-5.15-2.33-5.26 0-1.89.55-3.41 1.64-4.49 1.56-1.54 3.65-1.52 3.73-1.52 2.71 0 4.41 1.33 5.26 2.24.85-.91 2.55-2.24 5.27-2.24.08 0 2.16-.01 3.72 1.52 1.09 1.07 1.64 2.6 1.64 4.54 0 .05.16 2.6-2.29 5.16l-7.83 7.07c-.14.13-.32.19-.5.19z",
    strokeWidth: 1
  }));
};
g7.displayName = "HeartFilled";
function m0() {
  return m0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, m0.apply(this, arguments);
}
var x7 = function x7(e) {
  return a.createElement("svg", m0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M13.888 3.252a2.75 2.75 0 0 0-3.776 0l-7 6.61.515.546-.515-.545a2.75 2.75 0 0 0-.862 2V19.5a2.25 2.25 0 0 0 2.25 2.25h4A1.75 1.75 0 0 0 10.25 20v-3.5a1.75 1.75 0 1 1 3.5 0V20c0 .966.784 1.75 1.75 1.75h4a2.25 2.25 0 0 0 2.25-2.25v-7.638a2.75 2.75 0 0 0-.862-2l-.515.546.515-.545z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M13.888 3.252a2.75 2.75 0 0 0-3.776 0l-7 6.61.515.546-.515-.545a2.75 2.75 0 0 0-.862 2V19.5a2.25 2.25 0 0 0 2.25 2.25h4A1.75 1.75 0 0 0 10.25 20v-3.5a1.75 1.75 0 1 1 3.5 0V20c0 .966.784 1.75 1.75 1.75h4a2.25 2.25 0 0 0 2.25-2.25v-7.638a2.75 2.75 0 0 0-.862-2l-.515.546.515-.545z",
    clipRule: "evenodd"
  }));
};
x7.displayName = "HomeFilled";
function g0() {
  return g0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, g0.apply(this, arguments);
}
var b7 = function b7(e) {
  return a.createElement("svg", g0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M3.75 5A2.75 2.75 0 0 0 1 7.75v10.63a2.75 2.75 0 0 0 2.75 2.75h15.84a2.75 2.75 0 0 0 2.75-2.75V7.75A2.75 2.75 0 0 0 19.59 5z",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: "white",
    fillRule: "evenodd",
    d: "M2.622 8.87a.75.75 0 0 1 1.048-.168l6.61 4.78.03.023a2.3 2.3 0 0 0 2.9-.013l6.45-4.66a.75.75 0 0 1 .88 1.216l-6.438 4.65a3.8 3.8 0 0 1-4.716-.01l-6.595-4.77a.75.75 0 0 1-.169-1.047",
    clipRule: "evenodd"
  }));
};
b7.displayName = "MailFilled";
function x0() {
  return x0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, x0.apply(this, arguments);
}
var w7 = function w7(e) {
  return a.createElement("svg", x0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none",
    strokeWidth: e.size > 16 ? 0 : .8,
    viewBox: "0 0 24 24"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    d: "M4.26 15.06a3.06 3.06 0 1 1 0-6.12 3.06 3.06 0 0 1 0 6.12m15.48 0a3.06 3.06 0 1 1 0-6.12 3.06 3.06 0 0 1 0 6.12M8.94 12a3.06 3.06 0 1 0 6.12 0 3.06 3.06 0 0 0-6.12 0",
    clipRule: "evenodd",
    strokeWidth: 1
  }));
};
w7.displayName = "MoreFilled";
function b0() {
  return b0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, b0.apply(this, arguments);
}
var y7 = function y7(e) {
  return a.createElement("svg", b0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M12 2.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5m-5 11.5a3.75 3.75 0 1 0 0 7.5h10a3.75 3.75 0 1 0 0-7.5z",
    clipRule: "evenodd"
  }));
};
y7.displayName = "PersonalFilled";
function w0() {
  return w0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, w0.apply(this, arguments);
}
var j7 = function j7(e) {
  return a.createElement("svg", w0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: "#0CAA8F",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M10.892 18.114a1.57 1.57 0 0 0 2.215 0l9.428-9.427A1.571 1.571 0 0 0 21.435 6H2.58a1.57 1.57 0 0 0-1.115 2.687z"
  }));
};
j7.displayName = "PriceDown";
function y0() {
  return y0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, y0.apply(this, arguments);
}
var z7 = function z7(e) {
  return a.createElement("svg", y0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: "#CA112F",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M13.108 6.457a1.57 1.57 0 0 0-2.215 0l-9.428 9.427a1.571 1.571 0 0 0 1.1 2.687H21.42a1.57 1.57 0 0 0 1.115-2.687z"
  }));
};
z7.displayName = "PriceUp";
function j0() {
  return j0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, j0.apply(this, arguments);
}
var p7 = function p7(e) {
  return a.createElement("svg", j0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M7.206 1.904c1.007-.805 2.679-.642 3.668.85.46.69.834 1.402 1.126 2.047.292-.645.667-1.356 1.126-2.048.989-1.491 2.661-1.654 3.668-.849l.053.047c.53.511.769 1.1.76 1.695-.009.567-.24 1.054-.489 1.409-.224.32-.593.588-.937.803-.21.132-.445.263-.692.392H19A2.75 2.75 0 0 1 21.75 9v10A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V9A2.75 2.75 0 0 1 5 6.25h3.511c-.247-.129-.481-.26-.692-.392-.344-.215-.713-.483-.937-.803-.248-.355-.48-.842-.489-1.409-.009-.595.23-1.184.76-1.695zm.961 1.153c-.235.239-.276.43-.274.567.003.17.077.37.218.57.038.056.181.192.503.392.298.187.68.387 1.108.592.327.156.669.31 1.008.458-.271-.625-.64-1.35-1.106-2.054-.533-.804-1.187-.715-1.457-.525m7.94.567c.002-.137-.039-.328-.274-.567-.27-.19-.924-.28-1.457.525a13.4 13.4 0 0 0-1.105 2.054c.338-.148.68-.302 1.007-.458.428-.205.81-.405 1.108-.592.322-.2.465-.336.503-.391.141-.202.215-.4.218-.571M12.75 8.5a.75.75 0 0 0-1.5 0v4.75H4.5a.75.75 0 0 0 0 1.5h6.75v4.75a.75.75 0 0 0 1.5 0v-4.75h6.75a.75.75 0 0 0 0-1.5h-6.75z",
    clipRule: "evenodd"
  }));
};
p7.displayName = "RewardsFilled";
function z0() {
  return z0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, z0.apply(this, arguments);
}
var O7 = function O7(e) {
  return a.createElement("svg", z0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    stroke: "none",
    d: "M17.86 7.95h-.74V6.06c0-2.62-2.13-4.75-4.75-4.75h-.53c-2.62 0-4.75 2.13-4.75 4.75v1.89h-.94c-1.52 0-2.75 1.23-2.75 2.75v9.23c0 1.52 1.23 2.75 2.75 2.75h11.71c1.52 0 2.75-1.23 2.75-2.75V10.7c0-1.52-1.23-2.75-2.75-2.75m-5.11 7.68v2.17c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.17c-.73-.3-1.25-1.01-1.25-1.85 0-1.1.9-2 2-2s2 .9 2 2c0 .84-.52 1.55-1.25 1.85m2.86-7.68H8.58V6.06c0-1.79 1.46-3.25 3.25-3.25h.53c1.79 0 3.25 1.46 3.25 3.25z",
    strokeWidth: 1
  }));
};
O7.displayName = "SecureFilled";
function p0() {
  return p0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, p0.apply(this, arguments);
}
var E7 = function E7(e) {
  return a.createElement("svg", p0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M7.26 6.25h-.274a2.75 2.75 0 0 0-2.74 2.526l-.817 10a2.75 2.75 0 0 0 2.74 2.974H17.83a2.75 2.75 0 0 0 2.74-2.974l-.815-10a2.75 2.75 0 0 0-2.741-2.526h-.268c-.048-1.535-.537-2.774-1.378-3.646C14.482 1.686 13.277 1.25 12 1.25c-1.305 0-2.486.502-3.347 1.436-.815.883-1.305 2.11-1.392 3.564m1.504 0h6.481c-.046-1.214-.43-2.059-.956-2.604-.562-.582-1.356-.896-2.289-.896-.905 0-1.68.34-2.245.953-.527.572-.907 1.422-.991 2.547",
    clipRule: "evenodd"
  }));
};
E7.displayName = "ShopFilled";
function O0() {
  return O0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, O0.apply(this, arguments);
}
var S7 = function S7(e) {
  return a.createElement("svg", O0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    d: "M17.67 22.47c-.302 0-.585-.075-.868-.228L12.2 19.754a.38.38 0 0 0-.358.001l-4.6 2.487c-.523.314-1.303.305-1.91-.101a1.81 1.81 0 0 1-.745-1.742l.917-5.4a.37.37 0 0 0-.104-.328l-3.898-3.897a1.77 1.77 0 0 1-.412-1.797c.205-.615.767-1.078 1.43-1.181l5.302-.789a.38.38 0 0 0 .283-.209l2.305-4.776A1.79 1.79 0 0 1 12.045 1c.682 0 1.322.399 1.632 1.019l2.307 4.801c.054.113.16.191.283.209l5.299.79c.664.102 1.225.564 1.43 1.176.226.605.07 1.292-.406 1.796l-3.923 3.881a.38.38 0 0 0-.106.329l.896 5.395c.102.694-.183 1.362-.744 1.743a1.75 1.75 0 0 1-1.043.331",
    clipRule: "evenodd",
    strokeWidth: 1
  }));
};
S7.displayName = "StarFull";
function E0() {
  return E0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, E0.apply(this, arguments);
}
var C7 = function C7(e) {
  return a.createElement("svg", E0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    fillRule: "evenodd",
    stroke: "none",
    clipRule: "evenodd",
    strokeWidth: 1
  }, a.createElement("path", {
    fill: e.color || "#E1E1E1",
    d: "M17.67 22.47c-.302 0-.585-.075-.868-.228L12.2 19.754a.38.38 0 0 0-.358.001l-4.6 2.487c-.523.314-1.303.305-1.91-.101a1.81 1.81 0 0 1-.745-1.742l.917-5.4a.37.37 0 0 0-.104-.328l-3.898-3.897a1.77 1.77 0 0 1-.412-1.797c.205-.615.767-1.078 1.43-1.181l5.302-.789a.38.38 0 0 0 .283-.209l2.305-4.776A1.79 1.79 0 0 1 12.045 1c.682 0 1.322.399 1.632 1.019l2.307 4.801c.054.113.16.191.283.209l5.299.79c.664.102 1.225.564 1.43 1.176.226.605.07 1.292-.406 1.796l-3.923 3.881a.38.38 0 0 0-.106.329l.896 5.395c.102.694-.183 1.362-.744 1.743a1.75 1.75 0 0 1-1.043.331"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M11.996 1H12v18.717a.4.4 0 0 0-.205.044l-4.58 2.488c-.52.314-1.297.305-1.9-.101a1.82 1.82 0 0 1-.743-1.743l.913-5.401a.38.38 0 0 0-.104-.329l-3.88-3.898a1.78 1.78 0 0 1-.41-1.797c.203-.616.763-1.079 1.424-1.182l5.277-.79a.37.37 0 0 0 .282-.208l2.295-4.778c.3-.63.925-1.022 1.627-1.022"
  })));
};
C7.displayName = "StarHalf";
function S0() {
  return S0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, S0.apply(this, arguments);
}
var R7 = function R7(e) {
  return a.createElement("svg", S0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M15.244 2.47a.75.75 0 0 1 1.06 0l1.153 1.152.009.009 3.484 3.484.009.009 1.152 1.152a.75.75 0 0 1-1.06 1.06l-.515-.514-2.196 3.295c-.37.555-.564 1.202-.793 1.97l-.117.387c-.316 1.032-.88 1.993-1.439 2.732-.28.371-.568.697-.834.957-.254.247-.53.475-.79.605a.75.75 0 0 1-.865-.14l-3.534-3.535L3.53 21.53a.75.75 0 1 1-1.06-1.06l6.437-6.438-3.534-3.534a.75.75 0 0 1-.055-.999c1.535-1.92 3.187-2.774 4.528-3.087.272-.063.546-.118.808-.171l.03-.006c.275-.055.537-.108.793-.169.514-.122.966-.267 1.361-.486l2.864-1.591-.458-.459a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  }), a.createElement("path", {
    fill: e.color || "#222222",
    fillOpacity: .2,
    fillRule: "evenodd",
    d: "M15.244 2.47a.75.75 0 0 1 1.06 0l1.153 1.152.009.009 3.484 3.484.009.009 1.152 1.152a.75.75 0 0 1-1.06 1.06l-.515-.514-2.196 3.295c-.37.555-.564 1.202-.793 1.97l-.117.387c-.316 1.032-.88 1.993-1.439 2.732-.28.371-.568.697-.834.957-.254.247-.53.475-.79.605a.75.75 0 0 1-.865-.14l-3.534-3.535L3.53 21.53a.75.75 0 1 1-1.06-1.06l6.437-6.438-3.534-3.534a.75.75 0 0 1-.055-.999c1.535-1.92 3.187-2.774 4.528-3.087.272-.063.546-.118.808-.171l.03-.006c.275-.055.537-.108.793-.169.514-.122.966-.267 1.361-.486l2.864-1.591-.458-.459a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  }));
};
R7.displayName = "TackFilled";
function C0() {
  return C0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, C0.apply(this, arguments);
}
var M7 = function M7(e) {
  return a.createElement("svg", C0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 32 32",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    stroke: "none",
    d: "M16 0a16 16 0 1 0-.015 32A16 16 0 0 0 16 0m.31 22.44-.41.33-.4-.33c-5.28-4.29-6.78-5.87-6.83-8.36a4 4 0 0 1 1-2.77 3.9 3.9 0 0 1 2.6-1.31 4.36 4.36 0 0 1 3.63 1.55 4.3 4.3 0 0 1 1.63-1.21 4.4 4.4 0 0 1 2-.34 3.94 3.94 0 0 1 3.61 4.07c-.06 2.5-1.56 4.08-6.83 8.37",
    strokeWidth: 1
  }));
};
M7.displayName = "FavouriteActive";
function R0() {
  return R0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, R0.apply(this, arguments);
}
var T7 = function T7(e) {
  return a.createElement("svg", R0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 32 32",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: "#A8A8A8",
    stroke: "none",
    d: "M16 0a16 16 0 1 0-.015 32A16 16 0 0 0 16 0m.31 22.44-.41.33-.4-.33c-5.28-4.29-6.78-5.87-6.83-8.36a4 4 0 0 1 1-2.77 3.9 3.9 0 0 1 2.6-1.31 4.36 4.36 0 0 1 3.63 1.55 4.3 4.3 0 0 1 1.63-1.21 4.4 4.4 0 0 1 2-.34 3.94 3.94 0 0 1 3.61 4.07c-.06 2.5-1.56 4.08-6.83 8.37",
    strokeWidth: 1
  }));
};
T7.displayName = "Favourite";
function M0() {
  return M0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, M0.apply(this, arguments);
}
var P7 = function P7(e) {
  return a.createElement("svg", M0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#FF3636",
    fillRule: "evenodd",
    stroke: "none",
    d: "M9.444 3.498c1.108-1.997 4.003-1.997 5.112 0l8.079 14.566c1.069 1.928-.337 4.286-2.556 4.286H3.921c-2.219 0-3.625-2.358-2.556-4.286zM12 7.775c.456 0 .825.37.825.825v5.5a.825.825 0 0 1-1.65 0V8.6c0-.455.37-.825.825-.825m1.1 9.625a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0",
    clipRule: "evenodd"
  }));
};
P7.displayName = "Alert";
function T0() {
  return T0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, T0.apply(this, arguments);
}
var k7 = function k7(e) {
  return a.createElement("svg", T0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#0062F5",
    stroke: "none",
    d: "M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1m.75 15.75c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-6c0-.41.34-.75.75-.75s.75.34.75.75zm-.04-9.08a1 1 0 0 1-.71.29.99.99 0 0 1-.92-1.38c.05-.12.12-.23.21-.32.28-.28.73-.37 1.09-.22.12.05.23.12.33.22.09.09.17.2.22.32s.07.25.07.38c0 .27-.1.52-.29.71"
  }));
};
k7.displayName = "CannotBeTracked";
function P0() {
  return P0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, P0.apply(this, arguments);
}
var A7 = function A7(e) {
  return a.createElement("svg", P0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("g", {
    stroke: "none",
    clipPath: "url(#a)"
  }, a.createElement("path", {
    fill: e.color || "#00D16A",
    d: "M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1m5.36 8.01-6.44 7a.73.73 0 0 1-.53.24h-.02c-.19 0-.38-.08-.52-.21l-3.18-3.06a.746.746 0 0 1-.02-1.06c.29-.3.76-.31 1.06-.02l2.63 2.53 5.92-6.44c.28-.3.76-.32 1.06-.04s.32.75.04 1.06"
  })), a.createElement("defs", null, a.createElement("clipPath", {
    id: "a"
  }, a.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
A7.displayName = "Completed";
function k0() {
  return k0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, k0.apply(this, arguments);
}
var B7 = function B7(e) {
  return a.createElement("svg", k0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none",
    strokeWidth: e.size > 16 ? 0 : .8,
    viewBox: "0 0 24 24"
  }, e), a.createElement("path", {
    fill: e.color || "#E1E1E1",
    fillRule: "evenodd",
    stroke: "none",
    d: "M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m0 1.5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11",
    clipRule: "evenodd",
    strokeWidth: 1
  }));
};
B7.displayName = "Default";
function A0() {
  return A0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, A0.apply(this, arguments);
}
var H7 = function H7(e) {
  return a.createElement("svg", A0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#FFAE4B",
    stroke: "none",
    d: "M12.01 1c-6.08 0-11 4.92-11 11s4.92 11 11 11 11-4.92 11-11-4.92-11-11-11m4 11.75h-4c-.41 0-.75-.34-.75-.75V5.56c0-.41.34-.75.75-.75s.75.34.75.75v5.69h3.25c.41 0 .75.34.75.75s-.34.75-.75.75"
  }));
};
H7.displayName = "InProgress";
function B0() {
  return B0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, B0.apply(this, arguments);
}
var W7 = function W7(e) {
  return a.createElement("svg", B0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#FFAE4B",
    fillRule: "evenodd",
    stroke: "none",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M7.609 4.928a4.62 4.62 0 0 1 5.998 6.111l5.077 5.078a1.934 1.934 0 1 1-2.735 2.735l-5.233-5.233a4.62 4.62 0 0 1-5.62-6.178.256.256 0 0 1 .418-.084l2.05 2.05 1.81-.201.201-1.81-2.05-2.05a.256.256 0 0 1 .084-.418m9.28 12.129a.607.607 0 0 0 0 .855c.236.236.62.236.856 0a.607.607 0 0 0 0-.855.607.607 0 0 0-.856 0",
    clipRule: "evenodd"
  }));
};
W7.displayName = "Maintenance";
function H0() {
  return H0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, H0.apply(this, arguments);
}
var L7 = function L7(e) {
  return a.createElement("svg", H0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#FF3636",
    fillRule: "evenodd",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11M7.97 7.97a.75.75 0 0 1 1.06 0L12 10.94l2.97-2.97a.75.75 0 1 1 1.06 1.06L13.06 12l2.97 2.97a.75.75 0 1 1-1.06 1.06L12 13.06l-2.97 2.97a.75.75 0 0 1-1.06-1.06L10.94 12 7.97 9.03a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  }));
};
L7.displayName = "No";
function W0() {
  return W0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, W0.apply(this, arguments);
}
var _7 = function _7(e) {
  return a.createElement("svg", W0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M11.95 17.25a.75.75 0 0 1-.53-.22l-8.95-9a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l8.42 8.47 8.52-8.47c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-9.05 9a.75.75 0 0 1-.53.22"
  }));
};
_7.displayName = "ArrowDown";
function L0() {
  return L0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, L0.apply(this, arguments);
}
var I7 = function I7(e) {
  return a.createElement("svg", L0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M15.9 21.75c-.19 0-.38-.07-.53-.22l-9-8.95a.75.75 0 0 1 0-1.06l9-9.05c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-8.47 8.52 8.47 8.42c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22"
  }));
};
I7.displayName = "ArrowLeft";
function _0() {
  return _0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, _0.apply(this, arguments);
}
var m1 = function m1(e) {
  return a.createElement("svg", _0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M8.1 21.75c-.19 0-.39-.07-.53-.22a.754.754 0 0 1 0-1.06l8.47-8.42-8.47-8.52a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l9 9.05a.75.75 0 0 1 0 1.06l-9 8.95c-.15.15-.34.22-.53.22"
  }));
};
m1.displayName = "ArrowRight";
function I0() {
  return I0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, I0.apply(this, arguments);
}
var N7 = function N7(e) {
  return a.createElement("svg", I0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M21 17.25c-.19 0-.39-.07-.53-.22l-8.42-8.47-8.52 8.47c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l9.05-9c.14-.14.38-.23.53-.22.2 0 .39.08.53.22l8.95 9c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22"
  }));
};
N7.displayName = "ArrowUp";
function N0() {
  return N0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, N0.apply(this, arguments);
}
var V7 = function V7(e) {
  return a.createElement("svg", N0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M12.39 21.53c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-7.766-7.72H20.08c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H5.775l7.675-7.72c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L3.4 11.52a.75.75 0 0 0 0 1.06z",
    clipRule: "evenodd"
  }));
};
V7.displayName = "BackArrow";
function V0() {
  return V0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, V0.apply(this, arguments);
}
var F7 = function F7(e) {
  return a.createElement("svg", V0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5M15 15.75c-.19 0-.38-.07-.53-.22L12 13.06l-2.47 2.47c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L10.94 12 8.47 9.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L12 10.94l2.47-2.47c.29-.29.77-.29 1.06 0s.29.77 0 1.06L13.06 12l2.47 2.47c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22",
    clipRule: "evenodd"
  }));
};
F7.displayName = "Clear";
function F0() {
  return F0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, F0.apply(this, arguments);
}
var D7 = function D7(e) {
  return a.createElement("svg", F0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M18.97 20.03c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06L13.06 12l6.97-6.97c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L12 10.94 5.03 3.97a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06L10.94 12l-6.97 6.97c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22L12 13.06z",
    clipRule: "evenodd"
  }));
};
D7.displayName = "Close";
function D0() {
  return D0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, D0.apply(this, arguments);
}
var $7 = function $7(e) {
  return a.createElement("svg", D0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5M12 7.96c-.06 0-.13-.01-.2-.02-.06 0-.12-.03-.18-.06a.8.8 0 0 1-.28-.168l-.05-.042-.12-.15a.8.8 0 0 1-.09-.18.6.6 0 0 1-.06-.18 1 1 0 0 0-.01-.1q-.009-.048-.01-.1c0-.26.11-.52.29-.71.28-.28.72-.37 1.09-.21q.18.075.33.21c.18.19.29.45.29.71s-.11.52-.29.71q-.15.135-.33.21c-.12.06-.25.08-.38.08m0 9.54c-.41 0-.75-.34-.75-.75v-6c0-.41.34-.75.75-.75s.75.34.75.75v6c0 .41-.34.75-.75.75",
    clipRule: "evenodd"
  }));
};
$7.displayName = "Info";
function $0() {
  return $0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, $0.apply(this, arguments);
}
var q7 = function q7(e) {
  return a.createElement("svg", $0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M20 12.75H4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h16c.41 0 .75.34.75.75s-.34.75-.75.75"
  }));
};
q7.displayName = "Minus";
function q0() {
  return q0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, q0.apply(this, arguments);
}
var U7 = function U7(e) {
  return a.createElement("svg", q0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M11.25 20c0 .41.34.75.75.75s.75-.34.75-.75v-7.25H20c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-7.25V4c0-.41-.34-.75-.75-.75s-.75.34-.75.75v7.25H4c-.41 0-.75.34-.75.75s.34.75.75.75h7.25z",
    clipRule: "evenodd"
  }));
};
U7.displayName = "Plus";
function U0() {
  return U0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, U0.apply(this, arguments);
}
var G7 = function G7(e) {
  return a.createElement("svg", U0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M11.25 4v14.432L6.47 14.56a.747.747 0 1 0-.94 1.16l5.945 4.815a.7.7 0 0 0 .329.19.8.8 0 0 0 .19.025H12c.193 0 .37-.075.503-.197l5.967-4.833a.747.747 0 1 0-.94-1.16l-4.78 3.872V4c0-.41-.34-.75-.75-.75s-.75.34-.75.75",
    clipRule: "evenodd"
  }));
};
G7.displayName = "SortingDown";
function G0() {
  return G0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, G0.apply(this, arguments);
}
var Y7 = function Y7(e) {
  return a.createElement("svg", G0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M12.9 6.15a.7.7 0 0 1-.47-.17L9.45 3.568V13c0 .41-.34.75-.75.75s-.75-.34-.75-.75V3.578L4.97 5.99c-.14.11-.31.17-.47.17v-.01a.71.71 0 0 1-.58-.28.747.747 0 0 1 .11-1.05l4.122-3.337A.746.746 0 0 1 9.17 1.41l4.2 3.4a.754.754 0 0 1-.47 1.34m1.65 14.272V11c0-.41.34-.75.75-.75s.75.34.75.75v9.422l2.98-2.412a.747.747 0 1 1 .94 1.16l-4.115 3.331a.75.75 0 0 1-.538.249H15.3a.8.8 0 0 1-.205-.027.7.7 0 0 1-.32-.187L10.63 19.18a.76.76 0 0 1-.11-1.06c.26-.32.73-.37 1.05-.11z",
    clipRule: "evenodd"
  }));
};
Y7.displayName = "SortingNeutral";
function Y0() {
  return Y0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Y0.apply(this, arguments);
}
var Q7 = function Q7(e) {
  return a.createElement("svg", Y0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    fillRule: "evenodd",
    d: "M12 20.75c-.41 0-.75-.34-.75-.75V5.568L6.47 9.44c-.14.11-.31.17-.47.17a.71.71 0 0 1-.58-.28.747.747 0 0 1 .11-1.05l5.966-4.833A.75.75 0 0 1 12 3.25c.192 0 .37.075.503.197L18.47 8.28c.32.26.37.73.11 1.05-.15.18-.36.28-.58.28a.7.7 0 0 1-.47-.17l-4.78-3.872V20c0 .41-.34.75-.75.75",
    clipRule: "evenodd"
  }));
};
Q7.displayName = "SortingUp";
function Q0() {
  return Q0 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }
    return e;
  }, Q0.apply(this, arguments);
}
var X7 = function X7(e) {
  return a.createElement("svg", Q0({
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size || 16,
    height: e.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: e.size > 16 ? 0 : .8,
    stroke: e.size <= 16 ? e.color ? e.color : "#242328" : "none"
  }, e), a.createElement("path", {
    fill: e.color || "#222222",
    d: "M8.95 19.3c-.19 0-.38-.08-.52-.21l-5.95-5.73a.746.746 0 0 1-.02-1.06c.29-.3.76-.31 1.06-.02l5.4 5.19L20.45 4.94c.28-.31.76-.32 1.06-.04s.32.75.04 1.06L9.5 19.05a.73.73 0 0 1-.53.24h-.02z"
  }));
};
X7.displayName = "Tick";
var Du = {
  add_generic: Ll,
  add_on_product: _l,
  announcement: Il,
  attachment: Nl,
  attention: Vl,
  bills: Fl,
  bookmark: Dl,
  broadband_addon: $l,
  broadband: ql,
  bulb: Ul,
  calendar: Gl,
  call_back: Yl,
  camera: Ql,
  cart: Xl,
  cart_active: Kl,
  cash: Jl,
  category: Zl,
  celebrate: ea,
  chart: ta,
  checklist: na,
  community: ra,
  connected: la,
  contacts: aa,
  contract: ia,
  copy: oa,
  coverage: ca,
  creditcard: sa,
  data: da,
  delivery: ua,
  discount: ha,
  document_info: fa,
  document_w_tick: va,
  document: ma,
  download: ga,
  eco: xa,
  edit: ba,
  entertainment: wa,
  expand: ya,
  express: ja,
  external_link: za,
  face_id: pa,
  faq: Oa,
  filter: Ea,
  flight_left: Sa,
  flight_right: Ca,
  flight: Ra,
  food: Ma,
  global_sms: Ta,
  globe: Pa,
  heart: ka,
  help: Aa,
  hi_app_prepaid: Ba,
  hide: Ha,
  home: Wa,
  hotel: La,
  idd: _a,
  itinerary: Ia,
  languages: Na,
  laptop: Va,
  leisure: Fa,
  lightning: Da,
  listen: $a,
  loading: qa,
  log_in: Ua,
  mail_unread: Ga,
  mail: Ya,
  map: Qa,
  menu: Xa,
  message: Ka,
  mic: Ja,
  minimise: Za,
  mobile_addon: ei,
  mobile_broadband: ti,
  mobile_signal: ni,
  mobile_share: ri,
  mobilephone_bill: li,
  mobilephone: ai,
  monitor: ii,
  more: oi,
  movie: ci,
  music: si,
  notice: di,
  notification_active: ui,
  notification_disabled: hi,
  notification: fi,
  options: vi,
  order: mi,
  partner_apps: gi,
  pause: xi,
  peace_of_mind: bi,
  personal: wi,
  phone_contact: yi,
  pin: ji,
  play: zi,
  pointer: pi,
  power_switch: Oi,
  processing: Ei,
  recommended: Si,
  red_membership: Ci,
  refresh_phone: Ri,
  refresh: Mi,
  remote: Ti,
  return: Pi,
  rewards: ki,
  roaming: Ai,
  search: j5,
  secure: Bi,
  send: Hi,
  services: Wi,
  settings: Li,
  share: _i,
  ship: Ii,
  shop: Ni,
  show: Vi,
  simcard: Fi,
  speed_meter: Di,
  star: $i,
  store: qi,
  support: Ui,
  tablet: Gi,
  tack: Yi,
  themepark: Qi,
  thumbsup: Xi,
  time: Ki,
  timeline: Ji,
  transport: Zi,
  trash: e7,
  troubleshoot: t7,
  tv_addon: n7,
  tv: r7,
  upload: l7,
  usage: a7,
  viewlist: i7,
  voucher: o7,
  wallet: c7,
  wifi: s7,
  work: d7,
  addon_product_filled: u7,
  bills_filled: h7,
  delivery_filled: f7,
  discount_filled: v7,
  flight_filled: m7,
  heart_filled: g7,
  home_filled: x7,
  mail_filled: b7,
  more_filled: w7,
  personal_filled: y7,
  price_down: j7,
  price_up: z7,
  rewards_filled: p7,
  secure_filled: O7,
  shop_filled: E7,
  star_full: S7,
  star_half: C7,
  tack_filled: R7,
  favourite_active: M7,
  favourite: T7,
  alert: P7,
  cannot_be_tracked: k7,
  completed: A7,
  default: B7,
  in_progress: H7,
  maintenance: W7,
  no: L7,
  arrow_down: _7,
  arrow_left: I7,
  arrow_right: m1,
  arrow_up: N7,
  back_arrow: V7,
  clear: F7,
  close: D7,
  info: $7,
  minus: q7,
  plus: U7,
  sorting_down: G7,
  sorting_neutral: Y7,
  sorting_up: Q7,
  tick: X7
};
function g1(_ref14) {
  var e = _ref14.name,
    t = _ref14.color,
    n = _ref14.size;
  var r = Du[e];
  return r ? a.createElement(r, {
    title: e,
    color: t,
    size: n
  }) : (console.error("icons '".concat(e, "' does not exist!")), null);
}
var K7 = j.default(i.Layout.Inline)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  & div:empty {\n    margin-right: 0;\n  }\n"]))),
  $u = function $u(_ref15) {
    var e = _ref15.icon,
      t = _ref15.text,
      n = _ref15.href,
      r = _ref15.target,
      o = _ref15.iconAlignment;
    return l.jsxs(K7, {
      alignY: "center",
      children: [o === ge.left && l.jsx(e, {}), l.jsx(i.Text, {
        type: "link",
        href: n,
        target: r,
        children: t
      }), o === ge.right && l.jsx(e, {})]
    });
  },
  qu = function qu(_ref16) {
    var e = _ref16.text,
      t = _ref16.textStyle,
      n = _ref16.tag,
      _ref16$inverse = _ref16.inverse,
      r = _ref16$inverse === void 0 ? !1 : _ref16$inverse;
    return l.jsx(K7, {
      alignY: "center",
      children: l.jsx(i.Text, {
        type: t,
        tag: n,
        inverse: r,
        children: e
      })
    });
  },
  Uu = ["link", "smallBodyLink"],
  Gu = function Gu(e) {
    var _e$iconSize = e.iconSize,
      t = _e$iconSize === void 0 ? 24 : _e$iconSize,
      _e$iconAlignment = e.iconAlignment,
      n = _e$iconAlignment === void 0 ? ge.right : _e$iconAlignment,
      _e$componentAlignment = e.componentAlignment,
      r = _e$componentAlignment === void 0 ? ge.left : _e$componentAlignment,
      _e$linkUrl = e.linkUrl,
      o = _e$linkUrl === void 0 ? "" : _e$linkUrl,
      _e$linkTarget = e.linkTarget,
      c = _e$linkTarget === void 0 ? "_blank" : _e$linkTarget,
      d = e.text,
      u = e.icon,
      _e$textStyle = e.textStyle,
      h = _e$textStyle === void 0 ? "body" : _e$textStyle,
      s = e.seoType,
      _e$inverse = e.inverse,
      v = _e$inverse === void 0 ? !1 : _e$inverse,
      g = R(R(R({}, r === ge.center && {
        center: "xs"
      }), r === ge.right && {
        end: "xs"
      }), r === ge.left && {
        start: "xs"
      }),
      x = function x() {
        return "link".includes(h) ? l.jsx(g1, {
          name: u,
          color: "#0062f5",
          size: t
        }) : null;
      },
      w = Uu.includes(h) ? $u : qu;
    return l.jsx($1, {
      vCompact: !0,
      children: l.jsx(i.Row, L(R({
        "data-testid": "TextWithIcon"
      }, g), {
        children: l.jsx(w, {
          icon: x,
          href: o,
          target: c,
          text: d,
          iconAlignment: n,
          textStyle: h,
          tag: s,
          inverse: v
        })
      }))
    });
  },
  Yu = q1(Gu, {
    top: 0,
    bottom: 0
  }),
  Qu = function Qu(_ref17) {
    var e = _ref17.type,
      t = _ref17.title,
      n = _ref17.content,
      r = _ref17.action;
    return l.jsx("div", {
      "data-testid": "Notification",
      children: l.jsx(i.StatusAlert, R({
        type: e,
        title: t,
        bodyContent: n
      }, (r == null ? void 0 : r.text) && {
        action: {
          type: r == null ? void 0 : r.type,
          onClick: function onClick() {
            return window.open(r == null ? void 0 : r.url, (r == null ? void 0 : r.target) || "_self");
          },
          text: r == null ? void 0 : r.text
        }
      }))
    });
  },
  Xu = q1(Qu, {
    top: 20,
    bottom: 20
  }),
  qe = {
    default: "default",
    bigImageCard: "bigImageCard",
    thumbnailCard: "thumbnailCard",
    bentoCard: "bentoCard",
    pricePlanCardList: "pricePlanCardList",
    pricePlanCard: "pricePlanCard"
  },
  Ku = function Ku(_ref18) {
    var _ref18$image = _ref18.image,
      e = _ref18$image === void 0 ? {
        imageSize: "16:9"
      } : _ref18$image,
      t = _ref18.title,
      n = _ref18.ribbon,
      r = _ref18.children,
      o = _ref18.action;
    var c = function c() {
        window.open(o == null ? void 0 : o.url, (o == null ? void 0 : o.target) || "_self");
      },
      d = o && o.type && o.type !== "none";
    return l.jsx(Uo, {
      children: l.jsxs(i.Card, {
        shadow: "sm",
        radius: "md",
        "data-testid": "CardDefault",
        children: [e && l.jsx(i.Card.Image, R({
          src: {
            url: e.imageSrc,
            alt: e.alt
          },
          ratio: e.imageSize
        }, n && {
          tag: n.text
        })), l.jsxs(i.Card.Content, {
          children: [t && l.jsx(i.Card.Title, {
            fontWeight: "heavy",
            children: t
          }), l.jsx(Go, {
            children: l.jsx("div", {
              children: r
            })
          }), d && l.jsx(i.Spacing, {
            topBottom: 1,
            children: l.jsx(i.Button, {
              "data-testid": "CardDefButtonCta",
              secondary: o.color === "secondary",
              text: o.text,
              onClick: c
            })
          })]
        })]
      })
    });
  },
  Ju = j.default.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  height: 100%;\n  &&& {\n    img {\n      min-height: 110%;\n\n      @media (max-width: 768px) {\n        height: 114%;\n      }\n    }\n  }\n"]))),
  Zu = j.default.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  &&& {\n    position: relative;\n    top: 8px;\n  }\n"]))),
  e8 = function e8(_ref19) {
    var e = _ref19.image,
      t = _ref19.imagePosition,
      n = _ref19.title,
      _ref19$titleType = _ref19.titleType,
      r = _ref19$titleType === void 0 ? "header" : _ref19$titleType,
      o = _ref19.icon,
      c = _ref19.subtitleContent,
      d = _ref19.body,
      u = _ref19.ribbonContent,
      _ref19$ribbonType = _ref19.ribbonType,
      h = _ref19$ribbonType === void 0 ? "noRibbon" : _ref19$ribbonType,
      s = _ref19.autoHeight,
      v = _ref19.withPadding,
      g = _ref19.isShadow,
      x = _ref19.isRoundedCorner,
      _ref19$backgroundColo = _ref19.backgroundColor,
      w = _ref19$backgroundColo === void 0 ? "light" : _ref19$backgroundColo,
      m = _ref19.ctaText,
      _ref19$ctaType = _ref19.ctaType,
      b = _ref19$ctaType === void 0 ? "primary" : _ref19$ctaType,
      O = _ref19.ctaUrl,
      _ref19$ctaTarget = _ref19.ctaTarget,
      y = _ref19$ctaTarget === void 0 ? "_self" : _ref19$ctaTarget;
    var C, M;
    var z = {
      background: w === "light" ? "standard" : w,
      roundedCorners: x,
      withPadding: v,
      autoHeight: s
    };
    z.shadow = g === !0 ? "sm" : !1;
    var E = h !== "noRibbon" && u ? l.jsx("div", {
        style: {
          position: "absolute",
          bottom: 4
        },
        children: l.jsx(i.Tag, {
          size: "tall",
          type: h,
          customStyle: {
            borderTopRightRadius: "8px"
          },
          children: u
        })
      }) : null,
      p = d ? l.jsx(i.Card.Body, {
        textNumOfLines: 3,
        viewMoreToggle: !1,
        textColorInverse: w === "dark",
        children: d
      }) : null;
    return l.jsxs(i.Card, L(R({}, z), {
      "data-testid": "BigImageCard",
      children: [t === "top" && e && l.jsx(i.Card.Image, L(R({}, ((C = e == null ? void 0 : e.src) == null ? void 0 : C.url) && {
        src: {
          url: e.src.url,
          alt: e.src.alt
        },
        srcSetObj: e == null ? void 0 : e.srcSetObj
      }), {
        tag: E,
        ratio: e.ratio || "1:1"
      })), l.jsxs(i.Card.Content, {
        children: [n && l.jsx(i.Card.Title, {
          textType: r,
          numberOfLines: 2,
          textColorInverse: w === "dark",
          children: n
        }), c && l.jsx(i.Spacing, {
          bottom: 1,
          responsive: !1,
          children: l.jsx(i.Card.Info, {
            icon: o,
            type: "bodySmall",
            textColorInverse: w === "dark",
            children: c
          })
        }), p, m && O && l.jsx(i.Spacing, {
          top: 2,
          responsive: !1,
          children: b !== "textLink" ? l.jsx(i.Button, {
            secondary: b === "secondary",
            text: m,
            onClick: function onClick() {
              return window.open(O, y);
            }
          }) : l.jsx(i.TextLink, {
            onClick: function onClick() {
              return window.open(O, y);
            },
            children: m
          })
        })]
      }), t !== "top" && e && l.jsx(Zu, {
        children: l.jsx(i.Card.Image, L(R({}, ((M = e == null ? void 0 : e.src) == null ? void 0 : M.url) && {
          src: {
            url: e.src.url,
            alt: e.src.alt
          },
          srcSetObj: e == null ? void 0 : e.srcSetObj
        }), {
          tag: E,
          ratio: e.ratio || "1:1"
        }))
      })]
    }));
  },
  t8 = function t8(_ref20) {
    var e = _ref20.image,
      t = _ref20.titleAlignment,
      n = _ref20.title,
      r = _ref20.titleType,
      o = _ref20.body,
      c = _ref20.ribbonContent,
      _ref20$ribbonType = _ref20.ribbonType,
      d = _ref20$ribbonType === void 0 ? "noRibbon" : _ref20$ribbonType,
      u = _ref20.autoHeight,
      h = _ref20.withPadding,
      s = _ref20.isShadow,
      v = _ref20.isRoundedCorner,
      _ref20$backgroundColo = _ref20.backgroundColor,
      g = _ref20$backgroundColo === void 0 ? "light" : _ref20$backgroundColo,
      x = _ref20.subtitleContent,
      w = _ref20.footerVariant,
      m = _ref20.footerTextLink,
      b = _ref20.footerText,
      O = _ref20.footerSecondaryText,
      y = _ref20.footerRibbon,
      z = _ref20.footerRibbonColor,
      E = _ref20.footerDivider,
      p = _ref20.ctaText,
      C = _ref20.ctaType,
      M = _ref20.ctaDisabled,
      P = _ref20.ctaUrl,
      _ = _ref20.ctaTarget,
      Y = _ref20.ctaFullWidth;
    var re, J, te, ae, se, I;
    var q = {
      background: g === "light" ? "standard" : g,
      roundedCorners: v,
      withPadding: h,
      autoHeight: u
    };
    q.shadow = s === !0 ? "sm" : !1;
    var le = o ? l.jsx(i.Card.Body, {
      viewMoreToggle: !1,
      textNumOfLines: 0,
      textColorInverse: g === "dark",
      children: l.jsx(y5, {
        text: o
      })
    }) : null;
    return l.jsx(i.Card, L(R({}, q), {
      "data-testid": "ThumbnailCard",
      children: l.jsxs(i.Card.Content, {
        children: [d !== "noRibbon" && c ? l.jsxs(l.Fragment, {
          children: [l.jsx(i.Ribbon.Variant1, {
            color: d,
            children: "New"
          }), l.jsx(i.Spacing, {
            top: 2,
            bottom: 2,
            responsive: !1,
            children: l.jsx(i.Card.Title, L(R({
              textType: r
            }, ((re = e == null ? void 0 : e.src) == null ? void 0 : re.url) && {
              thumbnail: {
                url: (J = e == null ? void 0 : e.src) == null ? void 0 : J.url,
                alt: (te = e == null ? void 0 : e.src) == null ? void 0 : te.alt
              }
            }), {
              thumbnailSize: e == null ? void 0 : e.imageSize,
              thumbnailAlignment: t,
              subTitleText: x,
              textColorInverse: g === "dark",
              children: n
            }))
          })]
        }) : l.jsx(i.Spacing, {
          bottom: 2,
          responsive: !1,
          children: l.jsx(i.Card.Title, L(R({
            textType: r
          }, ((ae = e == null ? void 0 : e.src) == null ? void 0 : ae.url) && {
            thumbnail: {
              url: (se = e == null ? void 0 : e.src) == null ? void 0 : se.url,
              alt: (I = e == null ? void 0 : e.src) == null ? void 0 : I.alt
            }
          }), {
            thumbnailSize: e == null ? void 0 : e.imageSize,
            thumbnailAlignment: t,
            subTitleText: x,
            textColorInverse: g === "dark",
            children: n
          }))
        }), le, l.jsx(i.Card.Footer, {
          action: {
            text: p,
            type: C,
            disabled: M,
            href: P,
            target: _,
            fullWidth: Y
          },
          inverse: g === "dark",
          footerVariant: w,
          footerTextLink: m,
          footerText: b,
          footerSecondaryText: O,
          footerRibbon: y,
          footerRibbonColor: z,
          divider: E
        })]
      })
    }));
  },
  X0 = function X0(_ref21) {
    var e = _ref21.image,
      t = _ref21.header,
      n = _ref21.subHeader,
      r = _ref21.tag,
      _ref21$inverse = _ref21.inverse,
      o = _ref21$inverse === void 0 ? !1 : _ref21$inverse,
      c = _ref21.textLinkDesc,
      d = _ref21.textLinkHref,
      u = _ref21.textLinkOnClick,
      h = _ref21.cardLinkHref,
      s = _ref21.cardLinkTarget,
      v = _ref21.cardLinkOnClick,
      _ref21$headerFontType = _ref21.headerFontType,
      g = _ref21$headerFontType === void 0 ? "header" : _ref21$headerFontType,
      _ref21$textContainerW = _ref21.textContainerWidthConfig,
      x = _ref21$textContainerW === void 0 ? {
        lg: 100,
        xs: 80,
        sm: 80
      } : _ref21$textContainerW;
    var _i$useDevice5 = i.useDevice(),
      w = _i$useDevice5.isMobile,
      m = _i$useDevice5.isTablet,
      b = _i$useDevice5.isDesktop,
      O = _i$useDevice5.isTV;
    var y = "100%";
    w ? y = "".concat(x.xs, "%") : m ? y = "".concat(x.sm, "%") : y = "".concat(x.lg, "%");
    var z = function z() {
      var E, p;
      return l.jsx(Ju, {
        children: l.jsx(i.Card, {
          shadow: !1,
          children: l.jsx(i.Card.Image, {
            src: {
              url: (E = e == null ? void 0 : e.src) == null ? void 0 : E.url,
              alt: (p = e == null ? void 0 : e.src) == null ? void 0 : p.alt
            },
            ratio: e == null ? void 0 : e.ratio,
            srcSetObj: e == null ? void 0 : e.srcSetObj,
            height: "100%",
            customStyle: {
              background: "none"
            },
            overlayContent: l.jsxs(l.Fragment, {
              children: [r ? l.jsx(i.Spacing, {
                children: l.jsx("div", {
                  children: l.jsx(i.Tag, {
                    size: "tall",
                    color: "#CA112F",
                    customStyle: {
                      borderTopRightRadius: "0",
                      borderBottomLeftRadius: "0",
                      borderBottomRightRadius: "8px"
                    },
                    children: r
                  })
                })
              }) : null, l.jsx(i.Spacing, {
                topBottom: 2,
                leftRight: 2,
                responsive: !1,
                children: l.jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    width: y
                  },
                  children: [l.jsx(i.Spacing, {
                    bottom: .5,
                    responsive: !1,
                    children: l.jsx(i.Text, {
                      type: g,
                      color: o ? "white" : "",
                      children: t
                    })
                  }), l.jsx(i.Spacing, {
                    bottom: 2,
                    responsive: !1,
                    children: l.jsx(i.Text, {
                      type: "smallBody",
                      color: o ? "white" : "",
                      children: n
                    })
                  }), d ? l.jsx("span", {
                    children: l.jsx(i.Text, {
                      type: "smallBody",
                      children: l.jsx(i.TextLink, {
                        inline: !0,
                        href: d,
                        onClick: u,
                        inverse: o,
                        children: c
                      })
                    })
                  }) : null]
                })
              })]
            })
          })
        })
      });
    };
    return h ? l.jsx(i.Link, {
      href: h,
      target: s,
      onClick: v,
      children: z()
    }) : z();
  },
  Me = 16,
  n8 = j.default.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]))),
  r8 = j.default.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n  }\n"]))),
  l8 = j.default.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n"])), function (_ref22) {
    var e = _ref22.$show;
    return e ? "" : "visibility: hidden;";
  }),
  i1 = j.default.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  margin-bottom: 16px;\n"]))),
  a8 = j.default.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: ", "px;\n  min-height: ", "px;\n  & > p {\n    white-space: pre;\n    max-width: ", "px;\n  }\n"])), Me, Me, Me),
  i8 = j.default.div(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n"])), Me, Me),
  o8 = j.default("ul")(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  list-style-type: none;  margin: 0;\n  padding: 0;\n\n  li {\n    min-height: ", "px;\n    margin-top: 4px;\n    display: flex;\n    gap: 0 8px;\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n"], ["\n  list-style-type: none;\\\n  margin: 0;\n  padding: 0;\n\n  li {\n    min-height: ", "px;\n    margin-top: 4px;\n    display: flex;\n    gap: 0 8px;\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n"])), Me),
  c8 = j.default.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n\n  padding: 16px;\n"]))),
  pr = j.default.div(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  margin: -8px 0;\n"]))),
  o1 = j.default.div(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  margin: 8px 0;\n"]))),
  s8 = i.withTheme(j.default.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  margin-top: auto;\n"])))),
  d8 = i.withTheme(j.default.div(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  margin-top: ", "; // negate CardFooter padding\n"])), function (_ref23) {
    var e = _ref23.coreTheme;
    return "-".concat(e == null ? void 0 : e.card.spacingCardFooterVerticalGap, "px");
  })),
  u8 = function u8(_ref24) {
    var e = _ref24.style,
      t = _ref24.imgSrc,
      n = _ref24.imgAlt,
      r = _ref24.imgRatio,
      o = _ref24.bookmarkTag,
      c = _ref24.tag,
      d = _ref24.title,
      _ref24$seoTitleTag = _ref24.seoTitleTag,
      u = _ref24$seoTitleTag === void 0 ? "h3" : _ref24$seoTitleTag,
      h = _ref24.description,
      _ref24$content = _ref24.content1,
      s = _ref24$content === void 0 ? [] : _ref24$content,
      v = _ref24.content2,
      g = _ref24.content3,
      x = _ref24.leftCtaText,
      w = _ref24.leftCtaType,
      m = _ref24.leftCtaUrl,
      b = _ref24.ctaTarget,
      O = _ref24.ctaFullWidth,
      y = _ref24.leftText,
      z = _ref24.leftMainPrice,
      E = _ref24.leftSecondaryText,
      p = _ref24.rightText,
      C = _ref24.rightMainPrice,
      M = _ref24.rightSecondaryText,
      P = _ref24.footerActionLoading,
      _ = _ref24.footerActionOnClick,
      Y = _ref24.footerActionDisabled;
    var k, ve, be;
    var _i$useTheme2 = i.useTheme(),
      q = _i$useTheme2.theme,
      le = r === "1:1" ? "1:1" : "2:1",
      re = o !== void 0,
      J = !!(o && o.text),
      te = !!(v != null && v.title),
      ae = !!(v != null && v.bullets) && v.bullets.length > 0,
      se = !!(g != null && g.title),
      I = !!(g != null && g.bullets) && g.bullets.length > 0,
      he = !!(g != null && g.imageList) && g.imageList.length > 0;
    return l.jsxs(n8, {
      style: e,
      children: [re && l.jsxs(l8, {
        $show: J,
        children: [l.jsx(i.Tag, {
          size: "tall",
          customStyle: {
            color: (o == null ? void 0 : o.color) || void 0,
            backgroundColor: o == null ? void 0 : o.backgroundColor,
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px"
          },
          children: o.text || l.jsx(l.Fragment, {
            children: " "
          })
        }), l.jsx("div", {
          style: {
            position: "absolute"
          },
          children: l.jsx(i.Tag, {
            size: "tall",
            customStyle: {
              backgroundColor: o == null ? void 0 : o.backgroundColor
            },
            children: " "
          })
        })]
      }), l.jsx(r8, {
        children: l.jsxs(i.Card, {
          children: [!!t && l.jsx(i.Card.Image, {
            src: {
              url: t,
              alt: n
            },
            ratio: le
          }), l.jsxs(c8, {
            children: [l.jsxs(i1, {
              children: [l.jsxs(i.Text, {
                type: "header",
                tag: u,
                children: [l.jsx("span", {
                  style: {
                    verticalAlign: "middle"
                  },
                  children: d
                }), !!(c != null && c.text) && l.jsxs(l.Fragment, {
                  children: [" ", l.jsx(i.Tag, {
                    customStyle: {
                      color: c.color || void 0,
                      backgroundColor: c.backgroundColor || "header.linkMainColor",
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                      borderBottomLeftRadius: "8px",
                      borderBottomRightRadius: "8px"
                    },
                    children: c.text
                  })]
                })]
              }), !!h && l.jsx(i.Text, {
                type: "body",
                children: h
              })]
            }), !!s && s.length > 0 && l.jsxs(l.Fragment, {
              children: [l.jsx(i1, {
                children: l.jsx(o8, {
                  children: s.map(function (_ref25) {
                    var de = _ref25.iconName,
                      We = _ref25.text;
                    return l.jsxs("li", {
                      children: [l.jsx("div", {
                        children: l.jsxs(a8, {
                          children: [l.jsx(i.Text, {
                            type: "smallBody",
                            children: " "
                          }), l.jsx(i8, {
                            children: l.jsx(g1, {
                              name: de,
                              size: "".concat(Me)
                            })
                          })]
                        })
                      }), l.jsx("div", {
                        style: {
                          flex: 1,
                          display: "flex"
                        },
                        children: l.jsx(i.Text, {
                          type: "smallBody",
                          style: {
                            margin: "auto 0"
                          },
                          children: We
                        })
                      })]
                    });
                  })
                })
              }), l.jsx(i1, {
                children: l.jsx(i.Divider, {})
              })]
            }), (te || ae) && l.jsx(i1, {
              children: l.jsxs(pr, {
                children: [te && l.jsx(o1, {
                  children: l.jsx(i.Text, {
                    type: "boldSmallBody",
                    children: v == null ? void 0 : v.title
                  })
                }), ae && l.jsx(o1, {
                  children: (k = v == null ? void 0 : v.bullets) == null ? void 0 : k.map(function (de) {
                    return l.jsx(i.BulletList, {
                      noSpace: !0,
                      size: "small",
                      children: de
                    });
                  })
                })]
              })
            }), (se || I || he) && l.jsx(i1, {
              style: {
                padding: q == null ? void 0 : q.card.paddingSm,
                margin: "0 -".concat(q == null ? void 0 : q.card.paddingSm),
                backgroundColor: q == null ? void 0 : q.color.background.subtle2
              },
              children: l.jsxs(pr, {
                children: [se && l.jsx(o1, {
                  children: l.jsx(i.Text, {
                    type: "boldSmallBody",
                    children: g == null ? void 0 : g.title
                  })
                }), I && l.jsx(o1, {
                  children: (ve = g == null ? void 0 : g.bullets) == null ? void 0 : ve.map(function (de) {
                    return l.jsx(i.BulletList, {
                      noSpace: !0,
                      size: "small",
                      children: de
                    });
                  })
                }), he && l.jsx(o1, {
                  style: {
                    marginLeft: "16px"
                  },
                  children: l.jsx(i.Card.IconList, {
                    items: (be = g == null ? void 0 : g.imageList) == null ? void 0 : be.map(function (_ref26) {
                      var de = _ref26.src,
                        We = _ref26.alt;
                      return l.jsx(i.Image, {
                        ratio: "1:1",
                        src: {
                          url: de,
                          alt: We
                        }
                      });
                    }),
                    onItemClick: g == null ? void 0 : g.onImageClick
                  })
                })]
              })
            }), l.jsx(s8, {
              children: l.jsx(d8, {
                children: l.jsx(i.Card.Footer, {
                  leftText: y,
                  leftMainPrice: z,
                  leftSecondaryText: E,
                  rightText: p,
                  rightMainPrice: C,
                  rightSecondaryText: M,
                  action: {
                    type: w || "secondary",
                    text: x || "Get",
                    href: m,
                    target: b,
                    fullWidth: O,
                    loading: P,
                    disabled: Y,
                    onClick: _
                  },
                  footerVariant: 4,
                  divider: !1
                })
              })
            })]
          })]
        })
      })]
    });
  },
  Or = (_Or = {}, _defineProperty(_Or, qe.default, Ku), _defineProperty(_Or, qe.bigImageCard, e8), _defineProperty(_Or, qe.thumbnailCard, t8), _defineProperty(_Or, qe.bentoCard, X0), _defineProperty(_Or, qe.pricePlanCard, u8), _Or),
  J7 = function J7(n) {
    var r = n,
      _r$variant = r.variant,
      e = _r$variant === void 0 ? qe.default : _r$variant,
      t = ee(r, ["variant"]);
    var o = Or[e] || Or.default;
    return l.jsx(o, R({}, t));
  },
  h8 = j.default.a(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), function (e) {
    return (e.scrollMarginTopMobile || e.scrollMarginTop) && "\n      scroll-margin-top: ".concat(e.scrollMarginTopMobile || e.scrollMarginTop || 0, ";    \n  ");
  }, function (e) {
    return e.scrollMarginTop && B.css(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n      ", ";\n    "])), Ue.md(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n        scroll-margin-top: ", ";\n      "])), e.scrollMarginTop));
  }),
  f8 = function f8(_ref27) {
    var e = _ref27.hash,
      t = _ref27.scrollMarginTop,
      n = _ref27.scrollMarginTopMobile;
    return A.useEffect(function () {
      (function () {
        window.location.hash && setTimeout(function () {
          var o = window.location.hash;
          window.location.hash = "", window.location.hash = o;
        }, 1e3);
      })();
    }, []), l.jsx(h8, {
      name: e,
      "data-testid": "AnchorLink",
      scrollMarginTop: t,
      scrollMarginTopMobile: n
    });
  },
  v8 = i.withTheme(j.default.div(function (e) {
    var t, n;
    return B.css(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n      display: flex;\n      align-items: center;\n      background-color: ", ";\n      border-bottom: ", ";\n      z-index: 99999;\n      position: sticky;\n      top: 0;\n      padding: 16px 24px;\n    "])), ((n = (t = e == null ? void 0 : e.coreTheme) == null ? void 0 : t.header) == null ? void 0 : n.backgroundColor) || "#FFFFFF", e != null && e.scrollOffset ? "1px solid ".concat(e.coreTheme.header.borderColor) : "0");
  })),
  K = function K(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    return e / t + "rem";
  },
  K0 = i.utils.responsiveStyles,
  Ge = j.default.li(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n"]))),
  m8 = j.default(i.Column)(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  opacity: 0;\n  visibility: hidden;\n  padding-right: 16px;\n\n  transform: translateY(-20px);\n\n  ", ":hover & {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n\n    transition: transform 0.32s ease-out, opacity 0.32s ease-out,\n      visibility 0.32s ease-out;\n  }\n\n  /** Todo: Interim fix for LG size range **/\n  @media (min-width: 1282px) and (max-width: 1600px) {\n    margin-left: 7.4%;\n  }\n"])), Ge),
  g8 = i.withTheme(j.default.div(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n\n    position: absolute;\n    left: 0;\n    right: 0;\n    z-index: 99999;\n    opacity: 0;\n    visibility: hidden;\n    margin: 0;\n    padding: 0;\n    transform: translateY(-5px);\n\n    transition: transform 0.32s ease-in, opacity 0.24s ease-in,\n      visibility 0.24s ease-in;\n\n    ", ":hover & {\n      opacity: 1;\n      visibility: visible;\n      transform: translateY(0);\n\n      transition: transform 0.32s ease-out, opacity 0.32s ease-out,\n        visibility 0.32s ease-out;\n    }\n  "])), function (e) {
    return e.coreTheme.cl_white;
  }, function (e) {
    return e.coreTheme.header.borderColor;
  }, Ge)),
  Er = i.withTheme(j.default(i.Text)(function (e) {
    var n, r, o, c, d, u;
    var t = e != null && e.secondary ? K0((r = (n = e.coreTheme) == null ? void 0 : n.header) == null ? void 0 : r.subMenuMainSecondaryFontStyles, e.coreTheme) : K0((c = (o = e.coreTheme) == null ? void 0 : o.header) == null ? void 0 : c.subMenuMainFontStyles, e.coreTheme);
    return B.css(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n      ", "\n      display: block;\n      padding-bottom: 4px;\n\n      &:hover {\n        color: ", ";\n      }\n    "])), t, (u = (d = e.coreTheme) == null ? void 0 : d.header) == null ? void 0 : u.linkHoverColor);
  })),
  x8 = i.withTheme(j.default(i.Text)(function (e) {
    var n, r, o, c, d, u, h, s;
    var t = K0((r = (n = e.coreTheme) == null ? void 0 : n.header) == null ? void 0 : r.mainMenuFontStyles, e.coreTheme);
    return B.css(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n      ", "\n\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "])), t, e != null && e.active ? (c = (o = e.coreTheme) == null ? void 0 : o.header) == null ? void 0 : c.linkActiveMainColor : (u = (d = e.coreTheme) == null ? void 0 : d.header) == null ? void 0 : u.linkStandardColor, (s = (h = e.coreTheme) == null ? void 0 : h.header) == null ? void 0 : s.linkHoverColor);
  })),
  b8 = i.withTheme(j.default.ul(function (e) {
    return B.css(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n      display: block;\n      list-style-type: none;\n      position: absolute;\n      visibility: hidden;\n      width: ", ";\n      border-radius: ", ";\n      background-color: ", ";\n      padding: 0;\n      margin-left: ", ";\n      margin-top: ", ";\n      box-shadow: ", ";\n      z-index: 999;\n\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 100%;\n        left: 50%;\n        margin-left: ", ";\n        border-width: ", ";\n        border-style: solid;\n        border-color: transparent transparent ", "\n          transparent;\n      }\n\n      ", ":hover & {\n        visibility: visible;\n      }\n    "])), K(150), K(8), e.coreTheme.cl_white, K(-10), K(-10), e.coreTheme.sd_size_1, K(-10), K(7), e.coreTheme.cl_white, Ge);
  })),
  w8 = i.withTheme(j.default(i.Text)(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n    display: block;\n    padding: ", " ", ";\n    text-decoration: none;\n\n    &:not([disabled]):hover {\n    }\n  "])), K(9), K(20))),
  y8 = j.default.ul(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  list-style-type: none;\n  text-align: left;\n  padding: 0;\n  margin: 0;\n  gap: 4px;\n"]))),
  j8 = j.default(i.Grid)(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  &&& {\n    padding: 16px 0 24px 0;\n  }\n"]))),
  Sr = i.utils.responsiveStyles,
  z8 = i.withTheme(j.default(i.Grid)(function (e) {
    var t, n, r;
    return B.css(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n      padding: 0;\n      background: ", ";\n    "])), (r = (n = (t = e == null ? void 0 : e.coreTheme) == null ? void 0 : t.color) == null ? void 0 : n.background) == null ? void 0 : r.subtle);
  })),
  p8 = i.withTheme(j.default(i.Row)(function (e) {
    var t, n, r;
    return B.css(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n    height: 100%;\n    > div:first-child {\n      background: ", ";\n    }\n  "])), (r = (n = (t = e == null ? void 0 : e.coreTheme) == null ? void 0 : t.color) == null ? void 0 : n.background) == null ? void 0 : r.standard);
  })),
  ht = i.withTheme(j.default(i.Text)(function (e) {
    var n, r, o, c, d, u, h, s, v, g;
    var t = e != null && e.secondary ? Sr((r = (n = e.coreTheme) == null ? void 0 : n.header) == null ? void 0 : r.subMenuMainSecondaryFontStyles, e.coreTheme) : Sr((c = (o = e.coreTheme) == null ? void 0 : o.header) == null ? void 0 : c.subMenuMainFontStyles, e.coreTheme);
    return B.css(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n      ", "\n      display: block;\n      padding: 6px 0px;\n\n      &:hover {\n        color: ", ";\n        & svg {\n          color: ", ";\n        }\n      }\n\n      & svg {\n        float: right;\n        &:hover {\n          color: ", ";\n      }\n    "])), t, (u = (d = e.coreTheme) == null ? void 0 : d.header) == null ? void 0 : u.linkHoverColor, (s = (h = e.coreTheme) == null ? void 0 : h.header) == null ? void 0 : s.linkHoverColor, (g = (v = e.coreTheme) == null ? void 0 : v.header) == null ? void 0 : g.linkHoverColor);
  })),
  O8 = a.default.memo(function (_ref28) {
    var e = _ref28.menuSections;
    var _A$useState7 = A.useState(null),
      _A$useState8 = _slicedToArray(_A$useState7, 2),
      t = _A$useState8[0],
      n = _A$useState8[1],
      _A$useState9 = A.useState(null),
      _A$useState10 = _slicedToArray(_A$useState9, 2),
      r = _A$useState10[0],
      o = _A$useState10[1],
      c = A.useCallback(function (h) {
        var v;
        o(h);
        var s = (v = h.subMenuItems) == null ? void 0 : v.find(function (g) {
          return g.isHighlights;
        });
        n(s || null);
      }, []),
      d = function d(h) {
        n(h);
      },
      u = A.useMemo(function () {
        if (!(r != null && r.subMenuItems)) return null;
        var h = r.subMenuItems.filter(function (v) {
            return !v.isHighlights;
          }),
          s = r.subMenuItems.filter(function (v) {
            return v.isHighlights;
          });
        return l.jsxs(p8, {
          children: [h.length > 0 && l.jsx(i.Column, {
            xs: 4,
            noGutter: !0,
            children: l.jsxs(i.Spacing, {
              topBottom: 2,
              leftRight: 2,
              children: [l.jsx(i.Text, {
                type: "boldBody",
                children: r.text
              }), h.map(function (v) {
                return l.jsx(ht, {
                  type: "link",
                  href: v.href,
                  secondary: !0,
                  children: v.text
                }, v.href);
              })]
            })
          }), s.length > 0 && l.jsx(i.Column, {
            xs: 4,
            noGutter: !0,
            children: l.jsxs(i.Spacing, {
              topBottom: 2,
              leftRight: 2,
              children: [l.jsx(i.Text, {
                type: "boldBody",
                children: "Highlights"
              }), s.map(function (v) {
                return l.jsx(ht, {
                  type: "link",
                  href: v.href,
                  secondary: !0,
                  onMouseEnter: function onMouseEnter() {
                    return d(v);
                  },
                  children: v.text
                }, v.href);
              })]
            })
          }), t && l.jsx(i.Column, {
            xs: 4,
            noGutter: !0,
            children: l.jsx(i.Spacing, {
              topBottom: 2,
              leftRight: 2,
              children: l.jsxs(i.Card, {
                shadow: "sm",
                roundedCorners: !0,
                withPadding: !0,
                children: [t.image && l.jsx(i.Card.Image, {
                  src: {
                    url: t.image,
                    alt: t.text
                  }
                }), t.description && l.jsxs(i.Card.Content, {
                  children: [t.text && l.jsx(i.Text, {
                    type: "boldBody",
                    children: t.text
                  }), t.description && l.jsx(i.Text, {
                    type: "body",
                    children: t.description
                  }), l.jsx(i.Spacing, {
                    topBottom: 1,
                    children: l.jsx(i.Button, {
                      secondary: !0,
                      text: "Find out more",
                      onClick: function onClick() {
                        window.location.href = t.href;
                      }
                    })
                  })]
                })]
              }, t.href)
            })
          })]
        });
      }, [r, t]);
    return l.jsx(i.Column, {
      noGutter: !0,
      children: l.jsx(z8, {
        children: l.jsxs(i.Row, {
          children: [l.jsx(i.Column, {
            xs: 3,
            noGutter: !0,
            children: l.jsx(i.Spacing, {
              topBottom: 2,
              leftRight: 2,
              children: e.map(function (h) {
                return l.jsxs(ht, {
                  type: "link",
                  onMouseEnter: function onMouseEnter() {
                    return c(h);
                  },
                  href: h.href,
                  secondary: !0,
                  children: [h.text, h.subMenuItems && l.jsx(m1, {
                    size: 14,
                    color: "#757575"
                  })]
                }, h.href);
              })
            })
          }), l.jsx(i.Column, {
            xs: 9,
            noGutter: !0,
            children: u
          })]
        })
      })
    });
  }),
  E8 = function E8(_ref29) {
    var e = _ref29.menuSections,
      t = _ref29.hasMenuSections,
      n = _ref29.CustomDesktopMenu,
      r = _ref29.businessHeader;
    var _i$useWindowSize = i.useWindowSize(),
      o = _i$useWindowSize.width;
    return l.jsx(l.Fragment, {
      children: e == null ? void 0 : e.map(function (c, d) {
        var u, h;
        return l.jsxs(Ge, {
          "data-testid": "desktop-menu-hover-".concat(d + 1),
          children: [l.jsx(x8, {
            type: "link",
            href: "".concat(c.href),
            active: c.isActive,
            children: c.text
          }), !t && c.subMenuItems && c.subMenuItems.map(function (s, v) {
            return l.jsx(b8, {
              children: l.jsx(Ge, {
                children: l.jsx(w8, {
                  type: "link",
                  href: "".concat(s.href),
                  children: s.text
                })
              })
            }, v);
          }), (u = c == null ? void 0 : c.subMenuItems) != null && u.length ? l.jsx(g8, {
            "data-testid": "secondary-desktop-menu",
            children: l.jsx(j8, {
              children: l.jsx(i.Row, {
                children: r ? l.jsx(O8, {
                  menuSections: c == null ? void 0 : c.subMenuItems
                }) : (h = c.subMenuItems) == null ? void 0 : h.map(function (s, v) {
                  var g;
                  return l.jsxs(m8, {
                    xs: v === 0 && o && o >= 1282 && o < 1600 ? 2 : 3,
                    index: v,
                    lgOffset: v === 0 ? 1.27 : 0,
                    xlOffset: v === 0 ? .75 : 0,
                    noGutter: !0,
                    children: [l.jsx(Er, {
                      type: "link",
                      href: "".concat(s.href),
                      children: s.text
                    }), l.jsx(y8, {
                      children: (g = s.subMenuItems) == null ? void 0 : g.map(function (x, w) {
                        return l.jsx(Ge, {
                          children: l.jsx(Er, {
                            type: "link",
                            href: "".concat(x.href),
                            secondary: !0,
                            children: x.text
                          })
                        }, w);
                      })
                    })]
                  }, v);
                })
              })
            })
          }) : null]
        }, d);
      })
    });
  },
  S8 = j.default(i.Text)(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]))),
  Cr = j.default.img(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n  height: ", ";\n"])), function (e) {
    return e.height ? e.height : "40px";
  }),
  Z7 = function Z7(_ref30) {
    var e = _ref30.href,
      t = _ref30.alt,
      n = _ref30.src;
    return e ? l.jsx(l.Fragment, {
      children: l.jsx(S8, {
        type: "link",
        href: e,
        children: l.jsx(Cr, {
          src: n,
          alt: t
        })
      })
    }) : l.jsx(Cr, {
      src: n,
      alt: t
    });
  },
  C8 = i.utils.responsiveStyles,
  R8 = i.withTheme(j.default.div(function (e) {
    return B.css(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n      display: none;\n      width: 100%;\n      z-index: 99;\n\n      @media (min-width: ", ") {\n        display: block;\n      }\n    "])), e.coreTheme.brk_md);
  })),
  M8 = j.default(i.Grid)(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n  &&& {\n    padding: 0;\n  }\n"]))),
  Rr = j.default(i.Column)(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n  padding-top: 0;\n  padding-bottom: 0;\n"]))),
  T8 = j.default.ul(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  float: right;\n  gap: 16px;\n"]))),
  P8 = j.default.ul(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  float: right;\n  align-items: center;\n  gap: 8px;\n"]))),
  eo = j.default.li(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 0;\n  padding: 0;\n"]))),
  k8 = i.withTheme(j.default(i.Text)(function (e) {
    var n, r, o, c, d, u, h, s;
    var t = C8((r = (n = e.coreTheme) == null ? void 0 : n.header) == null ? void 0 : r.subMenuMainSecondaryFontStyles, e.coreTheme);
    return B.css(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n      ", "\n\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "])), t, e.active ? (c = (o = e.coreTheme) == null ? void 0 : o.header) == null ? void 0 : c.linkHoverColor : (u = (d = e.coreTheme) == null ? void 0 : d.header) == null ? void 0 : u.linkStandardColor, (s = (h = e.coreTheme) == null ? void 0 : h.header) == null ? void 0 : s.linkHoverColor);
  })),
  A8 = j.default.ul(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  gap: 16px;\n  align-items: flex-end;\n"]))),
  B8 = j.default.li(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral([""]))),
  H8 = function H8(_ref31) {
    var e = _ref31.items;
    return l.jsx(l.Fragment, {
      children: e.map(function (t, n) {
        return l.jsx(eo, {
          children: l.jsx(k8, {
            lineHeight: "medium",
            type: "link",
            href: "".concat(t.href),
            active: t.isActive,
            children: t.text
          })
        }, n);
      })
    });
  },
  W8 = function W8(e) {
    var t = A.useRef();
    return A.useEffect(function () {
      var n = function n(r) {
        t.current && !t.current.contains(r.target) && e();
      };
      return document.addEventListener("click", n, !0), function () {
        document.removeEventListener("click", n, !0);
      };
    }, [t]), t;
  },
  _i$utils = i.utils,
  ft = _i$utils.responsiveStyles,
  E9 = _i$utils.testIdProps,
  c1 = j.default.div(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
j.default(i.Text)(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n  line-height: unset;\n"])));
var Mr = i.withTheme(j.default.div(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 2rem;\n\n    @media (min-width: ", ") {\n      top: ", ";\n    }\n\n    right: -0.7rem;\n    width: ", ";\n    margin-top: ", ";\n    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.12);\n    z-index: 9999;\n    overflow-x: visible;\n    border-radius: 8px;\n\n    &::before {\n      position: absolute;\n      top: ", ";\n      right: ", ";\n      content: '';\n      border-style: solid;\n      border-color: transparent transparent\n        ", " transparent;\n      border-width: 0 ", " ", " ", ";\n    }\n  "])), function (e) {
    return e.coreTheme.brk_md;
  }, K(40), K(180), K(12), K(-10), K(20), function (e) {
    return e.coreTheme.cl_ter_l5;
  }, K(10), K(10), K(10))),
  Tr = i.withTheme(j.default.ul(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n    display: block;\n    list-style-type: none;\n    background: ", ";\n    overflow: hidden;\n    margin: 0;\n    padding-left: 0;\n    z-index: 9;\n\n    border-radius: 8px;\n\n    &::before {\n      position: absolute;\n      top: ", ";\n      right: ", ";\n      content: '';\n      border-style: solid;\n      border-color: transparent transparent ", "\n        transparent;\n      border-width: 0 ", " ", " ", ";\n    }\n\n    padding: 24px 16px;\n  "])), function (e) {
    return e.coreTheme.cl_white;
  }, K(-8), K(22), function (e) {
    return e.coreTheme.cl_white;
  }, K(8), K(8), K(8))),
  J0 = i.withTheme(j.default.li(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n  "])), function (e) {
    return e != null && e.main ? "4px" : "unset";
  })),
  Z0 = i.withTheme(j.default(i.Text)(function (e) {
    var o, c, d, u, h, s;
    var t = ft((c = (o = e.coreTheme) == null ? void 0 : o.header) == null ? void 0 : c.subMenuMainFontStyles, e.coreTheme),
      n = ft((u = (d = e.coreTheme) == null ? void 0 : d.header) == null ? void 0 : u.subMenuMainSecondaryFontStyles, e.coreTheme),
      r = ft((s = (h = e.coreTheme) == null ? void 0 : h.header) == null ? void 0 : s.subMenuTextLinkStyles, e.coreTheme);
    return e != null && e.unstyle ? B.css(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n          ", "\n        "])), r) : B.css(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n          ", "\n        "])), e.main ? t : n);
  })),
  s1 = i.utils.testIdProps,
  Pr = function Pr(e) {
    return e == null ? void 0 : e.map(function (t, n) {
      return l.jsx(J0, {
        children: l.jsx(Z0, {
          type: "link",
          href: t.href,
          children: t.text
        })
      }, n);
    });
  },
  L8 = function L8(n) {
    var r = n,
      e = r.navIcon,
      t = ee(r, ["navIcon"]);
    var _A$useState11 = A.useState(!1),
      _A$useState12 = _slicedToArray(_A$useState11, 2),
      o = _A$useState12[0],
      c = _A$useState12[1],
      d = e.type,
      u = e.href,
      h = e.subMenuItems,
      _e$isActive = e.isActive,
      s = _e$isActive === void 0 ? !1 : _e$isActive,
      v = e.onClick,
      x = W8(function () {
        c(!1);
      }),
      w = function w() {
        if (v) {
          v();
          return;
        }
        h && c(!o), u && window.open(u, "_blank");
      };
    switch (d) {
      case "search":
        return l.jsx(c1, {
          children: l.jsx(i.Column, {
            noGutter: !0,
            children: l.jsx(i.IconButton, R({
              iconName: "search",
              onClick: w
            }, s1(t)))
          })
        });
      case "cart":
        return l.jsx(c1, {
          children: l.jsx(i.Column, {
            noGutter: !0,
            children: l.jsx(i.IconButton, R({
              iconName: s ? "cart_active" : "cart",
              onClick: w
            }, s1(t)))
          })
        });
      case "link":
        return l.jsx(c1, {
          children: l.jsx(i.Column, {
            noGutter: !0,
            children: l.jsx(i.IconButton, R({
              iconName: "store",
              onClick: w
            }, s1(t)))
          })
        });
      case "profile":
        return l.jsx(l.Fragment, {
          children: l.jsxs(c1, {
            children: [l.jsx(i.Column, {
              noGutter: !0,
              children: l.jsx(i.IconButton, R({
                iconName: "personal",
                onClick: w
              }, s1(t)))
            }), h && o && l.jsx(Mr, {
              "data-testid": "icon-sub-menu",
              ref: x,
              children: l.jsx(Tr, {
                children: h.map(function (m, b) {
                  return l.jsxs(i.Spacing, {
                    bottom: h[h.length - 1] === m ? 0 : 1,
                    children: [l.jsx(J0, {
                      main: !0,
                      children: l.jsx(Z0, {
                        type: "link",
                        href: m.href && "".concat(m.href),
                        onClick: m.onClick,
                        main: !0,
                        unstyle: m.text.split(" ").join("").toLowerCase().includes("logout"),
                        children: m.text
                      })
                    }), m.subMenuItems ? Pr(m.subMenuItems) : l.jsx(l.Fragment, {})]
                  }, b);
                })
              })
            })]
          })
        });
      case "enterpriseshop":
        return l.jsx(l.Fragment, {
          children: l.jsxs(c1, {
            children: [l.jsx(i.Column, {
              noGutter: !0,
              children: l.jsx(i.IconButton, R({
                iconName: "shop",
                onClick: w
              }, s1(t)))
            }), h && o && l.jsx(Mr, {
              "data-testid": "icon-sub-menu",
              ref: x,
              children: l.jsx(Tr, {
                children: h.map(function (m, b) {
                  return l.jsxs(i.Spacing, {
                    bottom: h[h.length - 1] === m ? 0 : 1,
                    children: [l.jsx(J0, {
                      main: !0,
                      children: l.jsx(Z0, {
                        type: "link",
                        href: m.href && "".concat(m.href),
                        main: !0,
                        unstyle: m.text.split(" ").join("").toLowerCase().includes("logout"),
                        children: m.text
                      })
                    }), m.subMenuItems ? Pr(m.subMenuItems) : l.jsx(l.Fragment, {})]
                  }, b);
                })
              })
            })]
          })
        });
      default:
        return l.jsx(l.Fragment, {});
    }
  },
  to = function to(n) {
    var r = n,
      e = r.navIcon,
      t = ee(r, ["navIcon"]);
    return L8(R({
      navIcon: e
    }, t));
  },
  _8 = function _8(_ref32) {
    var e = _ref32.navIcons;
    return l.jsx(P8, {
      children: e == null ? void 0 : e.map(function (t, n) {
        return l.jsx(B8, {
          children: l.jsx(to, {
            navIcon: t,
            "data-testid": "icon-menu-".concat(n + 1)
          })
        }, n);
      })
    });
  },
  I8 = function I8(_ref33) {
    var e = _ref33.siteLogo,
      t = _ref33.firstLevelLinks,
      n = _ref33.menuSections,
      r = _ref33.navIcons,
      o = _ref33.CustomDesktopMenu,
      c = _ref33.businessHeader;
    return l.jsx(R8, {
      "data-testid": "desktop-header",
      children: l.jsxs(M8, {
        children: [t && l.jsx(i.Spacing, {
          bottom: 1,
          children: l.jsxs(i.Row, {
            children: [l.jsx(Rr, {
              xs: 9,
              lg: 8
            }), l.jsx(Rr, {
              xs: 3,
              lg: 4,
              children: l.jsx(T8, {
                children: l.jsx(H8, {
                  items: t
                })
              })
            })]
          })
        }), l.jsxs(i.Row, {
          children: [l.jsx(i.Column, {
            xs: 8,
            lg: 9,
            noGutter: !0,
            children: l.jsxs(A8, {
              children: [l.jsx(eo, {
                children: e && l.jsx(Z7, {
                  href: e.href,
                  alt: e.alt,
                  src: e.sourceUrl
                })
              }), n && l.jsx(E8, {
                menuSections: n,
                hasMenuSections: n.length > 0,
                CustomDesktopMenu: o,
                businessHeader: c
              })]
            })
          }), l.jsx(i.Column, {
            xs: 4,
            lg: 3,
            noGutter: !0,
            children: r ? l.jsx(_8, {
              navIcons: r
            }) : l.jsx(l.Fragment, {})
          })]
        })]
      })
    });
  },
  N8 = i.withTheme(j.default.div(function (e) {
    return B.css(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: 100vw;\n\n      @media (min-width: ", ") {\n        display: none;\n      }\n    "])), e.coreTheme.brk_md);
  })),
  V8 = j.default.div(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n"]))),
  F8 = function F8(e) {
    return e.type === "search";
  },
  D8 = function D8(e) {
    return e.type === "link";
  },
  $8 = function $8(_ref34) {
    var e = _ref34.navIcons;
    return l.jsx(l.Fragment, {
      children: e.map(function (t, n) {
        return l.jsx(to, {
          navIcon: t,
          "data-testid": "mobile-icon-menu-".concat(n + 1)
        }, n);
      })
    });
  },
  q8 = function q8(_ref35) {
    var e = _ref35.siteLogo,
      t = _ref35.navIcons,
      n = _ref35.onHamburgerClick,
      _ref35$showHamburger = _ref35.showHamburger,
      r = _ref35$showHamburger === void 0 ? !0 : _ref35$showHamburger;
    var o = t == null ? void 0 : t.filter(function (c) {
      return !F8(c) && !D8(c);
    });
    return l.jsxs(N8, {
      "data-testid": "mobile-header",
      children: [e && l.jsx("div", {
        children: l.jsx(Z7, {
          href: e.href,
          alt: e.alt,
          src: e.sourceUrl
        })
      }), l.jsxs(V8, {
        children: [o && l.jsx($8, {
          navIcons: o
        }), r ? l.jsx(i.IconButton, {
          iconName: "menu",
          onClick: n,
          "data-testid": "hamburger-menu"
        }) : null]
      })]
    });
  },
  U8 = function U8(_ref36) {
    var e = _ref36.searchIcon;
    var n;
    var t = function t(r) {
      r.preventDefault();
      var o = r.currentTarget.elements.namedItem("search-input").value;
      window.open("".concat(e == null ? void 0 : e.href, "?").concat(e == null ? void 0 : e.queryParam, "=").concat(o), "_blank");
    };
    return l.jsx("form", {
      onSubmit: t,
      children: l.jsx(i.TextInput, {
        bgColor: "haze",
        label: (n = e == null ? void 0 : e.placeholder) != null ? n : "Search",
        "data-testid": "search-input",
        inputDataTestId: "input-field-id",
        name: "search-input",
        suffix: l.jsx(j5, {
          size: 24
        })
      })
    });
  },
  vt = i.utils.responsiveStyles,
  G8 = i.withTheme(j.default.div(function (e) {
    return B.css(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["\n      height: 100vh;\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      background-color: #ffffff; /* TODO: get this from themes {props.backgroundColor} */\n      overflow-y: auto;\n      visibility: hidden;\n      z-index: 99999;\n\n      transform: translateX(360px);\n      transition: 0.24s all;\n\n      ", ";\n    "])), e.isHamburgerMenuOpen && B.css(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["\n        transform: translateX(0);\n        visibility: visible;\n      "]))));
  })),
  Y8 = j.default(i.Grid)(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding-top: 0;\n  gap: 24px;\n\n  &&& {\n    padding: 16px 24px;\n  }\n"]))),
  Q8 = i.withTheme(j.default(i.Row)(function () {
    return B.css(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["\n      align-items: center;\n    "])));
  })),
  X8 = j.default.div(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["\n  display: block;\n  float: right;\n"]))),
  me = i.withTheme(j.default(i.Text)(function (e) {
    var o, c, d, u, h, s;
    var t = vt((c = (o = e.coreTheme) == null ? void 0 : o.header) == null ? void 0 : c.mainMenuSectionStyles, e.coreTheme),
      n = vt((u = (d = e.coreTheme) == null ? void 0 : d.header) == null ? void 0 : u.mainMenuFontStyles, e.coreTheme),
      r = vt((s = (h = e.coreTheme) == null ? void 0 : h.header) == null ? void 0 : s.mainSubmenuFontStyles, e.coreTheme);
    return B.css(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["\n      ", "\n      display: block;\n\n      ", "\n\n      & svg {\n        float: right;\n      }\n    "])), e != null && e.active ? t : n, ((e == null ? void 0 : e.secondary) || !(e != null && e.active)) && r);
  })),
  z5 = j.default(i.Column)(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["\n  padding: 0;\n"]))),
  no = j.default(z5)(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["\n  padding: 0;\n"]))),
  mt = j.default(i.Column)(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["\n  padding: 16px 0 0;\n"]))),
  K8 = i.withTheme(j.default.div(function (e) {
    var t, n, r;
    return B.css(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["\n      margin: 0 -24px;\n      padding: 24px;\n      background: ", ";\n  "])), (r = (n = (t = e == null ? void 0 : e.coreTheme) == null ? void 0 : t.color) == null ? void 0 : n.background) == null ? void 0 : r.subtle);
  })),
  J8 = function J8(_ref37) {
    var e = _ref37.activeSubMenuItem,
      t = _ref37.firstLevelLinks,
      n = _ref37.menuSections,
      r = _ref37.businessHeader,
      o = _ref37.isFourthLevelMenuOpen,
      c = _ref37.isFifthLevelMenuOpen,
      d = _ref37.setIsFifthLevelMenuOpen,
      u = _ref37.onThirdLevelMenuClick,
      h = _ref37.onMenuItemClick;
    var _A$useState13 = A.useState(),
      _A$useState14 = _slicedToArray(_A$useState13, 2),
      s = _A$useState14[0],
      v = _A$useState14[1],
      _A$useState15 = A.useState(""),
      _A$useState16 = _slicedToArray(_A$useState15, 2),
      g = _A$useState16[0],
      x = _A$useState16[1],
      _A$useState17 = A.useState(),
      _A$useState18 = _slicedToArray(_A$useState17, 2),
      w = _A$useState18[0],
      m = _A$useState18[1],
      b = function b(p, C) {
        v(C), x(p), c || u();
      },
      O = function O(p, C) {
        m(C), x(p), d(!0);
      },
      y = t == null ? void 0 : t.find(function (p) {
        return p.isSwitcher;
      }),
      z = (w == null ? void 0 : w.filter(function (p) {
        return p.isHighlights;
      })) || [],
      E = (w == null ? void 0 : w.filter(function (p) {
        return !p.isHighlights;
      })) || [];
    return o ? l.jsxs(l.Fragment, {
      children: [l.jsx(i.Spacing, {
        bottom: 2,
        children: l.jsx(i.Text, {
          type: "sectionTitle",
          children: g
        })
      }), r ? c ? l.jsxs(l.Fragment, {
        children: [l.jsx(i.Spacing, {
          bottom: 2,
          children: E.map(function (p) {
            return l.jsx(mt, {
              xs: 12,
              children: l.jsx(me, {
                type: "link",
                href: p.href,
                secondary: !0,
                onClick: function onClick(C) {
                  return h(C, p);
                },
                children: p.text
              })
            }, p.text);
          })
        }), z.length > 0 && l.jsxs(K8, {
          children: [l.jsx(i.Spacing, {
            bottom: 2,
            children: l.jsx(i.Text, {
              type: "sectionTitle",
              children: "Highlights"
            })
          }), z.map(function (p) {
            return l.jsx(mt, {
              xs: 12,
              children: l.jsx(me, {
                type: "link",
                href: p.href,
                secondary: !0,
                onClick: function onClick(C) {
                  return h(C, p);
                },
                children: p.text
              })
            }, p.text);
          })]
        })]
      }) : s == null ? void 0 : s.map(function (p) {
        return p != null && p.subMenuItems ? l.jsx(i.Spacing, {
          bottom: 3,
          children: l.jsxs(me, {
            type: "link",
            onClick: function onClick() {
              O(p.text, p.subMenuItems);
            },
            secondary: !0,
            children: [p.text, l.jsx(m1, {
              size: 16,
              color: "#757575"
            })]
          })
        }, p.text) : l.jsx(i.Spacing, {
          bottom: 3,
          children: l.jsx(me, {
            type: "link",
            href: p.href,
            secondary: !0,
            onClick: function onClick(C) {
              h(C, p);
            },
            children: p.text
          })
        }, p.text);
      }) : s == null ? void 0 : s.map(function (p) {
        return l.jsxs(l.Fragment, {
          children: [l.jsx(i.Text, {
            type: "boldBody",
            "data-testid": "fourth-level-menu",
            onClick: function onClick(C) {
              h(C, p);
            },
            main: !0,
            children: p.text
          }), p.subMenuItems && p.subMenuItems.map(function (C, M) {
            return l.jsx(A.Fragment, {
              children: l.jsx(i.Row, {
                children: l.jsx(mt, {
                  xs: 12,
                  children: l.jsx(me, {
                    type: "link",
                    href: C.href,
                    secondary: !0,
                    onClick: function onClick(P) {
                      h(P, C);
                    },
                    children: C.text
                  })
                })
              }, M)
            }, M);
          }), l.jsx(i.Spacing, {
            topBottom: 3,
            children: s[s.length - 1] !== p ? l.jsx(i.Divider, {}) : l.jsx(l.Fragment, {})
          })]
        });
      })]
    }) : l.jsx(l.Fragment, {
      children: t == null ? void 0 : t.map(function (p, C) {
        return l.jsxs(i.Row, {
          children: [p != null && p.isSwitcher ? null : l.jsx(z5, {
            xs: 12,
            noGutter: !0,
            children: l.jsx(i.Spacing, {
              bottom: C === 1 ? 2 : 3,
              children: l.jsx(me, {
                type: "link",
                href: p.href,
                onClick: function onClick(M) {
                  h(M, p);
                },
                active: p.isActive,
                children: p.text
              })
            })
          }), p.isActive && (n == null ? void 0 : n.map(function (M, P) {
            return l.jsx(i.Column, {
              xs: 12,
              noGutter: !0,
              children: l.jsx(no, {
                xs: 12,
                noGutter: !0,
                children: l.jsxs(i.Spacing, {
                  bottom: 3,
                  children: [(M.subMenuItems || []).length > 0 && l.jsxs(me, {
                    type: "link",
                    active: P === e,
                    onClick: function onClick() {
                      b(M.text, M.subMenuItems);
                    },
                    secondary: !0,
                    "data-testid": "second-level-menu-".concat(P + 1),
                    children: [M.text, l.jsx(m1, {
                      size: 16,
                      color: "#757575"
                    })]
                  }), (M.subMenuItems || []).length === 0 && l.jsx(me, {
                    type: "link",
                    href: M.href,
                    secondary: !0,
                    onClick: function onClick(_) {
                      h(_, M);
                    },
                    children: M.text
                  })]
                })
              })
            }, P);
          })), C === 1 && l.jsxs(l.Fragment, {
            children: [l.jsx(i.Divider, {}), l.jsx(i.Spacing, {
              bottom: 3
            })]
          }), t.length - 1 === C && y ? l.jsxs(l.Fragment, {
            children: [l.jsx(i.Divider, {}), l.jsx(i.Spacing, {
              top: 3
            }), l.jsx(me, {
              type: "link",
              href: y.href,
              onClick: function onClick(M) {
                h(M, y);
              },
              active: y.isActive,
              children: y.switcherLabel
            })]
          }) : null]
        }, C);
      })
    });
  },
  Z8 = function Z8(_ref38) {
    var e = _ref38.menuSection,
      t = _ref38.onMenuItemClick;
    return e == null ? void 0 : e.map(function (n, r) {
      return l.jsxs(i.Row, {
        children: [l.jsx(z5, {
          xs: 12,
          children: l.jsx(me, {
            type: "link",
            href: n.href,
            active: n.isActive,
            style: {
              padding: "15px 0px 20px 19px"
            },
            onClick: function onClick(o) {
              t(o, n);
            },
            children: n.text
          })
        }), n.subMenuItems && n.subMenuItems.map(function (o, c) {
          return l.jsx(i.Column, {
            xs: 12,
            style: {
              padding: "0 auto"
            },
            children: l.jsx(no, {
              style: {
                paddingLeft: "46px",
                paddingBottom: "15px"
              },
              xs: 12,
              children: l.jsx(me, {
                type: "link",
                href: o.href,
                secondary: !0,
                onClick: function onClick(d) {
                  t(d, o);
                },
                children: o.text
              })
            })
          }, c);
        })]
      }, r);
    });
  },
  eh = function eh(_ref39) {
    var e = _ref39.firstLevelLinks,
      t = _ref39.isHamburgerMenuOpen,
      n = _ref39.menuSections,
      r = _ref39.businessHeader,
      o = _ref39.onClose,
      _ref39$onMenuItemClic = _ref39.onMenuItemClick,
      c = _ref39$onMenuItemClic === void 0 ? function () {
        return null;
      } : _ref39$onMenuItemClic,
      d = _ref39.searchIcon,
      u = _ref39.showSearch,
      h = _ref39.menuItems;
    var _A$useState19 = A.useState(!1),
      _A$useState20 = _slicedToArray(_A$useState19, 2),
      s = _A$useState20[0],
      v = _A$useState20[1],
      _A$useState21 = A.useState(!1),
      _A$useState22 = _slicedToArray(_A$useState21, 2),
      g = _A$useState22[0],
      x = _A$useState22[1],
      w = function w() {
        g ? x(!1) : v(!1);
      },
      m = function m() {
        w(), o();
      },
      b = function b() {
        v(!0);
      };
    return l.jsx(G8, {
      isHamburgerMenuOpen: t,
      "data-testid": "mobile-menu",
      children: l.jsxs(Y8, {
        children: [l.jsxs(Q8, {
          children: [l.jsx(i.Column, {
            noGutter: !0,
            children: s && l.jsx(i.IconButton, {
              iconName: "back_arrow",
              onClick: w
            })
          }), l.jsx(i.Column, {
            noGutter: !0,
            children: l.jsx(X8, {
              children: l.jsx(i.IconButton, {
                onClick: m,
                iconName: "close"
              })
            })
          })]
        }), u ? l.jsx(i.Row, {
          "data-testid": "mobile-search-menu-item",
          children: l.jsx(i.Column, {
            xs: 12,
            noGutter: !0,
            children: l.jsx(U8, {
              searchIcon: d
            })
          })
        }) : null, l.jsx(i.Row, {
          children: l.jsxs(i.Column, {
            xs: 12,
            noGutter: !0,
            children: [e && l.jsx(J8, {
              firstLevelLinks: e,
              menuSections: n,
              businessHeader: r,
              isFourthLevelMenuOpen: s,
              isFifthLevelMenuOpen: g,
              setIsFifthLevelMenuOpen: x,
              onThirdLevelMenuClick: b,
              onMenuItemClick: c
            }), !e && l.jsx(Z8, {
              menuItems: h,
              onMenuItemClick: c
            })]
          })
        })]
      })
    });
  },
  th = function th(s) {
    var v = s,
      e = v.siteLogo,
      t = v.primaryNavLinks,
      n = v.menuSections,
      r = v.navIcons,
      o = v.onMenuItemClick,
      c = v.CustomDesktopMenu,
      d = v.businessHeader,
      u = v.showHamburger,
      h = ee(v, ["siteLogo", "primaryNavLinks", "menuSections", "navIcons", "onMenuItemClick", "CustomDesktopMenu", "businessHeader", "showHamburger"]);
    var _A$useState23 = A.useState(!1),
      _A$useState24 = _slicedToArray(_A$useState23, 2),
      g = _A$useState24[0],
      x = _A$useState24[1],
      _A$useState25 = A.useState(-1),
      _A$useState26 = _slicedToArray(_A$useState25, 2),
      w = _A$useState26[1],
      _A$useState27 = A.useState(0),
      _A$useState28 = _slicedToArray(_A$useState27, 2),
      m = _A$useState28[0],
      b = _A$useState28[1],
      O = function O(p) {
        return w(p);
      },
      y = function y() {
        return w(-1);
      },
      z = function z() {
        return x(!g);
      };
    A.useEffect(function () {
      var p = function p() {
        return b(window.scrollY);
      };
      return window.removeEventListener("scroll", p), window.addEventListener("scroll", p, {
        passive: !0
      }), function () {
        return window.removeEventListener("scroll", p);
      };
    }, []);
    var E = r.find(function (p) {
      return p.type === "search";
    });
    return l.jsxs(v8, L(R({
      scrollOffset: m
    }, i.utils.testIdProps(h)), {
      children: [l.jsx(q8, {
        siteLogo: e,
        navIcons: r,
        onHamburgerClick: z,
        showHamburger: u
      }), l.jsx(I8, {
        siteLogo: e,
        firstLevelLinks: t,
        menuSections: n,
        CustomDesktopMenu: c,
        businessHeader: d,
        navIcons: r,
        onMenuMouseEnter: O,
        onMenuMouseLeave: y,
        onMenuItemClick: o
      }), l.jsx(eh, {
        showSearch: !!E,
        firstLevelLinks: t,
        isHamburgerMenuOpen: g,
        menuSections: n,
        businessHeader: d,
        onClose: z,
        searchIcon: E
      })]
    }));
  };
function Pe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16,
    n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return typeof __PORTABLE_LUX__ != "undefined" && __PORTABLE_LUX__ || n ? e + "px" : e / t + "rem";
}
var pe = i.utils.responsiveStyles,
  ro = i.withTheme(j.default(i.Grid)(function (e) {
    var t, n;
    return B.css(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral(["\n      &&& {\n        background-color: ", ";\n        padding: 0;\n      }\n    "])), (n = (t = e.coreTheme) == null ? void 0 : t.footer) == null ? void 0 : n.backgroundColor);
  })),
  nh = i.withTheme(j.default(i.Grid)(function (e) {
    var t, n;
    return B.css(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["\n      &&& {\n        background-color: ", ";\n        padding: 0;\n\n        @media (max-width: ", ") {\n          padding: 0 24px;\n        }\n\n        /** Todo: Interim fix for LG size range **/\n        @media (min-width: 1290px) and (max-width: 1600px) {\n          padding: 0;\n        }\n      }\n    "])), (n = (t = e.coreTheme) == null ? void 0 : t.footer) == null ? void 0 : n.backgroundColor, e.coreTheme.brk_lg);
  }));
i.withTheme(j.default(i.Row)(function (e) {
  return B.css(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["\n      margin-top: ", ";\n      margin-bottom: ", ";\n      display: none;\n\n      @media (min-width: ", ") {\n        display: flex;\n      }\n    "])), Pe(40), Pe(40), e.coreTheme.brk_md);
}));
var rh = i.withTheme(j.default(i.Text)(function (e) {
    var n, r;
    var t = pe((r = (n = e.coreTheme) == null ? void 0 : n.footer) == null ? void 0 : r.linkHeaderTextLinkStyle, e.coreTheme);
    return B.css(_templateObject88 || (_templateObject88 = _taggedTemplateLiteral(["\n      display: block;\n      ", ";\n    "])), t);
  })),
  kr = i.withTheme(j.default(i.Text)(function (e) {
    var n, r;
    var t = pe((r = (n = e.coreTheme) == null ? void 0 : n.footer) == null ? void 0 : r.linkHeaderTextLinkStyleMobile, e.coreTheme);
    return B.css(_templateObject89 || (_templateObject89 = _taggedTemplateLiteral(["\n      display: block;\n      ", ";\n    "])), t);
  })),
  lh = j.default(i.Column)(_templateObject90 || (_templateObject90 = _taggedTemplateLiteral(["\n  &&& {\n    display: flex;\n    gap: 4px;\n    padding-right: 16px;\n  }\n"]))),
  ah = i.withTheme(j.default(i.Text)(function (e) {
    var n, r;
    var t = pe((r = (n = e.coreTheme) == null ? void 0 : n.footer) == null ? void 0 : r.linkTextLinkStyle, e.coreTheme);
    return B.css(_templateObject91 || (_templateObject91 = _taggedTemplateLiteral(["\n      display: block;\n      ", ";\n    "])), t);
  })),
  Ar = i.withTheme(j.default(i.Text)(function (e) {
    var n, r;
    var t = pe((r = (n = e.coreTheme) == null ? void 0 : n.footer) == null ? void 0 : r.linkTextLinkStyleMobile, e.coreTheme);
    return B.css(_templateObject92 || (_templateObject92 = _taggedTemplateLiteral(["\n      display: block;\n      ", ";\n    "])), t);
  })),
  Br = j.default(i.Row)(_templateObject93 || (_templateObject93 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 16px;\n  flex-direction: column;\n"])));
j.default.div(_templateObject94 || (_templateObject94 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var lo = i.withTheme(j.default.div(function (e) {
    return B.css(_templateObject95 || (_templateObject95 = _taggedTemplateLiteral(["\n      display: flex;\n      gap: 8px;\n      padding: 0;\n      margin: 0;\n      flex-wrap: wrap;\n\n      @media (min-width: ", ") {\n        display: flex;\n      }\n    "])), e.coreTheme.brk_md);
  })),
  ao = i.withTheme(j.default(i.Text)(function (e) {
    var n, r;
    var t = pe((r = (n = e.coreTheme) == null ? void 0 : n.footer) == null ? void 0 : r.linkTextLinkStyle, e.coreTheme);
    return B.css(_templateObject96 || (_templateObject96 = _taggedTemplateLiteral(["\n      margin-bottom: ", ";\n      ", ";\n    "])), Pe(20), t);
  })),
  io = i.withTheme(j.default(i.Text)(function (e) {
    var n, r;
    var t = pe((r = (n = e.coreTheme) == null ? void 0 : n.footer) == null ? void 0 : r.linkTextLinkStyle, e.coreTheme);
    return B.css(_templateObject97 || (_templateObject97 = _taggedTemplateLiteral(["\n      ", ";\n    "])), t);
  })),
  ih = i.withTheme(j.default.div(function (e) {
    var n, r;
    var t = pe((r = (n = e.coreTheme) == null ? void 0 : n.footer) == null ? void 0 : r.linkTextLinkStyle, e.coreTheme);
    return B.css(_templateObject98 || (_templateObject98 = _taggedTemplateLiteral(["\n      ", "\n      display: flex;\n      justify-content: flex-end;\n    "])), t);
  })),
  oh = i.withTheme(j.default.div(function (e) {
    var n, r;
    var t = pe((r = (n = e.coreTheme) == null ? void 0 : n.footer) == null ? void 0 : r.linkTextLinkStyle, e.coreTheme);
    return B.css(_templateObject99 || (_templateObject99 = _taggedTemplateLiteral(["\n      ", "\n    "])), t);
  }));
i.withTheme(j.default.div(function (e) {
  return B.css(_templateObject100 || (_templateObject100 = _taggedTemplateLiteral(["\n      margin-bottom: ", ";\n      text-align: center;\n\n      @media (min-width: ", ") {\n        text-align: right;\n      }\n    "])), Pe(10), e.coreTheme.brk_xs);
}));
i.withTheme(j.default.a(function (e) {
  return B.css(_templateObject101 || (_templateObject101 = _taggedTemplateLiteral(["\n      display: inline-block;\n      margin: 0 ", ";\n      @media (min-width: ", ") {\n        margin: 0 0 0 ", ";\n      }\n    "])), Pe(15), e.coreTheme.brk_xs, Pe(10));
}));
j.default.img(_templateObject102 || (_templateObject102 = _taggedTemplateLiteral(["\n  margin: 0;\n  height: ", ";\n"])), Pe(30));
var ch = j.default.div(_templateObject103 || (_templateObject103 = _taggedTemplateLiteral(["\n  width: 100%;\n"]))),
  sh = j.default.div(_templateObject104 || (_templateObject104 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-right: 16px;\n"]))),
  dh = j.default.div(_templateObject105 || (_templateObject105 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: 4px;\n  padding-top: 4px;\n  gap: 8px;\n\n  &&& {\n    > a {\n      height: 100%;\n    }\n  }\n"]))),
  Hr = j.default.div(_templateObject106 || (_templateObject106 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"]))),
  uh = j.default.div(_templateObject107 || (_templateObject107 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 4px;\n  flex-direction: column;\n  padding-right: 16px;\n"]))),
  hh = j.default.div(_templateObject108 || (_templateObject108 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n"]))),
  fh = i.withTheme(j.default.text(function (e) {
    var n, r;
    var t = pe((r = (n = e.coreTheme) == null ? void 0 : n.footer) == null ? void 0 : r.linkTextLinkStyle, e.coreTheme);
    return B.css(_templateObject109 || (_templateObject109 = _taggedTemplateLiteral(["\n      ", "\n      text-decoration: none;\n    "])), t);
  })),
  vh = "data:image/png;base64,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",
  mh = "data:image/png;base64,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",
  e5 = function e5(_ref40) {
    var e = _ref40.appLogos;
    var t = e.label,
      n = e.body,
      r = e.logos,
      _i$useDevice6 = i.useDevice(),
      o = _i$useDevice6.isMobile,
      c = _i$useDevice6.isTablet,
      d = _i$useDevice6.isLandscapeTablet,
      _i$useTheme3 = i.useTheme(),
      u = _i$useTheme3.theme,
      s = function (v) {
        if (!v) return null;
        var g = /<a href="([^"]*)">(.*?)<\/a>/g,
          x = [];
        var w = 0,
          m;
        for (; (m = g.exec(v)) !== null;) {
          m.index > w && x.push(v.substring(w, m.index)), x.push(l.jsx(i.TextLink, {
            inline: !0,
            href: m[1],
            children: m[2]
          }, m.index)), w = m.index + m[0].length;
        }
        return w < v.length && x.push(v.substring(w)), x;
      }(n == null ? void 0 : n.toString());
    return l.jsxs(sh, {
      children: [l.jsx(i.Text, {
        type: o || c || d ? "boldBody" : "boldSmallBody",
        color: (u == null ? void 0 : u.footer.linkHeaderTextLinkStyle.color) || "#565656",
        children: t
      }), l.jsx(fh, {
        type: "smallBody",
        children: s
      }), l.jsx(dh, {
        children: r == null ? void 0 : r.map(function (v) {
          return v.type === "appstore" || v.type === "playstore" ? l.jsx(l.Fragment, {
            children: l.jsx(i.TextLink, {
              href: v.href,
              children: l.jsx("img", {
                src: v.type === "appstore" ? vh : mh,
                alt: v.type,
                width: 120,
                height: 40
              })
            })
          }) : l.jsx(l.Fragment, {});
        })
      })]
    });
  },
  gh = {
    social_appstore_badge: Promise.resolve().then(function () {
      return require("./social_appstore_badge-13dde4b4.js");
    }),
    social_facebook: Promise.resolve().then(function () {
      return require("./social_facebook-c64136ee.js");
    }),
    social_facebook_black: Promise.resolve().then(function () {
      return require("./social_facebook_black-60abeb99.js");
    }),
    social_facebook_footer: Promise.resolve().then(function () {
      return require("./social_facebook_footer-f53fcafe.js");
    }),
    social_facebook_footer_white: Promise.resolve().then(function () {
      return require("./social_facebook_footer_white-fe5f16ea.js");
    }),
    social_facebook_white: Promise.resolve().then(function () {
      return require("./social_facebook_white-d75c3d84.js");
    }),
    social_googleplay_badge: Promise.resolve().then(function () {
      return require("./social_googleplay_badge-32b91514.js");
    }),
    social_instagram: Promise.resolve().then(function () {
      return require("./social_instagram-e7252528.js");
    }),
    social_instagram_black: Promise.resolve().then(function () {
      return require("./social_instagram_black-95a03910.js");
    }),
    social_instagram_footer: Promise.resolve().then(function () {
      return require("./social_instagram_footer-79fc4510.js");
    }),
    social_instagram_footer_white: Promise.resolve().then(function () {
      return require("./social_instagram_footer_white-bfc82afd.js");
    }),
    social_instagram_white: Promise.resolve().then(function () {
      return require("./social_instagram_white-d3f2a2ca.js");
    }),
    social_linkedin: Promise.resolve().then(function () {
      return require("./social_linkedin-fbbd86c3.js");
    }),
    social_linkedin_black: Promise.resolve().then(function () {
      return require("./social_linkedin_black-71578254.js");
    }),
    social_linkedin_footer: Promise.resolve().then(function () {
      return require("./social_linkedin_footer-24cf0ed9.js");
    }),
    social_linkedin_footer_white: Promise.resolve().then(function () {
      return require("./social_linkedin_footer_white-72206f84.js");
    }),
    social_linkedin_white: Promise.resolve().then(function () {
      return require("./social_linkedin_white-c5c48976.js");
    }),
    social_tiktok: Promise.resolve().then(function () {
      return require("./social_tiktok-7204312d.js");
    }),
    social_tiktok_black: Promise.resolve().then(function () {
      return require("./social_tiktok_black-f99a9066.js");
    }),
    social_tiktok_footer: Promise.resolve().then(function () {
      return require("./social_tiktok_footer-07518a06.js");
    }),
    social_tiktok_footer_white: Promise.resolve().then(function () {
      return require("./social_tiktok_footer_white-966ba1e2.js");
    }),
    social_tiktok_white: Promise.resolve().then(function () {
      return require("./social_tiktok_white-fe337d2a.js");
    }),
    social_twitter_black: Promise.resolve().then(function () {
      return require("./social_twitter_black-26926353.js");
    }),
    social_twitter_footer: Promise.resolve().then(function () {
      return require("./social_twitter_footer-78266e79.js");
    }),
    social_twitter_footer_white: Promise.resolve().then(function () {
      return require("./social_twitter_footer_white-77dadfe6.js");
    }),
    social_twitter_white: Promise.resolve().then(function () {
      return require("./social_twitter_white-09cb85b5.js");
    }),
    social_youtube: Promise.resolve().then(function () {
      return require("./social_youtube-3c93d163.js");
    }),
    social_youtube_black: Promise.resolve().then(function () {
      return require("./social_youtube_black-51773fe8.js");
    }),
    social_youtube_footer: Promise.resolve().then(function () {
      return require("./social_youtube_footer-8642b146.js");
    }),
    social_youtube_footer_white: Promise.resolve().then(function () {
      return require("./social_youtube_footer_white-13532518.js");
    }),
    social_youtube_white: Promise.resolve().then(function () {
      return require("./social_youtube_white-ce4f56b7.js");
    })
  },
  xh = {},
  t5 = function t5(_ref41) {
    var e = _ref41.socialLinks;
    var _i$useDevice7 = i.useDevice(),
      t = _i$useDevice7.isMobile,
      n = _i$useDevice7.isTablet,
      r = _i$useDevice7.isLandscapeTablet,
      _i$useTheme4 = i.useTheme(),
      o = _i$useTheme4.theme,
      _A$useState29 = A.useState([]),
      _A$useState30 = _slicedToArray(_A$useState29, 2),
      c = _A$useState30[0],
      d = _A$useState30[1];
    return A.useEffect(function () {
      (function () {
        return at(exports, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var h;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  h = [];
                  _context2.next = 3;
                  return Promise.all(Object.entries(gh).map(function (g) {
                    return at(exports, [g], /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref42) {
                      var _ref43, s, v, _iterator3, _step3, x, w;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _ref43 = _slicedToArray(_ref42, 2), s = _ref43[0], v = _ref43[1];
                              _iterator3 = _createForOfIteratorHelper(e);
                              _context.prev = 2;
                              _iterator3.s();
                            case 4:
                              if ((_step3 = _iterator3.n()).done) {
                                _context.next = 13;
                                break;
                              }
                              x = _step3.value;
                              if (!(x.type === s.split("_")[1] && s.split("_")[2] === "footer")) {
                                _context.next = 11;
                                break;
                              }
                              _context.next = 9;
                              return v;
                            case 9:
                              w = _context.sent;
                              h.push({
                                key: s.split("_")[1],
                                source: w.default
                              });
                            case 11:
                              _context.next = 4;
                              break;
                            case 13:
                              _context.next = 18;
                              break;
                            case 15:
                              _context.prev = 15;
                              _context.t0 = _context["catch"](2);
                              _iterator3.e(_context.t0);
                            case 18:
                              _context.prev = 18;
                              _iterator3.f();
                              return _context.finish(18);
                            case 21:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, null, [[2, 15, 18, 21]]);
                    }));
                  }));
                case 3:
                  d(h);
                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
      })();
    }, []), l.jsxs(uh, {
      children: [l.jsx(i.Text, {
        type: t || n || r ? "boldBody" : "boldSmallBody",
        color: (o == null ? void 0 : o.footer.linkHeaderTextLinkStyle.color) || "#565656",
        tag: "span",
        children: "Find us on"
      }), l.jsx(hh, {
        children: e == null ? void 0 : e.map(function (u, h) {
          var s;
          return xh[u.type], l.jsx(l.Fragment, {
            children: l.jsx(i.TextLink, {
              href: u.href,
              children: l.jsx("img", {
                src: (s = c[h]) == null ? void 0 : s.source,
                alt: u.type,
                width: 40,
                height: 40
              })
            }, h)
          });
        })
      })]
    });
  },
  bh = function bh(u) {
    var h = u,
      e = h.menuSections,
      t = h.minimalLinks,
      n = h.socialLinks,
      r = h.appLogos,
      o = h.copyrightText,
      _h$topDivider = h.topDivider,
      c = _h$topDivider === void 0 ? !1 : _h$topDivider,
      d = ee(h, ["menuSections", "minimalLinks", "socialLinks", "appLogos", "copyrightText", "topDivider"]);
    var m, b, O, y, z;
    var _A$useState31 = A.useState(-1),
      _A$useState32 = _slicedToArray(_A$useState31, 2),
      s = _A$useState32[0],
      v = _A$useState32[1],
      g = function g(E) {
        return v(s === E ? -1 : E);
      },
      x = function x(E) {
        return E && (E.startsWith("http://") || E.startsWith("https://")), E;
      },
      w = function w() {
        return l.jsxs(l.Fragment, {
          children: [l.jsxs(l.Fragment, {
            children: [r || n ? l.jsx(i.Spacing, {
              topBottom: 3,
              children: l.jsx(i.Divider, {})
            }) : null, r ? l.jsx(e5, {
              appLogos: r
            }) : null, n ? l.jsx(i.Spacing, {
              top: 3,
              children: l.jsx(t5, {
                socialLinks: n
              })
            }) : null]
          }), (t == null ? void 0 : t.length) && l.jsxs(l.Fragment, {
            children: [l.jsx(i.Spacing, {
              topBottom: 3,
              children: l.jsx(i.Divider, {})
            }), l.jsx(lo, {
              children: t.map(function (E, p) {
                return l.jsxs(a.default.Fragment, {
                  children: [l.jsx(ao, {
                    type: "link",
                    href: x(E.href),
                    children: E.text
                  }), p !== (t == null ? void 0 : t.length) - 1 ? l.jsx(io, {
                    type: "smallBody",
                    children: "|"
                  }) : null]
                }, p);
              })
            })]
          }), l.jsx(i.Spacing, {
            top: 3,
            children: l.jsx(oh, {
              children: o
            })
          })]
        });
      };
    return l.jsx(ro, {
      fluid: !0,
      children: l.jsxs(i.Spacing, {
        bottom: 5,
        leftRight: 2,
        responsive: !1,
        children: [l.jsx(i.Spacing, {
          bottom: (e == null ? void 0 : e.length) === 1 ? 5 : 3,
          responsive: !1,
          children: c ? l.jsx(i.Divider, {}) : null
        }), (e == null ? void 0 : e.length) === 1 ? l.jsxs(l.Fragment, {
          children: [l.jsx(i.Spacing, {
            bottom: 2,
            responsive: !1,
            children: l.jsx(kr, {
              type: "link",
              children: (m = e[0]) == null ? void 0 : m.text
            })
          }), l.jsx(Br, {
            children: (O = (b = e[0]) == null ? void 0 : b.subMenuItems) == null ? void 0 : O.map(function (E, p) {
              return l.jsx(Ar, {
                type: "link",
                href: x(E.href),
                children: E.text
              }, p);
            })
          }), w()]
        }) : l.jsxs(ch, L(R({}, (z = (y = i.utils).testIdProps) == null ? void 0 : z.call(y, d)), {
          children: [e == null ? void 0 : e.map(function (E, p) {
            var C;
            return l.jsx(i.Accordion, {
              title: l.jsx(kr, {
                type: "link",
                children: E.text
              }),
              dividerNeeded: !1,
              desc: l.jsx(Br, {
                children: (C = E == null ? void 0 : E.subMenuItems) == null ? void 0 : C.map(function (M, P) {
                  return l.jsx(Ar, {
                    type: "link",
                    href: x(M.href),
                    children: M.text
                  }, P);
                })
              }),
              selected: s === p,
              value: p,
              onClick: function onClick() {
                return g(p);
              }
            }, p);
          }), w()]
        }))]
      })
    });
  },
  wh = function wh(u) {
    var h = u,
      e = h.menuSections,
      t = h.minimalLinks,
      n = h.socialLinks,
      r = h.appLogos,
      o = h.copyrightText,
      _h$topDivider2 = h.topDivider,
      c = _h$topDivider2 === void 0 ? !1 : _h$topDivider2,
      d = ee(h, ["menuSections", "minimalLinks", "socialLinks", "appLogos", "copyrightText", "topDivider"]);
    var v, g;
    var s = function s(x) {
      return x && (x.startsWith("http://") || x.startsWith("https://")), x;
    };
    return l.jsx(ro, {
      fluid: !0,
      children: l.jsx(i.Spacing, {
        bottom: 2,
        responsive: !1,
        children: l.jsx(i.Row, {
          children: l.jsx(i.Column, {
            xs: 12,
            noGutter: !0,
            children: l.jsxs(nh, L(R({}, (g = (v = i.utils).testIdProps) == null ? void 0 : g.call(v, d)), {
              children: [l.jsx(i.Spacing, {
                bottom: 5,
                responsive: !1,
                children: c ? l.jsx(i.Divider, {}) : null
              }), (e == null ? void 0 : e.length) && l.jsx(i.Spacing, {
                bottom: 2,
                children: l.jsxs(i.Row, {
                  children: [e == null ? void 0 : e.map(function (x, w) {
                    return l.jsxs(lh, {
                      noGutter: !0,
                      children: [l.jsx(rh, {
                        type: "link",
                        href: s(x.href),
                        children: x.text
                      }), x.subMenuItems && x.subMenuItems.map(function (m, b) {
                        return l.jsx(ah, {
                          type: "link",
                          href: s(m.href),
                          children: m.text
                        }, b);
                      })]
                    }, w);
                  }), e && e.length < 5 ? l.jsx(i.Column, {
                    xs: 12,
                    sm: 4,
                    noGutter: !0,
                    children: l.jsxs(Hr, {
                      children: [r && l.jsx(e5, {
                        appLogos: r
                      }), n && l.jsx(t5, {
                        socialLinks: n
                      })]
                    })
                  }) : null]
                })
              }), e && e.length >= 5 ? l.jsx(i.Spacing, {
                bottom: 2,
                children: l.jsx(i.Column, {
                  xs: 12,
                  sm: 4,
                  noGutter: !0,
                  children: l.jsxs(Hr, {
                    children: [r && l.jsx(e5, {
                      appLogos: r
                    }), n && l.jsx(t5, {
                      socialLinks: n
                    })]
                  })
                })
              }) : null, t != null && t.length ? l.jsx(i.Spacing, {
                topBottom: 1,
                children: l.jsx(i.Divider, {})
              }) : null, l.jsxs(i.Row, {
                children: [l.jsx(i.Column, {
                  xs: 12,
                  sm: 8,
                  md: 8,
                  lg: 8,
                  noGutter: !0,
                  children: t && l.jsx(lo, {
                    children: t.map(function (x, w) {
                      return l.jsxs(a.default.Fragment, {
                        children: [l.jsx(ao, {
                          type: "link",
                          href: s(x.href),
                          children: x.text
                        }), w !== (t == null ? void 0 : t.length) - 1 ? l.jsx(io, {
                          type: "smallBody",
                          children: "|"
                        }) : null]
                      }, w);
                    })
                  })
                }), l.jsx(i.Column, {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  noGutter: !0,
                  children: l.jsx(ih, {
                    children: o
                  })
                })]
              })]
            }))
          })
        })
      })
    });
  },
  yh = function yh(d) {
    var u = d,
      e = u.menuSections,
      t = u.minimalLinks,
      n = u.socialLinks,
      r = u.appLogos,
      o = u.copyrightText,
      c = ee(u, ["menuSections", "minimalLinks", "socialLinks", "appLogos", "copyrightText"]);
    var _i$useDevice8 = i.useDevice(),
      h = _i$useDevice8.isMobile,
      s = _i$useDevice8.isTablet,
      v = _i$useDevice8.isLandscapeTablet;
    return h || s || v ? l.jsx(bh, R({
      menuSections: e,
      minimalLinks: t,
      socialLinks: n,
      appLogos: r,
      copyrightText: o
    }, c)) : l.jsx(wh, R({
      menuSections: e,
      minimalLinks: t,
      socialLinks: n,
      appLogos: r,
      copyrightText: o
    }, c));
  },
  p5 = A.createContext({
    title: "",
    bodyText: "",
    videoUrl: "",
    layout: "1",
    action: void 0,
    isMobile: !1,
    isTablet: !1
  }),
  jh = function jh(_ref44) {
    var e = _ref44.title,
      t = _ref44.bodyText,
      n = _ref44.videoUrl,
      _ref44$layout = _ref44.layout,
      r = _ref44$layout === void 0 ? "1" : _ref44$layout,
      _ref44$action = _ref44.action,
      o = _ref44$action === void 0 ? void 0 : _ref44$action,
      c = _ref44.children;
    var _i$useDevice9 = i.useDevice(),
      d = _i$useDevice9.isMobile,
      u = _i$useDevice9.isTablet,
      h = {
        title: e,
        bodyText: t,
        videoUrl: n,
        layout: r,
        action: o,
        isMobile: d,
        isTablet: u
      };
    return l.jsx(p5.Provider, {
      value: h,
      children: c
    });
  },
  gt = j.default(i.Column)(_templateObject110 || (_templateObject110 = _taggedTemplateLiteral(["\n  text-align: center;\n\n  ", "\n"])), function (e) {
    return e.center ? "text-align: center;" : Ue.sm(_templateObject111 || (_templateObject111 = _taggedTemplateLiteral(["\n  text-align:left;\n  "])));
  }),
  Ne = {
    VIDEO_LEFT: "1",
    VIDEO_RIGHT: "2",
    VIDEO_TOP: "3",
    VIDEO_BOTTOM: "4"
  },
  zh = function zh() {
    var _A$useContext = A.useContext(p5),
      e = _A$useContext.action,
      t = _A$useContext.title,
      n = _A$useContext.bodyText,
      r = _A$useContext.videoUrl,
      o = _A$useContext.layout,
      c = _A$useContext.isMobile,
      d = _A$useContext.isTablet,
      _A$useState33 = A.useState(!1),
      _A$useState34 = _slicedToArray(_A$useState33, 2),
      u = _A$useState34[0],
      h = _A$useState34[1],
      s = A.useCallback(function () {
        e != null && e.url && (window == null || window.open(e == null ? void 0 : e.url, (e == null ? void 0 : e.target) || "_self"));
      }, [e == null ? void 0 : e.url]),
      v = l.jsxs(l.Fragment, {
        children: [l.jsx(Wr, {
          onPlay: h,
          url: r
        }), u && l.jsx(Wr, {
          onPlay: h,
          url: r,
          overlay: !0
        })]
      });
    switch (o) {
      case Ne.VIDEO_LEFT:
      case Ne.VIDEO_RIGHT:
        return l.jsxs(l.Fragment, {
          children: [l.jsx(i.Row, {
            children: l.jsxs(gt, {
              noGutter: !0,
              center: !0,
              children: [l.jsx(i.Text, {
                type: "sectionTitle",
                children: t
              }), l.jsx(i.Spacing, {
                bottom: c || d ? 3 : 4
              })]
            })
          }), l.jsxs(i.Row, {
            middle: "lg",
            reverse: Ne.VIDEO_RIGHT === o,
            children: [l.jsx(i.Column, {
              xs: 12,
              sm: 12,
              md: 6,
              noGutter: !0,
              children: v
            }), l.jsx(i.Column, {
              xs: 12,
              md: 1,
              noGutter: !0
            }), l.jsxs(gt, {
              sm: 12,
              md: 5,
              noGutter: !0,
              children: [l.jsx(i.Spacing, {
                topBottom: 3,
                children: l.jsx(i.Text, {
                  type: "header",
                  children: n
                })
              }), l.jsx(i.Button, {
                secondary: (e == null ? void 0 : e.buttonType) === "secondary",
                text: e == null ? void 0 : e.text,
                onClick: s
              })]
            })]
          })]
        });
      case Ne.VIDEO_TOP:
      case Ne.VIDEO_BOTTOM:
        return l.jsxs(i.Row, L(R({
          middle: "lg"
        }, Ne.VIDEO_BOTTOM === o && {
          style: {
            flexWrap: "wrap-reverse"
          }
        }), {
          children: [l.jsxs(gt, {
            xs: 12,
            md: 8,
            mdOffset: 2,
            noGutter: !0,
            center: !0,
            children: [l.jsx(i.Text, {
              type: "sectionTitle",
              children: t
            }), l.jsx(i.Spacing, {
              top: 2,
              responsive: !1,
              children: l.jsx(i.Text, {
                type: "body",
                children: n
              })
            })]
          }), l.jsx(i.Column, {
            xs: 12,
            md: 8,
            mdOffset: 2,
            noGutter: !0,
            children: l.jsx(i.Spacing, {
              bottom: c || d ? 3 : 4
            })
          }), l.jsx(i.Column, {
            xs: 12,
            md: 8,
            mdOffset: 2,
            noGutter: !0,
            children: v
          })]
        }));
      default:
        return null;
    }
  };
j.default.div(_templateObject112 || (_templateObject112 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
j.default.iframe(_templateObject113 || (_templateObject113 = _taggedTemplateLiteral(["\n  height: auto;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  border: none;\n"])));
var ph = j.default.div(_templateObject114 || (_templateObject114 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n\n  &::after {\n    content: '';\n    display: block;\n    padding-bottom: 56.25%;\n  }\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"]))),
  Oh = j.default.div(_templateObject115 || (_templateObject115 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  cursor: pointer;\n  z-index: 1;\n"])));
j.default.div(_templateObject116 || (_templateObject116 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), function (_ref45) {
  var e = _ref45.backdropColor;
  return e;
});
var Eh = function Eh(e) {
    var t;
    return e && e.match(/youtube.com/) && (t = e.split("/watch?v=")[1]), e && e.match(/youtu.be/) && (t = e.split("youtu.be/")[1]), t;
  },
  Sh = function Sh() {
    var _A$useContext2 = A.useContext(p5),
      e = _A$useContext2.isMobile,
      t = _A$useContext2.isTablet;
    return l.jsx("div", {
      "data-testid": "video",
      children: l.jsx(i.Grid, {
        children: l.jsx(i.Spacing, {
          topBottom: e || t ? 5 : 9,
          children: l.jsx(zh, {})
        })
      })
    });
  },
  Wr = function Wr(_ref46) {
    var _ref46$overlay = _ref46.overlay,
      e = _ref46$overlay === void 0 ? !1 : _ref46$overlay,
      t = _ref46.url,
      n = _ref46.onPlay;
    var o = "https://www.youtube.com/embed/".concat(t ? Eh(t) : void 0);
    e && (o += "?autoplay=1");
    var c = l.jsxs(ph, {
      children: [l.jsx("iframe", {
        "data-testid": "video-iframe",
        src: o,
        frameBorder: 0,
        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: !0
      }), !e && l.jsx(Oh, {
        onClick: function onClick() {
          return n(!0);
        }
      })]
    });
    return e ? Nr.createPortal(l.jsx(Wl, {
      onClose: function onClose() {
        return n(!1);
      },
      children: c
    }), document.body) : c;
  },
  Ch = function Ch(e) {
    return l.jsx(jh, L(R({}, e), {
      children: l.jsx(Sh, {})
    }));
  },
  Rh = j.default(i.Grid)(_templateObject117 || (_templateObject117 = _taggedTemplateLiteral(["\n  padding: 0px;\n"]))),
  Mh = function Mh(_ref47) {
    var e = _ref47.cards;
    return l.jsx(Rh, {
      children: l.jsx(i.Row, {
        children: l.jsx(i.Column, {
          xs: 12,
          noGutter: !0,
          children: l.jsx(i.Carousel, {
            type: "card",
            swimlaneChildrenConfig: {
              sm: 2
            },
            children: e.map(function (t, n) {
              return l.jsx(J7, R({}, t), n);
            })
          })
        })
      })
    });
  },
  Th = function Th(o) {
    var c = o,
      e = c.image,
      _c$layout = c.layout,
      t = _c$layout === void 0 ? "4-4-4" : _c$layout,
      _c$centered = c.centered,
      n = _c$centered === void 0 ? !1 : _c$centered,
      r = ee(c, ["image", "layout", "centered"]);
    var d = e.src,
      u = e.ratio,
      h = e.srcSetObj,
      s = e.title,
      v = e.description,
      g = +(t == null ? void 0 : t.charAt(0)),
      _i$useDevice10 = i.useDevice(),
      x = _i$useDevice10.isMobile,
      w = _i$useDevice10.isTablet,
      m = _i$useDevice10.isLandscapeTablet,
      b = x || w || m ? 1 : 2,
      O = x || w || m ? .5 : 1;
    return l.jsxs(i.Column, {
      xs: 12,
      sm: g,
      children: [l.jsx(i.Image, R({
        src: d,
        ratio: u,
        srcSetObj: h
      }, r)), l.jsxs("div", {
        style: {
          textAlign: n ? "center" : "left"
        },
        children: [l.jsx(i.Spacing, {
          responsive: !1,
          top: b
        }), l.jsx(i.Text, {
          type: "boldBody",
          children: s
        }), l.jsx(i.Spacing, {
          responsive: !1,
          top: O
        }), l.jsx(i.Text, {
          type: "body",
          children: v
        })]
      })]
    });
  },
  Ph = function Ph(r) {
    var o = r,
      e = o.image,
      t = o.centered,
      n = ee(o, ["image", "centered"]);
    var c = e.src,
      d = e.ratio,
      u = e.srcSetObj,
      h = e.title,
      s = e.description,
      v = e.buttonText,
      g = e.buttonLink,
      x = e.buttonOnPress,
      w = function w(m) {
        g ? window.location.href = g : x && x(m);
      };
    return l.jsx(i.Grid, {
      fluid: !0,
      children: l.jsx(i.Row, {
        xs: 12,
        children: l.jsxs(i.Column, {
          children: [l.jsx(i.Image, R({
            src: c,
            ratio: d,
            srcSetObj: u
          }, n)), l.jsxs("div", {
            style: {
              textAlign: t ? "center" : "left"
            },
            children: [l.jsx(i.Spacing, {
              responsive: !1,
              top: 3
            }), l.jsx(i.Text, {
              type: "header",
              children: h
            }), l.jsx(i.Spacing, {
              responsive: !1,
              top: 1
            }), l.jsx(i.Text, {
              type: "body",
              children: s
            }), l.jsx(i.Spacing, {
              responsive: !1,
              top: 3
            }), v && l.jsx(i.Button, {
              text: v,
              secondary: !0,
              onClick: function onClick(m) {
                return w(m);
              }
            })]
          })]
        })
      })
    });
  },
  kh = function kh(o) {
    var c = o,
      e = c.image,
      t = c.centered,
      n = c.layout,
      r = ee(c, ["image", "centered", "layout"]);
    var d = e.src,
      u = e.ratio,
      h = e.srcSetObj,
      s = e.title,
      v = e.description,
      g = e.buttonText,
      x = e.buttonLink,
      w = e.buttonOnPress,
      _i$useDevice11 = i.useDevice(),
      m = _i$useDevice11.isMobile,
      b = _i$useDevice11.isTablet,
      O = function O(y) {
        x ? window.location.href = x : w && w(y);
      };
    return m || b ? l.jsx(Ph, R({
      image: e
    }, r)) : l.jsx(i.Grid, {
      fluid: !0,
      children: l.jsxs(i.Row, {
        children: [n === "content-right" && l.jsxs(l.Fragment, {
          children: [l.jsx(i.Column, {
            xs: 12,
            md: 6,
            children: l.jsx(i.Image, R({
              src: d,
              ratio: u,
              srcSetObj: h
            }, r))
          }), l.jsx(i.Column, {
            xs: 12,
            md: 1
          })]
        }), l.jsxs(i.Column, {
          xs: 12,
          md: 5,
          style: {
            alignSelf: "center",
            textAlign: t ? "center" : "left"
          },
          children: [l.jsx(i.Text, {
            type: "header",
            children: s
          }), l.jsx(i.Spacing, {
            responsive: !1,
            top: 2
          }), l.jsx(i.Text, {
            type: "body",
            children: v
          }), l.jsx(i.Spacing, {
            responsive: !1,
            top: 3
          }), g && l.jsx(i.Button, {
            text: g,
            secondary: !0,
            onClick: function onClick(y) {
              return O(y);
            }
          })]
        }), n === "content-left" && l.jsxs(l.Fragment, {
          children: [l.jsx(i.Column, {
            xs: 12,
            md: 1
          }), l.jsx(i.Column, {
            xs: 12,
            md: 6,
            children: l.jsx(i.Image, R({
              src: d,
              ratio: u,
              srcSetObj: h
            }, r))
          })]
        })]
      })
    });
  },
  Ah = function Ah(o) {
    var c = o,
      e = c.images,
      _c$layout2 = c.layout,
      t = _c$layout2 === void 0 ? "4-4-4" : _c$layout2,
      _c$centered2 = c.centered,
      n = _c$centered2 === void 0 ? !1 : _c$centered2,
      r = ee(c, ["images", "layout", "centered"]);
    return l.jsx(l.Fragment, {
      children: t === "content-left" || t === "content-right" ? l.jsx(kh, R({
        image: e[e.length - 1],
        centered: n,
        layout: t
      }, r)) : l.jsx(i.Grid, {
        fluid: !0,
        children: l.jsx(i.Row, {
          children: e.map(function (d, u) {
            return l.jsx(Th, R({
              image: d,
              layout: t,
              centered: n
            }, r), u);
          })
        })
      })
    });
  },
  Bh = function Bh(_ref48) {
    var e = _ref48.items;
    var t = function t(n) {
      n && (window.location.href = n);
    };
    return l.jsx(i.Breadcrumb, {
      children: e && e.map(function (n, r) {
        return l.jsx(i.Breadcrumb.Item, {
          onClick: function onClick() {
            return t(n.link);
          },
          lastItem: r === e.length - 1,
          children: n.text
        }, r);
      })
    });
  },
  Hh = function Hh(_ref49) {
    var e = _ref49.title,
      t = _ref49.subTitle,
      _ref49$leftType = _ref49.leftType,
      n = _ref49$leftType === void 0 ? "none" : _ref49$leftType,
      r = _ref49.image,
      o = _ref49.icon,
      _ref49$rightType = _ref49.rightType,
      c = _ref49$rightType === void 0 ? "none" : _ref49$rightType,
      d = _ref49.ctaText,
      u = _ref49.ctaUrl;
    var h = function h() {
        switch (n) {
          case "image":
            return r ? l.jsx("img", {
              src: r.src.url,
              alt: r.src.alt
            }) : null;
          case "icon":
            return o ? l.jsx(i.ListItem.Icon, {
              icon: function icon() {
                return l.jsx(g1, {
                  name: o,
                  size: 24
                });
              }
            }) : null;
          default:
            return null;
        }
      },
      s = function s() {
        switch (c) {
          case "secondary":
            return d && u ? l.jsx(i.Button, {
              secondary: !0,
              text: d,
              onClick: function onClick() {
                return window.open(u, "_blank");
              }
            }) : null;
          case "icon":
            return u ? l.jsx(i.TextLink, {
              onClick: function onClick() {
                return window.open(u, "_blank");
              },
              children: l.jsx(i.ListItem.Icon, {
                icon: function icon() {
                  return l.jsx(g1, {
                    name: "arrow_right",
                    size: 24
                  });
                }
              })
            }) : null;
          case "link":
            return d && u ? l.jsx(i.TextLink, {
              onClick: function onClick() {
                return window.open(u, "_blank");
              },
              children: d
            }) : null;
          default:
            return null;
        }
      };
    return l.jsx(i.ListItem, {
      bordered: !1,
      body: [{
        title: e
      }, {
        subTitle: t
      }],
      leftContent: h(),
      rightContent: s()
    });
  },
  Wh = function Wh(_ref50) {
    var e = _ref50.accordionItems,
      _ref50$activeKey = _ref50.activeKey,
      t = _ref50$activeKey === void 0 ? -1 : _ref50$activeKey,
      n = _ref50.seoTitleTag,
      r = _ref50.children;
    var _A$useState35 = A.useState(t),
      _A$useState36 = _slicedToArray(_A$useState35, 2),
      o = _A$useState36[0],
      c = _A$useState36[1],
      d = A.useCallback(function (u) {
        c(function (h) {
          return h === u ? -1 : u;
        });
      }, []);
    return l.jsx(l.Fragment, {
      children: e.map(function (v, s) {
        var g = v,
          _g$mountContent = g.mountContent,
          u = _g$mountContent === void 0 ? !1 : _g$mountContent,
          h = ee(g, ["mountContent"]);
        var x = n ? l.jsx(i.Text, {
          tag: n,
          type: "boldBody",
          children: h.title
        }) : h.title;
        return l.jsx(i.Accordion, L(R({}, h), {
          selected: s === o,
          title: x,
          onClick: function onClick() {
            return d(s);
          },
          mountContent: u,
          dividerNeeded: !0,
          children: Array.isArray(r) ? r[s] : r
        }), s);
      })
    });
  },
  Lh = j.default.div(_templateObject118 || (_templateObject118 = _taggedTemplateLiteral(["\n  display: grid;\n  gap: 16px;\n  padding: 0;\n\n  grid-template-columns: ", ";\n  grid-template-rows: ", ";\n  grid-template-areas: ", ";\n\n  @media (max-width: 767px) {\n    gap: 8px;\n    ", "\n  }\n\n  @media (min-width: 768px) and (max-width: 991px) {\n    gap: 8px;\n    ", "\n  }\n"])), function (e) {
    return e.gridLayout.gridTemplateColumns;
  }, function (e) {
    return e.gridLayout.gridTemplateRows;
  }, function (e) {
    return e.gridLayout.gridTemplateAreas;
  }, function (e) {
    var t;
    return (t = e == null ? void 0 : e.gridLayout) != null && t.mobile ? B.css(_templateObject119 || (_templateObject119 = _taggedTemplateLiteral(["\n            grid-template-columns: ", ";\n            grid-template-rows: ", ";\n            grid-template-areas: ", ";\n          "])), function (n) {
      return n.gridLayout.mobile.gridTemplateColumns;
    }, function (n) {
      return n.gridLayout.mobile.gridTemplateRows;
    }, function (n) {
      return n.gridLayout.mobile.gridTemplateAreas;
    }) : B.css(_templateObject120 || (_templateObject120 = _taggedTemplateLiteral(["\n            grid-template-columns: 1fr;\n            grid-template-rows: auto;\n            grid-template-areas: ", ";\n          "])), function () {
      return e.gridLayout.areas.map(function (r) {
        return "'".concat(r, "'");
      }).join("\n");
    });
  }, function (e) {
    var t;
    return (t = e == null ? void 0 : e.gridLayout) != null && t.tablet ? B.css(_templateObject121 || (_templateObject121 = _taggedTemplateLiteral(["\n            grid-template-columns: ", ";\n            grid-template-rows: ", ";\n            grid-template-areas: ", ";\n          "])), function (n) {
      return n.gridLayout.tablet.gridTemplateColumns;
    }, function (n) {
      return n.gridLayout.tablet.gridTemplateRows;
    }, function (n) {
      return n.gridLayout.tablet.gridTemplateAreas;
    }) : B.css(_templateObject122 || (_templateObject122 = _taggedTemplateLiteral(["\n            grid-template-columns: 1fr;\n            grid-template-rows: auto;\n            grid-template-areas: ", ";\n          "])), function () {
      return e.gridLayout.areas.map(function (r) {
        return "'".concat(r, "'");
      }).join("\n");
    });
  }),
  Lr = j.default.div(_templateObject123 || (_templateObject123 = _taggedTemplateLiteral(["\n  grid-area: ", ";\n"])), function (e) {
    return e.gridArea;
  }),
  _h = j.default.div(_templateObject124 || (_templateObject124 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-rows: 1fr 1fr;\n  gap: 16px;\n\n  &&& {\n    img {\n      min-height: 104%;\n    }\n  }\n\n  @media (max-width: 768px) {\n    gap: 8px;\n  }\n"])));
function Ih(e, t) {
  var n = "",
    r = "",
    o = "",
    c = [],
    d = {},
    u,
    h;
  return e === "4a" ? (n = "repeat(12, 1fr)", r = "auto auto", o = "\n      'box1 box1 box1 box1 box1 box1 box2 box2 box2 box2 box2 box2'\n      'box3 box3 box3 box3 box3 box3 box4 box4 box4 box4 box4 box4'\n    ", c = ["box1", "box2", "box3", "box4"]) : e === "4b" ? (n = "repeat(3, 1fr)", o = "'box1 box2 verticalStack'", c = ["box1", "box2", "verticalStack"], d.verticalStack = {
    startIndex: 2,
    count: 2
  }, h = {
    gridTemplateColumns: "repeat(12, 1fr)",
    gridTemplateRows: "repeat(3, auto)",
    gridTemplateAreas: "\n        'box1 box1 box1 box1 box1 box1 box2 box2 box2 box2 box2 box2'\n        'box1 box1 box1 box1 box1 box1 box2 box2 box2 box2 box2 box2'\n        'box3 box3 box3 box3 box3 box3 box4 box4 box4 box4 box4 box4'\n      ",
    areas: ["box1", "box2", "box3", "box4"],
    stackedAreas: {}
  }) : e === "5a" ? (n = "repeat()", r = "auto auto", o = "\n      'box1 box1 box1 box1 box2 box2 box2 box2 box3 box3 box3 box3'\n      'box4 box4 box4 box4 box4 box4 box5 box5 box5 box5 box5 box5'\n    ", c = ["box1", "box2", "box3", "box4", "box5"]) : e === "5b" ? (n = "repeat(3, 1fr)", o = "'box1 verticalStack1 verticalStack2'", c = ["box1", "verticalStack1", "verticalStack2"], d.verticalStack1 = {
    startIndex: 1,
    count: 2
  }, d.verticalStack2 = {
    startIndex: 3,
    count: 2
  }, h = {
    gridTemplateColumns: "repeat(2, 1fr)",
    gridTemplateRows: "auto auto",
    gridTemplateAreas: "\n        'box1 verticalStack'\n        'box4 box5'\n      ",
    areas: ["box1", "verticalStack", "box4", "box5"],
    stackedAreas: {
      verticalStack: {
        startIndex: 1,
        count: 2
      }
    }
  }) : e === "6" ? (n = "repeat(4, 1fr)", o = "'box1 verticalStack1 verticalStack2 box2'", c = ["box1", "verticalStack1", "verticalStack2", "box2"], d.verticalStack1 = {
    startIndex: 1,
    count: 2
  }, d.verticalStack2 = {
    startIndex: 3,
    count: 2
  }, u = {
    gridTemplateColumns: "repeat(2, 1fr)",
    gridTemplateRows: "repeat(2, 1fr)",
    gridTemplateAreas: "\n        'box1 verticalStack1'\n        'verticalStack2 box2'\n      ",
    areas: ["box1", "verticalStack1", "verticalStack2", "box2"],
    stackedAreas: {
      verticalStack1: {
        startIndex: 1,
        count: 2
      },
      verticalStack2: {
        startIndex: 3,
        count: 2
      }
    }
  }, h = {
    gridTemplateColumns: "repeat(4, 1fr)",
    gridTemplateRows: "auto",
    gridTemplateAreas: "'box1 verticalStack1 verticalStack2 box2'",
    areas: ["box1", "verticalStack1", "verticalStack2", "box2"],
    stackedAreas: {
      verticalStack1: {
        startIndex: 1,
        count: 2
      },
      verticalStack2: {
        startIndex: 3,
        count: 2
      }
    }
  }) : e === "7" ? (n = "repeat(4, 1fr)", o = "'box1 verticalStack1 verticalStack2 verticalStack3'", c = ["box1", "verticalStack1", "verticalStack2", "verticalStack3"], d.verticalStack1 = {
    startIndex: 1,
    count: 2
  }, d.verticalStack2 = {
    startIndex: 3,
    count: 2
  }, d.verticalStack3 = {
    startIndex: 5,
    count: 2
  }, h = {
    gridTemplateColumns: "repeat(4, 1fr)",
    gridTemplateRows: "auto",
    gridTemplateAreas: "'box1 verticalStack1 verticalStack2 verticalStack3'",
    areas: ["box1", "verticalStack1", "verticalStack2", "verticalStack3"],
    stackedAreas: {
      verticalStack1: {
        startIndex: 1,
        count: 2
      },
      verticalStack2: {
        startIndex: 3,
        count: 2
      },
      verticalStack3: {
        startIndex: 5,
        count: 2
      }
    }
  }, u = {
    gridTemplateColumns: "repeat(2, 1fr)",
    gridTemplateRows: "repeat(2, 1fr)",
    gridTemplateAreas: "\n        'box1 verticalStack1'\n        'verticalStack2 verticalStack3'\n      ",
    areas: ["box1", "verticalStack1", "verticalStack2", "verticalStack3"],
    stackedAreas: {
      verticalStack1: {
        startIndex: 1,
        count: 2
      },
      verticalStack2: {
        startIndex: 3,
        count: 2
      },
      verticalStack3: {
        startIndex: 5,
        count: 2
      }
    }
  }) : (n = "repeat(".concat(t, ", 1fr)"), r = "1fr", o = "'".concat(Array.from({
    length: t
  }, function (s, v) {
    return "box".concat(v + 1);
  }).join(" "), "'"), c = Array.from({
    length: t
  }, function (s, v) {
    return "box".concat(v + 1);
  })), {
    gridTemplateColumns: n,
    gridTemplateRows: r,
    gridTemplateAreas: o,
    areas: c,
    stackedAreas: d,
    mobile: u,
    tablet: h
  };
}
var Nh = function Nh(_ref51) {
    var _ref51$layoutType = _ref51.layoutType,
      e = _ref51$layoutType === void 0 ? "2" : _ref51$layoutType,
      _ref51$boxes = _ref51.boxes,
      t = _ref51$boxes === void 0 ? [] : _ref51$boxes;
    var _i$useDevice12 = i.useDevice(),
      n = _i$useDevice12.isTablet,
      r = _i$useDevice12.isMobile,
      o = t.length,
      c = Ih(e, o);
    var d = c.areas,
      u = c.stackedAreas;
    return n && c.tablet ? (d = c.tablet.areas, u = c.tablet.stackedAreas) : r && c.mobile && (d = c.mobile.areas, u = c.mobile.stackedAreas), l.jsx(Lh, {
      gridLayout: c,
      layoutType: e,
      "data-testid": "bento-container",
      children: d.map(function (h) {
        if (u[h]) {
          var _u$h = u[h],
            s = _u$h.startIndex,
            v = _u$h.count,
            g = t.slice(s, s + v);
          return l.jsx(Lr, {
            gridArea: h,
            children: l.jsx(_h, {
              gridLayout: c,
              children: g.map(function (x, w) {
                return l.jsx(X0, R({}, x), x.id || w);
              })
            })
          }, h);
        } else {
          var _s2 = parseInt(h.replace("box", "")) - 1;
          return _s2 === 1 && o === 6 && (_s2 = o - 1), l.jsx(Lr, {
            gridArea: h,
            children: l.jsx(X0, R({}, t[_s2]))
          }, h);
        }
      })
    });
  },
  Vh = function Vh(_ref52) {
    var _ref52$inverse = _ref52.inverse,
      e = _ref52$inverse === void 0 ? !1 : _ref52$inverse,
      _ref52$type = _ref52.type,
      t = _ref52$type === void 0 ? "variant1" : _ref52$type,
      n = _ref52.thumbnail,
      _ref52$title = _ref52.title,
      r = _ref52$title === void 0 ? "" : _ref52$title,
      _ref52$body = _ref52.body,
      o = _ref52$body === void 0 ? "" : _ref52$body,
      _ref52$seoType = _ref52.seoType,
      c = _ref52$seoType === void 0 ? "h3" : _ref52$seoType;
    return l.jsx(i.CirclePattern, {
      thumbnail: n,
      title: r,
      type: t,
      body: t === "variant2" ? l.jsx(y5, {
        text: o,
        inverse: e
      }) : o,
      inverse: e,
      seoType: c
    });
  },
  Fh = function Fh(_ref53) {
    var e = _ref53.title,
      t = _ref53.titleOnTimerEnd,
      _ref53$titleAlignment = _ref53.titleAlignment,
      n = _ref53$titleAlignment === void 0 ? "left" : _ref53$titleAlignment,
      _ref53$size = _ref53.size,
      r = _ref53$size === void 0 ? "S" : _ref53$size,
      o = _ref53.startTime,
      c = _ref53.endTime,
      d = _ref53.statusUpdateTime,
      u = _ref53.statusUpdateTitleText,
      _ref53$inverse = _ref53.inverse,
      h = _ref53$inverse === void 0 ? !1 : _ref53$inverse,
      s = _ref53.onTimeoutAction,
      v = _ref53.onTimeoutImage,
      g = _ref53.onTimeoutText,
      _ref53$onTimeoutTextS = _ref53.onTimeoutTextSEOType,
      x = _ref53$onTimeoutTextS === void 0 ? "h3" : _ref53$onTimeoutTextS,
      w = _ref53.onTimeout;
    var Y, q, le;
    var m = A.useRef(null),
      _A$useState37 = A.useState(e),
      _A$useState38 = _slicedToArray(_A$useState37, 2),
      b = _A$useState38[0],
      O = _A$useState38[1],
      _A$useState39 = A.useState(!1),
      _A$useState40 = _slicedToArray(_A$useState39, 2),
      y = _A$useState40[0],
      z = _A$useState40[1],
      _A$useState41 = A.useState(!1),
      _A$useState42 = _slicedToArray(_A$useState41, 2),
      E = _A$useState42[0],
      p = _A$useState42[1],
      _A$useState43 = A.useState(!1),
      _A$useState44 = _slicedToArray(_A$useState43, 2),
      C = _A$useState44[0],
      M = _A$useState44[1],
      _i$useTheme5 = i.useTheme(),
      P = _i$useTheme5.theme,
      _ = function _() {
        m.current && (clearInterval(m.current), m.current = null), w ? w() : (O(t || ""), z(!1), s === "show-image" && p(!0), s === "show-text" && M(!0), s === "show-image-text" && (p(!0), M(!0)));
      };
    return A.useEffect(function () {
      return m.current = setInterval(function () {
        var re = new Date().getTime();
        re >= o && z(!0), d !== void 0 && re >= d && u !== void 0 && O(u), re >= o && d && re >= d && m.current && clearInterval(m.current);
      }, 1e3), function () {
        m.current && (clearInterval(m.current), m.current = null);
      };
    }, [o, d, u]), l.jsx(i.Grid, {
      children: l.jsx(i.Row, {
        children: l.jsxs(i.Column, {
          xs: 12,
          style: {
            justifyContent: "center"
          },
          children: [C && g ? l.jsx("div", {
            style: {
              paddingBottom: 16,
              textAlign: n
            },
            children: l.jsx(i.Text, {
              type: r === "S" ? "boldBody" : "header",
              tag: x,
              color: h ? (Y = P == null ? void 0 : P.countdown) == null ? void 0 : Y.colorCountdownTextInverse : (le = (q = P == null ? void 0 : P.color) == null ? void 0 : q.text) == null ? void 0 : le.neutral,
              children: g
            })
          }) : null, E && v ? l.jsx(i.Image, {
            src: v.src,
            ratio: v.ratio,
            srcSetObj: v.srcSetObj
          }) : null, y && l.jsx(i.Countdown, {
            title: b,
            titleAlignment: n,
            size: r,
            targetTime: new Date(c),
            inverse: h,
            onTimeout: _
          })]
        })
      })
    });
  },
  Dh = function Dh(_ref54) {
    var e = _ref54.title,
      t = _ref54.subTitleText,
      n = _ref54.imgSrc,
      r = _ref54.imgAlt,
      o = _ref54.ribbon,
      _ref54$colors = _ref54.colors,
      c = _ref54$colors === void 0 ? [] : _ref54$colors,
      _ref54$cardTitleHeigh = _ref54.cardTitleHeight,
      d = _ref54$cardTitleHeigh === void 0 ? "sm" : _ref54$cardTitleHeigh,
      _ref54$cardBackground = _ref54.cardBackgroundColor,
      u = _ref54$cardBackground === void 0 ? "standard" : _ref54$cardBackground,
      _ref54$ctaUrl = _ref54.ctaUrl,
      h = _ref54$ctaUrl === void 0 ? "" : _ref54$ctaUrl,
      _ref54$ctaTarget = _ref54.ctaTarget,
      s = _ref54$ctaTarget === void 0 ? "_self" : _ref54$ctaTarget,
      _ref54$isShadow = _ref54.isShadow,
      v = _ref54$isShadow === void 0 ? !1 : _ref54$isShadow,
      _ref54$isRoundedCorne = _ref54.isRoundedCorner,
      g = _ref54$isRoundedCorne === void 0 ? !1 : _ref54$isRoundedCorne,
      _ref54$seoTitleTag = _ref54.seoTitleTag,
      x = _ref54$seoTitleTag === void 0 ? "h3" : _ref54$seoTitleTag;
    var w = A.useCallback(function () {
      return l.jsxs(i.Card, {
        autoHeight: !0,
        roundedCorners: g,
        shadow: v ? "sm" : !1,
        background: u,
        children: [l.jsx(i.Card.Image, {
          src: {
            url: n,
            alt: r
          },
          ratio: "1:1"
        }), l.jsxs(i.Spacing, {
          top: 1,
          leftRight: 2,
          bottom: 2,
          responsive: !1,
          children: [o ? l.jsx(i.Ribbon.Variant1, {
            inverse: u === "dark",
            children: o
          }) : null, l.jsx(i.Card.Title, {
            textType: "boldBody",
            numberOfLines: 2,
            height: d === "lg" ? 72 : 54,
            subTitleText: t,
            textColorInverse: u === "dark",
            subTitleTextColorInverse: u === "dark",
            seoType: x,
            children: e
          }), l.jsx(i.Spacing, {
            top: 1,
            responsive: !1,
            children: l.jsx(i.Card.ColorList, {
              colors: c
            })
          })]
        })]
      });
    }, [u, n, r, o, d, t, u, e, c]);
    return h ? l.jsx(i.Link, {
      href: h,
      target: s,
      children: w()
    }) : w();
  },
  n5 = ["bookmarkTag", "img", "title", "description", "content1", "content1Divider", "content2", "content3", "footer", "cta"],
  $h = 16,
  r5 = 16,
  _r = function _r(e, t, n) {
    var r = Math.ceil(n / t),
      o = n5.length,
      c = 100 / t;
    return "\n@media (min-width: ".concat(e, ") {\n  width: ").concat(c, "%;\n\n  ").concat(Array(r).fill(0).map(function (d, u) {
      return n5.map(function (h, s) {
        var v = t * o,
          g = s + 1;
        return "\n  :nth-child(".concat(o, "n + ").concat(g + v * u, "):nth-child(-n + ").concat(v * (u + 1), ") {\n    order: ").concat(g + u * o, ";\n    margin-top: ").concat(g === 1 && u > 0 ? "".concat($h, "px") : "0", ";\n  }\n");
      }).join("");
    }).join(""), "\n\n    :nth-last-child(-n + ").concat(o, ") {\n      margin-right: ").concat(n % t !== 0 ? "".concat(c * (t - n % t), "%") : "0", ";\n    }\n}\n");
  },
  qh = function qh(e, t) {
    var n = {
        xs: 360,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: 1680
      },
      r = [];
    return r.push(_r("0px", 1, t)), Object.entries(e).forEach(function (_ref55) {
      var _ref56 = _slicedToArray(_ref55, 2),
        o = _ref56[0],
        c = _ref56[1];
      c && r.push(_r("".concat(n[o], "px"), c, t));
    }), r.join("");
  },
  Uh = j.default.div(_templateObject125 || (_templateObject125 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]))),
  Gh = j.default.div(_templateObject126 || (_templateObject126 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  ", "\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n\n    & > div {\n      flex-grow: 1;\n    }\n\n    ", ";\n  }\n"])), function (_ref57) {
    var e = _ref57.$numItems;
    return e > 0 ? "margin: 0 -".concat(r5 / 2, "px;") : "";
  }, function (_ref58) {
    var e = _ref58.$displayConfig,
      t = _ref58.$numItems;
    return qh(e, t);
  }),
  Oe = B.css(_templateObject127 || (_templateObject127 = _taggedTemplateLiteral(["\n  background: ", ";\n  box-shadow: ", ";\n"])), function (_ref59) {
    var e = _ref59.coreTheme;
    return e == null ? void 0 : e.card.cardContentBackgroundStandard;
  }, function (_ref60) {
    var e = _ref60.coreTheme;
    return e == null ? void 0 : e.card.shadowCardLow;
  }),
  He = B.css(_templateObject128 || (_templateObject128 = _taggedTemplateLiteral(["\n  clip-path: polygon(\n    0% 0%,\n    100% 0%,\n    100% -200%,\n    200% -200%,\n    200% 200%,\n    100% 200%,\n    100% 100%,\n    0% 100%,\n    0% 200%,\n    -100% 200%,\n    -100% -100%,\n    0% -100%\n  );\n"]))),
  Yh = B.css(_templateObject129 || (_templateObject129 = _taggedTemplateLiteral(["\n  clip-path: polygon(\n    0% 0%,\n    100% 0%,\n    100% -200%,\n    200% -200%,\n    200% 200%,\n    -100% 200%,\n    -100% -100%,\n    0% -100%\n  );\n"]))),
  oo = B.css(_templateObject130 || (_templateObject130 = _taggedTemplateLiteral(["\n  clip-path: polygon(\n    200% -200%,\n    200% 200%,\n    100% 200%,\n    100% 100%,\n    0% 100%,\n    0% 200%,\n    -100% 200%,\n    -100% -100%\n  );\n"]))),
  Ee = B.css(_templateObject131 || (_templateObject131 = _taggedTemplateLiteral(["\n  position: relative;\n  &::before {\n    content: '';\n    position: absolute;\n    top: -0.5px;\n    left: 0;\n    right: 0;\n    bottom: calc(100% - 0.5px);\n    background: inherit;\n    z-index: -1;\n  }\n"]))),
  ze = B.css(_templateObject132 || (_templateObject132 = _taggedTemplateLiteral(["\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    top: calc(100% - 0.5px);\n    left: 0;\n    right: 0;\n    bottom: -0.5px;\n    background: inherit;\n    z-index: -1;\n  }\n"]))),
  co = B.css(_templateObject133 || (_templateObject133 = _taggedTemplateLiteral(["\n  position: relative;\n\n  ", "\n"])), function (_ref61) {
    var e = _ref61.$showBorder;
    return e ? "\n  &::after {\n    border: 1px solid #bfbfc7;\n    border-radius: inherit;\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n  " : "";
  }),
  ye = B.css(_templateObject134 || (_templateObject134 = _taggedTemplateLiteral(["\n  margin-left: ", "px;\n  margin-right: ", "px;\n"])), r5 / 2, r5 / 2),
  Se = B.css(_templateObject135 || (_templateObject135 = _taggedTemplateLiteral(["\n  padding: ", ";\n"])), function (_ref62) {
    var e = _ref62.coreTheme;
    return e == null ? void 0 : e.card.paddingSm;
  }),
  e1 = B.css(_templateObject136 || (_templateObject136 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n"]))),
  Qh = i.withTheme(j.default.div(_templateObject137 || (_templateObject137 = _taggedTemplateLiteral(["\n  ", "\n  padding-top: 0;\n  padding-right: 24px;\n  padding-bottom: 0;\n  padding-left: 0;\n"])), ye)),
  Xh = i.withTheme(j.default.div(_templateObject138 || (_templateObject138 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  border-radius: ", ";\n"])), Oe, oo, ze, ye, function (_ref63) {
    var e = _ref63.coreTheme,
      t = _ref63.$noTopLeftBorderRadius;
    return t ? "0 ".concat(e == null ? void 0 : e.card.borderRadiusCardSm, "px 0 0") : "".concat(e == null ? void 0 : e.card.borderRadiusCardSm, "px ").concat(e == null ? void 0 : e.card.borderRadiusCardSm, "px 0 0");
  })),
  Kh = i.withTheme(j.default.div(_templateObject139 || (_templateObject139 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  border-radius: ", ";\n"])), function (_ref64) {
    var e = _ref64.coreTheme,
      t = _ref64.$noTopLeftBorderRadius;
    return t ? "0 ".concat(e == null ? void 0 : e.card.borderRadiusCardSm, "px 0 0") : "".concat(e == null ? void 0 : e.card.borderRadiusCardSm, "px ").concat(e == null ? void 0 : e.card.borderRadiusCardSm, "px 0 0");
  })),
  Jh = i.withTheme(j.default.div(_templateObject140 || (_templateObject140 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  \n  ", "\n  ", "\n  padding-bottom: 0;\n"])), Oe, function (_ref65) {
    var e = _ref65.coreTheme,
      t = _ref65.$applyTopSectionContainerStyle,
      n = _ref65.$noTopLeftBorderRadius;
    return t ? "\n    ".concat(oo, "\n    ").concat(ze, "\n    border-radius: ").concat(n ? "0 ".concat(e == null ? void 0 : e.card.borderRadiusCardSm, "px 0 0") : "".concat(e == null ? void 0 : e.card.borderRadiusCardSm, "px ").concat(e == null ? void 0 : e.card.borderRadiusCardSm, "px 0 0"), ";\n  ") : "\n    ".concat(He, "\n    ").concat(Ee, "\n    ").concat(ze, "\n    ");
  }, ye, Se)),
  Zh = i.withTheme(j.default.div(_templateObject141 || (_templateObject141 = _taggedTemplateLiteral([""])))),
  e9 = i.withTheme(j.default.div(_templateObject142 || (_templateObject142 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  padding-top: 0;\n  padding-bottom: 0;\n"])), Oe, He, Ee, ze, ye, Se)),
  t9 = i.withTheme(j.default.div(_templateObject143 || (_templateObject143 = _taggedTemplateLiteral([""])))),
  Te = 16,
  n9 = j.default.div(_templateObject144 || (_templateObject144 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: ", "px;\n  min-height: ", "px;\n  & > p {\n    white-space: pre;\n    max-width: ", "px;\n  }\n"])), Te, Te, Te),
  r9 = j.default.div(_templateObject145 || (_templateObject145 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: ", "px;\n  height: ", "px;\n"])), Te, Te),
  l9 = j.default("ul")(_templateObject146 || (_templateObject146 = _taggedTemplateLiteral(["\n  list-style-type: none;  margin: 0;\n  padding: 0;\n\n  li {\n    min-height: ", "px;\n    margin-top: 4px;\n    display: flex;\n    gap: 0 8px;\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n"], ["\n  list-style-type: none;\\\n  margin: 0;\n  padding: 0;\n\n  li {\n    min-height: ", "px;\n    margin-top: 4px;\n    display: flex;\n    gap: 0 8px;\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n"])), Te),
  a9 = i.withTheme(j.default.div(_templateObject147 || (_templateObject147 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  padding-top: 0;\n  padding-bottom: 0;\n"])), Oe, He, Ee, ze, ye, Se)),
  i9 = i.withTheme(j.default.div(_templateObject148 || (_templateObject148 = _taggedTemplateLiteral(["\n  ", "\n"])), e1)),
  o9 = i.withTheme(j.default.div(_templateObject149 || (_templateObject149 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  padding-top: 0;\n  padding-bottom: 0;\n"])), Oe, He, Ee, ze, ye, Se)),
  c9 = i.withTheme(j.default.div(_templateObject150 || (_templateObject150 = _taggedTemplateLiteral(["\n  ", "\n"])), e1)),
  s9 = i.withTheme(j.default.div(_templateObject151 || (_templateObject151 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  padding-top: 0;\n  padding-bottom: 0;\n"])), Oe, He, Ee, ze, ye, Se)),
  d9 = i.withTheme(j.default.div(_templateObject152 || (_templateObject152 = _taggedTemplateLiteral(["\n  ", "\n\n  & > *:nth-child(n + 2) {\n    margin-top: 8px;\n  }\n"])), e1)),
  u9 = i.withTheme(j.default.div(_templateObject153 || (_templateObject153 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), Oe, He, Ee, ze, ye)),
  h9 = i.withTheme(j.default.div(_templateObject154 || (_templateObject154 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  height: 100%;\n  background: ", ";\n\n  & > *:nth-child(n + 2) {\n    margin-top: 8px;\n  }\n"])), Se, e1, function (_ref66) {
    var e = _ref66.coreTheme;
    return e == null ? void 0 : e.color.background.subtle2;
  })),
  f9 = i.withTheme(j.default.div(_templateObject155 || (_templateObject155 = _taggedTemplateLiteral(["\n  height: inherit;\n  width: inherit;\n  border-radius: inherit;\n  ", "\n"])), co)),
  v9 = i.withTheme(j.default.div(_templateObject156 || (_templateObject156 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  padding-top: 0;\n  padding-bottom: 0;\n"])), Oe, He, Ee, ze, ye, Se)),
  m9 = i.withTheme(j.default.div(_templateObject157 || (_templateObject157 = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  flex-direction: row;\n"])), e1)),
  g9 = i.withTheme(j.default.div(_templateObject158 || (_templateObject158 = _taggedTemplateLiteral(["\n  visibility: ", ";\n  margin: 0 16px;\n  width: 1px;\n  background-color: ", ";\n"])), function (_ref67) {
    var e = _ref67.$visible;
    return e ? "visible" : "hidden";
  }, function (_ref68) {
    var e = _ref68.coreTheme;
    var t;
    return (t = e == null ? void 0 : e.divider) == null ? void 0 : t.dividerColor;
  })),
  Ir = i.withTheme(j.default.div(_templateObject159 || (_templateObject159 = _taggedTemplateLiteral(["\n  flex: 1;\n"])))),
  x9 = i.withTheme(j.default.div(_templateObject160 || (_templateObject160 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  padding-top: 0;\n  border-radius: ", ";\n"])), Oe, Yh, Ee, ye, Se, function (_ref69) {
    var e = _ref69.coreTheme;
    return "0 0 ".concat(e == null ? void 0 : e.card.borderRadiusCardSm, "px ").concat(e == null ? void 0 : e.card.borderRadiusCardSm, "px");
  })),
  b9 = i.withTheme(j.default.div(_templateObject161 || (_templateObject161 = _taggedTemplateLiteral(["\n  ", "\n"])), e1)),
  w9 = j.default.div(_templateObject162 || (_templateObject162 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n"]))),
  y9 = j.default.div(_templateObject163 || (_templateObject163 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 16px;\n"]))),
  j9 = j.default.div(_templateObject164 || (_templateObject164 = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  width: 56px;\n  height: 56px;\n  margin-right: 16px;\n  border-radius: 8px;\n  ", "\n"])), co),
  z9 = j.default.div(_templateObject165 || (_templateObject165 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n"]))),
  p9 = function p9(_ref70) {
    var e = _ref70.cards,
      _ref70$numberOfCardPe = _ref70.numberOfCardPerRow,
      t = _ref70$numberOfCardPe === void 0 ? 3 : _ref70$numberOfCardPe,
      _ref70$imageRatio = _ref70.imageRatio,
      n = _ref70$imageRatio === void 0 ? "2:1" : _ref70$imageRatio;
    var _i$useDevice13 = i.useDevice(),
      r = _i$useDevice13.isMobile,
      _A$useState45 = A.useState(null),
      _A$useState46 = _slicedToArray(_A$useState45, 2),
      o = _A$useState46[0],
      c = _A$useState46[1],
      d = {
        xs: 1,
        sm: 2,
        md: t
      },
      u = n === "1:1" ? "1:1" : "2:1",
      h = function h(s) {
        c(s);
      };
    return l.jsx(Uh, {
      children: l.jsx(Gh, {
        $displayConfig: d,
        $numItems: (e == null ? void 0 : e.length) || 0,
        children: e == null ? void 0 : e.map(function (s, v) {
          return l.jsx(l.Fragment, {
            children: n5.map(function (g) {
              var x, w, m, b, O, y, z, E, p, C, M, P, _, Y, q, le, re, J, te, ae, se;
              return l.jsxs("div", {
                children: [g === "bookmarkTag" && !!((x = s == null ? void 0 : s.bookmarkTag) != null && x.text) && l.jsxs(Qh, {
                  children: [l.jsx(i.Tag, {
                    size: "tall",
                    customStyle: {
                      color: s.bookmarkTag.color || void 0,
                      backgroundColor: s.bookmarkTag.backgroundColor,
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px"
                    },
                    children: s.bookmarkTag.text || l.jsx(l.Fragment, {
                      children: " "
                    })
                  }), l.jsx("div", {
                    style: {
                      position: "absolute"
                    },
                    children: l.jsx(i.Tag, {
                      size: "tall",
                      customStyle: {
                        backgroundColor: s.bookmarkTag.backgroundColor
                      },
                      children: " "
                    })
                  })]
                }), g === "img" && l.jsx(Xh, {
                  children: !!((w = s.img) != null && w.src) && l.jsx(Kh, {
                    children: l.jsx(i.Card.Image, {
                      src: {
                        url: s.img.src,
                        alt: s.img.alt || ""
                      },
                      ratio: u
                    })
                  })
                }), g === "title" && l.jsx(Jh, {
                  $applyTopSectionContainerStyle: !((m = s.img) != null && m.src),
                  children: l.jsx(Zh, {
                    children: l.jsxs(i.Text, {
                      type: "header",
                      tag: s.seoTitleTag || "h3",
                      children: [l.jsx("span", {
                        style: {
                          verticalAlign: "middle"
                        },
                        children: s.title
                      }), !!((b = s.tag) != null && b.text) && l.jsxs(l.Fragment, {
                        children: [" ", l.jsx(i.Tag, {
                          customStyle: {
                            color: s.tag.color || void 0,
                            backgroundColor: s.tag.backgroundColor || "header.linkMainColor",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            borderBottomRightRadius: "8px"
                          },
                          children: s.tag.text
                        })]
                      })]
                    })
                  })
                }), g === "description" && l.jsx(e9, {
                  children: s.description && l.jsx(t9, {
                    children: l.jsx(i.Text, {
                      type: "body",
                      children: s.description
                    })
                  })
                }), g === "content1" && l.jsx(a9, {
                  children: s.content1 && s.content1.length > 0 && l.jsx(l.Fragment, {
                    children: l.jsx(i9, {
                      children: l.jsx(l9, {
                        children: (O = s.content1) == null ? void 0 : O.map(function (_ref71) {
                          var I = _ref71.iconName,
                            he = _ref71.text;
                          return l.jsxs("li", {
                            children: [l.jsx("div", {
                              children: l.jsxs(n9, {
                                children: [l.jsx(i.Text, {
                                  type: "smallBody",
                                  children: " "
                                }), l.jsx(r9, {
                                  children: l.jsx(g1, {
                                    name: I,
                                    size: "".concat(Te)
                                  })
                                })]
                              })
                            }), l.jsx("div", {
                              style: {
                                flex: 1,
                                display: "flex"
                              },
                              children: l.jsx(i.Text, {
                                type: "smallBody",
                                style: {
                                  margin: "auto 0"
                                },
                                children: he
                              })
                            })]
                          });
                        })
                      })
                    })
                  })
                }), g === "content1Divider" && l.jsx(o9, {
                  children: s.content1 && s.content1.length > 0 && l.jsx(c9, {
                    children: l.jsx(i.Divider, {})
                  })
                }), g === "content2" && l.jsx(s9, {
                  children: l.jsxs(d9, {
                    children: [l.jsx(i.Text, {
                      type: "boldSmallBody",
                      children: s.content2.title
                    }), l.jsx("div", {
                      children: (z = (y = s.content2) == null ? void 0 : y.bullets) == null ? void 0 : z.map(function (I) {
                        return l.jsx(i.BulletList, {
                          noSpace: !0,
                          size: "small",
                          children: I
                        });
                      })
                    })]
                  })
                }), g === "content3" && l.jsxs(u9, {
                  children: [!!s.content3 && !!(s.content3.title || s.content3.bullets && s.content3.bullets.length > 0 || s.content3.imageList && s.content3.imageList.length > 0) && l.jsxs(h9, {
                    children: [l.jsx(i.Text, {
                      type: "boldSmallBody",
                      children: (E = s.content3) == null ? void 0 : E.title
                    }), !!((p = s.content3) != null && p.bullets) && s.content3.bullets.length > 0 && l.jsx("div", {
                      children: s.content3.bullets.map(function (I) {
                        return l.jsx(i.BulletList, {
                          noSpace: !0,
                          size: "small",
                          children: I
                        });
                      })
                    }), !!s.content3.imageList && s.content3.imageList.length > 0 && l.jsx("div", {
                      style: {
                        marginLeft: "20px"
                      },
                      children: l.jsx(i.Card.IconList, {
                        items: (C = s.content3.imageList) == null ? void 0 : C.map(function (_ref72) {
                          var I = _ref72.src,
                            he = _ref72.title,
                            k = _ref72.alt,
                            ve = _ref72.showBorder;
                          return l.jsx(f9, {
                            $showBorder: ve,
                            children: l.jsx(i.Image, {
                              ratio: "1:1",
                              src: {
                                url: I,
                                alt: k || he || ""
                              }
                            })
                          });
                        }),
                        onItemClick: (M = s.content3) != null && M.showModal ? function () {
                          return h(v);
                        } : (P = s.content3) == null ? void 0 : P.onImageClick
                      })
                    })]
                  }), ((_ = s.content3) == null ? void 0 : _.showModal) && l.jsx(i.Modal, {
                    visible: o === v,
                    title: ((Y = s.content3) == null ? void 0 : Y.modalTitle) || "",
                    onClose: function onClose() {
                      return c(null);
                    },
                    scrollable: r,
                    children: l.jsx(i.Modal.Content, {
                      children: ((q = s.content3) == null ? void 0 : q.imageList) && s.content3.imageList.length > 0 && l.jsx(w9, {
                        children: s.content3.imageList.map(function (I) {
                          return l.jsx("div", {
                            children: l.jsxs(y9, {
                              children: [l.jsx(j9, {
                                $showBorder: (I == null ? void 0 : I.showBorder) || !1,
                                children: l.jsx(i.Image, {
                                  ratio: "1:1",
                                  src: {
                                    url: I.src,
                                    alt: I.alt || I.title || ""
                                  }
                                })
                              }), l.jsxs(z9, {
                                children: [I.title && l.jsx(i.Text, {
                                  type: "boldBody",
                                  children: I.title
                                }), I.description && l.jsx(i.Text, {
                                  type: "smallBody",
                                  color: "#70707A",
                                  children: I.description
                                })]
                              })]
                            })
                          }, (I == null ? void 0 : I.key) || (I == null ? void 0 : I.title));
                        })
                      })
                    })
                  })]
                }), g === "footer" && l.jsx(v9, {
                  children: l.jsxs(m9, {
                    children: [l.jsxs(Ir, {
                      children: [l.jsx(i.Text, {
                        type: "smallBody",
                        color: "#70707A",
                        children: s.footerLeft.text
                      }), l.jsx(i.Text, {
                        type: "boldBody",
                        children: s.footerLeft.mainPrice
                      }), l.jsx(i.Text, {
                        type: "smallBody",
                        strikeThrough: !0,
                        children: s.footerLeft.secondaryText
                      })]
                    }), l.jsx(g9, {
                      $visible: !!((le = s.footerRight) != null && le.text || (re = s.footerRight) != null && re.mainPrice || (J = s.footerRight) != null && J.secondaryText)
                    }), l.jsxs(Ir, {
                      children: [l.jsx(i.Text, {
                        type: "smallBody",
                        color: "#70707A",
                        children: (te = s.footerRight) == null ? void 0 : te.text
                      }), l.jsx(i.Text, {
                        type: "boldBody",
                        children: (ae = s.footerRight) == null ? void 0 : ae.mainPrice
                      }), l.jsx(i.Text, {
                        type: "smallBody",
                        strikeThrough: !0,
                        children: (se = s.footerRight) == null ? void 0 : se.secondaryText
                      })]
                    })]
                  })
                }), g === "cta" && l.jsx(x9, {
                  children: l.jsx(b9, {
                    children: s.cta.url ? l.jsx(i.Link, {
                      href: s.cta.url,
                      target: s.cta.target || "_self",
                      children: l.jsx(i.Button, {
                        text: s.cta.text || "Get",
                        secondary: s.cta.type !== "primary",
                        onClick: s.cta.onClick,
                        fullWidth: !0
                      })
                    }) : s.cta.loading === "success" ? l.jsx("span", {
                      onClick: s.cta.onClick,
                      "aria-hidden": "true",
                      style: {
                        cursor: "pointer"
                      },
                      children: l.jsx(i.Button, {
                        text: s.cta.text || "Get",
                        secondary: s.cta.type !== "primary",
                        onClick: s.cta.onClick,
                        fullWidth: !0,
                        loading: s.cta.loading,
                        disabled: s.cta.disabled
                      })
                    }) : l.jsx(i.Button, {
                      text: s.cta.text || "Get",
                      secondary: s.cta.type !== "primary",
                      onClick: s.cta.onClick,
                      fullWidth: !0,
                      loading: s.cta.loading,
                      disabled: s.cta.disabled
                    })
                  })
                })]
              });
            })
          });
        })
      })
    });
  };
exports.Accordion = Wh;
exports.AnchorLink = f8;
exports.ArticleList = Mh;
exports.Banner = tc;
exports.Bento = Nh;
exports.BreadCrumb = Bh;
exports.CardComponent = J7;
exports.CardList = lc;
exports.Carousel = ac;
exports.CirclePattern = Vh;
exports.ColumnController = Wu;
exports.CountdownTimer = Fh;
exports.Footer = yh;
exports.Header = th;
exports.ImageList = Ah;
exports.ListItem = Hh;
exports.Notification = Xu;
exports.PaddingController = Vr;
exports.PageSection = sc;
exports.PricePlanCardList = p9;
exports.ProductCard = Dh;
exports.RichText = y5;
exports.SingtelButton = Fu;
exports.TabGroup = Yo;
exports.Tabs = Xo;
exports.TextWithIcon = Yu;
exports.Video = Ch;